(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode("._widgetContentWrapper_9ss9w_1{overflow-x:auto}._wrapper_17fxs_27{margin-bottom:16px}._wrapperBox_17fxs_30{border:1px solid #d7dfea;border-radius:4px;padding:16px}._wrapperBoxErrorBorder_17fxs_35{border-color:#c11d1d}")),document.head.appendChild(e)}}catch(r){console.error("vite-plugin-css-injected-by-js",r)}})();
import { WidgetContextProvider as Sv, makeUseMutation as Nv, makeUseQuery as xv, makeUseLazyQuery as wv, makeExecuteQuery as jv, useTracking as sn, DisplayErrors as bn, OAuthSettings as ga, useWidgetContext as rn, useData as fl, KlaviyoSubscribeSetting as Cv, isDownstreamApiAuthorizationError as Ev, isDownstreamApiPermissionError as Fv, hasDownstreamApiPermissionError as km, hasDownstreamApiNotFoundError as vl } from "@dixa/partner-widget-integration-support";
export * from "@dixa/partner-widget-integration-support";
import Cn, { useMemo as At, useState as G, useEffect as Pe, useLayoutEffect as Iv, createElement as $v, useCallback as Tv, Fragment as Ov } from "react";
import { Modal as jt, ModalHead as Ct, ModalBody as Et, ModalFoot as Mt, FlexBox as C, Button as On, Spinner as ln, Text as se, Tag as an, NavigationButton as rt, Icon as Fe, CollapseCard as Kn, Box as nn, Select as Wn, FormGrid as Ar, FormField as wn, FieldWrapper as Fn, InputText as St, Tooltip as jn, Textarea as ys, TagsInput as Rv, IconButton as Bt, List as Ln, Badge as ut, Divider as yl, InputSelectionList as Qt, SelectionList as Jt, FieldText as Lt, FieldTextarea as Dv, CopyToClipboardButton as Pv, Avatar as gl, Checkbox as Av, Image as bm, Timestamp as _m, Attachment as Lv, ErrorBoundaryContext as Sm, FieldSwitch as Nm } from "@dixa/lib-shared-habla";
import { ApolloClient as Uv, InMemoryCache as Mv, ApolloLink as Bv, createHttpLink as Vv, ApolloProvider as qv, ApolloConsumer as zv, gql as ci, NetworkStatus as Yn, isApolloError as Hv, ApolloError as Kv, useQuery as Gv, useMutation as lc } from "@apollo/client";
import Wv from "cross-fetch";
import { __extends as xm, __assign as ir, __rest as Yv } from "tslib";
import { config as ta } from "lib-shared-backend-config";
import { colors as $e, sizes as tn, typography as _t } from "@dixa/lib-shared-tokens";
import { useDebounce as Lr, useCopyToClipboard as hl, useMap as Qv, useMount as Jv } from "react-use";
import { useForm as kl, Controller as nt } from "react-hook-form";
import Nt from "moment";
import { useLocation as Zv } from "react-router-dom";
function Xv(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var gs = { exports: {} }, ar = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var za, cc;
function wm() {
  if (cc)
    return za;
  cc = 1;
  var e = Object.getOwnPropertySymbols, n = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function i(s) {
    if (s == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(s);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var s = new String("abc");
      if (s[5] = "de", Object.getOwnPropertyNames(s)[0] === "5")
        return !1;
      for (var l = {}, c = 0; c < 10; c++)
        l["_" + String.fromCharCode(c)] = c;
      var u = Object.getOwnPropertyNames(l).map(function(m) {
        return l[m];
      });
      if (u.join("") !== "0123456789")
        return !1;
      var p = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(m) {
        p[m] = m;
      }), Object.keys(Object.assign({}, p)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return za = o() ? Object.assign : function(s, l) {
    for (var c, u = i(s), p, m = 1; m < arguments.length; m++) {
      c = Object(arguments[m]);
      for (var v in c)
        n.call(c, v) && (u[v] = c[v]);
      if (e) {
        p = e(c);
        for (var y = 0; y < p.length; y++)
          r.call(c, p[y]) && (u[p[y]] = c[p[y]]);
      }
    }
    return u;
  }, za;
}
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var dc;
function ey() {
  if (dc)
    return ar;
  dc = 1, wm();
  var e = Cn, n = 60103;
  if (ar.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var r = Symbol.for;
    n = r("react.element"), ar.Fragment = r("react.fragment");
  }
  var i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = Object.prototype.hasOwnProperty, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(c, u, p) {
    var m, v = {}, y = null, b = null;
    p !== void 0 && (y = "" + p), u.key !== void 0 && (y = "" + u.key), u.ref !== void 0 && (b = u.ref);
    for (m in u)
      o.call(u, m) && !s.hasOwnProperty(m) && (v[m] = u[m]);
    if (c && c.defaultProps)
      for (m in u = c.defaultProps, u)
        v[m] === void 0 && (v[m] = u[m]);
    return { $$typeof: n, type: c, key: y, ref: b, props: v, _owner: i.current };
  }
  return ar.jsx = l, ar.jsxs = l, ar;
}
var Ha = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var uc;
function ny() {
  return uc || (uc = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      var n = Cn, r = wm(), i = 60103, o = 60106;
      e.Fragment = 60107;
      var s = 60108, l = 60114, c = 60109, u = 60110, p = 60112, m = 60113, v = 60120, y = 60115, b = 60116, N = 60121, x = 60122, T = 60117, $ = 60129, P = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var h = Symbol.for;
        i = h("react.element"), o = h("react.portal"), e.Fragment = h("react.fragment"), s = h("react.strict_mode"), l = h("react.profiler"), c = h("react.provider"), u = h("react.context"), p = h("react.forward_ref"), m = h("react.suspense"), v = h("react.suspense_list"), y = h("react.memo"), b = h("react.lazy"), N = h("react.block"), x = h("react.server.block"), T = h("react.fundamental"), h("react.scope"), h("react.opaque.id"), $ = h("react.debug_trace_mode"), h("react.offscreen"), P = h("react.legacy_hidden");
      }
      var E = typeof Symbol == "function" && Symbol.iterator, q = "@@iterator";
      function M(t) {
        if (t === null || typeof t != "object")
          return null;
        var a = E && t[E] || t[q];
        return typeof a == "function" ? a : null;
      }
      var R = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function w(t) {
        {
          for (var a = arguments.length, d = new Array(a > 1 ? a - 1 : 0), f = 1; f < a; f++)
            d[f - 1] = arguments[f];
          H("error", t, d);
        }
      }
      function H(t, a, d) {
        {
          var f = R.ReactDebugCurrentFrame, _ = f.getStackAddendum();
          _ !== "" && (a += "%s", d = d.concat([_]));
          var S = d.map(function(k) {
            return "" + k;
          });
          S.unshift("Warning: " + a), Function.prototype.apply.call(console[t], console, S);
        }
      }
      var pe = !1;
      function le(t) {
        return !!(typeof t == "string" || typeof t == "function" || t === e.Fragment || t === l || t === $ || t === s || t === m || t === v || t === P || pe || typeof t == "object" && t !== null && (t.$$typeof === b || t.$$typeof === y || t.$$typeof === c || t.$$typeof === u || t.$$typeof === p || t.$$typeof === T || t.$$typeof === N || t[0] === x));
      }
      function Se(t, a, d) {
        var f = a.displayName || a.name || "";
        return t.displayName || (f !== "" ? d + "(" + f + ")" : d);
      }
      function ae(t) {
        return t.displayName || "Context";
      }
      function D(t) {
        if (t == null)
          return null;
        if (typeof t.tag == "number" && w("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof t == "function")
          return t.displayName || t.name || null;
        if (typeof t == "string")
          return t;
        switch (t) {
          case e.Fragment:
            return "Fragment";
          case o:
            return "Portal";
          case l:
            return "Profiler";
          case s:
            return "StrictMode";
          case m:
            return "Suspense";
          case v:
            return "SuspenseList";
        }
        if (typeof t == "object")
          switch (t.$$typeof) {
            case u:
              var a = t;
              return ae(a) + ".Consumer";
            case c:
              var d = t;
              return ae(d._context) + ".Provider";
            case p:
              return Se(t, t.render, "ForwardRef");
            case y:
              return D(t.type);
            case N:
              return D(t._render);
            case b: {
              var f = t, _ = f._payload, S = f._init;
              try {
                return D(S(_));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var V = 0, de, te, he, _e, Z, J, z;
      function me() {
      }
      me.__reactDisabledLog = !0;
      function ke() {
        {
          if (V === 0) {
            de = console.log, te = console.info, he = console.warn, _e = console.error, Z = console.group, J = console.groupCollapsed, z = console.groupEnd;
            var t = {
              configurable: !0,
              enumerable: !0,
              value: me,
              writable: !0
            };
            Object.defineProperties(console, {
              info: t,
              log: t,
              warn: t,
              error: t,
              group: t,
              groupCollapsed: t,
              groupEnd: t
            });
          }
          V++;
        }
      }
      function Oe() {
        {
          if (V--, V === 0) {
            var t = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: r({}, t, {
                value: de
              }),
              info: r({}, t, {
                value: te
              }),
              warn: r({}, t, {
                value: he
              }),
              error: r({}, t, {
                value: _e
              }),
              group: r({}, t, {
                value: Z
              }),
              groupCollapsed: r({}, t, {
                value: J
              }),
              groupEnd: r({}, t, {
                value: z
              })
            });
          }
          V < 0 && w("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var Y = R.ReactCurrentDispatcher, fe;
      function ge(t, a, d) {
        {
          if (fe === void 0)
            try {
              throw Error();
            } catch (_) {
              var f = _.stack.trim().match(/\n( *(at )?)/);
              fe = f && f[1] || "";
            }
          return `
` + fe + t;
        }
      }
      var X = !1, ye;
      {
        var W = typeof WeakMap == "function" ? WeakMap : Map;
        ye = new W();
      }
      function ce(t, a) {
        if (!t || X)
          return "";
        {
          var d = ye.get(t);
          if (d !== void 0)
            return d;
        }
        var f;
        X = !0;
        var _ = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var S;
        S = Y.current, Y.current = null, ke();
        try {
          if (a) {
            var k = function() {
              throw Error();
            };
            if (Object.defineProperty(k.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(k, []);
              } catch (A) {
                f = A;
              }
              Reflect.construct(t, [], k);
            } else {
              try {
                k.call();
              } catch (A) {
                f = A;
              }
              t.call(k.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (A) {
              f = A;
            }
            t();
          }
        } catch (A) {
          if (A && f && typeof A.stack == "string") {
            for (var g = A.stack.split(`
`), L = f.stack.split(`
`), I = g.length - 1, O = L.length - 1; I >= 1 && O >= 0 && g[I] !== L[O]; )
              O--;
            for (; I >= 1 && O >= 0; I--, O--)
              if (g[I] !== L[O]) {
                if (I !== 1 || O !== 1)
                  do
                    if (I--, O--, O < 0 || g[I] !== L[O]) {
                      var re = `
` + g[I].replace(" at new ", " at ");
                      return typeof t == "function" && ye.set(t, re), re;
                    }
                  while (I >= 1 && O >= 0);
                break;
              }
          }
        } finally {
          X = !1, Y.current = S, Oe(), Error.prepareStackTrace = _;
        }
        var Ce = t ? t.displayName || t.name : "", j = Ce ? ge(Ce) : "";
        return typeof t == "function" && ye.set(t, j), j;
      }
      function ie(t, a, d) {
        return ce(t, !1);
      }
      function oe(t) {
        var a = t.prototype;
        return !!(a && a.isReactComponent);
      }
      function be(t, a, d) {
        if (t == null)
          return "";
        if (typeof t == "function")
          return ce(t, oe(t));
        if (typeof t == "string")
          return ge(t);
        switch (t) {
          case m:
            return ge("Suspense");
          case v:
            return ge("SuspenseList");
        }
        if (typeof t == "object")
          switch (t.$$typeof) {
            case p:
              return ie(t.render);
            case y:
              return be(t.type, a, d);
            case N:
              return ie(t._render);
            case b: {
              var f = t, _ = f._payload, S = f._init;
              try {
                return be(S(_), a, d);
              } catch {
              }
            }
          }
        return "";
      }
      var Ee = {}, Ie = R.ReactDebugCurrentFrame;
      function we(t) {
        if (t) {
          var a = t._owner, d = be(t.type, t._source, a ? a.type : null);
          Ie.setExtraStackFrame(d);
        } else
          Ie.setExtraStackFrame(null);
      }
      function Ge(t, a, d, f, _) {
        {
          var S = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var k in t)
            if (S(t, k)) {
              var g = void 0;
              try {
                if (typeof t[k] != "function") {
                  var L = Error((f || "React class") + ": " + d + " type `" + k + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[k] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw L.name = "Invariant Violation", L;
                }
                g = t[k](a, k, f, d, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (I) {
                g = I;
              }
              g && !(g instanceof Error) && (we(_), w("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", f || "React class", d, k, typeof g), we(null)), g instanceof Error && !(g.message in Ee) && (Ee[g.message] = !0, we(_), w("Failed %s type: %s", d, g.message), we(null));
            }
        }
      }
      var je = R.ReactCurrentOwner, Te = Object.prototype.hasOwnProperty, Ye = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, Ae, Be, De;
      De = {};
      function cn(t) {
        if (Te.call(t, "ref")) {
          var a = Object.getOwnPropertyDescriptor(t, "ref").get;
          if (a && a.isReactWarning)
            return !1;
        }
        return t.ref !== void 0;
      }
      function en(t) {
        if (Te.call(t, "key")) {
          var a = Object.getOwnPropertyDescriptor(t, "key").get;
          if (a && a.isReactWarning)
            return !1;
        }
        return t.key !== void 0;
      }
      function yn(t, a) {
        if (typeof t.ref == "string" && je.current && a && je.current.stateNode !== a) {
          var d = D(je.current.type);
          De[d] || (w('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', D(je.current.type), t.ref), De[d] = !0);
        }
      }
      function pn(t, a) {
        {
          var d = function() {
            Ae || (Ae = !0, w("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", a));
          };
          d.isReactWarning = !0, Object.defineProperty(t, "key", {
            get: d,
            configurable: !0
          });
        }
      }
      function gn(t, a) {
        {
          var d = function() {
            Be || (Be = !0, w("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", a));
          };
          d.isReactWarning = !0, Object.defineProperty(t, "ref", {
            get: d,
            configurable: !0
          });
        }
      }
      var dn = function(t, a, d, f, _, S, k) {
        var g = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: i,
          // Built-in properties that belong on the element
          type: t,
          key: a,
          ref: d,
          props: k,
          // Record the component responsible for creating this element.
          _owner: S
        };
        return g._store = {}, Object.defineProperty(g._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(g, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: f
        }), Object.defineProperty(g, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: _
        }), Object.freeze && (Object.freeze(g.props), Object.freeze(g)), g;
      };
      function un(t, a, d, f, _) {
        {
          var S, k = {}, g = null, L = null;
          d !== void 0 && (g = "" + d), en(a) && (g = "" + a.key), cn(a) && (L = a.ref, yn(a, _));
          for (S in a)
            Te.call(a, S) && !Ye.hasOwnProperty(S) && (k[S] = a[S]);
          if (t && t.defaultProps) {
            var I = t.defaultProps;
            for (S in I)
              k[S] === void 0 && (k[S] = I[S]);
          }
          if (g || L) {
            var O = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
            g && pn(k, O), L && gn(k, O);
          }
          return dn(t, g, L, _, f, je.current, k);
        }
      }
      var Re = R.ReactCurrentOwner, He = R.ReactDebugCurrentFrame;
      function Ne(t) {
        if (t) {
          var a = t._owner, d = be(t.type, t._source, a ? a.type : null);
          He.setExtraStackFrame(d);
        } else
          He.setExtraStackFrame(null);
      }
      var Le;
      Le = !1;
      function Me(t) {
        return typeof t == "object" && t !== null && t.$$typeof === i;
      }
      function ze() {
        {
          if (Re.current) {
            var t = D(Re.current.type);
            if (t)
              return `

Check the render method of \`` + t + "`.";
          }
          return "";
        }
      }
      function _n(t) {
        {
          if (t !== void 0) {
            var a = t.fileName.replace(/^.*[\\\/]/, ""), d = t.lineNumber;
            return `

Check your code at ` + a + ":" + d + ".";
          }
          return "";
        }
      }
      var Je = {};
      function qe(t) {
        {
          var a = ze();
          if (!a) {
            var d = typeof t == "string" ? t : t.displayName || t.name;
            d && (a = `

Check the top-level render call using <` + d + ">.");
          }
          return a;
        }
      }
      function Ke(t, a) {
        {
          if (!t._store || t._store.validated || t.key != null)
            return;
          t._store.validated = !0;
          var d = qe(a);
          if (Je[d])
            return;
          Je[d] = !0;
          var f = "";
          t && t._owner && t._owner !== Re.current && (f = " It was passed a child from " + D(t._owner.type) + "."), Ne(t), w('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', d, f), Ne(null);
        }
      }
      function Ze(t, a) {
        {
          if (typeof t != "object")
            return;
          if (Array.isArray(t))
            for (var d = 0; d < t.length; d++) {
              var f = t[d];
              Me(f) && Ke(f, a);
            }
          else if (Me(t))
            t._store && (t._store.validated = !0);
          else if (t) {
            var _ = M(t);
            if (typeof _ == "function" && _ !== t.entries)
              for (var S = _.call(t), k; !(k = S.next()).done; )
                Me(k.value) && Ke(k.value, a);
          }
        }
      }
      function hn(t) {
        {
          var a = t.type;
          if (a == null || typeof a == "string")
            return;
          var d;
          if (typeof a == "function")
            d = a.propTypes;
          else if (typeof a == "object" && (a.$$typeof === p || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          a.$$typeof === y))
            d = a.propTypes;
          else
            return;
          if (d) {
            var f = D(a);
            Ge(d, t.props, "prop", f, t);
          } else if (a.PropTypes !== void 0 && !Le) {
            Le = !0;
            var _ = D(a);
            w("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _ || "Unknown");
          }
          typeof a.getDefaultProps == "function" && !a.getDefaultProps.isReactClassApproved && w("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function fn(t) {
        {
          for (var a = Object.keys(t.props), d = 0; d < a.length; d++) {
            var f = a[d];
            if (f !== "children" && f !== "key") {
              Ne(t), w("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", f), Ne(null);
              break;
            }
          }
          t.ref !== null && (Ne(t), w("Invalid attribute `ref` supplied to `React.Fragment`."), Ne(null));
        }
      }
      function Qe(t, a, d, f, _, S) {
        {
          var k = le(t);
          if (!k) {
            var g = "";
            (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (g += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var L = _n(_);
            L ? g += L : g += ze();
            var I;
            t === null ? I = "null" : Array.isArray(t) ? I = "array" : t !== void 0 && t.$$typeof === i ? (I = "<" + (D(t.type) || "Unknown") + " />", g = " Did you accidentally export a JSX literal instead of a component?") : I = typeof t, w("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", I, g);
          }
          var O = un(t, a, d, _, S);
          if (O == null)
            return O;
          if (k) {
            var re = a.children;
            if (re !== void 0)
              if (f)
                if (Array.isArray(re)) {
                  for (var Ce = 0; Ce < re.length; Ce++)
                    Ze(re[Ce], t);
                  Object.freeze && Object.freeze(re);
                } else
                  w("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                Ze(re, t);
          }
          return t === e.Fragment ? fn(O) : hn(O), O;
        }
      }
      function kn(t, a, d) {
        return Qe(t, a, d, !0);
      }
      function Sn(t, a, d) {
        return Qe(t, a, d, !1);
      }
      var mn = Sn, vn = kn;
      e.jsx = mn, e.jsxs = vn;
    }();
  }(Ha)), Ha;
}
process.env.NODE_ENV === "production" ? gs.exports = ey() : gs.exports = ny();
var xe = gs.exports, Ka = "Invariant Violation", mc = Object.setPrototypeOf, ty = mc === void 0 ? function(e, n) {
  return e.__proto__ = n, e;
} : mc, jm = (
  /** @class */
  function(e) {
    xm(n, e);
    function n(r) {
      r === void 0 && (r = Ka);
      var i = e.call(this, typeof r == "number" ? Ka + ": " + r + " (see https://github.com/apollographql/invariant-packages)" : r) || this;
      return i.framesToPop = 1, i.name = Ka, ty(i, n.prototype), i;
    }
    return n;
  }(Error)
);
function Zt(e, n) {
  if (!e)
    throw new jm(n);
}
var Cm = ["debug", "log", "warn", "error", "silent"], ry = Cm.indexOf("log");
function _i(e) {
  return function() {
    if (Cm.indexOf(e) >= ry) {
      var n = console[e] || console.log;
      return n.apply(console, arguments);
    }
  };
}
(function(e) {
  e.debug = _i("debug"), e.log = _i("log"), e.warn = _i("warn"), e.error = _i("error");
})(Zt || (Zt = {}));
var Em = "3.9.6";
function or(e) {
  try {
    return e();
  } catch {
  }
}
const pc = or(function() {
  return globalThis;
}) || or(function() {
  return window;
}) || or(function() {
  return self;
}) || or(function() {
  return global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
or(function() {
  return or.constructor("return this")();
});
var fc = /* @__PURE__ */ new Map();
function iy(e) {
  var n = fc.get(e) || 1;
  return fc.set(e, n + 1), "".concat(e, ":").concat(n, ":").concat(Math.random().toString(36).slice(2));
}
function ay(e, n) {
  n === void 0 && (n = 0);
  var r = iy("stringifyForDisplay");
  return JSON.stringify(e, function(i, o) {
    return o === void 0 ? r : o;
  }, n).split(JSON.stringify(r)).join("<undefined>");
}
function Si(e) {
  return function(n) {
    for (var r = [], i = 1; i < arguments.length; i++)
      r[i - 1] = arguments[i];
    if (typeof n == "number") {
      var o = n;
      n = bl(o), n || (n = _l(o, r), r = []);
    }
    e.apply(void 0, [n].concat(r));
  };
}
var oy = Object.assign(function(n, r) {
  for (var i = [], o = 2; o < arguments.length; o++)
    i[o - 2] = arguments[o];
  n || Zt(n, bl(r, i) || _l(r, i));
}, {
  debug: Si(Zt.debug),
  log: Si(Zt.log),
  warn: Si(Zt.warn),
  error: Si(Zt.error)
});
function Fm(e) {
  for (var n = [], r = 1; r < arguments.length; r++)
    n[r - 1] = arguments[r];
  return new jm(bl(e, n) || _l(e, n));
}
var vc = Symbol.for("ApolloErrorMessageHandler_" + Em);
function Im(e) {
  return typeof e == "string" ? e : ay(e, 2).slice(0, 1e3);
}
function bl(e, n) {
  if (n === void 0 && (n = []), !!e)
    return pc[vc] && pc[vc](e, n.map(Im));
}
function _l(e, n) {
  if (n === void 0 && (n = []), !!e)
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
      version: Em,
      message: e,
      args: n.map(Im)
    })));
}
function sy(e) {
  return e.definitions.filter(function(n) {
    return n.kind === "OperationDefinition" && !!n.name;
  }).map(function(n) {
    return n.name.value;
  })[0] || null;
}
function ly(e, n) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r)
    return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = cy(e)) || n && e && typeof e.length == "number") {
    r && (e = r);
    var i = 0;
    return function() {
      return i >= e.length ? { done: !0 } : { done: !1, value: e[i++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function cy(e, n) {
  if (e) {
    if (typeof e == "string")
      return yc(e, n);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return yc(e, n);
  }
}
function yc(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var r = 0, i = new Array(n); r < n; r++)
    i[r] = e[r];
  return i;
}
function gc(e, n) {
  for (var r = 0; r < n.length; r++) {
    var i = n[r];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
  }
}
function Sl(e, n, r) {
  return n && gc(e.prototype, n), r && gc(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var Nl = function() {
  return typeof Symbol == "function";
}, xl = function(e) {
  return Nl() && !!Symbol[e];
}, wl = function(e) {
  return xl(e) ? Symbol[e] : "@@" + e;
};
Nl() && !xl("observable") && (Symbol.observable = Symbol("observable"));
var dy = wl("iterator"), hs = wl("observable"), $m = wl("species");
function ra(e, n) {
  var r = e[n];
  if (r != null) {
    if (typeof r != "function")
      throw new TypeError(r + " is not a function");
    return r;
  }
}
function zr(e) {
  var n = e.constructor;
  return n !== void 0 && (n = n[$m], n === null && (n = void 0)), n !== void 0 ? n : Tn;
}
function uy(e) {
  return e instanceof Tn;
}
function Or(e) {
  Or.log ? Or.log(e) : setTimeout(function() {
    throw e;
  });
}
function Hi(e) {
  Promise.resolve().then(function() {
    try {
      e();
    } catch (n) {
      Or(n);
    }
  });
}
function Tm(e) {
  var n = e._cleanup;
  if (n !== void 0 && (e._cleanup = void 0, !!n))
    try {
      if (typeof n == "function")
        n();
      else {
        var r = ra(n, "unsubscribe");
        r && r.call(n);
      }
    } catch (i) {
      Or(i);
    }
}
function ks(e) {
  e._observer = void 0, e._queue = void 0, e._state = "closed";
}
function my(e) {
  var n = e._queue;
  if (n) {
    e._queue = void 0, e._state = "ready";
    for (var r = 0; r < n.length && (Om(e, n[r].type, n[r].value), e._state !== "closed"); ++r)
      ;
  }
}
function Om(e, n, r) {
  e._state = "running";
  var i = e._observer;
  try {
    var o = ra(i, n);
    switch (n) {
      case "next":
        o && o.call(i, r);
        break;
      case "error":
        if (ks(e), o)
          o.call(i, r);
        else
          throw r;
        break;
      case "complete":
        ks(e), o && o.call(i);
        break;
    }
  } catch (s) {
    Or(s);
  }
  e._state === "closed" ? Tm(e) : e._state === "running" && (e._state = "ready");
}
function Ga(e, n, r) {
  if (e._state !== "closed") {
    if (e._state === "buffering") {
      e._queue.push({
        type: n,
        value: r
      });
      return;
    }
    if (e._state !== "ready") {
      e._state = "buffering", e._queue = [{
        type: n,
        value: r
      }], Hi(function() {
        return my(e);
      });
      return;
    }
    Om(e, n, r);
  }
}
var py = /* @__PURE__ */ function() {
  function e(r, i) {
    this._cleanup = void 0, this._observer = r, this._queue = void 0, this._state = "initializing";
    var o = new fy(this);
    try {
      this._cleanup = i.call(void 0, o);
    } catch (s) {
      o.error(s);
    }
    this._state === "initializing" && (this._state = "ready");
  }
  var n = e.prototype;
  return n.unsubscribe = function() {
    this._state !== "closed" && (ks(this), Tm(this));
  }, Sl(e, [{
    key: "closed",
    get: function() {
      return this._state === "closed";
    }
  }]), e;
}(), fy = /* @__PURE__ */ function() {
  function e(r) {
    this._subscription = r;
  }
  var n = e.prototype;
  return n.next = function(i) {
    Ga(this._subscription, "next", i);
  }, n.error = function(i) {
    Ga(this._subscription, "error", i);
  }, n.complete = function() {
    Ga(this._subscription, "complete");
  }, Sl(e, [{
    key: "closed",
    get: function() {
      return this._subscription._state === "closed";
    }
  }]), e;
}(), Tn = /* @__PURE__ */ function() {
  function e(r) {
    if (!(this instanceof e))
      throw new TypeError("Observable cannot be called as a function");
    if (typeof r != "function")
      throw new TypeError("Observable initializer must be a function");
    this._subscriber = r;
  }
  var n = e.prototype;
  return n.subscribe = function(i) {
    return (typeof i != "object" || i === null) && (i = {
      next: i,
      error: arguments[1],
      complete: arguments[2]
    }), new py(i, this._subscriber);
  }, n.forEach = function(i) {
    var o = this;
    return new Promise(function(s, l) {
      if (typeof i != "function") {
        l(new TypeError(i + " is not a function"));
        return;
      }
      function c() {
        u.unsubscribe(), s();
      }
      var u = o.subscribe({
        next: function(p) {
          try {
            i(p, c);
          } catch (m) {
            l(m), u.unsubscribe();
          }
        },
        error: l,
        complete: s
      });
    });
  }, n.map = function(i) {
    var o = this;
    if (typeof i != "function")
      throw new TypeError(i + " is not a function");
    var s = zr(this);
    return new s(function(l) {
      return o.subscribe({
        next: function(c) {
          try {
            c = i(c);
          } catch (u) {
            return l.error(u);
          }
          l.next(c);
        },
        error: function(c) {
          l.error(c);
        },
        complete: function() {
          l.complete();
        }
      });
    });
  }, n.filter = function(i) {
    var o = this;
    if (typeof i != "function")
      throw new TypeError(i + " is not a function");
    var s = zr(this);
    return new s(function(l) {
      return o.subscribe({
        next: function(c) {
          try {
            if (!i(c))
              return;
          } catch (u) {
            return l.error(u);
          }
          l.next(c);
        },
        error: function(c) {
          l.error(c);
        },
        complete: function() {
          l.complete();
        }
      });
    });
  }, n.reduce = function(i) {
    var o = this;
    if (typeof i != "function")
      throw new TypeError(i + " is not a function");
    var s = zr(this), l = arguments.length > 1, c = !1, u = arguments[1], p = u;
    return new s(function(m) {
      return o.subscribe({
        next: function(v) {
          var y = !c;
          if (c = !0, !y || l)
            try {
              p = i(p, v);
            } catch (b) {
              return m.error(b);
            }
          else
            p = v;
        },
        error: function(v) {
          m.error(v);
        },
        complete: function() {
          if (!c && !l)
            return m.error(new TypeError("Cannot reduce an empty sequence"));
          m.next(p), m.complete();
        }
      });
    });
  }, n.concat = function() {
    for (var i = this, o = arguments.length, s = new Array(o), l = 0; l < o; l++)
      s[l] = arguments[l];
    var c = zr(this);
    return new c(function(u) {
      var p, m = 0;
      function v(y) {
        p = y.subscribe({
          next: function(b) {
            u.next(b);
          },
          error: function(b) {
            u.error(b);
          },
          complete: function() {
            m === s.length ? (p = void 0, u.complete()) : v(c.from(s[m++]));
          }
        });
      }
      return v(i), function() {
        p && (p.unsubscribe(), p = void 0);
      };
    });
  }, n.flatMap = function(i) {
    var o = this;
    if (typeof i != "function")
      throw new TypeError(i + " is not a function");
    var s = zr(this);
    return new s(function(l) {
      var c = [], u = o.subscribe({
        next: function(m) {
          if (i)
            try {
              m = i(m);
            } catch (y) {
              return l.error(y);
            }
          var v = s.from(m).subscribe({
            next: function(y) {
              l.next(y);
            },
            error: function(y) {
              l.error(y);
            },
            complete: function() {
              var y = c.indexOf(v);
              y >= 0 && c.splice(y, 1), p();
            }
          });
          c.push(v);
        },
        error: function(m) {
          l.error(m);
        },
        complete: function() {
          p();
        }
      });
      function p() {
        u.closed && c.length === 0 && l.complete();
      }
      return function() {
        c.forEach(function(m) {
          return m.unsubscribe();
        }), u.unsubscribe();
      };
    });
  }, n[hs] = function() {
    return this;
  }, e.from = function(i) {
    var o = typeof this == "function" ? this : e;
    if (i == null)
      throw new TypeError(i + " is not an object");
    var s = ra(i, hs);
    if (s) {
      var l = s.call(i);
      if (Object(l) !== l)
        throw new TypeError(l + " is not an object");
      return uy(l) && l.constructor === o ? l : new o(function(c) {
        return l.subscribe(c);
      });
    }
    if (xl("iterator") && (s = ra(i, dy), s))
      return new o(function(c) {
        Hi(function() {
          if (!c.closed) {
            for (var u = ly(s.call(i)), p; !(p = u()).done; ) {
              var m = p.value;
              if (c.next(m), c.closed)
                return;
            }
            c.complete();
          }
        });
      });
    if (Array.isArray(i))
      return new o(function(c) {
        Hi(function() {
          if (!c.closed) {
            for (var u = 0; u < i.length; ++u)
              if (c.next(i[u]), c.closed)
                return;
            c.complete();
          }
        });
      });
    throw new TypeError(i + " is not observable");
  }, e.of = function() {
    for (var i = arguments.length, o = new Array(i), s = 0; s < i; s++)
      o[s] = arguments[s];
    var l = typeof this == "function" ? this : e;
    return new l(function(c) {
      Hi(function() {
        if (!c.closed) {
          for (var u = 0; u < o.length; ++u)
            if (c.next(o[u]), c.closed)
              return;
          c.complete();
        }
      });
    });
  }, Sl(e, null, [{
    key: $m,
    get: function() {
      return this;
    }
  }]), e;
}();
Nl() && Object.defineProperty(Tn, Symbol("extensions"), {
  value: {
    symbol: hs,
    hostReportError: Or
  },
  configurable: !0
});
function vy(e) {
  var n, r = e.Symbol;
  if (typeof r == "function")
    if (r.observable)
      n = r.observable;
    else {
      typeof r.for == "function" ? n = r.for("https://github.com/benlesh/symbol-observable") : n = r("https://github.com/benlesh/symbol-observable");
      try {
        r.observable = n;
      } catch {
      }
    }
  else
    n = "@@observable";
  return n;
}
var xr;
typeof self < "u" ? xr = self : typeof window < "u" ? xr = window : typeof global < "u" ? xr = global : typeof module < "u" ? xr = module : xr = Function("return this")();
vy(xr);
var hc = Tn.prototype, kc = "@@observable";
hc[kc] || (hc[kc] = function() {
  return this;
});
function yy(e) {
  for (var n = [
    "query",
    "operationName",
    "variables",
    "extensions",
    "context"
  ], r = 0, i = Object.keys(e); r < i.length; r++) {
    var o = i[r];
    if (n.indexOf(o) < 0)
      throw Fm(43, o);
  }
  return e;
}
function gy(e, n) {
  var r = ir({}, e), i = function(s) {
    typeof s == "function" ? r = ir(ir({}, r), s(r)) : r = ir(ir({}, r), s);
  }, o = function() {
    return ir({}, r);
  };
  return Object.defineProperty(n, "setContext", {
    enumerable: !1,
    value: i
  }), Object.defineProperty(n, "getContext", {
    enumerable: !1,
    value: o
  }), n;
}
function hy(e) {
  var n = {
    variables: e.variables || {},
    extensions: e.extensions || {},
    operationName: e.operationName,
    query: e.query
  };
  return n.operationName || (n.operationName = typeof n.query != "string" ? sy(n.query) || void 0 : ""), n;
}
function bc(e, n) {
  return n ? n(e) : Tn.of();
}
function Hr(e) {
  return typeof e == "function" ? new ha(e) : e;
}
function Ni(e) {
  return e.request.length <= 1;
}
var ha = (
  /** @class */
  function() {
    function e(n) {
      n && (this.request = n);
    }
    return e.empty = function() {
      return new e(function() {
        return Tn.of();
      });
    }, e.from = function(n) {
      return n.length === 0 ? e.empty() : n.map(Hr).reduce(function(r, i) {
        return r.concat(i);
      });
    }, e.split = function(n, r, i) {
      var o = Hr(r), s = Hr(i || new e(bc)), l;
      return Ni(o) && Ni(s) ? l = new e(function(c) {
        return n(c) ? o.request(c) || Tn.of() : s.request(c) || Tn.of();
      }) : l = new e(function(c, u) {
        return n(c) ? o.request(c, u) || Tn.of() : s.request(c, u) || Tn.of();
      }), Object.assign(l, { left: o, right: s });
    }, e.execute = function(n, r) {
      return n.request(gy(r.context, hy(yy(r)))) || Tn.of();
    }, e.concat = function(n, r) {
      var i = Hr(n);
      if (Ni(i))
        return globalThis.__DEV__ !== !1 && oy.warn(35, i), i;
      var o = Hr(r), s;
      return Ni(o) ? s = new e(function(l) {
        return i.request(l, function(c) {
          return o.request(c) || Tn.of();
        }) || Tn.of();
      }) : s = new e(function(l, c) {
        return i.request(l, function(u) {
          return o.request(u, c) || Tn.of();
        }) || Tn.of();
      }), Object.assign(s, { left: i, right: o });
    }, e.prototype.split = function(n, r, i) {
      return this.concat(e.split(n, r, i || new e(bc)));
    }, e.prototype.concat = function(n) {
      return e.concat(this, n);
    }, e.prototype.request = function(n, r) {
      throw Fm(36);
    }, e.prototype.onError = function(n, r) {
      if (r && r.error)
        return r.error(n), !1;
      throw n;
    }, e.prototype.setOnError = function(n) {
      return this.onError = n, this;
    }, e;
  }()
);
function Rm(e) {
  return new ha(function(n, r) {
    var i = Yv(n, []);
    return new Tn(function(o) {
      var s, l = !1;
      return Promise.resolve(i).then(function(c) {
        return e(c, n.getContext());
      }).then(n.setContext).then(function() {
        l || (s = r(n).subscribe({
          next: o.next.bind(o),
          error: o.error.bind(o),
          complete: o.complete.bind(o)
        }));
      }).catch(o.error.bind(o)), function() {
        l = !0, s && s.unsubscribe();
      };
    });
  });
}
function Dm(e, n) {
  return function() {
    return e.apply(n, arguments);
  };
}
const { toString: ky } = Object.prototype, { getPrototypeOf: jl } = Object, ka = /* @__PURE__ */ ((e) => (n) => {
  const r = ky.call(n);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), mt = (e) => (e = e.toLowerCase(), (n) => ka(n) === e), ba = (e) => (n) => typeof n === e, { isArray: Ur } = Array, ai = ba("undefined");
function by(e) {
  return e !== null && !ai(e) && e.constructor !== null && !ai(e.constructor) && Gn(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Pm = mt("ArrayBuffer");
function _y(e) {
  let n;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? n = ArrayBuffer.isView(e) : n = e && e.buffer && Pm(e.buffer), n;
}
const Sy = ba("string"), Gn = ba("function"), Am = ba("number"), _a = (e) => e !== null && typeof e == "object", Ny = (e) => e === !0 || e === !1, Ki = (e) => {
  if (ka(e) !== "object")
    return !1;
  const n = jl(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, xy = mt("Date"), wy = mt("File"), jy = mt("Blob"), Cy = mt("FileList"), Ey = (e) => _a(e) && Gn(e.pipe), Fy = (e) => {
  let n;
  return e && (typeof FormData == "function" && e instanceof FormData || Gn(e.append) && ((n = ka(e)) === "formdata" || // detect form-data instance
  n === "object" && Gn(e.toString) && e.toString() === "[object FormData]"));
}, Iy = mt("URLSearchParams"), $y = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function di(e, n, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let i, o;
  if (typeof e != "object" && (e = [e]), Ur(e))
    for (i = 0, o = e.length; i < o; i++)
      n.call(null, e[i], i, e);
  else {
    const s = r ? Object.getOwnPropertyNames(e) : Object.keys(e), l = s.length;
    let c;
    for (i = 0; i < l; i++)
      c = s[i], n.call(null, e[c], c, e);
  }
}
function Lm(e, n) {
  n = n.toLowerCase();
  const r = Object.keys(e);
  let i = r.length, o;
  for (; i-- > 0; )
    if (o = r[i], n === o.toLowerCase())
      return o;
  return null;
}
const Um = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Mm = (e) => !ai(e) && e !== Um;
function bs() {
  const { caseless: e } = Mm(this) && this || {}, n = {}, r = (i, o) => {
    const s = e && Lm(n, o) || o;
    Ki(n[s]) && Ki(i) ? n[s] = bs(n[s], i) : Ki(i) ? n[s] = bs({}, i) : Ur(i) ? n[s] = i.slice() : n[s] = i;
  };
  for (let i = 0, o = arguments.length; i < o; i++)
    arguments[i] && di(arguments[i], r);
  return n;
}
const Ty = (e, n, r, { allOwnKeys: i } = {}) => (di(n, (o, s) => {
  r && Gn(o) ? e[s] = Dm(o, r) : e[s] = o;
}, { allOwnKeys: i }), e), Oy = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), Ry = (e, n, r, i) => {
  e.prototype = Object.create(n.prototype, i), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: n.prototype
  }), r && Object.assign(e.prototype, r);
}, Dy = (e, n, r, i) => {
  let o, s, l;
  const c = {};
  if (n = n || {}, e == null)
    return n;
  do {
    for (o = Object.getOwnPropertyNames(e), s = o.length; s-- > 0; )
      l = o[s], (!i || i(l, e, n)) && !c[l] && (n[l] = e[l], c[l] = !0);
    e = r !== !1 && jl(e);
  } while (e && (!r || r(e, n)) && e !== Object.prototype);
  return n;
}, Py = (e, n, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= n.length;
  const i = e.indexOf(n, r);
  return i !== -1 && i === r;
}, Ay = (e) => {
  if (!e)
    return null;
  if (Ur(e))
    return e;
  let n = e.length;
  if (!Am(n))
    return null;
  const r = new Array(n);
  for (; n-- > 0; )
    r[n] = e[n];
  return r;
}, Ly = /* @__PURE__ */ ((e) => (n) => e && n instanceof e)(typeof Uint8Array < "u" && jl(Uint8Array)), Uy = (e, n) => {
  const i = (e && e[Symbol.iterator]).call(e);
  let o;
  for (; (o = i.next()) && !o.done; ) {
    const s = o.value;
    n.call(e, s[0], s[1]);
  }
}, My = (e, n) => {
  let r;
  const i = [];
  for (; (r = e.exec(n)) !== null; )
    i.push(r);
  return i;
}, By = mt("HTMLFormElement"), Vy = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(r, i, o) {
    return i.toUpperCase() + o;
  }
), _c = (({ hasOwnProperty: e }) => (n, r) => e.call(n, r))(Object.prototype), qy = mt("RegExp"), Bm = (e, n) => {
  const r = Object.getOwnPropertyDescriptors(e), i = {};
  di(r, (o, s) => {
    let l;
    (l = n(o, s, e)) !== !1 && (i[s] = l || o);
  }), Object.defineProperties(e, i);
}, zy = (e) => {
  Bm(e, (n, r) => {
    if (Gn(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const i = e[r];
    if (Gn(i)) {
      if (n.enumerable = !1, "writable" in n) {
        n.writable = !1;
        return;
      }
      n.set || (n.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, Hy = (e, n) => {
  const r = {}, i = (o) => {
    o.forEach((s) => {
      r[s] = !0;
    });
  };
  return Ur(e) ? i(e) : i(String(e).split(n)), r;
}, Ky = () => {
}, Gy = (e, n) => (e = +e, Number.isFinite(e) ? e : n), Wa = "abcdefghijklmnopqrstuvwxyz", Sc = "0123456789", Vm = {
  DIGIT: Sc,
  ALPHA: Wa,
  ALPHA_DIGIT: Wa + Wa.toUpperCase() + Sc
}, Wy = (e = 16, n = Vm.ALPHA_DIGIT) => {
  let r = "";
  const { length: i } = n;
  for (; e--; )
    r += n[Math.random() * i | 0];
  return r;
};
function Yy(e) {
  return !!(e && Gn(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const Qy = (e) => {
  const n = new Array(10), r = (i, o) => {
    if (_a(i)) {
      if (n.indexOf(i) >= 0)
        return;
      if (!("toJSON" in i)) {
        n[o] = i;
        const s = Ur(i) ? [] : {};
        return di(i, (l, c) => {
          const u = r(l, o + 1);
          !ai(u) && (s[c] = u);
        }), n[o] = void 0, s;
      }
    }
    return i;
  };
  return r(e, 0);
}, Jy = mt("AsyncFunction"), Zy = (e) => e && (_a(e) || Gn(e)) && Gn(e.then) && Gn(e.catch), ee = {
  isArray: Ur,
  isArrayBuffer: Pm,
  isBuffer: by,
  isFormData: Fy,
  isArrayBufferView: _y,
  isString: Sy,
  isNumber: Am,
  isBoolean: Ny,
  isObject: _a,
  isPlainObject: Ki,
  isUndefined: ai,
  isDate: xy,
  isFile: wy,
  isBlob: jy,
  isRegExp: qy,
  isFunction: Gn,
  isStream: Ey,
  isURLSearchParams: Iy,
  isTypedArray: Ly,
  isFileList: Cy,
  forEach: di,
  merge: bs,
  extend: Ty,
  trim: $y,
  stripBOM: Oy,
  inherits: Ry,
  toFlatObject: Dy,
  kindOf: ka,
  kindOfTest: mt,
  endsWith: Py,
  toArray: Ay,
  forEachEntry: Uy,
  matchAll: My,
  isHTMLForm: By,
  hasOwnProperty: _c,
  hasOwnProp: _c,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Bm,
  freezeMethods: zy,
  toObjectSet: Hy,
  toCamelCase: Vy,
  noop: Ky,
  toFiniteNumber: Gy,
  findKey: Lm,
  global: Um,
  isContextDefined: Mm,
  ALPHABET: Vm,
  generateString: Wy,
  isSpecCompliantForm: Yy,
  toJSONObject: Qy,
  isAsyncFn: Jy,
  isThenable: Zy
};
function We(e, n, r, i, o) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", n && (this.code = n), r && (this.config = r), i && (this.request = i), o && (this.response = o);
}
ee.inherits(We, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: ee.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const qm = We.prototype, zm = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  zm[e] = { value: e };
});
Object.defineProperties(We, zm);
Object.defineProperty(qm, "isAxiosError", { value: !0 });
We.from = (e, n, r, i, o, s) => {
  const l = Object.create(qm);
  return ee.toFlatObject(e, l, function(u) {
    return u !== Error.prototype;
  }, (c) => c !== "isAxiosError"), We.call(l, e.message, n, r, i, o), l.cause = e, l.name = e.name, s && Object.assign(l, s), l;
};
const Xy = null;
function _s(e) {
  return ee.isPlainObject(e) || ee.isArray(e);
}
function Hm(e) {
  return ee.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Nc(e, n, r) {
  return e ? e.concat(n).map(function(o, s) {
    return o = Hm(o), !r && s ? "[" + o + "]" : o;
  }).join(r ? "." : "") : n;
}
function eg(e) {
  return ee.isArray(e) && !e.some(_s);
}
const ng = ee.toFlatObject(ee, {}, null, function(n) {
  return /^is[A-Z]/.test(n);
});
function Sa(e, n, r) {
  if (!ee.isObject(e))
    throw new TypeError("target must be an object");
  n = n || new FormData(), r = ee.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(x, T) {
    return !ee.isUndefined(T[x]);
  });
  const i = r.metaTokens, o = r.visitor || m, s = r.dots, l = r.indexes, u = (r.Blob || typeof Blob < "u" && Blob) && ee.isSpecCompliantForm(n);
  if (!ee.isFunction(o))
    throw new TypeError("visitor must be a function");
  function p(N) {
    if (N === null)
      return "";
    if (ee.isDate(N))
      return N.toISOString();
    if (!u && ee.isBlob(N))
      throw new We("Blob is not supported. Use a Buffer instead.");
    return ee.isArrayBuffer(N) || ee.isTypedArray(N) ? u && typeof Blob == "function" ? new Blob([N]) : Buffer.from(N) : N;
  }
  function m(N, x, T) {
    let $ = N;
    if (N && !T && typeof N == "object") {
      if (ee.endsWith(x, "{}"))
        x = i ? x : x.slice(0, -2), N = JSON.stringify(N);
      else if (ee.isArray(N) && eg(N) || (ee.isFileList(N) || ee.endsWith(x, "[]")) && ($ = ee.toArray(N)))
        return x = Hm(x), $.forEach(function(h, E) {
          !(ee.isUndefined(h) || h === null) && n.append(
            // eslint-disable-next-line no-nested-ternary
            l === !0 ? Nc([x], E, s) : l === null ? x : x + "[]",
            p(h)
          );
        }), !1;
    }
    return _s(N) ? !0 : (n.append(Nc(T, x, s), p(N)), !1);
  }
  const v = [], y = Object.assign(ng, {
    defaultVisitor: m,
    convertValue: p,
    isVisitable: _s
  });
  function b(N, x) {
    if (!ee.isUndefined(N)) {
      if (v.indexOf(N) !== -1)
        throw Error("Circular reference detected in " + x.join("."));
      v.push(N), ee.forEach(N, function($, P) {
        (!(ee.isUndefined($) || $ === null) && o.call(
          n,
          $,
          ee.isString(P) ? P.trim() : P,
          x,
          y
        )) === !0 && b($, x ? x.concat(P) : [P]);
      }), v.pop();
    }
  }
  if (!ee.isObject(e))
    throw new TypeError("data must be an object");
  return b(e), n;
}
function xc(e) {
  const n = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(i) {
    return n[i];
  });
}
function Cl(e, n) {
  this._pairs = [], e && Sa(e, this, n);
}
const Km = Cl.prototype;
Km.append = function(n, r) {
  this._pairs.push([n, r]);
};
Km.toString = function(n) {
  const r = n ? function(i) {
    return n.call(this, i, xc);
  } : xc;
  return this._pairs.map(function(o) {
    return r(o[0]) + "=" + r(o[1]);
  }, "").join("&");
};
function tg(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function Gm(e, n, r) {
  if (!n)
    return e;
  const i = r && r.encode || tg, o = r && r.serialize;
  let s;
  if (o ? s = o(n, r) : s = ee.isURLSearchParams(n) ? n.toString() : new Cl(n, r).toString(i), s) {
    const l = e.indexOf("#");
    l !== -1 && (e = e.slice(0, l)), e += (e.indexOf("?") === -1 ? "?" : "&") + s;
  }
  return e;
}
class wc {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(n, r, i) {
    return this.handlers.push({
      fulfilled: n,
      rejected: r,
      synchronous: i ? i.synchronous : !1,
      runWhen: i ? i.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(n) {
    this.handlers[n] && (this.handlers[n] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(n) {
    ee.forEach(this.handlers, function(i) {
      i !== null && n(i);
    });
  }
}
const Wm = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, rg = typeof URLSearchParams < "u" ? URLSearchParams : Cl, ig = typeof FormData < "u" ? FormData : null, ag = typeof Blob < "u" ? Blob : null, og = {
  isBrowser: !0,
  classes: {
    URLSearchParams: rg,
    FormData: ig,
    Blob: ag
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Ym = typeof window < "u" && typeof document < "u", sg = ((e) => Ym && ["ReactNative", "NativeScript", "NS"].indexOf(e) < 0)(typeof navigator < "u" && navigator.product), lg = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", cg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Ym,
  hasStandardBrowserEnv: sg,
  hasStandardBrowserWebWorkerEnv: lg
}, Symbol.toStringTag, { value: "Module" })), ct = {
  ...cg,
  ...og
};
function dg(e, n) {
  return Sa(e, new ct.classes.URLSearchParams(), Object.assign({
    visitor: function(r, i, o, s) {
      return ct.isNode && ee.isBuffer(r) ? (this.append(i, r.toString("base64")), !1) : s.defaultVisitor.apply(this, arguments);
    }
  }, n));
}
function ug(e) {
  return ee.matchAll(/\w+|\[(\w*)]/g, e).map((n) => n[0] === "[]" ? "" : n[1] || n[0]);
}
function mg(e) {
  const n = {}, r = Object.keys(e);
  let i;
  const o = r.length;
  let s;
  for (i = 0; i < o; i++)
    s = r[i], n[s] = e[s];
  return n;
}
function Qm(e) {
  function n(r, i, o, s) {
    let l = r[s++];
    const c = Number.isFinite(+l), u = s >= r.length;
    return l = !l && ee.isArray(o) ? o.length : l, u ? (ee.hasOwnProp(o, l) ? o[l] = [o[l], i] : o[l] = i, !c) : ((!o[l] || !ee.isObject(o[l])) && (o[l] = []), n(r, i, o[l], s) && ee.isArray(o[l]) && (o[l] = mg(o[l])), !c);
  }
  if (ee.isFormData(e) && ee.isFunction(e.entries)) {
    const r = {};
    return ee.forEachEntry(e, (i, o) => {
      n(ug(i), o, r, 0);
    }), r;
  }
  return null;
}
function pg(e, n, r) {
  if (ee.isString(e))
    try {
      return (n || JSON.parse)(e), ee.trim(e);
    } catch (i) {
      if (i.name !== "SyntaxError")
        throw i;
    }
  return (r || JSON.stringify)(e);
}
const El = {
  transitional: Wm,
  adapter: ["xhr", "http"],
  transformRequest: [function(n, r) {
    const i = r.getContentType() || "", o = i.indexOf("application/json") > -1, s = ee.isObject(n);
    if (s && ee.isHTMLForm(n) && (n = new FormData(n)), ee.isFormData(n))
      return o && o ? JSON.stringify(Qm(n)) : n;
    if (ee.isArrayBuffer(n) || ee.isBuffer(n) || ee.isStream(n) || ee.isFile(n) || ee.isBlob(n))
      return n;
    if (ee.isArrayBufferView(n))
      return n.buffer;
    if (ee.isURLSearchParams(n))
      return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), n.toString();
    let c;
    if (s) {
      if (i.indexOf("application/x-www-form-urlencoded") > -1)
        return dg(n, this.formSerializer).toString();
      if ((c = ee.isFileList(n)) || i.indexOf("multipart/form-data") > -1) {
        const u = this.env && this.env.FormData;
        return Sa(
          c ? { "files[]": n } : n,
          u && new u(),
          this.formSerializer
        );
      }
    }
    return s || o ? (r.setContentType("application/json", !1), pg(n)) : n;
  }],
  transformResponse: [function(n) {
    const r = this.transitional || El.transitional, i = r && r.forcedJSONParsing, o = this.responseType === "json";
    if (n && ee.isString(n) && (i && !this.responseType || o)) {
      const l = !(r && r.silentJSONParsing) && o;
      try {
        return JSON.parse(n);
      } catch (c) {
        if (l)
          throw c.name === "SyntaxError" ? We.from(c, We.ERR_BAD_RESPONSE, this, null, this.response) : c;
      }
    }
    return n;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: ct.classes.FormData,
    Blob: ct.classes.Blob
  },
  validateStatus: function(n) {
    return n >= 200 && n < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
ee.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  El.headers[e] = {};
});
const Fl = El, fg = ee.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), vg = (e) => {
  const n = {};
  let r, i, o;
  return e && e.split(`
`).forEach(function(l) {
    o = l.indexOf(":"), r = l.substring(0, o).trim().toLowerCase(), i = l.substring(o + 1).trim(), !(!r || n[r] && fg[r]) && (r === "set-cookie" ? n[r] ? n[r].push(i) : n[r] = [i] : n[r] = n[r] ? n[r] + ", " + i : i);
  }), n;
}, jc = Symbol("internals");
function Kr(e) {
  return e && String(e).trim().toLowerCase();
}
function Gi(e) {
  return e === !1 || e == null ? e : ee.isArray(e) ? e.map(Gi) : String(e);
}
function yg(e) {
  const n = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let i;
  for (; i = r.exec(e); )
    n[i[1]] = i[2];
  return n;
}
const gg = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function Ya(e, n, r, i, o) {
  if (ee.isFunction(i))
    return i.call(this, n, r);
  if (o && (n = r), !!ee.isString(n)) {
    if (ee.isString(i))
      return n.indexOf(i) !== -1;
    if (ee.isRegExp(i))
      return i.test(n);
  }
}
function hg(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (n, r, i) => r.toUpperCase() + i);
}
function kg(e, n) {
  const r = ee.toCamelCase(" " + n);
  ["get", "set", "has"].forEach((i) => {
    Object.defineProperty(e, i + r, {
      value: function(o, s, l) {
        return this[i].call(this, n, o, s, l);
      },
      configurable: !0
    });
  });
}
let Na = class {
  constructor(n) {
    n && this.set(n);
  }
  set(n, r, i) {
    const o = this;
    function s(c, u, p) {
      const m = Kr(u);
      if (!m)
        throw new Error("header name must be a non-empty string");
      const v = ee.findKey(o, m);
      (!v || o[v] === void 0 || p === !0 || p === void 0 && o[v] !== !1) && (o[v || u] = Gi(c));
    }
    const l = (c, u) => ee.forEach(c, (p, m) => s(p, m, u));
    return ee.isPlainObject(n) || n instanceof this.constructor ? l(n, r) : ee.isString(n) && (n = n.trim()) && !gg(n) ? l(vg(n), r) : n != null && s(r, n, i), this;
  }
  get(n, r) {
    if (n = Kr(n), n) {
      const i = ee.findKey(this, n);
      if (i) {
        const o = this[i];
        if (!r)
          return o;
        if (r === !0)
          return yg(o);
        if (ee.isFunction(r))
          return r.call(this, o, i);
        if (ee.isRegExp(r))
          return r.exec(o);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(n, r) {
    if (n = Kr(n), n) {
      const i = ee.findKey(this, n);
      return !!(i && this[i] !== void 0 && (!r || Ya(this, this[i], i, r)));
    }
    return !1;
  }
  delete(n, r) {
    const i = this;
    let o = !1;
    function s(l) {
      if (l = Kr(l), l) {
        const c = ee.findKey(i, l);
        c && (!r || Ya(i, i[c], c, r)) && (delete i[c], o = !0);
      }
    }
    return ee.isArray(n) ? n.forEach(s) : s(n), o;
  }
  clear(n) {
    const r = Object.keys(this);
    let i = r.length, o = !1;
    for (; i--; ) {
      const s = r[i];
      (!n || Ya(this, this[s], s, n, !0)) && (delete this[s], o = !0);
    }
    return o;
  }
  normalize(n) {
    const r = this, i = {};
    return ee.forEach(this, (o, s) => {
      const l = ee.findKey(i, s);
      if (l) {
        r[l] = Gi(o), delete r[s];
        return;
      }
      const c = n ? hg(s) : String(s).trim();
      c !== s && delete r[s], r[c] = Gi(o), i[c] = !0;
    }), this;
  }
  concat(...n) {
    return this.constructor.concat(this, ...n);
  }
  toJSON(n) {
    const r = /* @__PURE__ */ Object.create(null);
    return ee.forEach(this, (i, o) => {
      i != null && i !== !1 && (r[o] = n && ee.isArray(i) ? i.join(", ") : i);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([n, r]) => n + ": " + r).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(n) {
    return n instanceof this ? n : new this(n);
  }
  static concat(n, ...r) {
    const i = new this(n);
    return r.forEach((o) => i.set(o)), i;
  }
  static accessor(n) {
    const i = (this[jc] = this[jc] = {
      accessors: {}
    }).accessors, o = this.prototype;
    function s(l) {
      const c = Kr(l);
      i[c] || (kg(o, l), i[c] = !0);
    }
    return ee.isArray(n) ? n.forEach(s) : s(n), this;
  }
};
Na.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
ee.reduceDescriptors(Na.prototype, ({ value: e }, n) => {
  let r = n[0].toUpperCase() + n.slice(1);
  return {
    get: () => e,
    set(i) {
      this[r] = i;
    }
  };
});
ee.freezeMethods(Na);
const xt = Na;
function Qa(e, n) {
  const r = this || Fl, i = n || r, o = xt.from(i.headers);
  let s = i.data;
  return ee.forEach(e, function(c) {
    s = c.call(r, s, o.normalize(), n ? n.status : void 0);
  }), o.normalize(), s;
}
function Jm(e) {
  return !!(e && e.__CANCEL__);
}
function ui(e, n, r) {
  We.call(this, e ?? "canceled", We.ERR_CANCELED, n, r), this.name = "CanceledError";
}
ee.inherits(ui, We, {
  __CANCEL__: !0
});
function bg(e, n, r) {
  const i = r.config.validateStatus;
  !r.status || !i || i(r.status) ? e(r) : n(new We(
    "Request failed with status code " + r.status,
    [We.ERR_BAD_REQUEST, We.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
    r.config,
    r.request,
    r
  ));
}
const _g = ct.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, n, r, i, o, s) {
      const l = [e + "=" + encodeURIComponent(n)];
      ee.isNumber(r) && l.push("expires=" + new Date(r).toGMTString()), ee.isString(i) && l.push("path=" + i), ee.isString(o) && l.push("domain=" + o), s === !0 && l.push("secure"), document.cookie = l.join("; ");
    },
    read(e) {
      const n = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return n ? decodeURIComponent(n[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function Sg(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function Ng(e, n) {
  return n ? e.replace(/\/+$/, "") + "/" + n.replace(/^\/+/, "") : e;
}
function Zm(e, n) {
  return e && !Sg(n) ? Ng(e, n) : n;
}
const xg = ct.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const n = /(msie|trident)/i.test(navigator.userAgent), r = document.createElement("a");
    let i;
    function o(s) {
      let l = s;
      return n && (r.setAttribute("href", l), l = r.href), r.setAttribute("href", l), {
        href: r.href,
        protocol: r.protocol ? r.protocol.replace(/:$/, "") : "",
        host: r.host,
        search: r.search ? r.search.replace(/^\?/, "") : "",
        hash: r.hash ? r.hash.replace(/^#/, "") : "",
        hostname: r.hostname,
        port: r.port,
        pathname: r.pathname.charAt(0) === "/" ? r.pathname : "/" + r.pathname
      };
    }
    return i = o(window.location.href), function(l) {
      const c = ee.isString(l) ? o(l) : l;
      return c.protocol === i.protocol && c.host === i.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function() {
    return function() {
      return !0;
    };
  }()
);
function wg(e) {
  const n = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return n && n[1] || "";
}
function jg(e, n) {
  e = e || 10;
  const r = new Array(e), i = new Array(e);
  let o = 0, s = 0, l;
  return n = n !== void 0 ? n : 1e3, function(u) {
    const p = Date.now(), m = i[s];
    l || (l = p), r[o] = u, i[o] = p;
    let v = s, y = 0;
    for (; v !== o; )
      y += r[v++], v = v % e;
    if (o = (o + 1) % e, o === s && (s = (s + 1) % e), p - l < n)
      return;
    const b = m && p - m;
    return b ? Math.round(y * 1e3 / b) : void 0;
  };
}
function Cc(e, n) {
  let r = 0;
  const i = jg(50, 250);
  return (o) => {
    const s = o.loaded, l = o.lengthComputable ? o.total : void 0, c = s - r, u = i(c), p = s <= l;
    r = s;
    const m = {
      loaded: s,
      total: l,
      progress: l ? s / l : void 0,
      bytes: c,
      rate: u || void 0,
      estimated: u && l && p ? (l - s) / u : void 0,
      event: o
    };
    m[n ? "download" : "upload"] = !0, e(m);
  };
}
const Cg = typeof XMLHttpRequest < "u", Eg = Cg && function(e) {
  return new Promise(function(r, i) {
    let o = e.data;
    const s = xt.from(e.headers).normalize();
    let { responseType: l, withXSRFToken: c } = e, u;
    function p() {
      e.cancelToken && e.cancelToken.unsubscribe(u), e.signal && e.signal.removeEventListener("abort", u);
    }
    let m;
    if (ee.isFormData(o)) {
      if (ct.hasStandardBrowserEnv || ct.hasStandardBrowserWebWorkerEnv)
        s.setContentType(!1);
      else if ((m = s.getContentType()) !== !1) {
        const [x, ...T] = m ? m.split(";").map(($) => $.trim()).filter(Boolean) : [];
        s.setContentType([x || "multipart/form-data", ...T].join("; "));
      }
    }
    let v = new XMLHttpRequest();
    if (e.auth) {
      const x = e.auth.username || "", T = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : "";
      s.set("Authorization", "Basic " + btoa(x + ":" + T));
    }
    const y = Zm(e.baseURL, e.url);
    v.open(e.method.toUpperCase(), Gm(y, e.params, e.paramsSerializer), !0), v.timeout = e.timeout;
    function b() {
      if (!v)
        return;
      const x = xt.from(
        "getAllResponseHeaders" in v && v.getAllResponseHeaders()
      ), $ = {
        data: !l || l === "text" || l === "json" ? v.responseText : v.response,
        status: v.status,
        statusText: v.statusText,
        headers: x,
        config: e,
        request: v
      };
      bg(function(h) {
        r(h), p();
      }, function(h) {
        i(h), p();
      }, $), v = null;
    }
    if ("onloadend" in v ? v.onloadend = b : v.onreadystatechange = function() {
      !v || v.readyState !== 4 || v.status === 0 && !(v.responseURL && v.responseURL.indexOf("file:") === 0) || setTimeout(b);
    }, v.onabort = function() {
      v && (i(new We("Request aborted", We.ECONNABORTED, e, v)), v = null);
    }, v.onerror = function() {
      i(new We("Network Error", We.ERR_NETWORK, e, v)), v = null;
    }, v.ontimeout = function() {
      let T = e.timeout ? "timeout of " + e.timeout + "ms exceeded" : "timeout exceeded";
      const $ = e.transitional || Wm;
      e.timeoutErrorMessage && (T = e.timeoutErrorMessage), i(new We(
        T,
        $.clarifyTimeoutError ? We.ETIMEDOUT : We.ECONNABORTED,
        e,
        v
      )), v = null;
    }, ct.hasStandardBrowserEnv && (c && ee.isFunction(c) && (c = c(e)), c || c !== !1 && xg(y))) {
      const x = e.xsrfHeaderName && e.xsrfCookieName && _g.read(e.xsrfCookieName);
      x && s.set(e.xsrfHeaderName, x);
    }
    o === void 0 && s.setContentType(null), "setRequestHeader" in v && ee.forEach(s.toJSON(), function(T, $) {
      v.setRequestHeader($, T);
    }), ee.isUndefined(e.withCredentials) || (v.withCredentials = !!e.withCredentials), l && l !== "json" && (v.responseType = e.responseType), typeof e.onDownloadProgress == "function" && v.addEventListener("progress", Cc(e.onDownloadProgress, !0)), typeof e.onUploadProgress == "function" && v.upload && v.upload.addEventListener("progress", Cc(e.onUploadProgress)), (e.cancelToken || e.signal) && (u = (x) => {
      v && (i(!x || x.type ? new ui(null, e, v) : x), v.abort(), v = null);
    }, e.cancelToken && e.cancelToken.subscribe(u), e.signal && (e.signal.aborted ? u() : e.signal.addEventListener("abort", u)));
    const N = wg(y);
    if (N && ct.protocols.indexOf(N) === -1) {
      i(new We("Unsupported protocol " + N + ":", We.ERR_BAD_REQUEST, e));
      return;
    }
    v.send(o || null);
  });
}, Ss = {
  http: Xy,
  xhr: Eg
};
ee.forEach(Ss, (e, n) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: n });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: n });
  }
});
const Ec = (e) => `- ${e}`, Fg = (e) => ee.isFunction(e) || e === null || e === !1, Xm = {
  getAdapter: (e) => {
    e = ee.isArray(e) ? e : [e];
    const { length: n } = e;
    let r, i;
    const o = {};
    for (let s = 0; s < n; s++) {
      r = e[s];
      let l;
      if (i = r, !Fg(r) && (i = Ss[(l = String(r)).toLowerCase()], i === void 0))
        throw new We(`Unknown adapter '${l}'`);
      if (i)
        break;
      o[l || "#" + s] = i;
    }
    if (!i) {
      const s = Object.entries(o).map(
        ([c, u]) => `adapter ${c} ` + (u === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let l = n ? s.length > 1 ? `since :
` + s.map(Ec).join(`
`) : " " + Ec(s[0]) : "as no adapter specified";
      throw new We(
        "There is no suitable adapter to dispatch the request " + l,
        "ERR_NOT_SUPPORT"
      );
    }
    return i;
  },
  adapters: Ss
};
function Ja(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new ui(null, e);
}
function Fc(e) {
  return Ja(e), e.headers = xt.from(e.headers), e.data = Qa.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Xm.getAdapter(e.adapter || Fl.adapter)(e).then(function(i) {
    return Ja(e), i.data = Qa.call(
      e,
      e.transformResponse,
      i
    ), i.headers = xt.from(i.headers), i;
  }, function(i) {
    return Jm(i) || (Ja(e), i && i.response && (i.response.data = Qa.call(
      e,
      e.transformResponse,
      i.response
    ), i.response.headers = xt.from(i.response.headers))), Promise.reject(i);
  });
}
const Ic = (e) => e instanceof xt ? e.toJSON() : e;
function Rr(e, n) {
  n = n || {};
  const r = {};
  function i(p, m, v) {
    return ee.isPlainObject(p) && ee.isPlainObject(m) ? ee.merge.call({ caseless: v }, p, m) : ee.isPlainObject(m) ? ee.merge({}, m) : ee.isArray(m) ? m.slice() : m;
  }
  function o(p, m, v) {
    if (ee.isUndefined(m)) {
      if (!ee.isUndefined(p))
        return i(void 0, p, v);
    } else
      return i(p, m, v);
  }
  function s(p, m) {
    if (!ee.isUndefined(m))
      return i(void 0, m);
  }
  function l(p, m) {
    if (ee.isUndefined(m)) {
      if (!ee.isUndefined(p))
        return i(void 0, p);
    } else
      return i(void 0, m);
  }
  function c(p, m, v) {
    if (v in n)
      return i(p, m);
    if (v in e)
      return i(void 0, p);
  }
  const u = {
    url: s,
    method: s,
    data: s,
    baseURL: l,
    transformRequest: l,
    transformResponse: l,
    paramsSerializer: l,
    timeout: l,
    timeoutMessage: l,
    withCredentials: l,
    withXSRFToken: l,
    adapter: l,
    responseType: l,
    xsrfCookieName: l,
    xsrfHeaderName: l,
    onUploadProgress: l,
    onDownloadProgress: l,
    decompress: l,
    maxContentLength: l,
    maxBodyLength: l,
    beforeRedirect: l,
    transport: l,
    httpAgent: l,
    httpsAgent: l,
    cancelToken: l,
    socketPath: l,
    responseEncoding: l,
    validateStatus: c,
    headers: (p, m) => o(Ic(p), Ic(m), !0)
  };
  return ee.forEach(Object.keys(Object.assign({}, e, n)), function(m) {
    const v = u[m] || o, y = v(e[m], n[m], m);
    ee.isUndefined(y) && v !== c || (r[m] = y);
  }), r;
}
const ep = "1.6.2", Il = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, n) => {
  Il[e] = function(i) {
    return typeof i === e || "a" + (n < 1 ? "n " : " ") + e;
  };
});
const $c = {};
Il.transitional = function(n, r, i) {
  function o(s, l) {
    return "[Axios v" + ep + "] Transitional option '" + s + "'" + l + (i ? ". " + i : "");
  }
  return (s, l, c) => {
    if (n === !1)
      throw new We(
        o(l, " has been removed" + (r ? " in " + r : "")),
        We.ERR_DEPRECATED
      );
    return r && !$c[l] && ($c[l] = !0, console.warn(
      o(
        l,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), n ? n(s, l, c) : !0;
  };
};
function Ig(e, n, r) {
  if (typeof e != "object")
    throw new We("options must be an object", We.ERR_BAD_OPTION_VALUE);
  const i = Object.keys(e);
  let o = i.length;
  for (; o-- > 0; ) {
    const s = i[o], l = n[s];
    if (l) {
      const c = e[s], u = c === void 0 || l(c, s, e);
      if (u !== !0)
        throw new We("option " + s + " must be " + u, We.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new We("Unknown option " + s, We.ERR_BAD_OPTION);
  }
}
const Ns = {
  assertOptions: Ig,
  validators: Il
}, $t = Ns.validators;
let ia = class {
  constructor(n) {
    this.defaults = n, this.interceptors = {
      request: new wc(),
      response: new wc()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(n, r) {
    typeof n == "string" ? (r = r || {}, r.url = n) : r = n || {}, r = Rr(this.defaults, r);
    const { transitional: i, paramsSerializer: o, headers: s } = r;
    i !== void 0 && Ns.assertOptions(i, {
      silentJSONParsing: $t.transitional($t.boolean),
      forcedJSONParsing: $t.transitional($t.boolean),
      clarifyTimeoutError: $t.transitional($t.boolean)
    }, !1), o != null && (ee.isFunction(o) ? r.paramsSerializer = {
      serialize: o
    } : Ns.assertOptions(o, {
      encode: $t.function,
      serialize: $t.function
    }, !0)), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let l = s && ee.merge(
      s.common,
      s[r.method]
    );
    s && ee.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (N) => {
        delete s[N];
      }
    ), r.headers = xt.concat(l, s);
    const c = [];
    let u = !0;
    this.interceptors.request.forEach(function(x) {
      typeof x.runWhen == "function" && x.runWhen(r) === !1 || (u = u && x.synchronous, c.unshift(x.fulfilled, x.rejected));
    });
    const p = [];
    this.interceptors.response.forEach(function(x) {
      p.push(x.fulfilled, x.rejected);
    });
    let m, v = 0, y;
    if (!u) {
      const N = [Fc.bind(this), void 0];
      for (N.unshift.apply(N, c), N.push.apply(N, p), y = N.length, m = Promise.resolve(r); v < y; )
        m = m.then(N[v++], N[v++]);
      return m;
    }
    y = c.length;
    let b = r;
    for (v = 0; v < y; ) {
      const N = c[v++], x = c[v++];
      try {
        b = N(b);
      } catch (T) {
        x.call(this, T);
        break;
      }
    }
    try {
      m = Fc.call(this, b);
    } catch (N) {
      return Promise.reject(N);
    }
    for (v = 0, y = p.length; v < y; )
      m = m.then(p[v++], p[v++]);
    return m;
  }
  getUri(n) {
    n = Rr(this.defaults, n);
    const r = Zm(n.baseURL, n.url);
    return Gm(r, n.params, n.paramsSerializer);
  }
};
ee.forEach(["delete", "get", "head", "options"], function(n) {
  ia.prototype[n] = function(r, i) {
    return this.request(Rr(i || {}, {
      method: n,
      url: r,
      data: (i || {}).data
    }));
  };
});
ee.forEach(["post", "put", "patch"], function(n) {
  function r(i) {
    return function(s, l, c) {
      return this.request(Rr(c || {}, {
        method: n,
        headers: i ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: s,
        data: l
      }));
    };
  }
  ia.prototype[n] = r(), ia.prototype[n + "Form"] = r(!0);
});
const Wi = ia;
let $g = class np {
  constructor(n) {
    if (typeof n != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(s) {
      r = s;
    });
    const i = this;
    this.promise.then((o) => {
      if (!i._listeners)
        return;
      let s = i._listeners.length;
      for (; s-- > 0; )
        i._listeners[s](o);
      i._listeners = null;
    }), this.promise.then = (o) => {
      let s;
      const l = new Promise((c) => {
        i.subscribe(c), s = c;
      }).then(o);
      return l.cancel = function() {
        i.unsubscribe(s);
      }, l;
    }, n(function(s, l, c) {
      i.reason || (i.reason = new ui(s, l, c), r(i.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(n) {
    if (this.reason) {
      n(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(n) : this._listeners = [n];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(n) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(n);
    r !== -1 && this._listeners.splice(r, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let n;
    return {
      token: new np(function(o) {
        n = o;
      }),
      cancel: n
    };
  }
};
const Tg = $g;
function Og(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function Rg(e) {
  return ee.isObject(e) && e.isAxiosError === !0;
}
const xs = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(xs).forEach(([e, n]) => {
  xs[n] = e;
});
const Dg = xs;
function tp(e) {
  const n = new Wi(e), r = Dm(Wi.prototype.request, n);
  return ee.extend(r, Wi.prototype, n, { allOwnKeys: !0 }), ee.extend(r, n, null, { allOwnKeys: !0 }), r.create = function(o) {
    return tp(Rr(e, o));
  }, r;
}
const xn = tp(Fl);
xn.Axios = Wi;
xn.CanceledError = ui;
xn.CancelToken = Tg;
xn.isCancel = Jm;
xn.VERSION = ep;
xn.toFormData = Sa;
xn.AxiosError = We;
xn.Cancel = xn.CanceledError;
xn.all = function(n) {
  return Promise.all(n);
};
xn.spread = Og;
xn.isAxiosError = Rg;
xn.mergeConfig = Rr;
xn.AxiosHeaders = xt;
xn.formToJSON = (e) => Qm(ee.isHTMLForm(e) ? new FormData(e) : e);
xn.getAdapter = Xm.getAdapter;
xn.HttpStatusCode = Dg;
xn.default = xn;
const {
  Axios: $R,
  AxiosError: TR,
  CanceledError: OR,
  isCancel: RR,
  CancelToken: DR,
  VERSION: PR,
  all: AR,
  Cancel: LR,
  isAxiosError: Pg,
  spread: UR,
  toFormData: MR,
  AxiosHeaders: BR,
  HttpStatusCode: VR,
  formToJSON: qR,
  getAdapter: zR,
  mergeConfig: HR
} = xn;
var Za = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ag(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var xi = function(e) {
  return e && e.Math === Math && e;
}, Rn = (
  // eslint-disable-next-line es/no-global-this -- safe
  xi(typeof globalThis == "object" && globalThis) || xi(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  xi(typeof self == "object" && self) || xi(typeof Za == "object" && Za) || // eslint-disable-next-line no-new-func -- fallback
  /* @__PURE__ */ function() {
    return this;
  }() || Za || Function("return this")()
), qn = function(e) {
  try {
    return !!e();
  } catch {
    return !0;
  }
}, Lg = qn, xa = !Lg(function() {
  var e = (function() {
  }).bind();
  return typeof e != "function" || e.hasOwnProperty("prototype");
}), Ug = xa, rp = Function.prototype, Tc = rp.apply, Oc = rp.call, ip = typeof Reflect == "object" && Reflect.apply || (Ug ? Oc.bind(Tc) : function() {
  return Oc.apply(Tc, arguments);
}), ap = xa, op = Function.prototype, ws = op.call, Mg = ap && op.bind.bind(ws, ws), Un = ap ? Mg : function(e) {
  return function() {
    return ws.apply(e, arguments);
  };
}, sp = Un, Bg = sp({}.toString), Vg = sp("".slice), wa = function(e) {
  return Vg(Bg(e), 8, -1);
}, qg = wa, zg = Un, lp = function(e) {
  if (qg(e) === "Function")
    return zg(e);
}, js = typeof document == "object" && document.all, Hg = typeof js > "u" && js !== void 0, cp = {
  all: js,
  IS_HTMLDDA: Hg
}, dp = cp, Kg = dp.all, $n = dp.IS_HTMLDDA ? function(e) {
  return typeof e == "function" || e === Kg;
} : function(e) {
  return typeof e == "function";
}, ja = {}, Gg = qn, Vt = !Gg(function() {
  return Object.defineProperty({}, 1, { get: function() {
    return 7;
  } })[1] !== 7;
}), Wg = xa, wi = Function.prototype.call, zn = Wg ? wi.bind(wi) : function() {
  return wi.apply(wi, arguments);
}, up = {}, mp = {}.propertyIsEnumerable, pp = Object.getOwnPropertyDescriptor, Yg = pp && !mp.call({ 1: 2 }, 1);
up.f = Yg ? function(n) {
  var r = pp(this, n);
  return !!r && r.enumerable;
} : mp;
var mi = function(e, n) {
  return {
    enumerable: !(e & 1),
    configurable: !(e & 2),
    writable: !(e & 4),
    value: n
  };
}, Qg = Un, Jg = qn, Zg = wa, Xa = Object, Xg = Qg("".split), eh = Jg(function() {
  return !Xa("z").propertyIsEnumerable(0);
}) ? function(e) {
  return Zg(e) === "String" ? Xg(e, "") : Xa(e);
} : Xa, Ca = function(e) {
  return e == null;
}, nh = Ca, th = TypeError, $l = function(e) {
  if (nh(e))
    throw th("Can't call method on " + e);
  return e;
}, rh = eh, ih = $l, pi = function(e) {
  return rh(ih(e));
}, Rc = $n, fp = cp, ah = fp.all, Ft = fp.IS_HTMLDDA ? function(e) {
  return typeof e == "object" ? e !== null : Rc(e) || e === ah;
} : function(e) {
  return typeof e == "object" ? e !== null : Rc(e);
}, Tl = {}, eo = Tl, no = Rn, oh = $n, Dc = function(e) {
  return oh(e) ? e : void 0;
}, qt = function(e, n) {
  return arguments.length < 2 ? Dc(eo[e]) || Dc(no[e]) : eo[e] && eo[e][n] || no[e] && no[e][n];
}, sh = Un, Ea = sh({}.isPrototypeOf), Fa = typeof navigator < "u" && String(navigator.userAgent) || "", vp = Rn, to = Fa, Pc = vp.process, Ac = vp.Deno, Lc = Pc && Pc.versions || Ac && Ac.version, Uc = Lc && Lc.v8, tt, aa;
Uc && (tt = Uc.split("."), aa = tt[0] > 0 && tt[0] < 4 ? 1 : +(tt[0] + tt[1]));
!aa && to && (tt = to.match(/Edge\/(\d+)/), (!tt || tt[1] >= 74) && (tt = to.match(/Chrome\/(\d+)/), tt && (aa = +tt[1])));
var yp = aa, Mc = yp, lh = qn, ch = Rn, dh = ch.String, gp = !!Object.getOwnPropertySymbols && !lh(function() {
  var e = Symbol("symbol detection");
  return !dh(e) || !(Object(e) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && Mc && Mc < 41;
}), uh = gp, hp = uh && !Symbol.sham && typeof Symbol.iterator == "symbol", mh = qt, ph = $n, fh = Ea, vh = hp, yh = Object, kp = vh ? function(e) {
  return typeof e == "symbol";
} : function(e) {
  var n = mh("Symbol");
  return ph(n) && fh(n.prototype, yh(e));
}, gh = String, Ia = function(e) {
  try {
    return gh(e);
  } catch {
    return "Object";
  }
}, hh = $n, kh = Ia, bh = TypeError, pt = function(e) {
  if (hh(e))
    return e;
  throw bh(kh(e) + " is not a function");
}, _h = pt, Sh = Ca, Ol = function(e, n) {
  var r = e[n];
  return Sh(r) ? void 0 : _h(r);
}, ro = zn, io = $n, ao = Ft, Nh = TypeError, xh = function(e, n) {
  var r, i;
  if (n === "string" && io(r = e.toString) && !ao(i = ro(r, e)) || io(r = e.valueOf) && !ao(i = ro(r, e)) || n !== "string" && io(r = e.toString) && !ao(i = ro(r, e)))
    return i;
  throw Nh("Can't convert object to primitive value");
}, bp = { exports: {} }, wh = !0, Bc = Rn, jh = Object.defineProperty, Ch = function(e, n) {
  try {
    jh(Bc, e, { value: n, configurable: !0, writable: !0 });
  } catch {
    Bc[e] = n;
  }
  return n;
}, Eh = Rn, Fh = Ch, Vc = "__core-js_shared__", Ih = Eh[Vc] || Fh(Vc, {}), Rl = Ih, qc = Rl;
(bp.exports = function(e, n) {
  return qc[e] || (qc[e] = n !== void 0 ? n : {});
})("versions", []).push({
  version: "3.32.1",
  mode: "pure",
  copyright: "© 2014-2023 Denis Pushkarev (zloirock.ru)",
  license: "https://github.com/zloirock/core-js/blob/v3.32.1/LICENSE",
  source: "https://github.com/zloirock/core-js"
});
var _p = bp.exports, $h = $l, Th = Object, Sp = function(e) {
  return Th($h(e));
}, Oh = Un, Rh = Sp, Dh = Oh({}.hasOwnProperty), ft = Object.hasOwn || function(n, r) {
  return Dh(Rh(n), r);
}, Ph = Un, Ah = 0, Lh = Math.random(), Uh = Ph(1 .toString), Np = function(e) {
  return "Symbol(" + (e === void 0 ? "" : e) + ")_" + Uh(++Ah + Lh, 36);
}, Mh = Rn, Bh = _p, zc = ft, Vh = Np, qh = gp, zh = hp, wr = Mh.Symbol, oo = Bh("wks"), Hh = zh ? wr.for || wr : wr && wr.withoutSetter || Vh, Mn = function(e) {
  return zc(oo, e) || (oo[e] = qh && zc(wr, e) ? wr[e] : Hh("Symbol." + e)), oo[e];
}, Kh = zn, Hc = Ft, Kc = kp, Gh = Ol, Wh = xh, Yh = Mn, Qh = TypeError, Jh = Yh("toPrimitive"), Zh = function(e, n) {
  if (!Hc(e) || Kc(e))
    return e;
  var r = Gh(e, Jh), i;
  if (r) {
    if (n === void 0 && (n = "default"), i = Kh(r, e, n), !Hc(i) || Kc(i))
      return i;
    throw Qh("Can't convert object to primitive value");
  }
  return n === void 0 && (n = "number"), Wh(e, n);
}, Xh = Zh, ek = kp, xp = function(e) {
  var n = Xh(e, "string");
  return ek(n) ? n : n + "";
}, nk = Rn, Gc = Ft, Cs = nk.document, tk = Gc(Cs) && Gc(Cs.createElement), Dl = function(e) {
  return tk ? Cs.createElement(e) : {};
}, rk = Vt, ik = qn, ak = Dl, wp = !rk && !ik(function() {
  return Object.defineProperty(ak("div"), "a", {
    get: function() {
      return 7;
    }
  }).a !== 7;
}), ok = Vt, sk = zn, lk = up, ck = mi, dk = pi, uk = xp, mk = ft, pk = wp, Wc = Object.getOwnPropertyDescriptor;
ja.f = ok ? Wc : function(n, r) {
  if (n = dk(n), r = uk(r), pk)
    try {
      return Wc(n, r);
    } catch {
    }
  if (mk(n, r))
    return ck(!sk(lk.f, n, r), n[r]);
};
var fk = qn, vk = $n, yk = /#|\.prototype\./, fi = function(e, n) {
  var r = hk[gk(e)];
  return r === bk ? !0 : r === kk ? !1 : vk(n) ? fk(n) : !!n;
}, gk = fi.normalize = function(e) {
  return String(e).replace(yk, ".").toLowerCase();
}, hk = fi.data = {}, kk = fi.NATIVE = "N", bk = fi.POLYFILL = "P", jp = fi, Yc = lp, _k = pt, Sk = xa, Nk = Yc(Yc.bind), $a = function(e, n) {
  return _k(e), n === void 0 ? e : Sk ? Nk(e, n) : function() {
    return e.apply(n, arguments);
  };
}, nr = {}, xk = Vt, wk = qn, Cp = xk && wk(function() {
  return Object.defineProperty(function() {
  }, "prototype", {
    value: 42,
    writable: !1
  }).prototype !== 42;
}), jk = Ft, Ck = String, Ek = TypeError, vt = function(e) {
  if (jk(e))
    return e;
  throw Ek(Ck(e) + " is not an object");
}, Fk = Vt, Ik = wp, $k = Cp, ji = vt, Qc = xp, Tk = TypeError, so = Object.defineProperty, Ok = Object.getOwnPropertyDescriptor, lo = "enumerable", co = "configurable", uo = "writable";
nr.f = Fk ? $k ? function(n, r, i) {
  if (ji(n), r = Qc(r), ji(i), typeof n == "function" && r === "prototype" && "value" in i && uo in i && !i[uo]) {
    var o = Ok(n, r);
    o && o[uo] && (n[r] = i.value, i = {
      configurable: co in i ? i[co] : o[co],
      enumerable: lo in i ? i[lo] : o[lo],
      writable: !1
    });
  }
  return so(n, r, i);
} : so : function(n, r, i) {
  if (ji(n), r = Qc(r), ji(i), Ik)
    try {
      return so(n, r, i);
    } catch {
    }
  if ("get" in i || "set" in i)
    throw Tk("Accessors not supported");
  return "value" in i && (n[r] = i.value), n;
};
var Rk = Vt, Dk = nr, Pk = mi, zt = Rk ? function(e, n, r) {
  return Dk.f(e, n, Pk(1, r));
} : function(e, n, r) {
  return e[n] = r, e;
}, Ci = Rn, Ak = ip, Lk = lp, Uk = $n, Mk = ja.f, Bk = jp, sr = Tl, Vk = $a, lr = zt, Jc = ft, qk = function(e) {
  var n = function(r, i, o) {
    if (this instanceof n) {
      switch (arguments.length) {
        case 0:
          return new e();
        case 1:
          return new e(r);
        case 2:
          return new e(r, i);
      }
      return new e(r, i, o);
    }
    return Ak(e, this, arguments);
  };
  return n.prototype = e.prototype, n;
}, at = function(e, n) {
  var r = e.target, i = e.global, o = e.stat, s = e.proto, l = i ? Ci : o ? Ci[r] : (Ci[r] || {}).prototype, c = i ? sr : sr[r] || lr(sr, r, {})[r], u = c.prototype, p, m, v, y, b, N, x, T, $;
  for (y in n)
    p = Bk(i ? y : r + (o ? "." : "#") + y, e.forced), m = !p && l && Jc(l, y), N = c[y], m && (e.dontCallGetSet ? ($ = Mk(l, y), x = $ && $.value) : x = l[y]), b = m && x ? x : n[y], !(m && typeof N == typeof b) && (e.bind && m ? T = Vk(b, Ci) : e.wrap && m ? T = qk(b) : s && Uk(b) ? T = Lk(b) : T = b, (e.sham || b && b.sham || N && N.sham) && lr(T, "sham", !0), lr(c, y, T), s && (v = r + "Prototype", Jc(sr, v) || lr(sr, v, {}), lr(sr[v], y, b), e.real && u && (p || !u[y]) && lr(u, y, b)));
}, zk = Un, Hk = pt, Kk = function(e, n, r) {
  try {
    return zk(Hk(Object.getOwnPropertyDescriptor(e, n)[r]));
  } catch {
  }
}, Gk = $n, Wk = String, Yk = TypeError, Qk = function(e) {
  if (typeof e == "object" || Gk(e))
    return e;
  throw Yk("Can't set " + Wk(e) + " as a prototype");
}, Jk = Kk, Zk = vt, Xk = Qk, eb = Object.setPrototypeOf || ("__proto__" in {} ? function() {
  var e = !1, n = {}, r;
  try {
    r = Jk(Object.prototype, "__proto__", "set"), r(n, []), e = n instanceof Array;
  } catch {
  }
  return function(o, s) {
    return Zk(o), Xk(s), e ? r(o, s) : o.__proto__ = s, o;
  };
}() : void 0), Ep = {}, nb = Math.ceil, tb = Math.floor, rb = Math.trunc || function(n) {
  var r = +n;
  return (r > 0 ? tb : nb)(r);
}, ib = rb, Pl = function(e) {
  var n = +e;
  return n !== n || n === 0 ? 0 : ib(n);
}, ab = Pl, ob = Math.max, sb = Math.min, lb = function(e, n) {
  var r = ab(e);
  return r < 0 ? ob(r + n, 0) : sb(r, n);
}, cb = Pl, db = Math.min, ub = function(e) {
  return e > 0 ? db(cb(e), 9007199254740991) : 0;
}, mb = ub, Fp = function(e) {
  return mb(e.length);
}, pb = pi, fb = lb, vb = Fp, Zc = function(e) {
  return function(n, r, i) {
    var o = pb(n), s = vb(o), l = fb(i, s), c;
    if (e && r !== r) {
      for (; s > l; )
        if (c = o[l++], c !== c)
          return !0;
    } else
      for (; s > l; l++)
        if ((e || l in o) && o[l] === r)
          return e || l || 0;
    return !e && -1;
  };
}, yb = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: Zc(!0),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: Zc(!1)
}, Al = {}, gb = Un, mo = ft, hb = pi, kb = yb.indexOf, bb = Al, Xc = gb([].push), Ip = function(e, n) {
  var r = hb(e), i = 0, o = [], s;
  for (s in r)
    !mo(bb, s) && mo(r, s) && Xc(o, s);
  for (; n.length > i; )
    mo(r, s = n[i++]) && (~kb(o, s) || Xc(o, s));
  return o;
}, Ll = [
  "constructor",
  "hasOwnProperty",
  "isPrototypeOf",
  "propertyIsEnumerable",
  "toLocaleString",
  "toString",
  "valueOf"
], _b = Ip, Sb = Ll, Nb = Object.keys || function(n) {
  return _b(n, Sb);
}, xb = Vt, wb = Cp, jb = nr, Cb = vt, Eb = pi, Fb = Nb;
Ep.f = xb && !wb ? Object.defineProperties : function(n, r) {
  Cb(n);
  for (var i = Eb(r), o = Fb(r), s = o.length, l = 0, c; s > l; )
    jb.f(n, c = o[l++], i[c]);
  return n;
};
var Ib = qt, $p = Ib("document", "documentElement"), $b = _p, Tb = Np, ed = $b("keys"), Ul = function(e) {
  return ed[e] || (ed[e] = Tb(e));
}, Ob = vt, Rb = Ep, nd = Ll, Db = Al, Pb = $p, Ab = Dl, Lb = Ul, td = ">", rd = "<", Es = "prototype", Fs = "script", Tp = Lb("IE_PROTO"), po = function() {
}, Op = function(e) {
  return rd + Fs + td + e + rd + "/" + Fs + td;
}, id = function(e) {
  e.write(Op("")), e.close();
  var n = e.parentWindow.Object;
  return e = null, n;
}, Ub = function() {
  var e = Ab("iframe"), n = "java" + Fs + ":", r;
  return e.style.display = "none", Pb.appendChild(e), e.src = String(n), r = e.contentWindow.document, r.open(), r.write(Op("document.F=Object")), r.close(), r.F;
}, Ei, Yi = function() {
  try {
    Ei = new ActiveXObject("htmlfile");
  } catch {
  }
  Yi = typeof document < "u" ? document.domain && Ei ? id(Ei) : Ub() : id(Ei);
  for (var e = nd.length; e--; )
    delete Yi[Es][nd[e]];
  return Yi();
};
Db[Tp] = !0;
var Ml = Object.create || function(n, r) {
  var i;
  return n !== null ? (po[Es] = Ob(n), i = new po(), po[Es] = null, i[Tp] = n) : i = Yi(), r === void 0 ? i : Rb.f(i, r);
}, Rp = {};
Rp.f = Object.getOwnPropertySymbols;
var Mb = Mn, Bb = Mb("toStringTag"), Dp = {};
Dp[Bb] = "z";
var Bl = String(Dp) === "[object z]", Vb = Bl, qb = $n, Qi = wa, zb = Mn, Hb = zb("toStringTag"), Kb = Object, Gb = Qi(/* @__PURE__ */ function() {
  return arguments;
}()) === "Arguments", Wb = function(e, n) {
  try {
    return e[n];
  } catch {
  }
}, vi = Vb ? Qi : function(e) {
  var n, r, i;
  return e === void 0 ? "Undefined" : e === null ? "Null" : typeof (r = Wb(n = Kb(e), Hb)) == "string" ? r : Gb ? Qi(n) : (i = Qi(n)) === "Object" && qb(n.callee) ? "Arguments" : i;
}, Yb = vi, Qb = String, Vl = function(e) {
  if (Yb(e) === "Symbol")
    throw TypeError("Cannot convert a Symbol value to a string");
  return Qb(e);
}, Pp = {}, Jb = Ip, Zb = Ll, Xb = Zb.concat("length", "prototype");
Pp.f = Object.getOwnPropertyNames || function(n) {
  return Jb(n, Xb);
};
var e0 = zt, ql = function(e, n, r, i) {
  return i && i.enumerable ? e[n] = r : e0(e, n, r), e;
}, n0 = nr, t0 = function(e, n, r) {
  return n0.f(e, n, r);
}, r0 = Bl, i0 = vi, a0 = r0 ? {}.toString : function() {
  return "[object " + i0(this) + "]";
}, o0 = Bl, s0 = nr.f, l0 = zt, c0 = ft, d0 = a0, u0 = Mn, ad = u0("toStringTag"), zl = function(e, n, r, i) {
  if (e) {
    var o = r ? e : e.prototype;
    c0(o, ad) || s0(o, ad, { configurable: !0, value: n }), i && !o0 && l0(o, "toString", d0);
  }
}, m0 = Rn, p0 = $n, od = m0.WeakMap, f0 = p0(od) && /native code/.test(String(od)), v0 = f0, Ap = Rn, y0 = Ft, g0 = zt, fo = ft, vo = Rl, h0 = Ul, k0 = Al, sd = "Object already initialized", Is = Ap.TypeError, b0 = Ap.WeakMap, oa, oi, sa, _0 = function(e) {
  return sa(e) ? oi(e) : oa(e, {});
}, S0 = function(e) {
  return function(n) {
    var r;
    if (!y0(n) || (r = oi(n)).type !== e)
      throw Is("Incompatible receiver, " + e + " required");
    return r;
  };
};
if (v0 || vo.state) {
  var ot = vo.state || (vo.state = new b0());
  ot.get = ot.get, ot.has = ot.has, ot.set = ot.set, oa = function(e, n) {
    if (ot.has(e))
      throw Is(sd);
    return n.facade = e, ot.set(e, n), n;
  }, oi = function(e) {
    return ot.get(e) || {};
  }, sa = function(e) {
    return ot.has(e);
  };
} else {
  var cr = h0("state");
  k0[cr] = !0, oa = function(e, n) {
    if (fo(e, cr))
      throw Is(sd);
    return n.facade = e, g0(e, cr, n), n;
  }, oi = function(e) {
    return fo(e, cr) ? e[cr] : {};
  }, sa = function(e) {
    return fo(e, cr);
  };
}
var Hl = {
  set: oa,
  get: oi,
  has: sa,
  enforce: _0,
  getterFor: S0
}, N0 = Un, x0 = $n, $s = Rl, w0 = N0(Function.toString);
x0($s.inspectSource) || ($s.inspectSource = function(e) {
  return w0(e);
});
var Lp = $s.inspectSource, j0 = Un, C0 = qn, Up = $n, E0 = vi, F0 = qt, I0 = Lp, Mp = function() {
}, $0 = [], Bp = F0("Reflect", "construct"), Kl = /^\s*(?:class|function)\b/, T0 = j0(Kl.exec), O0 = !Kl.exec(Mp), Gr = function(n) {
  if (!Up(n))
    return !1;
  try {
    return Bp(Mp, $0, n), !0;
  } catch {
    return !1;
  }
}, Vp = function(n) {
  if (!Up(n))
    return !1;
  switch (E0(n)) {
    case "AsyncFunction":
    case "GeneratorFunction":
    case "AsyncGeneratorFunction":
      return !1;
  }
  try {
    return O0 || !!T0(Kl, I0(n));
  } catch {
    return !0;
  }
};
Vp.sham = !0;
var R0 = !Bp || C0(function() {
  var e;
  return Gr(Gr.call) || !Gr(Object) || !Gr(function() {
    e = !0;
  }) || e;
}) ? Vp : Gr, D0 = Un, P0 = D0([].slice), A0 = qn, L0 = !A0(function() {
  function e() {
  }
  return e.prototype.constructor = null, Object.getPrototypeOf(new e()) !== e.prototype;
}), U0 = ft, M0 = $n, B0 = Sp, V0 = Ul, q0 = L0, ld = V0("IE_PROTO"), Ts = Object, z0 = Ts.prototype, Gl = q0 ? Ts.getPrototypeOf : function(e) {
  var n = B0(e);
  if (U0(n, ld))
    return n[ld];
  var r = n.constructor;
  return M0(r) && n instanceof r ? r.prototype : n instanceof Ts ? z0 : null;
}, H0 = qt, K0 = Un, G0 = Pp, W0 = Rp, Y0 = vt, Q0 = K0([].concat), J0 = H0("Reflect", "ownKeys") || function(n) {
  var r = G0.f(Y0(n)), i = W0.f;
  return i ? Q0(r, i(n)) : r;
}, cd = ft, Z0 = J0, X0 = ja, e_ = nr, n_ = function(e, n, r) {
  for (var i = Z0(n), o = e_.f, s = X0.f, l = 0; l < i.length; l++) {
    var c = i[l];
    !cd(e, c) && !(r && cd(r, c)) && o(e, c, s(n, c));
  }
}, t_ = Ft, r_ = zt, i_ = function(e, n) {
  t_(n) && "cause" in n && r_(e, "cause", n.cause);
}, a_ = Un, qp = Error, o_ = a_("".replace), s_ = function(e) {
  return String(qp(e).stack);
}("zxcasd"), zp = /\n\s*at [^:]*:[^\n]*/, l_ = zp.test(s_), c_ = function(e, n) {
  if (l_ && typeof e == "string" && !qp.prepareStackTrace)
    for (; n--; )
      e = o_(e, zp, "");
  return e;
}, d_ = qn, u_ = mi, m_ = !d_(function() {
  var e = Error("a");
  return "stack" in e ? (Object.defineProperty(e, "stack", u_(1, 7)), e.stack !== 7) : !0;
}), p_ = zt, f_ = c_, v_ = m_, dd = Error.captureStackTrace, y_ = function(e, n, r, i) {
  v_ && (dd ? dd(e, n) : p_(e, "stack", f_(r, i)));
}, Mr = {}, g_ = Mn, h_ = Mr, k_ = g_("iterator"), b_ = Array.prototype, __ = function(e) {
  return e !== void 0 && (h_.Array === e || b_[k_] === e);
}, S_ = vi, ud = Ol, N_ = Ca, x_ = Mr, w_ = Mn, j_ = w_("iterator"), Hp = function(e) {
  if (!N_(e))
    return ud(e, j_) || ud(e, "@@iterator") || x_[S_(e)];
}, C_ = zn, E_ = pt, F_ = vt, I_ = Ia, $_ = Hp, T_ = TypeError, O_ = function(e, n) {
  var r = arguments.length < 2 ? $_(e) : n;
  if (E_(r))
    return F_(C_(r, e));
  throw T_(I_(e) + " is not iterable");
}, R_ = zn, md = vt, D_ = Ol, P_ = function(e, n, r) {
  var i, o;
  md(e);
  try {
    if (i = D_(e, "return"), !i) {
      if (n === "throw")
        throw r;
      return r;
    }
    i = R_(i, e);
  } catch (s) {
    o = !0, i = s;
  }
  if (n === "throw")
    throw r;
  if (o)
    throw i;
  return md(i), r;
}, A_ = $a, L_ = zn, U_ = vt, M_ = Ia, B_ = __, V_ = Fp, pd = Ea, q_ = O_, z_ = Hp, fd = P_, H_ = TypeError, Ji = function(e, n) {
  this.stopped = e, this.result = n;
}, vd = Ji.prototype, yi = function(e, n, r) {
  var i = r && r.that, o = !!(r && r.AS_ENTRIES), s = !!(r && r.IS_RECORD), l = !!(r && r.IS_ITERATOR), c = !!(r && r.INTERRUPTED), u = A_(n, i), p, m, v, y, b, N, x, T = function(P) {
    return p && fd(p, "normal", P), new Ji(!0, P);
  }, $ = function(P) {
    return o ? (U_(P), c ? u(P[0], P[1], T) : u(P[0], P[1])) : c ? u(P, T) : u(P);
  };
  if (s)
    p = e.iterator;
  else if (l)
    p = e;
  else {
    if (m = z_(e), !m)
      throw H_(M_(e) + " is not iterable");
    if (B_(m)) {
      for (v = 0, y = V_(e); y > v; v++)
        if (b = $(e[v]), b && pd(vd, b))
          return b;
      return new Ji(!1);
    }
    p = q_(e, m);
  }
  for (N = s ? e.next : p.next; !(x = L_(N, p)).done; ) {
    try {
      b = $(x.value);
    } catch (P) {
      fd(p, "throw", P);
    }
    if (typeof b == "object" && b && pd(vd, b))
      return b;
  }
  return new Ji(!1);
}, K_ = Vl, G_ = function(e, n) {
  return e === void 0 ? arguments.length < 2 ? "" : n : K_(e);
}, W_ = at, Y_ = Ea, Q_ = Gl, la = eb, J_ = n_, Kp = Ml, yo = zt, go = mi, Z_ = i_, X_ = y_, eS = yi, nS = G_, tS = Mn, rS = tS("toStringTag"), ca = Error, iS = [].push, Dr = function(n, r) {
  var i = Y_(ho, this), o;
  la ? o = la(ca(), i ? Q_(this) : ho) : (o = i ? this : Kp(ho), yo(o, rS, "Error")), r !== void 0 && yo(o, "message", nS(r)), X_(o, Dr, o.stack, 1), arguments.length > 2 && Z_(o, arguments[2]);
  var s = [];
  return eS(n, iS, { that: s }), yo(o, "errors", s), o;
};
la ? la(Dr, ca) : J_(Dr, ca, { name: !0 });
var ho = Dr.prototype = Kp(ca.prototype, {
  constructor: go(1, Dr),
  message: go(1, ""),
  name: go(1, "AggregateError")
});
W_({ global: !0, constructor: !0, arity: 2 }, {
  AggregateError: Dr
});
var Os = Vt, aS = ft, Gp = Function.prototype, oS = Os && Object.getOwnPropertyDescriptor, Wl = aS(Gp, "name"), sS = Wl && (function() {
}).name === "something", lS = Wl && (!Os || Os && oS(Gp, "name").configurable), cS = {
  EXISTS: Wl,
  PROPER: sS,
  CONFIGURABLE: lS
}, dS = qn, uS = $n, mS = Ft, pS = Ml, yd = Gl, fS = ql, vS = Mn, Rs = vS("iterator"), Wp = !1, wt, ko, bo;
[].keys && (bo = [].keys(), "next" in bo ? (ko = yd(yd(bo)), ko !== Object.prototype && (wt = ko)) : Wp = !0);
var yS = !mS(wt) || dS(function() {
  var e = {};
  return wt[Rs].call(e) !== e;
});
yS ? wt = {} : wt = pS(wt);
uS(wt[Rs]) || fS(wt, Rs, function() {
  return this;
});
var Yp = {
  IteratorPrototype: wt,
  BUGGY_SAFARI_ITERATORS: Wp
}, gS = Yp.IteratorPrototype, hS = Ml, kS = mi, bS = zl, _S = Mr, SS = function() {
  return this;
}, NS = function(e, n, r, i) {
  var o = n + " Iterator";
  return e.prototype = hS(gS, { next: kS(+!i, r) }), bS(e, o, !1, !0), _S[o] = SS, e;
}, xS = at, wS = zn, jS = cS, CS = NS, ES = Gl, FS = zl, gd = ql, IS = Mn, hd = Mr, $S = Yp, TS = jS.PROPER, Fi = $S.BUGGY_SAFARI_ITERATORS, _o = IS("iterator"), kd = "keys", Ii = "values", bd = "entries", OS = function() {
  return this;
}, Qp = function(e, n, r, i, o, s, l) {
  CS(r, n, i);
  var c = function($) {
    if ($ === o && y)
      return y;
    if (!Fi && $ in m)
      return m[$];
    switch ($) {
      case kd:
        return function() {
          return new r(this, $);
        };
      case Ii:
        return function() {
          return new r(this, $);
        };
      case bd:
        return function() {
          return new r(this, $);
        };
    }
    return function() {
      return new r(this);
    };
  }, u = n + " Iterator", p = !1, m = e.prototype, v = m[_o] || m["@@iterator"] || o && m[o], y = !Fi && v || c(o), b = n === "Array" && m.entries || v, N, x, T;
  if (b && (N = ES(b.call(new e())), N !== Object.prototype && N.next && (FS(N, u, !0, !0), hd[u] = OS)), TS && o === Ii && v && v.name !== Ii && (p = !0, y = function() {
    return wS(v, this);
  }), o)
    if (x = {
      values: c(Ii),
      keys: s ? y : c(kd),
      entries: c(bd)
    }, l)
      for (T in x)
        (Fi || p || !(T in m)) && gd(m, T, x[T]);
    else
      xS({ target: n, proto: !0, forced: Fi || p }, x);
  return l && m[_o] !== y && gd(m, _o, y, { name: o }), hd[n] = y, x;
}, Jp = function(e, n) {
  return { value: e, done: n };
}, RS = pi, _d = Mr, Zp = Hl;
nr.f;
var DS = Qp, $i = Jp, Xp = "Array Iterator", PS = Zp.set, AS = Zp.getterFor(Xp);
DS(Array, "Array", function(e, n) {
  PS(this, {
    type: Xp,
    target: RS(e),
    // target
    index: 0,
    // next index
    kind: n
    // kind
  });
}, function() {
  var e = AS(this), n = e.target, r = e.kind, i = e.index++;
  if (!n || i >= n.length)
    return e.target = void 0, $i(void 0, !0);
  switch (r) {
    case "keys":
      return $i(i, !1);
    case "values":
      return $i(n[i], !1);
  }
  return $i([i, n[i]], !1);
}, "values");
_d.Arguments = _d.Array;
var LS = Rn, US = wa, Ta = US(LS.process) === "process", MS = qt, BS = t0, VS = Mn, qS = Vt, Sd = VS("species"), zS = function(e) {
  var n = MS(e);
  qS && n && !n[Sd] && BS(n, Sd, {
    configurable: !0,
    get: function() {
      return this;
    }
  });
}, HS = Ea, KS = TypeError, GS = function(e, n) {
  if (HS(n, e))
    return e;
  throw KS("Incorrect invocation");
}, WS = R0, YS = Ia, QS = TypeError, JS = function(e) {
  if (WS(e))
    return e;
  throw QS(YS(e) + " is not a constructor");
}, Nd = vt, ZS = JS, XS = Ca, eN = Mn, nN = eN("species"), ef = function(e, n) {
  var r = Nd(e).constructor, i;
  return r === void 0 || XS(i = Nd(r)[nN]) ? n : ZS(i);
}, tN = TypeError, rN = function(e, n) {
  if (e < n)
    throw tN("Not enough arguments");
  return e;
}, iN = Fa, nf = /(?:ipad|iphone|ipod).*applewebkit/i.test(iN), Vn = Rn, aN = ip, oN = $a, xd = $n, sN = ft, tf = qn, wd = $p, lN = P0, jd = Dl, cN = rN, dN = nf, uN = Ta, Ds = Vn.setImmediate, Ps = Vn.clearImmediate, mN = Vn.process, So = Vn.Dispatch, pN = Vn.Function, Cd = Vn.MessageChannel, fN = Vn.String, No = 0, ti = {}, Ed = "onreadystatechange", si, Kt, xo, wo;
tf(function() {
  si = Vn.location;
});
var Yl = function(e) {
  if (sN(ti, e)) {
    var n = ti[e];
    delete ti[e], n();
  }
}, jo = function(e) {
  return function() {
    Yl(e);
  };
}, Fd = function(e) {
  Yl(e.data);
}, Id = function(e) {
  Vn.postMessage(fN(e), si.protocol + "//" + si.host);
};
(!Ds || !Ps) && (Ds = function(n) {
  cN(arguments.length, 1);
  var r = xd(n) ? n : pN(n), i = lN(arguments, 1);
  return ti[++No] = function() {
    aN(r, void 0, i);
  }, Kt(No), No;
}, Ps = function(n) {
  delete ti[n];
}, uN ? Kt = function(e) {
  mN.nextTick(jo(e));
} : So && So.now ? Kt = function(e) {
  So.now(jo(e));
} : Cd && !dN ? (xo = new Cd(), wo = xo.port2, xo.port1.onmessage = Fd, Kt = oN(wo.postMessage, wo)) : Vn.addEventListener && xd(Vn.postMessage) && !Vn.importScripts && si && si.protocol !== "file:" && !tf(Id) ? (Kt = Id, Vn.addEventListener("message", Fd, !1)) : Ed in jd("script") ? Kt = function(e) {
  wd.appendChild(jd("script"))[Ed] = function() {
    wd.removeChild(this), Yl(e);
  };
} : Kt = function(e) {
  setTimeout(jo(e), 0);
});
var rf = {
  set: Ds,
  clear: Ps
}, af = function() {
  this.head = null, this.tail = null;
};
af.prototype = {
  add: function(e) {
    var n = { item: e, next: null }, r = this.tail;
    r ? r.next = n : this.head = n, this.tail = n;
  },
  get: function() {
    var e = this.head;
    if (e) {
      var n = this.head = e.next;
      return n === null && (this.tail = null), e.item;
    }
  }
};
var of = af, vN = Fa, yN = /ipad|iphone|ipod/i.test(vN) && typeof Pebble < "u", gN = Fa, hN = /web0s(?!.*chrome)/i.test(gN), er = Rn, $d = $a, kN = ja.f, Co = rf.set, bN = of, _N = nf, SN = yN, NN = hN, Eo = Ta, Td = er.MutationObserver || er.WebKitMutationObserver, Od = er.document, Rd = er.process, Ti = er.Promise, Dd = kN(er, "queueMicrotask"), As = Dd && Dd.value, dr, Fo, Io, Oi, Pd;
if (!As) {
  var Ri = new bN(), Di = function() {
    var e, n;
    for (Eo && (e = Rd.domain) && e.exit(); n = Ri.get(); )
      try {
        n();
      } catch (r) {
        throw Ri.head && dr(), r;
      }
    e && e.enter();
  };
  !_N && !Eo && !NN && Td && Od ? (Fo = !0, Io = Od.createTextNode(""), new Td(Di).observe(Io, { characterData: !0 }), dr = function() {
    Io.data = Fo = !Fo;
  }) : !SN && Ti && Ti.resolve ? (Oi = Ti.resolve(void 0), Oi.constructor = Ti, Pd = $d(Oi.then, Oi), dr = function() {
    Pd(Di);
  }) : Eo ? dr = function() {
    Rd.nextTick(Di);
  } : (Co = $d(Co, er), dr = function() {
    Co(Di);
  }), As = function(e) {
    Ri.head || dr(), Ri.add(e);
  };
}
var xN = As, wN = function(e, n) {
  try {
    arguments.length === 1 ? console.error(e) : console.error(e, n);
  } catch {
  }
}, gi = function(e) {
  try {
    return { error: !1, value: e() };
  } catch (n) {
    return { error: !0, value: n };
  }
}, jN = Rn, Br = jN.Promise, sf = typeof Deno == "object" && Deno && typeof Deno.version == "object", CN = sf, EN = Ta, FN = !CN && !EN && typeof window == "object" && typeof document == "object", IN = Rn, ri = Br, $N = $n, TN = jp, ON = Lp, RN = Mn, DN = FN, PN = sf, $o = yp, Ad = ri && ri.prototype, AN = RN("species"), Ls = !1, lf = $N(IN.PromiseRejectionEvent), LN = TN("Promise", function() {
  var e = ON(ri), n = e !== String(ri);
  if (!n && $o === 66 || !(Ad.catch && Ad.finally))
    return !0;
  if (!$o || $o < 51 || !/native code/.test(e)) {
    var r = new ri(function(s) {
      s(1);
    }), i = function(s) {
      s(function() {
      }, function() {
      });
    }, o = r.constructor = {};
    if (o[AN] = i, Ls = r.then(function() {
    }) instanceof i, !Ls)
      return !0;
  }
  return !n && (DN || PN) && !lf;
}), hi = {
  CONSTRUCTOR: LN,
  REJECTION_EVENT: lf,
  SUBCLASSING: Ls
}, Ht = {}, Ld = pt, UN = TypeError, MN = function(e) {
  var n, r;
  this.promise = new e(function(i, o) {
    if (n !== void 0 || r !== void 0)
      throw UN("Bad Promise constructor");
    n = i, r = o;
  }), this.resolve = Ld(n), this.reject = Ld(r);
};
Ht.f = function(e) {
  return new MN(e);
};
var BN = at, da = Ta, Ut = Rn, ki = zn, VN = ql, qN = zl, zN = zS, HN = pt, Us = $n, KN = Ft, GN = GS, WN = ef, cf = rf.set, Ql = xN, YN = wN, QN = gi, JN = of, df = Hl, Ms = Br, uf = hi, mf = Ht, Oa = "Promise", pf = uf.CONSTRUCTOR, ZN = uf.REJECTION_EVENT, To = df.getterFor(Oa), XN = df.set, e1 = Ms && Ms.prototype, jr = Ms, Oo = e1, ff = Ut.TypeError, Bs = Ut.document, Jl = Ut.process, Vs = mf.f, n1 = Vs, t1 = !!(Bs && Bs.createEvent && Ut.dispatchEvent), vf = "unhandledrejection", r1 = "rejectionhandled", Ud = 0, yf = 1, i1 = 2, Zl = 1, gf = 2, Pi, Md, a1, hf = function(e) {
  var n;
  return KN(e) && Us(n = e.then) ? n : !1;
}, kf = function(e, n) {
  var r = n.value, i = n.state === yf, o = i ? e.ok : e.fail, s = e.resolve, l = e.reject, c = e.domain, u, p, m;
  try {
    o ? (i || (n.rejection === gf && s1(n), n.rejection = Zl), o === !0 ? u = r : (c && c.enter(), u = o(r), c && (c.exit(), m = !0)), u === e.promise ? l(ff("Promise-chain cycle")) : (p = hf(u)) ? ki(p, u, s, l) : s(u)) : l(r);
  } catch (v) {
    c && !m && c.exit(), l(v);
  }
}, bf = function(e, n) {
  e.notified || (e.notified = !0, Ql(function() {
    for (var r = e.reactions, i; i = r.get(); )
      kf(i, e);
    e.notified = !1, n && !e.rejection && o1(e);
  }));
}, _f = function(e, n, r) {
  var i, o;
  t1 ? (i = Bs.createEvent("Event"), i.promise = n, i.reason = r, i.initEvent(e, !1, !0), Ut.dispatchEvent(i)) : i = { promise: n, reason: r }, !ZN && (o = Ut["on" + e]) ? o(i) : e === vf && YN("Unhandled promise rejection", r);
}, o1 = function(e) {
  ki(cf, Ut, function() {
    var n = e.facade, r = e.value, i = Bd(e), o;
    if (i && (o = QN(function() {
      da ? Jl.emit("unhandledRejection", r, n) : _f(vf, n, r);
    }), e.rejection = da || Bd(e) ? gf : Zl, o.error))
      throw o.value;
  });
}, Bd = function(e) {
  return e.rejection !== Zl && !e.parent;
}, s1 = function(e) {
  ki(cf, Ut, function() {
    var n = e.facade;
    da ? Jl.emit("rejectionHandled", n) : _f(r1, n, e.value);
  });
}, Cr = function(e, n, r) {
  return function(i) {
    e(n, i, r);
  };
}, Er = function(e, n, r) {
  e.done || (e.done = !0, r && (e = r), e.value = n, e.state = i1, bf(e, !0));
}, qs = function(e, n, r) {
  if (!e.done) {
    e.done = !0, r && (e = r);
    try {
      if (e.facade === n)
        throw ff("Promise can't be resolved itself");
      var i = hf(n);
      i ? Ql(function() {
        var o = { done: !1 };
        try {
          ki(
            i,
            n,
            Cr(qs, o, e),
            Cr(Er, o, e)
          );
        } catch (s) {
          Er(o, s, e);
        }
      }) : (e.value = n, e.state = yf, bf(e, !1));
    } catch (o) {
      Er({ done: !1 }, o, e);
    }
  }
};
pf && (jr = function(n) {
  GN(this, Oo), HN(n), ki(Pi, this);
  var r = To(this);
  try {
    n(Cr(qs, r), Cr(Er, r));
  } catch (i) {
    Er(r, i);
  }
}, Oo = jr.prototype, Pi = function(n) {
  XN(this, {
    type: Oa,
    done: !1,
    notified: !1,
    parent: !1,
    reactions: new JN(),
    rejection: !1,
    state: Ud,
    value: void 0
  });
}, Pi.prototype = VN(Oo, "then", function(n, r) {
  var i = To(this), o = Vs(WN(this, jr));
  return i.parent = !0, o.ok = Us(n) ? n : !0, o.fail = Us(r) && r, o.domain = da ? Jl.domain : void 0, i.state === Ud ? i.reactions.add(o) : Ql(function() {
    kf(o, i);
  }), o.promise;
}), Md = function() {
  var e = new Pi(), n = To(e);
  this.promise = e, this.resolve = Cr(qs, n), this.reject = Cr(Er, n);
}, mf.f = Vs = function(e) {
  return e === jr || e === a1 ? new Md(e) : n1(e);
});
BN({ global: !0, constructor: !0, wrap: !0, forced: pf }, {
  Promise: jr
});
qN(jr, Oa, !1, !0);
zN(Oa);
var l1 = Mn, Sf = l1("iterator"), Nf = !1;
try {
  var c1 = 0, Vd = {
    next: function() {
      return { done: !!c1++ };
    },
    return: function() {
      Nf = !0;
    }
  };
  Vd[Sf] = function() {
    return this;
  }, Array.from(Vd, function() {
    throw 2;
  });
} catch {
}
var d1 = function(e, n) {
  if (!n && !Nf)
    return !1;
  var r = !1;
  try {
    var i = {};
    i[Sf] = function() {
      return {
        next: function() {
          return { done: r = !0 };
        }
      };
    }, e(i);
  } catch {
  }
  return r;
}, u1 = Br, m1 = d1, p1 = hi.CONSTRUCTOR, Ra = p1 || !m1(function(e) {
  u1.all(e).then(void 0, function() {
  });
}), f1 = at, v1 = zn, y1 = pt, g1 = Ht, h1 = gi, k1 = yi, b1 = Ra;
f1({ target: "Promise", stat: !0, forced: b1 }, {
  all: function(n) {
    var r = this, i = g1.f(r), o = i.resolve, s = i.reject, l = h1(function() {
      var c = y1(r.resolve), u = [], p = 0, m = 1;
      k1(n, function(v) {
        var y = p++, b = !1;
        m++, v1(c, r, v).then(function(N) {
          b || (b = !0, u[y] = N, --m || o(u));
        }, s);
      }), --m || o(u);
    });
    return l.error && s(l.value), i.promise;
  }
});
var _1 = at, S1 = hi.CONSTRUCTOR, qd = Br;
qd && qd.prototype;
_1({ target: "Promise", proto: !0, forced: S1, real: !0 }, {
  catch: function(e) {
    return this.then(void 0, e);
  }
});
var N1 = at, x1 = zn, w1 = pt, j1 = Ht, C1 = gi, E1 = yi, F1 = Ra;
N1({ target: "Promise", stat: !0, forced: F1 }, {
  race: function(n) {
    var r = this, i = j1.f(r), o = i.reject, s = C1(function() {
      var l = w1(r.resolve);
      E1(n, function(c) {
        x1(l, r, c).then(i.resolve, o);
      });
    });
    return s.error && o(s.value), i.promise;
  }
});
var I1 = at, $1 = zn, T1 = Ht, O1 = hi.CONSTRUCTOR;
I1({ target: "Promise", stat: !0, forced: O1 }, {
  reject: function(n) {
    var r = T1.f(this);
    return $1(r.reject, void 0, n), r.promise;
  }
});
var R1 = vt, D1 = Ft, P1 = Ht, xf = function(e, n) {
  if (R1(e), D1(n) && n.constructor === e)
    return n;
  var r = P1.f(e), i = r.resolve;
  return i(n), r.promise;
}, A1 = at, L1 = qt, U1 = wh, M1 = Br, B1 = hi.CONSTRUCTOR, V1 = xf, q1 = L1("Promise"), z1 = !B1;
A1({ target: "Promise", stat: !0, forced: U1 }, {
  resolve: function(n) {
    return V1(z1 && this === q1 ? M1 : this, n);
  }
});
var H1 = at, K1 = zn, G1 = pt, W1 = Ht, Y1 = gi, Q1 = yi, J1 = Ra;
H1({ target: "Promise", stat: !0, forced: J1 }, {
  allSettled: function(n) {
    var r = this, i = W1.f(r), o = i.resolve, s = i.reject, l = Y1(function() {
      var c = G1(r.resolve), u = [], p = 0, m = 1;
      Q1(n, function(v) {
        var y = p++, b = !1;
        m++, K1(c, r, v).then(function(N) {
          b || (b = !0, u[y] = { status: "fulfilled", value: N }, --m || o(u));
        }, function(N) {
          b || (b = !0, u[y] = { status: "rejected", reason: N }, --m || o(u));
        });
      }), --m || o(u);
    });
    return l.error && s(l.value), i.promise;
  }
});
var Z1 = at, X1 = zn, ex = pt, nx = qt, tx = Ht, rx = gi, ix = yi, ax = Ra, zd = "No one promise resolved";
Z1({ target: "Promise", stat: !0, forced: ax }, {
  any: function(n) {
    var r = this, i = nx("AggregateError"), o = tx.f(r), s = o.resolve, l = o.reject, c = rx(function() {
      var u = ex(r.resolve), p = [], m = 0, v = 1, y = !1;
      ix(n, function(b) {
        var N = m++, x = !1;
        v++, X1(u, r, b).then(function(T) {
          x || y || (y = !0, s(T));
        }, function(T) {
          x || y || (x = !0, p[N] = T, --v || l(new i(p, zd)));
        });
      }), --v || l(new i(p, zd));
    });
    return c.error && l(c.value), o.promise;
  }
});
var ox = at, zs = Br, sx = qn, lx = qt, cx = $n, dx = ef, Hd = xf, ux = zs && zs.prototype, mx = !!zs && sx(function() {
  ux.finally.call({ then: function() {
  } }, function() {
  });
});
ox({ target: "Promise", proto: !0, real: !0, forced: mx }, {
  finally: function(e) {
    var n = dx(this, lx("Promise")), r = cx(e);
    return this.then(
      r ? function(i) {
        return Hd(n, e()).then(function() {
          return i;
        });
      } : e,
      r ? function(i) {
        return Hd(n, e()).then(function() {
          throw i;
        });
      } : e
    );
  }
});
var Xl = Un, px = Pl, fx = Vl, vx = $l, yx = Xl("".charAt), Kd = Xl("".charCodeAt), gx = Xl("".slice), Gd = function(e) {
  return function(n, r) {
    var i = fx(vx(n)), o = px(r), s = i.length, l, c;
    return o < 0 || o >= s ? e ? "" : void 0 : (l = Kd(i, o), l < 55296 || l > 56319 || o + 1 === s || (c = Kd(i, o + 1)) < 56320 || c > 57343 ? e ? yx(i, o) : l : e ? gx(i, o, o + 2) : (l - 55296 << 10) + (c - 56320) + 65536);
  };
}, hx = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: Gd(!1),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: Gd(!0)
}, kx = hx.charAt, bx = Vl, wf = Hl, _x = Qp, Wd = Jp, jf = "String Iterator", Sx = wf.set, Nx = wf.getterFor(jf);
_x(String, "String", function(e) {
  Sx(this, {
    type: jf,
    string: bx(e),
    index: 0
  });
}, function() {
  var n = Nx(this), r = n.string, i = n.index, o;
  return i >= r.length ? Wd(void 0, !0) : (o = kx(r, i), n.index += o.length, Wd(o, !1));
});
var xx = Tl, wx = xx.Promise, jx = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
}, Cx = jx, Ex = Rn, Fx = vi, Ix = zt, Yd = Mr, $x = Mn, Qd = $x("toStringTag");
for (var Ro in Cx) {
  var Jd = Ex[Ro], Do = Jd && Jd.prototype;
  Do && Fx(Do) !== Qd && Ix(Do, Qd, Ro), Yd[Ro] = Yd.Array;
}
var Tx = wx, Ox = Tx, Rx = Ox, Dx = /* @__PURE__ */ Ag(Rx);
function Po(e, n, r, i) {
  function o(s) {
    return s instanceof r ? s : new r(function(l) {
      l(s);
    });
  }
  return new (r || (r = Dx))(function(s, l) {
    function c(m) {
      try {
        p(i.next(m));
      } catch (v) {
        l(v);
      }
    }
    function u(m) {
      try {
        p(i.throw(m));
      } catch (v) {
        l(v);
      }
    }
    function p(m) {
      m.done ? s(m.value) : o(m.value).then(c, u);
    }
    p((i = i.apply(e, n || [])).next());
  });
}
class Px {
  /** Checks whether the app is running as an electron application. */
  isElectron() {
    var n;
    return window.electron ? !!window.electron : !!(!((n = process == null ? void 0 : process.versions) === null || n === void 0) && n.electron) || /electron/i.test(navigator.userAgent);
  }
  /**
   * Gets the electron version.
   *
   * version 0.0.0 represents a unsupported version
   */
  getVersion() {
    return Po(this, void 0, void 0, function* () {
      return window.electron ? (yield window.electron.getVersion()).split("-")[0] : "0.0.0";
    });
  }
  /** Checks if the running Electron build is a standalone (non auto-updating windows version) */
  isStandaloneBuild() {
    return Po(this, void 0, void 0, function* () {
      var n;
      return !((n = window.electron) === null || n === void 0) && n.isStandaloneBuild ? yield window.electron.isStandaloneBuild() : null;
    });
  }
  /** Checks if the running Electron build is installed from an windows MSI installer */
  isMsiBuild() {
    return Po(this, void 0, void 0, function* () {
      var n;
      return !((n = window.electron) === null || n === void 0) && n.isMsiBuild ? yield window.electron.isMsiBuild() : null;
    });
  }
}
const Zd = new Px();
function Ax(e, n) {
  return Xd(e), Xd(n), e.localeCompare(n, void 0, {
    numeric: !0
  });
}
function Xd(e) {
  if (e.split(".").length !== 3)
    throw Error(`The version '${e}' must be in the format 'x.x.x'.`);
}
const Lx = Object.prototype.toString;
function Ux(e, n) {
  return Lx.call(e) === `[object ${n}]`;
}
function Cf(e) {
  return Ux(e, "Object");
}
function Ef(e) {
  return !!(e && e.then && typeof e.then == "function");
}
function Ai(e) {
  return e && e.Math == Math ? e : void 0;
}
const dt = typeof globalThis == "object" && Ai(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == "object" && Ai(window) || typeof self == "object" && Ai(self) || typeof global == "object" && Ai(global) || /* @__PURE__ */ function() {
  return this;
}() || {};
function Mx() {
  return dt;
}
function Ff(e, n, r) {
  const i = r || dt, o = i.__SENTRY__ = i.__SENTRY__ || {};
  return o[e] || (o[e] = n());
}
const Bx = "Sentry Logger ", eu = ["debug", "info", "warn", "error", "log", "assert", "trace"], nu = {};
function If(e) {
  if (!("console" in dt))
    return e();
  const n = dt.console, r = {}, i = Object.keys(nu);
  i.forEach((o) => {
    const s = nu[o];
    r[o] = n[o], n[o] = s;
  });
  try {
    return e();
  } finally {
    i.forEach((o) => {
      n[o] = r[o];
    });
  }
}
function Vx() {
  let e = !1;
  const n = {
    enable: () => {
      e = !0;
    },
    disable: () => {
      e = !1;
    }
  };
  return typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__ ? eu.forEach((r) => {
    n[r] = (...i) => {
      e && If(() => {
        dt.console[r](`${Bx}[${r}]:`, ...i);
      });
    };
  }) : eu.forEach((r) => {
    n[r] = () => {
    };
  }), n;
}
const Hs = Vx();
function qx(e) {
  return Ks(e, /* @__PURE__ */ new Map());
}
function Ks(e, n) {
  if (Cf(e)) {
    const r = n.get(e);
    if (r !== void 0)
      return r;
    const i = {};
    n.set(e, i);
    for (const o of Object.keys(e))
      typeof e[o] < "u" && (i[o] = Ks(e[o], n));
    return i;
  }
  if (Array.isArray(e)) {
    const r = n.get(e);
    if (r !== void 0)
      return r;
    const i = [];
    return n.set(e, i), e.forEach((o) => {
      i.push(Ks(o, n));
    }), i;
  }
  return e;
}
function Xt() {
  const e = dt, n = e.crypto || e.msCrypto;
  let r = () => Math.random() * 16;
  try {
    if (n && n.randomUUID)
      return n.randomUUID().replace(/-/g, "");
    n && n.getRandomValues && (r = () => n.getRandomValues(new Uint8Array(1))[0]);
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (i) => (
      // eslint-disable-next-line no-bitwise
      (i ^ (r() & 15) >> i / 4).toString(16)
    )
  );
}
function zx(e) {
  return Array.isArray(e) ? e : [e];
}
function Hx() {
  return typeof __SENTRY_BROWSER_BUNDLE__ < "u" && !!__SENTRY_BROWSER_BUNDLE__;
}
function Kx() {
  return !Hx() && Object.prototype.toString.call(typeof process < "u" ? process : 0) === "[object process]";
}
function Gx(e, n) {
  return e.require(n);
}
var bt;
(function(e) {
  e[e.PENDING = 0] = "PENDING";
  const r = 1;
  e[e.RESOLVED = r] = "RESOLVED";
  const i = 2;
  e[e.REJECTED = i] = "REJECTED";
})(bt || (bt = {}));
class Dt {
  constructor(n) {
    Dt.prototype.__init.call(this), Dt.prototype.__init2.call(this), Dt.prototype.__init3.call(this), Dt.prototype.__init4.call(this), this._state = bt.PENDING, this._handlers = [];
    try {
      n(this._resolve, this._reject);
    } catch (r) {
      this._reject(r);
    }
  }
  /** JSDoc */
  then(n, r) {
    return new Dt((i, o) => {
      this._handlers.push([
        !1,
        (s) => {
          if (!n)
            i(s);
          else
            try {
              i(n(s));
            } catch (l) {
              o(l);
            }
        },
        (s) => {
          if (!r)
            o(s);
          else
            try {
              i(r(s));
            } catch (l) {
              o(l);
            }
        }
      ]), this._executeHandlers();
    });
  }
  /** JSDoc */
  catch(n) {
    return this.then((r) => r, n);
  }
  /** JSDoc */
  finally(n) {
    return new Dt((r, i) => {
      let o, s;
      return this.then(
        (l) => {
          s = !1, o = l, n && n();
        },
        (l) => {
          s = !0, o = l, n && n();
        }
      ).then(() => {
        if (s) {
          i(o);
          return;
        }
        r(o);
      });
    });
  }
  /** JSDoc */
  __init() {
    this._resolve = (n) => {
      this._setResult(bt.RESOLVED, n);
    };
  }
  /** JSDoc */
  __init2() {
    this._reject = (n) => {
      this._setResult(bt.REJECTED, n);
    };
  }
  /** JSDoc */
  __init3() {
    this._setResult = (n, r) => {
      if (this._state === bt.PENDING) {
        if (Ef(r)) {
          r.then(this._resolve, this._reject);
          return;
        }
        this._state = n, this._value = r, this._executeHandlers();
      }
    };
  }
  /** JSDoc */
  __init4() {
    this._executeHandlers = () => {
      if (this._state === bt.PENDING)
        return;
      const n = this._handlers.slice();
      this._handlers = [], n.forEach((r) => {
        r[0] || (this._state === bt.RESOLVED && r[1](this._value), this._state === bt.REJECTED && r[2](this._value), r[0] = !0);
      });
    };
  }
}
const $f = Mx(), Gs = {
  nowSeconds: () => Date.now() / 1e3
};
function Wx() {
  const { performance: e } = $f;
  if (!e || !e.now)
    return;
  const n = Date.now() - e.now();
  return {
    now: () => e.now(),
    timeOrigin: n
  };
}
function Yx() {
  try {
    return Gx(module, "perf_hooks").performance;
  } catch {
    return;
  }
}
const Ao = Kx() ? Yx() : Wx(), tu = Ao === void 0 ? Gs : {
  nowSeconds: () => (Ao.timeOrigin + Ao.now()) / 1e3
}, Tf = Gs.nowSeconds.bind(Gs), Of = tu.nowSeconds.bind(tu);
(() => {
  const { performance: e } = $f;
  if (!e || !e.now)
    return;
  const n = 3600 * 1e3, r = e.now(), i = Date.now(), o = e.timeOrigin ? Math.abs(e.timeOrigin + r - i) : n, s = o < n, l = e.timing && e.timing.navigationStart, u = typeof l == "number" ? Math.abs(l + r - i) : n, p = u < n;
  return s || p ? o <= u ? e.timeOrigin : l : i;
})();
const Qx = "production";
function Jx(e) {
  const n = Of(), r = {
    sid: Xt(),
    init: !0,
    timestamp: n,
    started: n,
    duration: 0,
    status: "ok",
    errors: 0,
    ignoreDuration: !1,
    toJSON: () => Xx(r)
  };
  return e && Da(r, e), r;
}
function Da(e, n = {}) {
  if (n.user && (!e.ipAddress && n.user.ip_address && (e.ipAddress = n.user.ip_address), !e.did && !n.did && (e.did = n.user.id || n.user.email || n.user.username)), e.timestamp = n.timestamp || Of(), n.ignoreDuration && (e.ignoreDuration = n.ignoreDuration), n.sid && (e.sid = n.sid.length === 32 ? n.sid : Xt()), n.init !== void 0 && (e.init = n.init), !e.did && n.did && (e.did = `${n.did}`), typeof n.started == "number" && (e.started = n.started), e.ignoreDuration)
    e.duration = void 0;
  else if (typeof n.duration == "number")
    e.duration = n.duration;
  else {
    const r = e.timestamp - e.started;
    e.duration = r >= 0 ? r : 0;
  }
  n.release && (e.release = n.release), n.environment && (e.environment = n.environment), !e.ipAddress && n.ipAddress && (e.ipAddress = n.ipAddress), !e.userAgent && n.userAgent && (e.userAgent = n.userAgent), typeof n.errors == "number" && (e.errors = n.errors), n.status && (e.status = n.status);
}
function Zx(e, n) {
  let r = {};
  n ? r = { status: n } : e.status === "ok" && (r = { status: "exited" }), Da(e, r);
}
function Xx(e) {
  return qx({
    sid: `${e.sid}`,
    init: e.init,
    // Make sure that sec is converted to ms for date constructor
    started: new Date(e.started * 1e3).toISOString(),
    timestamp: new Date(e.timestamp * 1e3).toISOString(),
    status: e.status,
    errors: e.errors,
    did: typeof e.did == "number" || typeof e.did == "string" ? `${e.did}` : void 0,
    duration: e.duration,
    attrs: {
      release: e.release,
      environment: e.environment,
      ip_address: e.ipAddress,
      user_agent: e.userAgent
    }
  });
}
const ew = 100;
class Fr {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called after {@link applyToEvent}. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  // eslint-disable-next-line deprecation/deprecation
  /** Transaction Name */
  /** Span */
  /** Session */
  /** Request Mode Session Status */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = ru();
  }
  /**
   * Inherit values from the parent scope.
   * @param scope to clone.
   */
  static clone(n) {
    const r = new Fr();
    return n && (r._breadcrumbs = [...n._breadcrumbs], r._tags = { ...n._tags }, r._extra = { ...n._extra }, r._contexts = { ...n._contexts }, r._user = n._user, r._level = n._level, r._span = n._span, r._session = n._session, r._transactionName = n._transactionName, r._fingerprint = n._fingerprint, r._eventProcessors = [...n._eventProcessors], r._requestSession = n._requestSession, r._attachments = [...n._attachments], r._sdkProcessingMetadata = { ...n._sdkProcessingMetadata }, r._propagationContext = { ...n._propagationContext }), r;
  }
  /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */
  addScopeListener(n) {
    this._scopeListeners.push(n);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(n) {
    return this._eventProcessors.push(n), this;
  }
  /**
   * @inheritDoc
   */
  setUser(n) {
    return this._user = n || {}, this._session && Da(this._session, { user: n }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  setRequestSession(n) {
    return this._requestSession = n, this;
  }
  /**
   * @inheritDoc
   */
  setTags(n) {
    return this._tags = {
      ...this._tags,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTag(n, r) {
    return this._tags = { ...this._tags, [n]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtras(n) {
    return this._extra = {
      ...this._extra,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtra(n, r) {
    return this._extra = { ...this._extra, [n]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(n) {
    return this._fingerprint = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(n) {
    return this._level = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTransactionName(n) {
    return this._transactionName = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(n, r) {
    return r === null ? delete this._contexts[n] : this._contexts[n] = r, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setSpan(n) {
    return this._span = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSpan() {
    return this._span;
  }
  /**
   * @inheritDoc
   */
  getTransaction() {
    const n = this.getSpan();
    return n && n.transaction;
  }
  /**
   * @inheritDoc
   */
  setSession(n) {
    return n ? this._session = n : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(n) {
    if (!n)
      return this;
    if (typeof n == "function") {
      const r = n(this);
      return r instanceof Fr ? r : this;
    }
    return n instanceof Fr ? (this._tags = { ...this._tags, ...n._tags }, this._extra = { ...this._extra, ...n._extra }, this._contexts = { ...this._contexts, ...n._contexts }, n._user && Object.keys(n._user).length && (this._user = n._user), n._level && (this._level = n._level), n._fingerprint && (this._fingerprint = n._fingerprint), n._requestSession && (this._requestSession = n._requestSession), n._propagationContext && (this._propagationContext = n._propagationContext)) : Cf(n) && (n = n, this._tags = { ...this._tags, ...n.tags }, this._extra = { ...this._extra, ...n.extra }, this._contexts = { ...this._contexts, ...n.contexts }, n.user && (this._user = n.user), n.level && (this._level = n.level), n.fingerprint && (this._fingerprint = n.fingerprint), n.requestSession && (this._requestSession = n.requestSession), n.propagationContext && (this._propagationContext = n.propagationContext)), this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._span = void 0, this._session = void 0, this._notifyScopeListeners(), this._attachments = [], this._propagationContext = ru(), this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(n, r) {
    const i = typeof r == "number" ? r : ew;
    if (i <= 0)
      return this;
    const o = {
      timestamp: Tf(),
      ...n
    }, s = this._breadcrumbs;
    return s.push(o), this._breadcrumbs = s.length > i ? s.slice(-i) : s, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(n) {
    return this._attachments.push(n), this;
  }
  /**
   * @inheritDoc
   */
  getAttachments() {
    return this._attachments;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   */
  applyToEvent(n, r = {}) {
    if (this._extra && Object.keys(this._extra).length && (n.extra = { ...this._extra, ...n.extra }), this._tags && Object.keys(this._tags).length && (n.tags = { ...this._tags, ...n.tags }), this._user && Object.keys(this._user).length && (n.user = { ...this._user, ...n.user }), this._contexts && Object.keys(this._contexts).length && (n.contexts = { ...this._contexts, ...n.contexts }), this._level && (n.level = this._level), this._transactionName && (n.transaction = this._transactionName), this._span) {
      n.contexts = { trace: this._span.getTraceContext(), ...n.contexts };
      const s = this._span.transaction;
      if (s) {
        n.sdkProcessingMetadata = {
          dynamicSamplingContext: s.getDynamicSamplingContext(),
          ...n.sdkProcessingMetadata
        };
        const l = s.name;
        l && (n.tags = { transaction: l, ...n.tags });
      }
    }
    this._applyFingerprint(n);
    const i = this._getBreadcrumbs(), o = [...n.breadcrumbs || [], ...i];
    return n.breadcrumbs = o.length > 0 ? o : void 0, n.sdkProcessingMetadata = {
      ...n.sdkProcessingMetadata,
      ...this._sdkProcessingMetadata,
      propagationContext: this._propagationContext
    }, this._notifyEventProcessors([...nw(), ...this._eventProcessors], n, r);
  }
  /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */
  setSDKProcessingMetadata(n) {
    return this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...n }, this;
  }
  /**
   * @inheritDoc
   */
  setPropagationContext(n) {
    return this._propagationContext = n, this;
  }
  /**
   * @inheritDoc
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * Get the breadcrumbs for this scope.
   */
  _getBreadcrumbs() {
    return this._breadcrumbs;
  }
  /**
   * This will be called after {@link applyToEvent} is finished.
   */
  _notifyEventProcessors(n, r, i, o = 0) {
    return new Dt((s, l) => {
      const c = n[o];
      if (r === null || typeof c != "function")
        s(r);
      else {
        const u = c({ ...r }, i);
        (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && c.id && u === null && Hs.log(`Event processor "${c.id}" dropped event`), Ef(u) ? u.then((p) => this._notifyEventProcessors(n, p, i, o + 1).then(s)).then(null, l) : this._notifyEventProcessors(n, u, i, o + 1).then(s).then(null, l);
      }
    });
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((n) => {
      n(this);
    }), this._notifyingListeners = !1);
  }
  /**
   * Applies fingerprint from the scope to the event if there's one,
   * uses message if there's one instead or get rid of empty fingerprint
   */
  _applyFingerprint(n) {
    n.fingerprint = n.fingerprint ? zx(n.fingerprint) : [], this._fingerprint && (n.fingerprint = n.fingerprint.concat(this._fingerprint)), n.fingerprint && !n.fingerprint.length && delete n.fingerprint;
  }
}
function nw() {
  return Ff("globalEventProcessors", () => []);
}
function ru() {
  return {
    traceId: Xt(),
    spanId: Xt().substring(16)
  };
}
const Rf = 4, tw = 100;
class Df {
  /** Is a {@link Layer}[] containing the client and scope */
  /** Contains the last event id of a captured event.  */
  /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   */
  constructor(n, r = new Fr(), i = Rf) {
    this._version = i, this._stack = [{ scope: r }], n && this.bindClient(n);
  }
  /**
   * @inheritDoc
   */
  isOlderThan(n) {
    return this._version < n;
  }
  /**
   * @inheritDoc
   */
  bindClient(n) {
    const r = this.getStackTop();
    r.client = n, n && n.setupIntegrations && n.setupIntegrations();
  }
  /**
   * @inheritDoc
   */
  pushScope() {
    const n = Fr.clone(this.getScope());
    return this.getStack().push({
      client: this.getClient(),
      scope: n
    }), n;
  }
  /**
   * @inheritDoc
   */
  popScope() {
    return this.getStack().length <= 1 ? !1 : !!this.getStack().pop();
  }
  /**
   * @inheritDoc
   */
  withScope(n) {
    const r = this.pushScope();
    try {
      n(r);
    } finally {
      this.popScope();
    }
  }
  /**
   * @inheritDoc
   */
  getClient() {
    return this.getStackTop().client;
  }
  /** Returns the scope of the top stack. */
  getScope() {
    return this.getStackTop().scope;
  }
  /** Returns the scope stack for domains or the process. */
  getStack() {
    return this._stack;
  }
  /** Returns the topmost scope layer in the order domain > local > process. */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * @inheritDoc
   */
  captureException(n, r) {
    const i = this._lastEventId = r && r.event_id ? r.event_id : Xt(), o = new Error("Sentry syntheticException");
    return this._withClient((s, l) => {
      s.captureException(
        n,
        {
          originalException: n,
          syntheticException: o,
          ...r,
          event_id: i
        },
        l
      );
    }), i;
  }
  /**
   * @inheritDoc
   */
  captureMessage(n, r, i) {
    const o = this._lastEventId = i && i.event_id ? i.event_id : Xt(), s = new Error(n);
    return this._withClient((l, c) => {
      l.captureMessage(
        n,
        r,
        {
          originalException: n,
          syntheticException: s,
          ...i,
          event_id: o
        },
        c
      );
    }), o;
  }
  /**
   * @inheritDoc
   */
  captureEvent(n, r) {
    const i = r && r.event_id ? r.event_id : Xt();
    return n.type || (this._lastEventId = i), this._withClient((o, s) => {
      o.captureEvent(n, { ...r, event_id: i }, s);
    }), i;
  }
  /**
   * @inheritDoc
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(n, r) {
    const { scope: i, client: o } = this.getStackTop();
    if (!o)
      return;
    const { beforeBreadcrumb: s = null, maxBreadcrumbs: l = tw } = o.getOptions && o.getOptions() || {};
    if (l <= 0)
      return;
    const u = { timestamp: Tf(), ...n }, p = s ? If(() => s(u, r)) : u;
    p !== null && (o.emit && o.emit("beforeAddBreadcrumb", p, r), i.addBreadcrumb(p, l));
  }
  /**
   * @inheritDoc
   */
  setUser(n) {
    this.getScope().setUser(n);
  }
  /**
   * @inheritDoc
   */
  setTags(n) {
    this.getScope().setTags(n);
  }
  /**
   * @inheritDoc
   */
  setExtras(n) {
    this.getScope().setExtras(n);
  }
  /**
   * @inheritDoc
   */
  setTag(n, r) {
    this.getScope().setTag(n, r);
  }
  /**
   * @inheritDoc
   */
  setExtra(n, r) {
    this.getScope().setExtra(n, r);
  }
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setContext(n, r) {
    this.getScope().setContext(n, r);
  }
  /**
   * @inheritDoc
   */
  configureScope(n) {
    const { scope: r, client: i } = this.getStackTop();
    i && n(r);
  }
  /**
   * @inheritDoc
   */
  run(n) {
    const r = iu(this);
    try {
      n(this);
    } finally {
      iu(r);
    }
  }
  /**
   * @inheritDoc
   */
  getIntegration(n) {
    const r = this.getClient();
    if (!r)
      return null;
    try {
      return r.getIntegration(n);
    } catch {
      return (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && Hs.warn(`Cannot retrieve integration ${n.id} from the current Hub`), null;
    }
  }
  /**
   * @inheritDoc
   */
  startTransaction(n, r) {
    const i = this._callExtensionMethod("startTransaction", n, r);
    if ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && !i) {
      const o = this.getClient();
      console.warn(o ? `Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
` : "Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
    }
    return i;
  }
  /**
   * @inheritDoc
   */
  traceHeaders() {
    return this._callExtensionMethod("traceHeaders");
  }
  /**
   * @inheritDoc
   */
  captureSession(n = !1) {
    if (n)
      return this.endSession();
    this._sendSessionUpdate();
  }
  /**
   * @inheritDoc
   */
  endSession() {
    const r = this.getStackTop().scope, i = r.getSession();
    i && Zx(i), this._sendSessionUpdate(), r.setSession();
  }
  /**
   * @inheritDoc
   */
  startSession(n) {
    const { scope: r, client: i } = this.getStackTop(), { release: o, environment: s = Qx } = i && i.getOptions() || {}, { userAgent: l } = dt.navigator || {}, c = Jx({
      release: o,
      environment: s,
      user: r.getUser(),
      ...l && { userAgent: l },
      ...n
    }), u = r.getSession && r.getSession();
    return u && u.status === "ok" && Da(u, { status: "exited" }), this.endSession(), r.setSession(c), c;
  }
  /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   */
  shouldSendDefaultPii() {
    const n = this.getClient(), r = n && n.getOptions();
    return !!(r && r.sendDefaultPii);
  }
  /**
   * Sends the current Session on the scope
   */
  _sendSessionUpdate() {
    const { scope: n, client: r } = this.getStackTop(), i = n.getSession();
    i && r && r.captureSession && r.captureSession(i);
  }
  /**
   * Internal helper function to call a method on the top client if it exists.
   *
   * @param method The method to call on the client.
   * @param args Arguments to pass to the client function.
   */
  _withClient(n) {
    const { scope: r, client: i } = this.getStackTop();
    i && n(i, r);
  }
  /**
   * Calls global extension method and binding current instance to the function call
   */
  // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _callExtensionMethod(n, ...r) {
    const o = Pa().__SENTRY__;
    if (o && o.extensions && typeof o.extensions[n] == "function")
      return o.extensions[n].apply(this, r);
    (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && Hs.warn(`Extension method ${n} couldn't be found, doing nothing.`);
  }
}
function Pa() {
  return dt.__SENTRY__ = dt.__SENTRY__ || {
    extensions: {},
    hub: void 0
  }, dt;
}
function iu(e) {
  const n = Pa(), r = Ws(n);
  return Pf(n, e), r;
}
function Aa() {
  const e = Pa();
  if (e.__SENTRY__ && e.__SENTRY__.acs) {
    const n = e.__SENTRY__.acs.getCurrentHub();
    if (n)
      return n;
  }
  return rw(e);
}
function rw(e = Pa()) {
  return (!iw(e) || Ws(e).isOlderThan(Rf)) && Pf(e, new Df()), Ws(e);
}
function iw(e) {
  return !!(e && e.__SENTRY__ && e.__SENTRY__.hub);
}
function Ws(e) {
  return Ff("hub", () => new Df(), e);
}
function Pf(e, n) {
  if (!e)
    return !1;
  const r = e.__SENTRY__ = e.__SENTRY__ || {};
  return r.hub = n, !0;
}
function au(e, n) {
  return Aa().captureException(e, { captureContext: n });
}
function aw(e, n) {
  const r = typeof n == "string" ? n : void 0, i = typeof n != "string" ? { captureContext: n } : void 0;
  return Aa().captureMessage(e, r, i);
}
function Yt(e) {
  Aa().addBreadcrumb(e);
}
function ow(e, n) {
  Aa().setContext(e, n);
}
var li;
(function(e) {
  e.Unknown = "unknown", e.Core = "core", e.Routing = "routing-and-presence", e.Insights = "insights", e.Ecosystem = "ecosystem", e.Partners = "partners", e.Channels = "channels", e.Messaging = "messaging", e.Platform = "platform", e.AI = "ai", e.Conversations = "conversations", e.Automation = "automation";
})(li || (li = {}));
function Ir(e) {
  const n = e.split(".")[1];
  if (!n)
    throw Error("Invalid token");
  const r = n.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(Buffer.from(r, "base64").toString());
  } catch (i) {
    throw Error(`Failed to parse the JSON Web Token with the following error: ${i}`);
  }
}
const sw = ta.backendDomain ? {
  "backend-domain": ta.backendDomain
} : void 0;
function Zi() {
  const e = new URLSearchParams(Object.assign({ noToken: "true" }, sw)).toString();
  document.location.href = `${ta.url.logIn}?${e}`;
}
const Lo = "authData", Uo = 30, lw = 600, Mo = 5;
class cw {
  constructor() {
    Object.defineProperty(this, "authData", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: null
    }), Object.defineProperty(this, "accessTokenExpiresAt", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), Object.defineProperty(this, "clientServerTimeDiff", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    });
  }
  /**
   * Returns an estimated server time (unix epoch in seconds) by adding the
   * client-server time difference to the current client time.
   *
   * The time-diff is stored whenever a new access token is saved.
   *
   * @returns {number} The estimated server time in seconds.
   */
  estimatedServerTime() {
    const n = Date.now() / 1e3;
    return this.clientServerTimeDiff >= Mo || this.clientServerTimeDiff <= -Mo ? Math.ceil(n + this.clientServerTimeDiff) : Math.ceil(n);
  }
  /**
   * Sets the auth data in localStorage.
   *
   * @param authData The auth data.
   */
  setAuthData(n) {
    this.authData = n;
    const i = Math.ceil(Date.now() / 1e3) + lw, o = Ir(n.access_token).exp;
    if (this.clientServerTimeDiff = o - i, process.env.NODE_ENV !== "test" && Math.abs(this.clientServerTimeDiff) > Mo) {
      const s = this.clientServerTimeDiff > 0 ? "behind" : "ahead";
      console.info(`Client time is ${s} by significant amount. (${Math.abs(this.clientServerTimeDiff)}s)`);
    }
    this.accessTokenExpiresAt = o, localStorage.setItem(Lo, JSON.stringify(n));
  }
  /** Gets the auth data from memory or localStorage. */
  getAuthData() {
    if (this.authData)
      return this.authData;
    const n = localStorage.getItem(Lo), r = n ? JSON.parse(n) : null;
    return this.validateAuthDataComplete(r) && (this.authData = r), r;
  }
  /** Removes the auth data from localStorage. */
  removeAuthData() {
    this.authData = null, localStorage.removeItem(Lo);
  }
  getAccessToken() {
    var n;
    return ((n = this.authData) === null || n === void 0 ? void 0 : n.access_token) || null;
  }
  getRefreshToken() {
    var n;
    return ((n = this.authData) === null || n === void 0 ? void 0 : n.refresh_token) || null;
  }
  /**
   * Validates that the auth data is complete - i.e not fragmented.
   *
   * @param authData The auth data.
   */
  validateAuthDataComplete(n) {
    return n ? [
      "access_token",
      "refresh_token",
      "expires_in"
    ].every((i) => typeof n[i] < "u") : !1;
  }
  isAccessTokenExpired() {
    if (!this.getAccessToken())
      return !0;
    const r = this.accessTokenExpiresAt - Uo;
    return this.estimatedServerTime() >= r;
  }
  isRefreshTokenExpired(n) {
    if (!n)
      return !0;
    const r = Ir(n), i = r.exp - Uo;
    return !r || this.estimatedServerTime() >= i;
  }
  accessTokenExpiresInMs() {
    return (this.accessTokenExpiresAt - Uo - this.estimatedServerTime()) * 1e3;
  }
}
const In = new cw();
var dw = function(e, n, r, i) {
  function o(s) {
    return s instanceof r ? s : new r(function(l) {
      l(s);
    });
  }
  return new (r || (r = Promise))(function(s, l) {
    function c(m) {
      try {
        p(i.next(m));
      } catch (v) {
        l(v);
      }
    }
    function u(m) {
      try {
        p(i.throw(m));
      } catch (v) {
        l(v);
      }
    }
    function p(m) {
      m.done ? s(m.value) : o(m.value).then(c, u);
    }
    p((i = i.apply(e, n || [])).next());
  });
};
function uw(e) {
  return dw(this, void 0, void 0, function* () {
    var n, r;
    const i = window.location.origin.replace(/^https?:\/\//, ""), o = ["localhost:8080", "uptrends-monitor"];
    if (!(!e.response || o.some((s) => i.includes(s)))) {
      try {
        const s = (n = e.response.config.headers.Authorization) !== null && n !== void 0 ? n : "", l = s ? (r = s.toString()) === null || r === void 0 ? void 0 : r.split("Basic ")[1] : "", c = l ? atob(l).split("token:")[1] : "", u = c ? Ir(c).exp : "None", p = yield ua.getAuthData({ localStorageOnly: !0 }), m = Math.floor(Date.now() / 1e3), v = p == null ? void 0 : p.access_token, y = p == null ? void 0 : p.refresh_token, b = v ? Ir(v).exp : "None", N = y ? Ir(y).exp : "None", x = typeof u == "number" ? m - u : "Unknown", T = typeof b == "number" ? m - b : "Unknown", $ = typeof N == "number" ? m - N : "Unknown", P = e.response.headers["x-dixa-rid"];
        ow("Expires", {
          currentTimestamp: m,
          accessTokenFromHeader: u,
          accessTokenFromHeaderDiff: x,
          accessTokenFromLocalStorage: b,
          accessTokenFromLocalStorageDiff: T,
          refreshTokenFromLocalStorage: N,
          refreshTokenFromLocalStorageDiff: $,
          xDixaRid: P,
          navigatorOnline: navigator.onLine
        });
      } catch (s) {
        console.error("Error adding Sentry error context", s);
      }
      aw("401 unauthorized interceptor", {
        level: "debug",
        tags: {
          team: li.Platform,
          domain: i
        }
      });
    }
  });
}
const Bo = /* @__PURE__ */ new Map(), mw = 3;
function pw(e) {
  e.interceptors.response.use((n) => (Bo.delete(n.config.url), n), (n) => {
    var r;
    if (n.response) {
      const { status: i } = n.response;
      switch (i) {
        case Ys.Unauthorized:
          if (!ua.isRefreshTokenExpired() && n.config) {
            Yt({
              category: "errorInterceptor",
              message: "Access token expired after request",
              level: "debug"
            });
            const o = (r = Bo.get(n.config.url)) !== null && r !== void 0 ? r : 0;
            if (console.log(`Retrying request (${o + 1}): ${n.config.url}`), o <= mw)
              return Bo.set(n.config.url, o + 1), e(n.config);
          }
          uw(n), console.error("401 unauthorized interceptor"), Zi();
          break;
      }
    }
    return Promise.reject(n);
  });
}
var Ot = function(e, n, r, i) {
  function o(s) {
    return s instanceof r ? s : new r(function(l) {
      l(s);
    });
  }
  return new (r || (r = Promise))(function(s, l) {
    function c(m) {
      try {
        p(i.next(m));
      } catch (v) {
        l(v);
      }
    }
    function u(m) {
      try {
        p(i.throw(m));
      } catch (v) {
        l(v);
      }
    }
    function p(m) {
      m.done ? s(m.value) : o(m.value).then(c, u);
    }
    p((i = i.apply(e, n || [])).next());
  });
};
const Af = xn.create();
pw(Af);
const gt = console.log;
function ou(e) {
  return Ot(this, void 0, void 0, function* () {
    return new Promise((n) => setTimeout(n, e * 1e3));
  });
}
class fw extends Error {
  constructor(n, r) {
    super(n, r);
  }
}
function vw(e = 0) {
  return Math.min(Math.round((Math.random() + 1) * Math.pow(1.5, e)), 30);
}
const yw = 5;
class gw {
  constructor() {
    Object.defineProperty(this, "authDataPromise", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: null
    }), Object.defineProperty(this, "retryCount", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    });
  }
  init(n) {
    return Ot(this, void 0, void 0, function* () {
      const r = yield this.refresh(n);
      if (r)
        In.setAuthData(r);
      else {
        const i = In.isRefreshTokenExpired(n) ? "expired" : "unknown";
        throw new fw("Failed to init refresh token", {
          cause: i
        });
      }
    });
  }
  getDebugInfo() {
    const n = In.getAccessToken();
    if (!n)
      return {};
    const r = Ir(n), { exp: i } = r;
    return {
      expire: i ? new Date(i * 1e3).toISOString() : null,
      now: (/* @__PURE__ */ new Date()).toISOString()
    };
  }
  /**
   * Gets auth data from LocalStorage, or fetches new auth data if the current
   * token is expired or is about to expire.
   */
  getAuthData() {
    return Ot(this, arguments, void 0, function* ({ localStorageOnly: n = !1 } = {}) {
      if (n)
        return In.getAuthData();
      if (this.authDataPromise)
        return yield this.authDataPromise;
      const r = In.getRefreshToken(), i = In.getAuthData();
      return !r || !i ? null : In.isAccessTokenExpired() ? (Yt({
        category: "refreshToken",
        // Cannot include "token" in the message, as it will be redacted
        message: "expired or about to expire",
        level: "debug",
        data: this.getDebugInfo()
      }), this.authDataPromise = this.refresh(r).then((o) => (o && In.setAuthData(o), this.authDataPromise = null, o)), yield this.authDataPromise) : i;
    });
  }
  removeAuthData() {
    return In.removeAuthData();
  }
  validateAuthDataComplete(n) {
    return In.validateAuthDataComplete(n);
  }
  isAccessTokenExpired() {
    return In.isAccessTokenExpired();
  }
  isRefreshTokenExpired() {
    const n = In.getAuthData();
    return n ? In.isRefreshTokenExpired(n.refresh_token) : !0;
  }
  /** Checks whether refresh token is supported. */
  isSupported() {
    return Ot(this, void 0, void 0, function* () {
      if (!Zd.isElectron())
        return !0;
      const n = yield Zd.getVersion();
      return Ax(n, "3.7.0") === 1;
    });
  }
  /**
   * Gets refreshed tokens from the API
   *
   * @param refreshToken The refresh token.
   * @param retriesLeft The number of retries left.
   */
  refresh(n) {
    return Ot(this, arguments, void 0, function* (r, i = yw) {
      try {
        return yield Af.post(`${ta.url.rest}/v2/login/refresh`, {
          refreshToken: r
        }).then((o) => (this.retryCount = 0, o.data.data));
      } catch (o) {
        return yield this.handleRefreshError(o, r, i);
      }
    });
  }
  waitUntilOnline() {
    return Ot(this, void 0, void 0, function* () {
      const n = navigator.onLine === !1;
      for (n && (gt("AUTH", "Network connection offline - waiting..."), Yt({
        category: "refreshToken",
        message: "Network connection offline - waiting...",
        level: "debug"
      })); navigator.onLine === !1; )
        yield ou(5);
      n && (gt("AUTH", "Network connection restored"), Yt({
        category: "refreshToken",
        message: "Network connection restored",
        level: "debug"
      }));
    });
  }
  retryRefresh(n, r) {
    return Ot(this, void 0, void 0, function* () {
      yield this.waitUntilOnline(), this.retryCount++;
      const i = vw(this.retryCount);
      return gt("AUTH", `Retrying in ${i} seconds`), yield ou(i), yield this.refresh(n, r);
    });
  }
  handleRefreshError(n, r, i) {
    return Ot(this, void 0, void 0, function* () {
      var o;
      if (In.isRefreshTokenExpired(r))
        return gt("AUTH", "Refresh token expired"), Yt({
          category: "refreshToken",
          message: "Refresh token expired",
          level: "debug"
        }), In.removeAuthData(), Zi(), null;
      if (Pg(n)) {
        if (n.message === "timeout exceeded")
          return gt("AUTH", "Timeout exceeded"), Yt({
            category: "refreshToken",
            message: "Timeout exceeded",
            level: "debug"
          }), yield this.retryRefresh(r, i);
        if (n.message === "Network Error")
          return gt("AUTH", "Network error"), Yt({
            category: "refreshToken",
            message: "Network error",
            level: "debug"
          }), yield this.retryRefresh(r, i);
        if (((o = n.response) === null || o === void 0 ? void 0 : o.status) === 401)
          return gt("AUTH", "Refresh token invalid (401)"), In.removeAuthData(), Zi(), null;
        au(n, {
          level: "error",
          tags: {
            team: li.Platform,
            errorSource: "authManager.refresh"
          }
        });
      }
      return i <= 0 ? (gt("AUTH", "Retries exhausted, logging out"), au(n, {
        level: "error",
        tags: {
          team: li.Platform,
          errorSource: "authManager.refresh"
        }
      }), In.removeAuthData(), Zi(), null) : (gt("AUTH", `Retrying ${i} more times`), yield this.retryRefresh(r, i - 1));
    });
  }
  accessTokenExpiresInMs() {
    return In.accessTokenExpiresInMs();
  }
}
const ua = new gw();
var Ys;
(function(e) {
  e[e.BadRequest = 400] = "BadRequest", e[e.Unauthorized = 401] = "Unauthorized", e[e.Forbidden = 403] = "Forbidden", e[e.NotFound = 404] = "NotFound", e[e.Conflict = 409] = "Conflict", e[e.InternalServerError = 500] = "InternalServerError", e[e.BadGateway = 502] = "BadGateway", e[e.ServiceUnavailable = 503] = "ServiceUnavailable";
})(Ys || (Ys = {}));
const hw = Rm(
  async (e, { headers: n }) => {
    const r = ua.isAccessTokenExpired(), i = await ua.getAuthData({
      localStorageOnly: !r
    }), o = i == null ? void 0 : i.access_token;
    return {
      headers: {
        ...n,
        Authorization: o ? `Bearer ${o}` : ""
      }
    };
  }
), kw = Rm(
  (e, n) => {
    const { headers: r, widgetId: i, widgetType: o, operationName: s } = n;
    return {
      ...n,
      headers: {
        ...r,
        ...i && { "x-integration-widget-id": i },
        ...o && { "x-integration-widget-type": o },
        ...s && {
          "x-integration-widget-operation": s
        }
      }
    };
  }
);
function Lf(e) {
  return new ha(function(n, r) {
    return new Tn(function(i) {
      var o, s, l;
      try {
        o = r(n).subscribe({
          next: function(c) {
            if (c.errors && (l = e({
              graphQLErrors: c.errors,
              response: c,
              operation: n,
              forward: r
            }), l)) {
              s = l.subscribe({
                next: i.next.bind(i),
                error: i.error.bind(i),
                complete: i.complete.bind(i)
              });
              return;
            }
            i.next(c);
          },
          error: function(c) {
            if (l = e({
              operation: n,
              networkError: c,
              //Network errors can return GraphQL errors on for example a 403
              graphQLErrors: c && c.result && c.result.errors,
              forward: r
            }), l) {
              s = l.subscribe({
                next: i.next.bind(i),
                error: i.error.bind(i),
                complete: i.complete.bind(i)
              });
              return;
            }
            i.error(c);
          },
          complete: function() {
            l || i.complete.bind(i)();
          }
        });
      } catch (c) {
        e({ networkError: c, operation: n, forward: r }), i.error(c);
      }
      return function() {
        o && o.unsubscribe(), s && o.unsubscribe();
      };
    });
  });
}
(function(e) {
  xm(n, e);
  function n(r) {
    var i = e.call(this) || this;
    return i.link = Lf(r), i;
  }
  return n.prototype.request = function(r, i) {
    return this.link.request(r, i);
  }, n;
})(ha);
const bw = Lf(
  ({ graphQLErrors: e, operation: n, forward: r }) => {
    if (e && e.some(
      (o) => {
        var s, l;
        return ((l = (s = o == null ? void 0 : o.extensions) == null ? void 0 : s.integration) == null ? void 0 : l.code) === "DIXA_AUTHORIZATION_ERROR";
      }
    ))
      return r(n);
  }
), Uf = (e) => new Uv({
  queryDeduplication: !1,
  cache: new Mv(),
  link: Bv.from([
    bw,
    hw,
    kw,
    Vv({
      uri: `${e}/graphql`,
      fetch: Wv
    })
  ]),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    query: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    mutate: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    }
  }
}), _w = ({
  configuration: e,
  children: n
}) => {
  const r = At(
    () => Uf(e.baseUrl),
    [e.baseUrl]
  );
  return /* @__PURE__ */ xe.jsx(qv, { client: r, children: n });
}, Mf = ({
  integrationId: e,
  type: n,
  configuration: r,
  showNotification: i,
  showModal: o,
  children: s
}) => {
  const l = !!e && !!n;
  return /* @__PURE__ */ xe.jsx(_w, { configuration: r, children: l ? /* @__PURE__ */ xe.jsx(zv, { children: (c) => /* @__PURE__ */ xe.jsx(
    Sv,
    {
      value: {
        useMutation: Nv(e, n),
        useQuery: xv(e, n),
        useLazyQuery: wv(e, n),
        executeQuery: jv(e, n, c),
        showNotification: i,
        showModal: o ?? (() => null)
      },
      children: s
    }
  ) }) : s });
}, Sw = ci`
  query getWidgetConfigurations {
    Management {
      widgetConfigurations {
        id
        type
        enabled
        name
        settings {
          key
          value
        }
      }
    }
  }
`;
function Nw(e) {
  const [n, r] = G([]), [i, o] = G(!1);
  return Pe(() => {
    o(!0), Uf(e).query({
      query: Sw
    }).then(({ data: s }) => {
      var l;
      r((l = s == null ? void 0 : s.Management) == null ? void 0 : l.widgetConfigurations), o(!1);
    }).catch(() => o(!1));
  }, [e]), {
    isLoading: i,
    widgets: n
  };
}
const Bf = ({
  headline: e,
  text: n,
  children: r,
  onConfirm: i,
  onCancel: o,
  confirmLabel: s,
  cancelLabel: l = "Cancel",
  confirmVariant: c = "primary",
  cancelVariant: u = "secondary",
  isOpen: p,
  setIsOpen: m,
  showOnClose: v = !1
}) => /* @__PURE__ */ xe.jsxs(
  jt,
  {
    isOpen: p,
    onClose: () => {
      o && o(), m(!1);
    },
    children: [
      /* @__PURE__ */ xe.jsx(
        Ct,
        {
          title: e,
          onClose: v ? o : void 0
        }
      ),
      /* @__PURE__ */ xe.jsxs(Et, { children: [
        n && /* @__PURE__ */ xe.jsx("div", { style: { width: "600px" }, children: n }),
        r
      ] }),
      /* @__PURE__ */ xe.jsx(
        Mt,
        {
          confirmOnClick: i ? () => {
            i(), m(!1);
          } : void 0,
          cancelOnClick: () => {
            o && o(), m(!1);
          },
          confirmName: s,
          cancelName: l,
          confirmProps: { variant: c },
          cancelProps: { variant: u }
        }
      )
    ]
  }
), xw = "_widgetContentWrapper_9ss9w_1", ww = {
  widgetContentWrapper: xw
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._contentWrapper_11voh_27{margin-bottom:16px}._contentWrapperHeadline_11voh_30{font-weight:600;font-size:10px;line-height:16px;color:#8294b0;margin-bottom:4px}._contentWrapperBody_11voh_37{max-height:75vh;overflow-y:auto}._contentWrapperAssigneeIcon_11voh_41{border-radius:50%;width:16px;vertical-align:middle}._contentWrapperStatusTag_11voh_46{margin-right:8px}._collapse_po0up_27{border:1px solid #d7dfea;border-radius:4px;font-size:12px;line-height:16px;padding:0}._collapseHeader_po0up_36>div{padding:16px 0!important}._collapseHeader_po0up_36>div>div>p{white-space:unset!important}._collapseHeader_po0up_36>div:first-child{width:100%}._collapseHeader_po0up_36>div:first-child div:first-child{width:100%}._collapseHeader_po0up_36>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_po0up_36{background-color:transparent!important;padding:0 16px 0 0;letter-spacing:-.08px;color:#8193b0}._collapseHeaderKey_po0up_57{font-size:12px;line-height:16px;color:#45587c}._collapseHeaderKeyIcon_po0up_62{margin-top:-2px;margin-right:4px;vertical-align:middle}._collapseHeaderKeyLink_po0up_67{text-decoration:none}._collapseHeaderIcon_po0up_70{padding-top:.35em;margin-left:4px;vertical-align:text-bottom}._collapseHeaderTitle_po0up_75{font-weight:600;font-size:14px;line-height:20px;letter-spacing:-.16px;color:#132243;width:100%}._collapseContent_po0up_83{padding:8px 16px!important}._collapseContentButtonSpacer_po0up_86{margin-top:12px}._collapseContentButtonLink_po0up_89{color:#0079cc}._result_14c4f_27{padding:0 8px;margin:0;outline:0;border:0;color:#132243;background-color:#fff;box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_14c4f_27:hover,._result_14c4f_27:focus{background-color:#f5f7fa}._resultName_14c4f_47{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:600}._resultItemIcon_14c4f_55{margin-top:-2px;margin-right:4px;vertical-align:middle}._resultDescription_14c4f_60{width:100%;text-align:left;font-size:12px;line-height:16px;color:#46597c;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_14c4f_72{position:absolute;right:5px;background-color:#fff;border:1px solid #d7dfea;border-radius:5px;color:#8193b0}._tooltip_14c4f_81{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipName_14c4f_87{text-align:left;white-space:nowrap;font-weight:600}._tooltipNameIcon_14c4f_92{height:20px;padding-right:4px;margin-top:-2px}._tooltipTag_14c4f_97{width:fit-content;max-width:15em}._itemButton_1vyz1_27{border:none;padding:0}._result_1vyz1_32{padding:0 8px;margin:0;outline:0;border:0;color:#132243;background-color:#fff;box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_1vyz1_32:hover,._result_1vyz1_32:focus{background-color:#f5f7fa}._resultIcon_1vyz1_52{height:24px;padding-right:12px}._resultName_1vyz1_56{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:400}._resultCheckIcon_1vyz1_64{height:24px}._resultAssigneeIcon_1vyz1_67{border-radius:50%;width:16px;vertical-align:middle;margin-right:8px}._modalBody_15ysb_27{width:600px}._modalBodyFormFields_15ysb_30{display:grid;gap:16px 24px}._wrapper_e2103_27{gap:12px;margin-bottom:16px}._inputWrapper_e2103_32{background-color:#f5f7fa;border-radius:4px;margin:16px 0;gap:12px;padding:16px;text-align:center}._inputField_e2103_41{text-align:center}._buttonLink_e2103_45{color:#0079cc}._noItemsFound_e2103_49{color:#b5c1d4;font-size:12px}._createIssueButton_e2103_54{min-height:38px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Qs = { exports: {} }, ur = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Vo, su;
function Vf() {
  if (su)
    return Vo;
  su = 1;
  var e = Object.getOwnPropertySymbols, n = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function i(s) {
    if (s == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(s);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var s = new String("abc");
      if (s[5] = "de", Object.getOwnPropertyNames(s)[0] === "5")
        return !1;
      for (var l = {}, c = 0; c < 10; c++)
        l["_" + String.fromCharCode(c)] = c;
      var u = Object.getOwnPropertyNames(l).map(function(m) {
        return l[m];
      });
      if (u.join("") !== "0123456789")
        return !1;
      var p = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(m) {
        p[m] = m;
      }), Object.keys(Object.assign({}, p)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Vo = o() ? Object.assign : function(s, l) {
    for (var c, u = i(s), p, m = 1; m < arguments.length; m++) {
      c = Object(arguments[m]);
      for (var v in c)
        n.call(c, v) && (u[v] = c[v]);
      if (e) {
        p = e(c);
        for (var y = 0; y < p.length; y++)
          r.call(c, p[y]) && (u[p[y]] = c[p[y]]);
      }
    }
    return u;
  }, Vo;
}
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var lu;
function jw() {
  if (lu)
    return ur;
  lu = 1, Vf();
  var e = Cn, n = 60103;
  if (ur.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var r = Symbol.for;
    n = r("react.element"), ur.Fragment = r("react.fragment");
  }
  var i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = Object.prototype.hasOwnProperty, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(c, u, p) {
    var m, v = {}, y = null, b = null;
    p !== void 0 && (y = "" + p), u.key !== void 0 && (y = "" + u.key), u.ref !== void 0 && (b = u.ref);
    for (m in u)
      o.call(u, m) && !s.hasOwnProperty(m) && (v[m] = u[m]);
    if (c && c.defaultProps)
      for (m in u = c.defaultProps, u)
        v[m] === void 0 && (v[m] = u[m]);
    return { $$typeof: n, type: c, key: y, ref: b, props: v, _owner: i.current };
  }
  return ur.jsx = l, ur.jsxs = l, ur;
}
var cu = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var du;
function Cw() {
  return du || (du = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      var n = Cn, r = Vf(), i = 60103, o = 60106;
      e.Fragment = 60107;
      var s = 60108, l = 60114, c = 60109, u = 60110, p = 60112, m = 60113, v = 60120, y = 60115, b = 60116, N = 60121, x = 60122, T = 60117, $ = 60129, P = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var h = Symbol.for;
        i = h("react.element"), o = h("react.portal"), e.Fragment = h("react.fragment"), s = h("react.strict_mode"), l = h("react.profiler"), c = h("react.provider"), u = h("react.context"), p = h("react.forward_ref"), m = h("react.suspense"), v = h("react.suspense_list"), y = h("react.memo"), b = h("react.lazy"), N = h("react.block"), x = h("react.server.block"), T = h("react.fundamental"), h("react.scope"), h("react.opaque.id"), $ = h("react.debug_trace_mode"), h("react.offscreen"), P = h("react.legacy_hidden");
      }
      var E = typeof Symbol == "function" && Symbol.iterator, q = "@@iterator";
      function M(t) {
        if (t === null || typeof t != "object")
          return null;
        var a = E && t[E] || t[q];
        return typeof a == "function" ? a : null;
      }
      var R = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function w(t) {
        {
          for (var a = arguments.length, d = new Array(a > 1 ? a - 1 : 0), f = 1; f < a; f++)
            d[f - 1] = arguments[f];
          H("error", t, d);
        }
      }
      function H(t, a, d) {
        {
          var f = R.ReactDebugCurrentFrame, _ = f.getStackAddendum();
          _ !== "" && (a += "%s", d = d.concat([_]));
          var S = d.map(function(k) {
            return "" + k;
          });
          S.unshift("Warning: " + a), Function.prototype.apply.call(console[t], console, S);
        }
      }
      var pe = !1;
      function le(t) {
        return !!(typeof t == "string" || typeof t == "function" || t === e.Fragment || t === l || t === $ || t === s || t === m || t === v || t === P || pe || typeof t == "object" && t !== null && (t.$$typeof === b || t.$$typeof === y || t.$$typeof === c || t.$$typeof === u || t.$$typeof === p || t.$$typeof === T || t.$$typeof === N || t[0] === x));
      }
      function Se(t, a, d) {
        var f = a.displayName || a.name || "";
        return t.displayName || (f !== "" ? d + "(" + f + ")" : d);
      }
      function ae(t) {
        return t.displayName || "Context";
      }
      function D(t) {
        if (t == null)
          return null;
        if (typeof t.tag == "number" && w("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof t == "function")
          return t.displayName || t.name || null;
        if (typeof t == "string")
          return t;
        switch (t) {
          case e.Fragment:
            return "Fragment";
          case o:
            return "Portal";
          case l:
            return "Profiler";
          case s:
            return "StrictMode";
          case m:
            return "Suspense";
          case v:
            return "SuspenseList";
        }
        if (typeof t == "object")
          switch (t.$$typeof) {
            case u:
              var a = t;
              return ae(a) + ".Consumer";
            case c:
              var d = t;
              return ae(d._context) + ".Provider";
            case p:
              return Se(t, t.render, "ForwardRef");
            case y:
              return D(t.type);
            case N:
              return D(t._render);
            case b: {
              var f = t, _ = f._payload, S = f._init;
              try {
                return D(S(_));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var V = 0, de, te, he, _e, Z, J, z;
      function me() {
      }
      me.__reactDisabledLog = !0;
      function ke() {
        {
          if (V === 0) {
            de = console.log, te = console.info, he = console.warn, _e = console.error, Z = console.group, J = console.groupCollapsed, z = console.groupEnd;
            var t = {
              configurable: !0,
              enumerable: !0,
              value: me,
              writable: !0
            };
            Object.defineProperties(console, {
              info: t,
              log: t,
              warn: t,
              error: t,
              group: t,
              groupCollapsed: t,
              groupEnd: t
            });
          }
          V++;
        }
      }
      function Oe() {
        {
          if (V--, V === 0) {
            var t = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: r({}, t, {
                value: de
              }),
              info: r({}, t, {
                value: te
              }),
              warn: r({}, t, {
                value: he
              }),
              error: r({}, t, {
                value: _e
              }),
              group: r({}, t, {
                value: Z
              }),
              groupCollapsed: r({}, t, {
                value: J
              }),
              groupEnd: r({}, t, {
                value: z
              })
            });
          }
          V < 0 && w("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var Y = R.ReactCurrentDispatcher, fe;
      function ge(t, a, d) {
        {
          if (fe === void 0)
            try {
              throw Error();
            } catch (_) {
              var f = _.stack.trim().match(/\n( *(at )?)/);
              fe = f && f[1] || "";
            }
          return `
` + fe + t;
        }
      }
      var X = !1, ye;
      {
        var W = typeof WeakMap == "function" ? WeakMap : Map;
        ye = new W();
      }
      function ce(t, a) {
        if (!t || X)
          return "";
        {
          var d = ye.get(t);
          if (d !== void 0)
            return d;
        }
        var f;
        X = !0;
        var _ = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var S;
        S = Y.current, Y.current = null, ke();
        try {
          if (a) {
            var k = function() {
              throw Error();
            };
            if (Object.defineProperty(k.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(k, []);
              } catch (A) {
                f = A;
              }
              Reflect.construct(t, [], k);
            } else {
              try {
                k.call();
              } catch (A) {
                f = A;
              }
              t.call(k.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (A) {
              f = A;
            }
            t();
          }
        } catch (A) {
          if (A && f && typeof A.stack == "string") {
            for (var g = A.stack.split(`
`), L = f.stack.split(`
`), I = g.length - 1, O = L.length - 1; I >= 1 && O >= 0 && g[I] !== L[O]; )
              O--;
            for (; I >= 1 && O >= 0; I--, O--)
              if (g[I] !== L[O]) {
                if (I !== 1 || O !== 1)
                  do
                    if (I--, O--, O < 0 || g[I] !== L[O]) {
                      var re = `
` + g[I].replace(" at new ", " at ");
                      return typeof t == "function" && ye.set(t, re), re;
                    }
                  while (I >= 1 && O >= 0);
                break;
              }
          }
        } finally {
          X = !1, Y.current = S, Oe(), Error.prepareStackTrace = _;
        }
        var Ce = t ? t.displayName || t.name : "", j = Ce ? ge(Ce) : "";
        return typeof t == "function" && ye.set(t, j), j;
      }
      function ie(t, a, d) {
        return ce(t, !1);
      }
      function oe(t) {
        var a = t.prototype;
        return !!(a && a.isReactComponent);
      }
      function be(t, a, d) {
        if (t == null)
          return "";
        if (typeof t == "function")
          return ce(t, oe(t));
        if (typeof t == "string")
          return ge(t);
        switch (t) {
          case m:
            return ge("Suspense");
          case v:
            return ge("SuspenseList");
        }
        if (typeof t == "object")
          switch (t.$$typeof) {
            case p:
              return ie(t.render);
            case y:
              return be(t.type, a, d);
            case N:
              return ie(t._render);
            case b: {
              var f = t, _ = f._payload, S = f._init;
              try {
                return be(S(_), a, d);
              } catch {
              }
            }
          }
        return "";
      }
      var Ee = {}, Ie = R.ReactDebugCurrentFrame;
      function we(t) {
        if (t) {
          var a = t._owner, d = be(t.type, t._source, a ? a.type : null);
          Ie.setExtraStackFrame(d);
        } else
          Ie.setExtraStackFrame(null);
      }
      function Ge(t, a, d, f, _) {
        {
          var S = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var k in t)
            if (S(t, k)) {
              var g = void 0;
              try {
                if (typeof t[k] != "function") {
                  var L = Error((f || "React class") + ": " + d + " type `" + k + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[k] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw L.name = "Invariant Violation", L;
                }
                g = t[k](a, k, f, d, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (I) {
                g = I;
              }
              g && !(g instanceof Error) && (we(_), w("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", f || "React class", d, k, typeof g), we(null)), g instanceof Error && !(g.message in Ee) && (Ee[g.message] = !0, we(_), w("Failed %s type: %s", d, g.message), we(null));
            }
        }
      }
      var je = R.ReactCurrentOwner, Te = Object.prototype.hasOwnProperty, Ye = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, Ae, Be, De;
      De = {};
      function cn(t) {
        if (Te.call(t, "ref")) {
          var a = Object.getOwnPropertyDescriptor(t, "ref").get;
          if (a && a.isReactWarning)
            return !1;
        }
        return t.ref !== void 0;
      }
      function en(t) {
        if (Te.call(t, "key")) {
          var a = Object.getOwnPropertyDescriptor(t, "key").get;
          if (a && a.isReactWarning)
            return !1;
        }
        return t.key !== void 0;
      }
      function yn(t, a) {
        if (typeof t.ref == "string" && je.current && a && je.current.stateNode !== a) {
          var d = D(je.current.type);
          De[d] || (w('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', D(je.current.type), t.ref), De[d] = !0);
        }
      }
      function pn(t, a) {
        {
          var d = function() {
            Ae || (Ae = !0, w("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", a));
          };
          d.isReactWarning = !0, Object.defineProperty(t, "key", {
            get: d,
            configurable: !0
          });
        }
      }
      function gn(t, a) {
        {
          var d = function() {
            Be || (Be = !0, w("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", a));
          };
          d.isReactWarning = !0, Object.defineProperty(t, "ref", {
            get: d,
            configurable: !0
          });
        }
      }
      var dn = function(t, a, d, f, _, S, k) {
        var g = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: i,
          // Built-in properties that belong on the element
          type: t,
          key: a,
          ref: d,
          props: k,
          // Record the component responsible for creating this element.
          _owner: S
        };
        return g._store = {}, Object.defineProperty(g._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(g, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: f
        }), Object.defineProperty(g, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: _
        }), Object.freeze && (Object.freeze(g.props), Object.freeze(g)), g;
      };
      function un(t, a, d, f, _) {
        {
          var S, k = {}, g = null, L = null;
          d !== void 0 && (g = "" + d), en(a) && (g = "" + a.key), cn(a) && (L = a.ref, yn(a, _));
          for (S in a)
            Te.call(a, S) && !Ye.hasOwnProperty(S) && (k[S] = a[S]);
          if (t && t.defaultProps) {
            var I = t.defaultProps;
            for (S in I)
              k[S] === void 0 && (k[S] = I[S]);
          }
          if (g || L) {
            var O = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
            g && pn(k, O), L && gn(k, O);
          }
          return dn(t, g, L, _, f, je.current, k);
        }
      }
      var Re = R.ReactCurrentOwner, He = R.ReactDebugCurrentFrame;
      function Ne(t) {
        if (t) {
          var a = t._owner, d = be(t.type, t._source, a ? a.type : null);
          He.setExtraStackFrame(d);
        } else
          He.setExtraStackFrame(null);
      }
      var Le;
      Le = !1;
      function Me(t) {
        return typeof t == "object" && t !== null && t.$$typeof === i;
      }
      function ze() {
        {
          if (Re.current) {
            var t = D(Re.current.type);
            if (t)
              return `

Check the render method of \`` + t + "`.";
          }
          return "";
        }
      }
      function _n(t) {
        {
          if (t !== void 0) {
            var a = t.fileName.replace(/^.*[\\\/]/, ""), d = t.lineNumber;
            return `

Check your code at ` + a + ":" + d + ".";
          }
          return "";
        }
      }
      var Je = {};
      function qe(t) {
        {
          var a = ze();
          if (!a) {
            var d = typeof t == "string" ? t : t.displayName || t.name;
            d && (a = `

Check the top-level render call using <` + d + ">.");
          }
          return a;
        }
      }
      function Ke(t, a) {
        {
          if (!t._store || t._store.validated || t.key != null)
            return;
          t._store.validated = !0;
          var d = qe(a);
          if (Je[d])
            return;
          Je[d] = !0;
          var f = "";
          t && t._owner && t._owner !== Re.current && (f = " It was passed a child from " + D(t._owner.type) + "."), Ne(t), w('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', d, f), Ne(null);
        }
      }
      function Ze(t, a) {
        {
          if (typeof t != "object")
            return;
          if (Array.isArray(t))
            for (var d = 0; d < t.length; d++) {
              var f = t[d];
              Me(f) && Ke(f, a);
            }
          else if (Me(t))
            t._store && (t._store.validated = !0);
          else if (t) {
            var _ = M(t);
            if (typeof _ == "function" && _ !== t.entries)
              for (var S = _.call(t), k; !(k = S.next()).done; )
                Me(k.value) && Ke(k.value, a);
          }
        }
      }
      function hn(t) {
        {
          var a = t.type;
          if (a == null || typeof a == "string")
            return;
          var d;
          if (typeof a == "function")
            d = a.propTypes;
          else if (typeof a == "object" && (a.$$typeof === p || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          a.$$typeof === y))
            d = a.propTypes;
          else
            return;
          if (d) {
            var f = D(a);
            Ge(d, t.props, "prop", f, t);
          } else if (a.PropTypes !== void 0 && !Le) {
            Le = !0;
            var _ = D(a);
            w("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _ || "Unknown");
          }
          typeof a.getDefaultProps == "function" && !a.getDefaultProps.isReactClassApproved && w("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function fn(t) {
        {
          for (var a = Object.keys(t.props), d = 0; d < a.length; d++) {
            var f = a[d];
            if (f !== "children" && f !== "key") {
              Ne(t), w("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", f), Ne(null);
              break;
            }
          }
          t.ref !== null && (Ne(t), w("Invalid attribute `ref` supplied to `React.Fragment`."), Ne(null));
        }
      }
      function Qe(t, a, d, f, _, S) {
        {
          var k = le(t);
          if (!k) {
            var g = "";
            (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (g += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var L = _n(_);
            L ? g += L : g += ze();
            var I;
            t === null ? I = "null" : Array.isArray(t) ? I = "array" : t !== void 0 && t.$$typeof === i ? (I = "<" + (D(t.type) || "Unknown") + " />", g = " Did you accidentally export a JSX literal instead of a component?") : I = typeof t, w("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", I, g);
          }
          var O = un(t, a, d, _, S);
          if (O == null)
            return O;
          if (k) {
            var re = a.children;
            if (re !== void 0)
              if (f)
                if (Array.isArray(re)) {
                  for (var Ce = 0; Ce < re.length; Ce++)
                    Ze(re[Ce], t);
                  Object.freeze && Object.freeze(re);
                } else
                  w("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                Ze(re, t);
          }
          return t === e.Fragment ? fn(O) : hn(O), O;
        }
      }
      function kn(t, a, d) {
        return Qe(t, a, d, !0);
      }
      function Sn(t, a, d) {
        return Qe(t, a, d, !1);
      }
      var mn = Sn, vn = kn;
      e.jsx = mn, e.jsxs = vn;
    }();
  }(cu)), cu;
}
process.env.NODE_ENV === "production" ? Qs.exports = jw() : Qs.exports = Cw();
var K = Qs.exports;
const Ew = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "IssueFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "issueState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, Fw = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "PullRequestFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "prState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, Iw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubOrganizationMembersByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "organization" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "login" }, value: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "members" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "login" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] } }] }, $w = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createGithubIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "GitHub_CreateIssueInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, Tw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubRepositoriesByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "REPOSITORY" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repositoryCount" } }, { kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Repository" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, Ow = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "issues" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "pullRequests" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "prQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] } }] }, Rw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, Dw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPullRequest" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pullRequest" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "prNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, Pw = {
  "\n  query getGithubOrganizationMembersByName(\n    $organizationQuery: String!\n    $usersQuery: String!\n    $maxResults: Int!\n  ) {\n    GitHub {\n      organization(login: $organizationQuery) {\n        teams(first: $maxResults) {\n          edges {\n            node {\n              id\n              name\n              members(first: $maxResults, query: $usersQuery) {\n                edges {\n                  node {\n                    id\n                    name\n                    login\n                    avatarUrl\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": Iw,
  "\n  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {\n    GitHub {\n      createIssue(input: $input) {\n        issue {\n          id\n          number\n          repository {\n            name\n          }\n        }\n      }\n    }\n  }\n": $w,
  "\n  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {\n    GitHub {\n      search(query: $query, type: REPOSITORY, first: $maxResults) {\n        repositoryCount\n        edges {\n          node {\n            ... on GitHub_Repository {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": Tw,
  "\n  fragment IssueFields on GitHub_Issue {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    issueState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": Ew,
  "\n  fragment PullRequestFields on GitHub_PullRequest {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    prState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": Fw,
  "\n  query searchItems(\n    $issueQuery: String!\n    $prQuery: String!\n    $maxIssueResults: Int\n    $maxPRResults: Int\n  ) {\n    GitHub {\n      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {\n        issueCount\n        nodes {\n          ... on GitHub_Issue {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {\n        issueCount\n        nodes {\n          ... on GitHub_PullRequest {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": Ow,
  "\n  query getIssue(\n    $owner: String!\n    $repositoryName: String!\n    $issueNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        issue(number: $issueNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": Rw,
  "\n  query getPullRequest(\n    $owner: String!\n    $repositoryName: String!\n    $prNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        pullRequest(number: $prNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": Dw
};
function Vr(e) {
  return Pw[e] ?? {};
}
const Aw = Vr(
  /* GraphQL */
  `
  query searchItems(
    $issueQuery: String!
    $prQuery: String!
    $maxIssueResults: Int
    $maxPRResults: Int
  ) {
    GitHub {
      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {
        issueCount
        nodes {
          ... on GitHub_Issue {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {
        issueCount
        nodes {
          ... on GitHub_PullRequest {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
    }
  }
`
), Lw = Vr(
  /* GraphQL */
  `
  query getIssue(
    $owner: String!
    $repositoryName: String!
    $issueNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        issue(number: $issueNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), Uw = Vr(
  /* GraphQL */
  `
  query getPullRequest(
    $owner: String!
    $repositoryName: String!
    $prNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        pullRequest(number: $prNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), uu = ({
  owner: e,
  repository: n,
  number: r
}) => `https://github.com/${e}/${n}/issues/${r}`, Hn = ({
  owner: e,
  repository: n,
  number: r
}) => `${e}/${n} #${r}`, Mw = ({
  number: e,
  repository: n
}) => ({
  number: e,
  repository: n.name,
  owner: n.owner.login
}), mu = (e) => {
  switch (e) {
    case "ISSUE":
      return "issue";
    case "PR":
      return "pull request";
    default:
      return e;
  }
}, Js = (e, n, r) => e === "ISSUE" ? {
  OPEN: /* @__PURE__ */ K.jsxs(
    "svg",
    {
      className: r,
      fill: "#3fb950",
      height: "16",
      width: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ K.jsx("path", { d: "M8 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" }),
        /* @__PURE__ */ K.jsx("path", { d: "M8 0a8 8 0 100 16A8 8 0 008 0zM1.5 8a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z" })
      ]
    }
  ),
  CLOSED: /* @__PURE__ */ K.jsxs(
    "svg",
    {
      className: r,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ K.jsx("path", { d: "M11.28 6.78a.75.75 0 00-1.06-1.06L7.25 8.69 5.78 7.22a.75.75 0 00-1.06 1.06l2 2a.75.75 0 001.06 0l3.5-3.5z" }),
        /* @__PURE__ */ K.jsx(
          "path",
          {
            fillRule: "evenodd",
            d: "M16 8A8 8 0 110 8a8 8 0 0116 0zm-1.5 0a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z"
          }
        )
      ]
    }
  )
}[n] : {
  OPEN: /* @__PURE__ */ K.jsx(
    "svg",
    {
      className: r,
      fill: "#3fb950",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ K.jsx("path", { d: "M7.177 3.073L9.573.677A.25.25 0 0110 .854v4.792a.25.25 0 01-.427.177L7.177 3.427a.25.25 0 010-.354zM3.75 2.5a.75.75 0 100 1.5.75.75 0 000-1.5zm-2.25.75a2.25 2.25 0 113 2.122v5.256a2.251 2.251 0 11-1.5 0V5.372A2.25 2.25 0 011.5 3.25zM11 2.5h-1V4h1a1 1 0 011 1v5.628a2.251 2.251 0 101.5 0V5A2.5 2.5 0 0011 2.5zm1 10.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.75 12a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  ),
  MERGED: /* @__PURE__ */ K.jsx(
    "svg",
    {
      className: r,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ K.jsx("path", { d: "M5 3.254V3.25v.005a.75.75 0 110-.005v.004zm.45 1.9a2.25 2.25 0 10-1.95.218v5.256a2.25 2.25 0 101.5 0V7.123A5.735 5.735 0 009.25 9h1.378a2.251 2.251 0 100-1.5H9.25a4.25 4.25 0 01-3.8-2.346zM12.75 9a.75.75 0 100-1.5.75.75 0 000 1.5zm-8.5 4.5a.75.75 0 100-1.5.75.75 0 000 1.5z" })
    }
  ),
  CLOSED: /* @__PURE__ */ K.jsx(
    "svg",
    {
      className: r,
      fill: "#f85149",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ K.jsx("path", { d: "M10.72 1.227a.75.75 0 011.06 0l.97.97.97-.97a.75.75 0 111.06 1.061l-.97.97.97.97a.75.75 0 01-1.06 1.06l-.97-.97-.97.97a.75.75 0 11-1.06-1.06l.97-.97-.97-.97a.75.75 0 010-1.06zM12.75 6.5a.75.75 0 00-.75.75v3.378a2.251 2.251 0 101.5 0V7.25a.75.75 0 00-.75-.75zm0 5.5a.75.75 0 100 1.5.75.75 0 000-1.5zM2.5 3.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.25 1a2.25 2.25 0 00-.75 4.372v5.256a2.251 2.251 0 101.5 0V5.372A2.25 2.25 0 003.25 1zm0 11a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  )
}[n];
function Bw({
  conversationId: e,
  githubOrganization: n
}) {
  var r, i;
  const o = {
    github: { issues: [], pullRequests: [] }
  }, [s, l] = G(
    []
  ), [c, u] = G([]), [p, m] = G([]), [v, y] = G([]), [b, N] = G(), { showNotification: x, showModal: T, executeQuery: $ } = rn(), { track: P } = sn(), {
    loading: h,
    data: E,
    error: q,
    store: M
  } = fl(e ?? null), R = ((r = E == null ? void 0 : E.github) == null ? void 0 : r.issues) || [], w = ((i = E == null ? void 0 : E.github) == null ? void 0 : i.pullRequests) || [], [H, pe] = G(!1), [le, Se] = G();
  Pe(
    () => N(q || le || void 0),
    [q, le]
  ), Pe(
    () => {
      !h && (R != null && R.length || w != null && w.length) ? (l(R), u(w), D(R, w)) : (l([]), u([]), m([]), y([]));
    },
    // Only trigger when data is loaded, not when the loading status changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [E]
  );
  const ae = async (J, z) => {
    await M(J).then(() => {
      x({
        icon: "check-circle-filled",
        severity: "success",
        title: z.success.title,
        text: z.success.text
      });
    }).catch((me) => {
      x({
        title: z.error.title,
        text: `${z.error.text} ${me.message && " (" + me.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, D = (J, z) => {
    if (!(J != null && J.length) && !(z != null && z.length)) {
      m([]), y([]);
      return;
    }
    const me = (J || []).map(
      (Y) => $(Lw, {
        owner: Y.owner,
        repositoryName: Y.repository,
        issueNumber: Y.number
      })
    ), ke = (z || []).map(
      (Y) => $(Uw, {
        owner: Y.owner,
        repositoryName: Y.repository,
        prNumber: Y.number
      })
    ), Oe = [...me, ...ke];
    pe(!0), Promise.all(Oe).then((Y) => {
      const fe = [], ge = [];
      Y.forEach((X) => {
        var ye;
        const W = (ye = X == null ? void 0 : X.data) == null ? void 0 : ye.GitHub;
        if (!W) {
          m([]), y([]);
          return;
        }
        Object.keys(W).forEach((ce) => {
          if (ce.startsWith("repository")) {
            const ie = W[ce];
            Object.keys(ie).forEach((oe) => {
              var be, Ee, Ie;
              const we = ie[oe], Ge = {
                number: we == null ? void 0 : we.number,
                owner: (Ee = (be = we == null ? void 0 : we.repository) == null ? void 0 : be.owner) == null ? void 0 : Ee.login,
                repository: (Ie = we == null ? void 0 : we.repository) == null ? void 0 : Ie.name
              };
              oe.startsWith("issue") && fe.push({
                ...we,
                type: "ISSUE",
                key: Ge
              }), oe.startsWith("pullRequest") && ge.push({
                ...we,
                type: "PR",
                key: Ge
              });
            });
          }
        });
      }), m(fe), y(ge);
    }).catch(Se).finally(() => {
      pe(!1);
    });
  }, V = ({ key: J, type: z }) => {
    P("github:link:issue:clicked", {
      githubOrganization: n
    });
    const me = E && (R.length || w.length) ? E : o, ke = z === "ISSUE" ? "issues" : "pullRequests";
    me.github[ke] = Array.from(
      new Set(me.github[ke]).add(J)
    ), ae(me, {
      success: {
        title: "GitHub issue linked",
        text: `You linked the GitHub issue ${Hn(
          J
        )} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${Hn(J)} failed. Please try again.`
      }
    });
  }, de = async ({ key: J, type: z }) => {
    P("github:link:issue:clicked", {
      githubOrganization: n
    });
    const me = E && (R.length || w.length) ? E : o, ke = z === "ISSUE" ? "issues" : "pullRequests";
    me.github[ke] = Array.from(
      new Set(me.github[ke]).add(J)
    ), await M(me).catch((Oe) => {
      x({
        title: "Linking failed",
        text: `Linking ${J} failed. Please try again. ${Oe.message && " (" + Oe.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, te = ({ key: J, type: z }) => {
    P("github:unlink:issue:clicked", {
      githubOrganization: n
    });
    const me = z === "ISSUE" ? "issue" : "pull request";
    T({
      headline: `Unlink ${me} ${Hn(J)}?`,
      text: `You are about to unlink the ${me} ${Hn(
        J
      )}. Do you want to proceed?`,
      confirmLabel: `Unlink GitHub ${me}`,
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        var ke;
        const Oe = z === "ISSUE" ? "issues" : "pullRequests";
        if (!E)
          return;
        const Y = {
          ...E,
          github: {
            ...E == null ? void 0 : E.github,
            [Oe]: (ke = E == null ? void 0 : E.github) == null ? void 0 : ke[Oe].filter(
              (fe) => fe.number !== J.number || fe.owner !== J.owner || fe.repository !== J.repository
            )
          }
        };
        P("github:unlink:issue:confirmed", {
          githubOrganization: n
        }), ae(Y, {
          success: {
            title: `GitHub ${me} unlinked`,
            text: `You unlinked the GitHub ${me} ${Hn(
              J
            )}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${Hn(J)} failed.`
          }
        });
      },
      onCancel: () => {
        P("github:unlink:issue:canceled", {
          githubOrganization: n
        });
      }
    });
  }, he = () => {
    P("github:unlink:all:clicked", {
      githubOrganization: n
    }), T({
      headline: "Unlink all GitHub issues/pull requests?",
      text: "You are about to unlink the all GitHub issues/pull requests from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues/pull requests",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        P("github:unlink:all:confirmed", {
          githubOrganization: n
        }), ae(o, {
          success: {
            title: "Unlinking successful",
            text: "All GitHub issues/pull requests were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues/pull requests failed."
          }
        });
      },
      onCancel: () => {
        P("github:unlink:all:canceled", {
          githubOrganization: n
        });
      }
    });
  }, _e = R.filter(
    (J) => !(s != null && s.includes(J))
  ) || [], Z = w.filter(
    (J) => !(c != null && c.includes(J))
  ) || [];
  return {
    linkGithubItem: V,
    linkGithubItemQuietly: de,
    unlinkGithubItem: te,
    loadGithubItems: D,
    removeDanglingGithubItemLinks: () => {
      const J = {
        ...E,
        github: {
          ...E == null ? void 0 : E.github,
          issues: R.filter(
            (z) => !_e.includes(z)
          ) || [],
          pullRequests: w.filter(
            (z) => !Z.includes(z)
          ) || []
        }
      };
      M(J);
    },
    unlinkAllGithubItems: he,
    isLoadingGithubItemLinks: h,
    danglingIssueLinks: _e,
    danglingPullRequestLinks: Z,
    isLoadingGithubItems: H,
    issues: p,
    pullRequests: v,
    error: b
  };
}
const Vw = "_contentWrapper_11voh_27", qw = "_contentWrapperHeadline_11voh_30", zw = "_contentWrapperBody_11voh_37", Hw = "_contentWrapperAssigneeIcon_11voh_41", Kw = "_contentWrapperStatusTag_11voh_46", ht = {
  contentWrapper: Vw,
  contentWrapperHeadline: qw,
  contentWrapperBody: zw,
  contentWrapperAssigneeIcon: Hw,
  contentWrapperStatusTag: Kw
}, qf = ({
  description: e,
  assignees: n,
  labels: r
}) => /* @__PURE__ */ K.jsxs(K.Fragment, { children: [
  e && /* @__PURE__ */ K.jsxs(nn, { className: ht.contentWrapper, children: [
    /* @__PURE__ */ K.jsx(nn, { className: ht.contentWrapperHeadline, children: "Description" }),
    /* @__PURE__ */ K.jsx(nn, { className: ht.contentWrapperBody, children: e })
  ] }),
  (n == null ? void 0 : n.nodes) && n.nodes.length > 0 && /* @__PURE__ */ K.jsxs(nn, { className: ht.contentWrapper, children: [
    /* @__PURE__ */ K.jsx(nn, { className: ht.contentWrapperHeadline, children: "Assignees" }),
    /* @__PURE__ */ K.jsx(nn, { className: ht.contentWrapperBody, children: n.nodes.map(
      (i) => i && /* @__PURE__ */ K.jsxs(nn, { margin: "100 0", children: [
        /* @__PURE__ */ K.jsx(
          "img",
          {
            className: ht.contentWrapperAssigneeIcon,
            src: i.avatarUrl,
            alt: i.name || ""
          }
        ),
        " ",
        i.name
      ] }, i.name)
    ) })
  ] }),
  (r == null ? void 0 : r.nodes) && (r == null ? void 0 : r.nodes.length) > 0 && /* @__PURE__ */ K.jsx(nn, { className: ht.contentWrapper, children: r.nodes.map(
    (i) => i && /* @__PURE__ */ K.jsx(
      an,
      {
        className: ht.contentWrapperStatusTag,
        children: i.name
      },
      i.name
    )
  ) })
] }), Gw = "_collapse_po0up_27", Ww = "_collapseHeader_po0up_36", Yw = "_collapseHeaderKey_po0up_57", Qw = "_collapseHeaderKeyIcon_po0up_62", Jw = "_collapseHeaderKeyLink_po0up_67", Zw = "_collapseHeaderIcon_po0up_70", Xw = "_collapseHeaderTitle_po0up_75", ej = "_collapseContent_po0up_83", nj = "_collapseContentButtonSpacer_po0up_86", tj = "_collapseContentButtonLink_po0up_89", st = {
  collapse: Gw,
  collapseHeader: Ww,
  collapseHeaderKey: Yw,
  collapseHeaderKeyIcon: Qw,
  collapseHeaderKeyLink: Jw,
  collapseHeaderIcon: Zw,
  collapseHeaderTitle: Xw,
  collapseContent: ej,
  collapseContentButtonSpacer: nj,
  collapseContentButtonLink: tj
}, rj = ({
  items: e,
  unlinkGithubItem: n,
  githubOrganization: r
}) => {
  const i = e.reduce(
    (u, p) => ({ ...u, [p.id]: !1 }),
    {}
  ), [o, s] = G(i), { track: l } = sn(), c = (u, p) => {
    s({ ...o, [u]: p });
  };
  return /* @__PURE__ */ K.jsx(C, { flexDirection: "column", gap: "250", children: e != null && e.length ? e.map((u) => {
    const {
      id: p,
      number: m,
      key: v,
      title: y,
      bodyText: b,
      repository: N,
      type: x,
      state: T,
      assignees: $,
      labels: P
    } = u, h = o[p];
    return /* @__PURE__ */ K.jsxs(
      Kn,
      {
        onToggle: () => c(p, !o[p]),
        isOpen: h,
        className: st.collapse,
        children: [
          /* @__PURE__ */ K.jsx(Kn.Header, { className: st.collapseHeader, children: /* @__PURE__ */ K.jsxs(
            C,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ K.jsx(nn, { children: /* @__PURE__ */ K.jsxs(nn, { as: "span", className: st.collapseHeaderKey, children: [
                  Js(
                    x,
                    T,
                    st.collapseHeaderKeyIcon
                  ),
                  /* @__PURE__ */ K.jsxs(
                    "a",
                    {
                      href: uu(v),
                      className: st.collapseHeaderKeyLink,
                      target: "_blank",
                      rel: "noreferrer",
                      onClick: (E) => {
                        E.stopPropagation();
                      },
                      children: [
                        Hn(v),
                        /* @__PURE__ */ K.jsx(
                          Fe,
                          {
                            className: st.collapseHeaderIcon,
                            name: "external-link",
                            size: 16
                          }
                        )
                      ]
                    }
                  )
                ] }) }),
                /* @__PURE__ */ K.jsx(nn, { className: st.collapseHeaderTitle, children: y })
              ]
            }
          ) }),
          /* @__PURE__ */ K.jsx(Kn.Content, { className: st.collapseContent, children: /* @__PURE__ */ K.jsxs(C, { flexDirection: "column", margin: "0 0 200 0", children: [
            /* @__PURE__ */ K.jsx(
              qf,
              {
                description: b,
                assignees: $,
                labels: P
              }
            ),
            /* @__PURE__ */ K.jsxs(
              On,
              {
                icon: "link-slash",
                variant: "secondary",
                className: st.collapseContentButtonSpacer,
                onClick: () => n({
                  key: {
                    number: m,
                    owner: N == null ? void 0 : N.owner.login,
                    repository: u.repository.name
                  },
                  type: x
                }),
                children: [
                  "Unlink ",
                  mu(x)
                ]
              }
            ),
            /* @__PURE__ */ K.jsxs(
              rt,
              {
                slotEnd: /* @__PURE__ */ K.jsx(Fe, { name: "external-link" }),
                variant: "tertiary",
                className: st.collapseContentButtonLink,
                navigate: () => {
                  var E;
                  l("github:view:link:clicked", {
                    githubOrganization: r
                  }), (E = window.open(uu(v), "_blank")) == null || E.focus();
                },
                children: [
                  "View ",
                  mu(x),
                  " in GitHub"
                ]
              }
            )
          ] }) })
        ]
      },
      p
    );
  }) : /* @__PURE__ */ K.jsx(K.Fragment, {}) });
}, ij = "_result_14c4f_27", aj = "_resultName_14c4f_47", oj = "_resultItemIcon_14c4f_55", sj = "_resultDescription_14c4f_60", lj = "_resultLinkIcon_14c4f_72", cj = "_tooltip_14c4f_81", dj = "_tooltipName_14c4f_87", uj = "_tooltipNameIcon_14c4f_92", mj = "_tooltipTag_14c4f_97", kt = {
  result: ij,
  resultName: aj,
  resultItemIcon: oj,
  resultDescription: sj,
  resultLinkIcon: lj,
  tooltip: cj,
  tooltipName: dj,
  tooltipNameIcon: uj,
  tooltipTag: mj
}, pj = ({
  item: e,
  onSelect: n
}) => {
  const { key: r, title: i, type: o, state: s, labels: l, bodyText: c, assignees: u } = e, [p, m] = G(!1);
  return /* @__PURE__ */ K.jsx(
    jn,
    {
      className: kt.tooltip,
      content: /* @__PURE__ */ K.jsxs(C, { flexDirection: "column", justifyContent: "center", width: "100%", children: [
        /* @__PURE__ */ K.jsxs(
          C,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
            margin: "0 0 300 0",
            children: [
              /* @__PURE__ */ K.jsxs(nn, { as: "span", className: kt.tooltipName, children: [
                Js(o, s, kt.resultItemIcon),
                i
              ] }),
              /* @__PURE__ */ K.jsx(an, { className: kt.tooltipTag, children: s })
            ]
          }
        ),
        /* @__PURE__ */ K.jsx(
          qf,
          {
            description: c,
            assignees: u,
            labels: l
          }
        )
      ] }),
      side: "left",
      children: /* @__PURE__ */ K.jsxs(
        "button",
        {
          className: kt.result,
          type: "button",
          onClick: () => {
            n(e);
          },
          onMouseEnter: () => m(!0),
          onMouseLeave: () => m(!1),
          children: [
            /* @__PURE__ */ K.jsxs(
              C,
              {
                flexDirection: "column",
                justifyContent: "center",
                width: "100%",
                style: {
                  width: p ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ K.jsx(C, { flexDirection: "row", children: /* @__PURE__ */ K.jsxs(nn, { as: "span", className: kt.resultName, children: [
                    Js(o, s, kt.resultItemIcon),
                    Hn(r)
                  ] }) }),
                  /* @__PURE__ */ K.jsx(nn, { className: kt.resultDescription, children: i })
                ]
              }
            ),
            p && /* @__PURE__ */ K.jsx(
              Fe,
              {
                className: kt.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, fj = ({
  className: e,
  searched: n,
  githubOrganization: r
}) => /* @__PURE__ */ K.jsx(
  rt,
  {
    slotEnd: /* @__PURE__ */ K.jsx(Fe, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      var i;
      (i = window.open(
        `https://github.com/search?q=is:issue+org:${r}+${n}`,
        "_blank"
      )) == null || i.focus();
    },
    children: "View matching items on GitHub"
  }
), ma = "[a-zA-z0-9_.-]+", zf = "[0-9]+", vj = new RegExp(
  `(${ma})/(${ma})/(?:issues|pull)/(${zf})`,
  "i"
), pu = new RegExp(`^${vj.source}$`), fu = new RegExp(
  `https://github.com/(${ma})/(${ma})/(?:issues|pull)/(${zf})`,
  "i"
), yj = ({
  onSelectItem: e,
  githubOrganization: n,
  linkedIssues: r,
  linkedPullRequests: i
}) => {
  const o = At(() => (r == null ? void 0 : r.map((M) => M.id)) || [], [r]), s = At(() => (i == null ? void 0 : i.map((M) => M.id)) || [], [i]), [l, c] = G([]), { useLazyQuery: u } = rn(), [p, m] = G(), [v, { loading: y, error: b, data: N, networkStatus: x }] = u(Aw, {
    notifyOnNetworkStatusChange: !0
  });
  Lr(
    () => {
      !y && p && x === Yn.ready ? v({
        variables: {
          issueQuery: `${p} type:issue`,
          prQuery: `${p} type:pr`,
          maxIssueResults: 12,
          maxPRResults: 12
        }
      }) : c([]);
    },
    500,
    [p]
  ), Pe(() => {
    var M, R, w;
    let H = ((R = (M = N == null ? void 0 : N.GitHub) == null ? void 0 : M.issues) == null ? void 0 : R.nodes) || [], pe = ((w = N == null ? void 0 : N.GitHub) == null ? void 0 : w.pullRequests.nodes) || [];
    o.length > 0 && (H = H.filter((le) => !o.includes(le.id))), s.length > 0 && (pe = pe.filter(
      (le) => !s.includes(le.id)
    )), c([
      ...H.map((le) => ({
        ...le,
        type: "ISSUE",
        key: {
          number: le.number,
          owner: le.repository.owner.login,
          repository: le.repository.name
        }
      })),
      ...pe.map((le) => ({
        ...le,
        type: "PR",
        key: {
          number: le.number,
          owner: le.repository.owner.login,
          repository: le.repository.name
        }
      }))
    ]);
  }, [N, o, s]);
  function T(M) {
    const R = M == null ? void 0 : M.trim();
    if (pu.test(R)) {
      const [w, H, pe, le] = R.match(pu) || [];
      return H !== n ? void 0 : {
        owner: n,
        repository: pe,
        number: parseInt(le)
      };
    }
    if (fu.test(R)) {
      const [w, H, pe, le] = R.match(fu) || [];
      return H !== n ? void 0 : {
        owner: n,
        repository: pe,
        number: parseInt(le)
      };
    }
  }
  const $ = (M) => {
    e({
      key: Mw(M),
      type: M.type
    }), m(void 0);
  }, P = (M) => {
    const R = T(M);
    m(
      R ? `org:${R.owner} repo:${R.repository} ${R.number}` : `org:${n} ${M}`
    );
  }, h = () => {
    m(void 0);
  }, E = ({ className: M, searched: R }) => /* @__PURE__ */ K.jsx(
    fj,
    {
      className: M,
      searched: R,
      githubOrganization: n
    }
  ), q = ({ item: M, onSelect: R }) => /* @__PURE__ */ K.jsx(pj, { item: M, onSelect: R });
  return !y && b ? /* @__PURE__ */ K.jsx(bn, { error: b }) : /* @__PURE__ */ K.jsx(
    Wn,
    {
      items: l == null ? void 0 : l.map((M) => ({ name: M.title, ...M })),
      loading: y,
      onSearch: P,
      onSelect: $,
      onClear: h,
      emptyMessage: p ? y ? "" : "No GitHub items found" : "Enter GitHub item key, link or search terms",
      suggestionComponent: E,
      itemComponent: q,
      placeholder: "Search GitHub items",
      searchable: !0,
      clearable: !0
    }
  );
}, gj = "_itemButton_1vyz1_27", hj = "_result_1vyz1_32", kj = "_resultIcon_1vyz1_52", bj = "_resultName_1vyz1_56", _j = "_resultCheckIcon_1vyz1_64", Sj = "_resultAssigneeIcon_1vyz1_67", Wr = {
  itemButton: gj,
  result: hj,
  resultIcon: kj,
  resultName: bj,
  resultCheckIcon: _j,
  resultAssigneeIcon: Sj
}, Hf = ({
  item: e,
  checked: n = !1,
  onSelectItem: r
}) => /* @__PURE__ */ K.jsx(
  C,
  {
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",
    "data-testid": "github-select-item-component",
    children: /* @__PURE__ */ K.jsx(
      "button",
      {
        onClick: () => {
          r(e);
        },
        className: Wr.itemButton,
        children: /* @__PURE__ */ K.jsxs(C, { className: Wr.result, flexDirection: "row", width: "100%", children: [
          e.iconUrl && /* @__PURE__ */ K.jsx(nn, { margin: "100 0", children: /* @__PURE__ */ K.jsx(
            "img",
            {
              className: Wr.resultAssigneeIcon,
              src: e.iconUrl,
              alt: e.name
            }
          ) }, e.name),
          /* @__PURE__ */ K.jsx(nn, { className: Wr.resultName, children: e.name }),
          n && /* @__PURE__ */ K.jsx(nn, { className: Wr.resultCheckIcon, children: /* @__PURE__ */ K.jsx(Fe, { name: "done" }) })
        ] })
      }
    )
  }
), Nj = Vr(
  /* GraphQL */
  `
  query getGithubOrganizationMembersByName(
    $organizationQuery: String!
    $usersQuery: String!
    $maxResults: Int!
  ) {
    GitHub {
      organization(login: $organizationQuery) {
        teams(first: $maxResults) {
          edges {
            node {
              id
              name
              members(first: $maxResults, query: $usersQuery) {
                edges {
                  node {
                    id
                    name
                    login
                    avatarUrl
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
), xj = ({
  githubOrganization: e,
  selectedItems: n,
  onChange: r,
  multiple: i = !1
}) => {
  const { useLazyQuery: o } = rn(), [s, l] = G([]), [c, u] = G(""), p = 2, [m, { loading: v, error: y, data: b, networkStatus: N }] = o(
    Nj,
    {
      notifyOnNetworkStatusChange: !0
    }
  );
  return Lr(
    () => {
      !v && c && c.length >= p && N === Yn.ready ? m({
        variables: {
          usersQuery: c,
          organizationQuery: e,
          maxResults: 10
        }
      }) : l([]);
    },
    500,
    [c]
  ), Pe(() => {
    var x, T, $;
    const P = ((T = (x = b == null ? void 0 : b.GitHub) == null ? void 0 : x.organization) == null ? void 0 : T.teams) || { edges: [] }, h = [];
    ($ = P == null ? void 0 : P.edges) == null || $.forEach((E) => {
      var q;
      const M = (q = E == null ? void 0 : E.node) == null ? void 0 : q.members, R = M == null ? void 0 : M.edges;
      ((R == null ? void 0 : R.length) || 0) > 0 && (R == null || R.forEach((w) => {
        const H = w == null ? void 0 : w.node;
        H && (H != null && H.id && h.find((pe) => pe.id === H.id) || h.push(H));
      }));
    }), l(
      h.sort((E, q) => {
        var M, R, w, H;
        const pe = ((M = E.name) == null ? void 0 : M.toLowerCase()) || ((R = E.login) == null ? void 0 : R.toLowerCase()), le = ((w = q.name) == null ? void 0 : w.toLowerCase()) || ((H = q.login) == null ? void 0 : H.toLowerCase());
        return pe.localeCompare(le, void 0, {
          sensitivity: "base"
        });
      })
    );
  }, [b]), !v && y ? /* @__PURE__ */ K.jsx(bn, { error: y }) : /* @__PURE__ */ K.jsx(
    Wn,
    {
      clearable: !0,
      searchable: !0,
      multiple: i,
      items: (s == null ? void 0 : s.map(({ id: x, name: T, login: $, avatarUrl: P }) => ({
        id: x,
        name: T || $,
        iconUrl: P
      }))) || [],
      loading: v,
      onSearch: (x) => u(x),
      onChange: (x, T) => {
        const $ = x.id;
        i ? (T && !n.find(
          (P) => P.id === $
        ) && n.push(x), T || (n = n.filter(
          (P) => P.id !== $
        ))) : n = T ? [x] : [], r(n);
      },
      onClear: () => u(""),
      selectedItems: n,
      emptyMessage: c ? v ? "" : "No user found" : "Search users",
      itemComponent: ({ item: x, onSelect: T, checked: $ }) => /* @__PURE__ */ K.jsx(
        Hf,
        {
          item: x,
          checked: $,
          onSelectItem: T
        }
      ),
      placeholder: "Search GitHub users"
    }
  );
}, wj = ({
  field: e,
  value: n,
  onChange: r,
  githubOrganization: i
}) => {
  var o;
  const { multiple: s, type: l } = e;
  switch (l) {
    case "any":
      return /* @__PURE__ */ K.jsx(St, { onChange: r, value: n });
    case "array":
      return e != null && e.allowedValues ? /* @__PURE__ */ K.jsx(
        Wn,
        {
          onSelect: r,
          selectedItems: Array.isArray(n) ? n : [],
          items: e == null ? void 0 : e.allowedValues.map(({ id: c, name: u, value: p }) => ({
            id: c,
            name: u || p
          }))
        }
      ) : /* @__PURE__ */ K.jsx(
        Rv,
        {
          onChange: r,
          selectedTags: Array.isArray(n) ? n : []
        }
      );
    case "number":
      return /* @__PURE__ */ K.jsx(St, { type: "number", onChange: r, value: n });
    case "option":
      return /* @__PURE__ */ K.jsx(
        Wn,
        {
          onSelect: r,
          selectedItems: Array.isArray(n) ? n : [],
          items: ((o = e == null ? void 0 : e.allowedValues) == null ? void 0 : o.map(
            ({ id: c, name: u, value: p }) => ({
              id: c,
              name: u || p
            })
          )) || []
        }
      );
    case "string":
      return /* @__PURE__ */ K.jsx(St, { onChange: r, value: n || "" });
    case "textarea":
      return /* @__PURE__ */ K.jsx(ys, { onChange: r, value: n || "" });
    case "user":
      return /* @__PURE__ */ K.jsx(
        xj,
        {
          githubOrganization: i,
          onChange: r,
          selectedItems: Array.isArray(n) ? n : [],
          multiple: s
        }
      );
    default:
      return /* @__PURE__ */ K.jsx(K.Fragment, { children: "Your organizations GitHub configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field." });
  }
}, jj = ({
  issueTypeFields: e,
  control: n,
  githubOrganization: r,
  conversationContext: i,
  errors: o
}) => /* @__PURE__ */ K.jsx(K.Fragment, { children: e.filter(({ key: s }) => s !== "repository").map((s) => /* @__PURE__ */ K.jsx(
  nt,
  {
    control: n,
    render: ({ field: { onChange: l, value: c } }) => /* @__PURE__ */ K.jsx(
      Fn,
      {
        meta: {
          error: o && s.key in o ? o[s.key].message : null
        },
        label: s.name,
        required: s.required,
        children: wj({
          field: s,
          value: c,
          onChange: l,
          githubOrganization: r,
          conversationContext: i
        })
      },
      s.key
    ),
    name: s.key,
    rules: {
      required: s.required ? "This field is required" : !1
    }
  },
  s.key
)) }), Cj = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: r,
  setIssueLinkCopied: i,
  copyToClipboard: o
}) => {
  const s = `${n}/${e.repository.name}/issues/${e.number}`;
  return /* @__PURE__ */ K.jsxs(
    C,
    {
      flexDirection: "column",
      gap: "400",
      "data-testid": "github-create-issue-success-message",
      children: [
        /* @__PURE__ */ K.jsxs(se.Paragraph, { children: [
          "You can visit your new issue by following",
          " ",
          /* @__PURE__ */ K.jsxs(se.ExternalLink, { href: s, target: "_blank", children: [
            "this link ",
            /* @__PURE__ */ K.jsx(Fe, { name: "external-link" })
          ] }),
          " ",
          "or copy it from the field below."
        ] }),
        /* @__PURE__ */ K.jsx(Fn, { label: "GitHub issue link", children: /* @__PURE__ */ K.jsx(
          St,
          {
            readOnly: !0,
            value: s,
            suffix: {
              type: "button",
              button: {
                icon: r ? "done" : "copy",
                onClick: () => {
                  i(!0), o(s);
                }
              }
            }
          }
        ) })
      ]
    }
  );
}, Ej = "_modalBody_15ysb_27", Fj = "_modalBodyFormFields_15ysb_30", qo = {
  modalBody: Ej,
  modalBodyFormFields: Fj
}, Ij = Vr(
  /* GraphQL */
  `
  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {
    GitHub {
      search(query: $query, type: REPOSITORY, first: $maxResults) {
        repositoryCount
        edges {
          node {
            ... on GitHub_Repository {
              id
              name
            }
          }
        }
      }
    }
  }
`
), $j = Vr(
  /* GraphQL */
  `
  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {
    GitHub {
      createIssue(input: $input) {
        issue {
          id
          number
          repository {
            name
          }
        }
      }
    }
  }
`
), Tj = [
  {
    key: "title",
    name: "Title",
    type: "string",
    required: !0
  },
  {
    key: "assignees",
    name: "Assignees",
    type: "user",
    required: !1,
    multiple: !0
  },
  {
    key: "body",
    name: "Description",
    type: "textarea",
    required: !1
  }
], Oj = ({
  isOpen: e,
  onClose: n,
  linkGithubIssueQuietly: r,
  conversationContext: i,
  githubOrganization: o
}) => {
  const { showNotification: s, useLazyQuery: l, useMutation: c } = rn(), { track: u } = sn(), {
    control: p,
    handleSubmit: m,
    formState: { errors: v },
    reset: y,
    getValues: b
  } = kl(), [N, x] = G(""), [T, $] = G([]), [P, h] = G(), [E, q] = G(!1), [M, R] = G(!1), [w, H] = hl(), [
    pe,
    {
      loading: le,
      error: Se,
      networkStatus: ae
    }
  ] = l(Ij, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (z) => {
      var me, ke;
      $(
        (ke = (me = z.GitHub.search) == null ? void 0 : me.edges) == null ? void 0 : ke.map((Oe) => Oe == null ? void 0 : Oe.node)
      );
    },
    onError: () => {
      s({
        title: "Could not get repository list",
        text: "We could not fetch the list of your repositories. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), $([]);
    }
  });
  Lr(
    () => {
      !le && N && ae === Yn.ready ? pe({
        variables: {
          query: N,
          maxResults: 10
        }
      }) : $([]);
    },
    500,
    [N]
  );
  const [D, { error: V }] = c(
    $j,
    {
      onError: (z) => {
        q(!1), s({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), console.warn("Error in createMutation", z);
      },
      onCompleted: (z) => {
        var me;
        q(!1);
        const ke = (me = z.GitHub.createIssue) == null ? void 0 : me.issue;
        h(ke), s({
          title: "Success",
          text: `GitHub issue '${ke.number}' created`,
          icon: "check-circle-filled",
          severity: "success"
        }), r({
          owner: o,
          repository: ke.repository.name,
          number: ke.number
        });
      }
    }
  ), de = (z) => {
    x(`org:${o} ${z}`);
  }, te = (z, me) => {
    me(z), x("");
  }, he = () => {
    x("");
  }, _e = (z) => {
    var me;
    u("github:create:issue:confirmed", {
      githubOrganization: o
    }), q(!0), D({
      variables: {
        input: {
          repositoryId: z.repository.id,
          title: z.title,
          body: z.body,
          assigneeIds: ((me = z.assignees) == null ? void 0 : me.length) > 0 ? z.assignees.map((ke) => ke.id) : void 0
        }
      }
    });
  };
  Pe(() => {
    const z = M ? window.setTimeout(() => R(!1), 2e3) : void 0;
    return () => window.clearTimeout(z);
  }, [M]);
  const Z = () => {
    x(""), $([]), h(void 0), q(!1), R(!1);
  }, J = () => {
    u("github:create:issue:canceled", {
      githubOrganization: o
    }), Z(), y(), n();
  };
  return /* @__PURE__ */ K.jsxs(
    jt,
    {
      isOpen: e,
      "data-testid": "github-create-issue-modal",
      onClose: J,
      children: [
        /* @__PURE__ */ K.jsx(
          Ct,
          {
            title: P ? "Issue creation successful" : "Create new GitHub issue",
            onClose: J
          }
        ),
        /* @__PURE__ */ K.jsxs(Et, { className: qo.modalBody, children: [
          !le && Se && /* @__PURE__ */ K.jsx(bn, { error: Se }),
          !E && V && /* @__PURE__ */ K.jsx(bn, { error: V }),
          P ? /* @__PURE__ */ K.jsx(
            Cj,
            {
              createdIssue: P,
              issueBaseLink: `https://github.com/${o}`,
              issueLinkCopied: M,
              setIssueLinkCopied: R,
              copyToClipboard: H
            }
          ) : /* @__PURE__ */ K.jsx(
            "form",
            {
              "data-testid": "github-create-issue-form",
              onSubmit: m(_e),
              children: /* @__PURE__ */ K.jsxs(Ar, { children: [
                /* @__PURE__ */ K.jsx(wn, { children: /* @__PURE__ */ K.jsx(Fn, { label: "Repository", required: !0, children: /* @__PURE__ */ K.jsx(
                  nt,
                  {
                    control: p,
                    name: "repository",
                    rules: { required: "Please select a repository" },
                    render: ({ field: { onChange: z, value: me } }) => /* @__PURE__ */ K.jsx(
                      Wn,
                      {
                        className: qo.modalBodyRepository,
                        searchable: !0,
                        clearable: !0,
                        loading: le,
                        onSearch: de,
                        onSelect: (ke) => te(ke, z),
                        onClear: he,
                        selectedItems: [me],
                        placeholder: "Search GitHub repositories",
                        emptyMessage: Se ? "No repositories found" : "No repositories available",
                        items: T || [],
                        itemComponent: ({ item: ke, onSelect: Oe, checked: Y }) => /* @__PURE__ */ K.jsx(
                          Hf,
                          {
                            item: ke,
                            checked: Y,
                            onSelectItem: Oe
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ K.jsx(wn, { className: qo.modalBodyFormFields, children: /* @__PURE__ */ K.jsx(
                  jj,
                  {
                    control: p,
                    errors: v,
                    getValues: b,
                    githubOrganization: o,
                    conversationContext: i,
                    issueTypeFields: Tj
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ K.jsx(
          Mt,
          {
            confirmOnClick: P ? J : m(_e),
            confirmProps: {
              isLoading: E,
              loadingIndicator: /* @__PURE__ */ K.jsx(ln, { size: 16 })
            },
            confirmName: P ? "Close" : "Save",
            cancelOnClick: P ? void 0 : J
          }
        )
      ]
    }
  );
}, Rj = "_wrapper_e2103_27", Dj = "_inputWrapper_e2103_32", Pj = "_inputField_e2103_41", Aj = "_buttonLink_e2103_45", Lj = "_noItemsFound_e2103_49", Uj = "_createIssueButton_e2103_54", mr = {
  wrapper: Rj,
  inputWrapper: Dj,
  inputField: Pj,
  buttonLink: Aj,
  noItemsFound: Lj,
  createIssueButton: Uj
}, Mj = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = G(!1), { track: o } = sn(), s = n == null ? void 0 : n.githubOrganization, l = !!(n != null && n.enableRemoveAllLinks), {
    linkGithubItem: c,
    linkGithubItemQuietly: u,
    unlinkGithubItem: p,
    loadGithubItems: m,
    removeDanglingGithubItemLinks: v,
    unlinkAllGithubItems: y,
    isLoadingGithubItemLinks: b,
    danglingIssueLinks: N,
    danglingPullRequestLinks: x,
    isLoadingGithubItems: T,
    issues: $,
    pullRequests: P,
    error: h
  } = Bw({
    conversationId: (e == null ? void 0 : e.conversationId) || null,
    githubOrganization: s
  }), E = (H) => u({ key: H, type: "ISSUE" }), q = !(!!($ != null && $.length)).valueOf() && !(!!(P != null && P.length)).valueOf() && !(!!(N != null && N.length)).valueOf() && !(!!(x != null && x.length)).valueOf(), M = !b && !T && !!(N != null && N.length) && !!(x != null && x.length) && !!(n != null && n.showDanglingLinks), R = n == null ? void 0 : n.enableCreateIssue, w = !!($ != null && $.length) || !!(P != null && P.length);
  return !T && h ? /* @__PURE__ */ K.jsx(bn, { error: h, retry: () => m() }) : /* @__PURE__ */ K.jsxs(K.Fragment, { children: [
    /* @__PURE__ */ K.jsxs(C, { className: mr.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ K.jsxs(C, { className: mr.inputWrapper, flexDirection: "column", children: [
        R && /* @__PURE__ */ K.jsxs(K.Fragment, { children: [
          /* @__PURE__ */ K.jsx(
            On,
            {
              variant: "primary",
              onClick: () => {
                o("github:create:issue:clicked", {
                  githubOrganization: n == null ? void 0 : n.githubOrganization
                }), i(!0);
              },
              className: mr.createIssueButton,
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ K.jsx("div", { className: mr.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ K.jsx(
          yj,
          {
            onSelectItem: c,
            githubOrganization: s,
            linkedIssues: $,
            linkedPullRequests: P
          }
        )
      ] }),
      T ? /* @__PURE__ */ K.jsx(C, { justifyContent: "center", children: /* @__PURE__ */ K.jsx(ln, { "data-testid": "github-widget-item-spinner" }) }) : w ? /* @__PURE__ */ K.jsx(
        rj,
        {
          items: [...$, ...P],
          unlinkGithubItem: p,
          githubOrganization: s
        }
      ) : /* @__PURE__ */ K.jsx(se.Paragraph, { align: "center", className: mr.noItemsFound, children: "No linked items found." }),
      M && /* @__PURE__ */ K.jsxs(
        C,
        {
          background: $e.neutral[100],
          padding: tn.spacer[300],
          borderRadius: tn["border-radius"][100],
          flexDirection: "column",
          gap: tn.spacer[200],
          children: [
            /* @__PURE__ */ K.jsx(se.Heading, { variant: "heading-3", children: "Unresolved linked issues and/or pull requests" }),
            /* @__PURE__ */ K.jsxs(
              C,
              {
                flexDirection: "row",
                flexWrap: "wrap",
                gap: tn.spacer[100],
                children: [
                  N.map((H) => /* @__PURE__ */ K.jsx(
                    an,
                    {
                      onDelete: () => p({
                        key: H,
                        type: "ISSUE"
                      }),
                      children: Hn(H)
                    },
                    Hn(H)
                  )),
                  x.map((H) => /* @__PURE__ */ K.jsx(
                    an,
                    {
                      onDelete: () => p({ key: H, type: "PR" }),
                      children: Hn(H)
                    },
                    Hn(H)
                  ))
                ]
              }
            ),
            /* @__PURE__ */ K.jsx(
              On,
              {
                variant: "secondary",
                onClick: () => v(),
                icon: "link-slash",
                children: "Remove all"
              }
            )
          ]
        }
      ),
      l && w && /* @__PURE__ */ K.jsx(
        On,
        {
          variant: "secondary",
          disabled: q,
          onClick: y,
          children: "Remove all links"
        }
      ),
      /* @__PURE__ */ K.jsx(
        rt,
        {
          slotEnd: /* @__PURE__ */ K.jsx(Fe, { name: "external-link" }),
          variant: "tertiary",
          className: mr.buttonLink,
          navigate: () => {
            var H;
            (H = window.open(`https://github.com/${s}`, "_blank")) == null || H.focus();
          },
          children: "Open GitHub"
        }
      )
    ] }),
    /* @__PURE__ */ K.jsx(
      Oj,
      {
        isOpen: r,
        onClose: () => i(!1),
        linkGithubIssueQuietly: E,
        conversationContext: e,
        githubOrganization: s
      }
    )
  ] });
}, Bj = [
  {
    key: "githubOrganization",
    label: "GitHub organization or user",
    placeholder: "Insert your GitHub organization or user name, e.g. dixahq",
    secret: !1,
    type: "input",
    required: !0
  },
  {
    key: "enableRemoveAllLinks",
    label: 'Enable the "Remove all links" button',
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    label: "Show unresolved links to GitHub items",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: ga
  }
];
var Kf = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var n = {}.hasOwnProperty;
    function r() {
      for (var s = "", l = 0; l < arguments.length; l++) {
        var c = arguments[l];
        c && (s = o(s, i(c)));
      }
      return s;
    }
    function i(s) {
      if (typeof s == "string" || typeof s == "number")
        return s;
      if (typeof s != "object")
        return "";
      if (Array.isArray(s))
        return r.apply(null, s);
      if (s.toString !== Object.prototype.toString && !s.toString.toString().includes("[native code]"))
        return s.toString();
      var l = "";
      for (var c in s)
        n.call(s, c) && s[c] && (l = o(l, c));
      return l;
    }
    function o(s, l) {
      return l ? s ? s + " " + l : s + l : s;
    }
    e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
  })();
})(Kf);
var Vj = Kf.exports;
const It = /* @__PURE__ */ Xv(Vj);
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._jiraCode_gv3ah_27{padding:2px 4px;font-size:100%;font-family:Courier,Consolas,Monaco,Lucida Console,Liberation Mono;color:#132243;border-radius:4px}._jiraCodeInline_gv3ah_34{background-color:#e7ecf3}._collapse_197xn_27{border:1px solid #d7dfea;border-radius:4px;font-size:12px;line-height:16px;padding:0}._collapseHeader_197xn_36>div{padding:16px 0!important}._collapseHeader_197xn_36>div>div>p{white-space:unset!important}._collapseHeader_197xn_36>div:first-child{width:100%}._collapseHeader_197xn_36>div:first-child div:first-child{width:100%}._collapseHeader_197xn_36>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_197xn_36{background-color:transparent!important;padding:0 16px 0 0;letter-spacing:-.08px;color:#8193b0}._collapseHeaderLink_197xn_57{font-size:12px;line-height:16px;color:#0079cc;text-decoration:none}._collapseHeaderLink_197xn_57:hover{text-decoration:underline}._collapseHeaderStatus_197xn_66{font-size:12px;line-height:16px;color:#8193b0;float:right}._collapseHeaderIcon_197xn_72{padding-top:.35em;transform:scale(1.4);margin-left:4px}._collapseHeaderTitle_197xn_77{font-weight:600;font-size:14px;line-height:20px;letter-spacing:-.16px;color:#132243;width:100%}._collapseContent_197xn_85{padding:8px 16px!important}._collapseContentHeadline_197xn_88{font-weight:600;font-size:10px;line-height:16px;color:#8294b0}._collapseContentButtonSpacer_197xn_94{margin-top:12px}._collapseContentButtonLink_197xn_97{color:#0079cc}._collapseContentStatusTag_197xn_100{max-width:10em}._collapseContentDescription_197xn_103{max-height:75vh;overflow-y:auto}._result_14091_27{padding:0 8px;margin:0;outline:0;border:0;color:#132243;background-color:#fff;box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_14091_27:hover,._result_14091_27:focus{background-color:#f5f7fa}._resultName_14091_47{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:600}._resultNameIcon_14091_55{height:16px;padding-right:4px;margin-top:-2px}._resultDescription_14091_60{width:100%;text-align:left;font-size:12px;line-height:16px;color:#46597c;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_14091_72{position:absolute;right:5px;background-color:#fff;border:1px solid #d7dfea;border-radius:5px;color:#8193b0}._tooltip_14091_81{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipName_14091_87{text-align:left;white-space:nowrap;font-weight:600}._tooltipNameIcon_14091_92{height:20px;padding-right:4px;margin-top:-2px}._tooltipDescription_14091_97{padding-top:.5em;width:100%;text-align:left;color:#46597c}._tooltipSummary_14091_103{padding-top:.5em;font-weight:600}._tooltipTag_14091_107{width:fit-content;max-width:15em}._itemButton_veukg_27{border:none;padding:0}._result_veukg_32{padding:0 8px;margin:0;outline:0;border:0;color:#132243;background-color:#fff;box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_veukg_32:hover,._result_veukg_32:focus{background-color:#f5f7fa}._resultIcon_veukg_52{height:24px;padding-right:12px}._resultName_veukg_56{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:600}._resultCheckIcon_veukg_64{height:24px}._modalBody_15ysb_27{width:600px}._modalBodyFormFields_15ysb_30{display:grid;gap:16px 24px}._wrapper_18e01_27{gap:12px;margin-bottom:16px}._inputWrapper_18e01_32{background-color:#f5f7fa;border-radius:4px;margin:16px 0;gap:12px;padding:16px;text-align:center}._inputField_18e01_41{text-align:center}._inputSeparator_18e01_45{color:#617598}._buttonLink_18e01_49{color:#0079cc}._noIssuesFound_18e01_53{color:#b5c1d4;font-size:12px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Zs = { exports: {} }, pr = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var zo, vu;
function Gf() {
  if (vu)
    return zo;
  vu = 1;
  var e = Object.getOwnPropertySymbols, n = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function i(s) {
    if (s == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(s);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var s = new String("abc");
      if (s[5] = "de", Object.getOwnPropertyNames(s)[0] === "5")
        return !1;
      for (var l = {}, c = 0; c < 10; c++)
        l["_" + String.fromCharCode(c)] = c;
      var u = Object.getOwnPropertyNames(l).map(function(m) {
        return l[m];
      });
      if (u.join("") !== "0123456789")
        return !1;
      var p = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(m) {
        p[m] = m;
      }), Object.keys(Object.assign({}, p)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return zo = o() ? Object.assign : function(s, l) {
    for (var c, u = i(s), p, m = 1; m < arguments.length; m++) {
      c = Object(arguments[m]);
      for (var v in c)
        n.call(c, v) && (u[v] = c[v]);
      if (e) {
        p = e(c);
        for (var y = 0; y < p.length; y++)
          r.call(c, p[y]) && (u[p[y]] = c[p[y]]);
      }
    }
    return u;
  }, zo;
}
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var yu;
function qj() {
  if (yu)
    return pr;
  yu = 1, Gf();
  var e = Cn, n = 60103;
  if (pr.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var r = Symbol.for;
    n = r("react.element"), pr.Fragment = r("react.fragment");
  }
  var i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = Object.prototype.hasOwnProperty, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(c, u, p) {
    var m, v = {}, y = null, b = null;
    p !== void 0 && (y = "" + p), u.key !== void 0 && (y = "" + u.key), u.ref !== void 0 && (b = u.ref);
    for (m in u)
      o.call(u, m) && !s.hasOwnProperty(m) && (v[m] = u[m]);
    if (c && c.defaultProps)
      for (m in u = c.defaultProps, u)
        v[m] === void 0 && (v[m] = u[m]);
    return { $$typeof: n, type: c, key: y, ref: b, props: v, _owner: i.current };
  }
  return pr.jsx = l, pr.jsxs = l, pr;
}
var gu = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hu;
function zj() {
  return hu || (hu = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      var n = Cn, r = Gf(), i = 60103, o = 60106;
      e.Fragment = 60107;
      var s = 60108, l = 60114, c = 60109, u = 60110, p = 60112, m = 60113, v = 60120, y = 60115, b = 60116, N = 60121, x = 60122, T = 60117, $ = 60129, P = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var h = Symbol.for;
        i = h("react.element"), o = h("react.portal"), e.Fragment = h("react.fragment"), s = h("react.strict_mode"), l = h("react.profiler"), c = h("react.provider"), u = h("react.context"), p = h("react.forward_ref"), m = h("react.suspense"), v = h("react.suspense_list"), y = h("react.memo"), b = h("react.lazy"), N = h("react.block"), x = h("react.server.block"), T = h("react.fundamental"), h("react.scope"), h("react.opaque.id"), $ = h("react.debug_trace_mode"), h("react.offscreen"), P = h("react.legacy_hidden");
      }
      var E = typeof Symbol == "function" && Symbol.iterator, q = "@@iterator";
      function M(t) {
        if (t === null || typeof t != "object")
          return null;
        var a = E && t[E] || t[q];
        return typeof a == "function" ? a : null;
      }
      var R = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function w(t) {
        {
          for (var a = arguments.length, d = new Array(a > 1 ? a - 1 : 0), f = 1; f < a; f++)
            d[f - 1] = arguments[f];
          H("error", t, d);
        }
      }
      function H(t, a, d) {
        {
          var f = R.ReactDebugCurrentFrame, _ = f.getStackAddendum();
          _ !== "" && (a += "%s", d = d.concat([_]));
          var S = d.map(function(k) {
            return "" + k;
          });
          S.unshift("Warning: " + a), Function.prototype.apply.call(console[t], console, S);
        }
      }
      var pe = !1;
      function le(t) {
        return !!(typeof t == "string" || typeof t == "function" || t === e.Fragment || t === l || t === $ || t === s || t === m || t === v || t === P || pe || typeof t == "object" && t !== null && (t.$$typeof === b || t.$$typeof === y || t.$$typeof === c || t.$$typeof === u || t.$$typeof === p || t.$$typeof === T || t.$$typeof === N || t[0] === x));
      }
      function Se(t, a, d) {
        var f = a.displayName || a.name || "";
        return t.displayName || (f !== "" ? d + "(" + f + ")" : d);
      }
      function ae(t) {
        return t.displayName || "Context";
      }
      function D(t) {
        if (t == null)
          return null;
        if (typeof t.tag == "number" && w("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof t == "function")
          return t.displayName || t.name || null;
        if (typeof t == "string")
          return t;
        switch (t) {
          case e.Fragment:
            return "Fragment";
          case o:
            return "Portal";
          case l:
            return "Profiler";
          case s:
            return "StrictMode";
          case m:
            return "Suspense";
          case v:
            return "SuspenseList";
        }
        if (typeof t == "object")
          switch (t.$$typeof) {
            case u:
              var a = t;
              return ae(a) + ".Consumer";
            case c:
              var d = t;
              return ae(d._context) + ".Provider";
            case p:
              return Se(t, t.render, "ForwardRef");
            case y:
              return D(t.type);
            case N:
              return D(t._render);
            case b: {
              var f = t, _ = f._payload, S = f._init;
              try {
                return D(S(_));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var V = 0, de, te, he, _e, Z, J, z;
      function me() {
      }
      me.__reactDisabledLog = !0;
      function ke() {
        {
          if (V === 0) {
            de = console.log, te = console.info, he = console.warn, _e = console.error, Z = console.group, J = console.groupCollapsed, z = console.groupEnd;
            var t = {
              configurable: !0,
              enumerable: !0,
              value: me,
              writable: !0
            };
            Object.defineProperties(console, {
              info: t,
              log: t,
              warn: t,
              error: t,
              group: t,
              groupCollapsed: t,
              groupEnd: t
            });
          }
          V++;
        }
      }
      function Oe() {
        {
          if (V--, V === 0) {
            var t = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: r({}, t, {
                value: de
              }),
              info: r({}, t, {
                value: te
              }),
              warn: r({}, t, {
                value: he
              }),
              error: r({}, t, {
                value: _e
              }),
              group: r({}, t, {
                value: Z
              }),
              groupCollapsed: r({}, t, {
                value: J
              }),
              groupEnd: r({}, t, {
                value: z
              })
            });
          }
          V < 0 && w("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var Y = R.ReactCurrentDispatcher, fe;
      function ge(t, a, d) {
        {
          if (fe === void 0)
            try {
              throw Error();
            } catch (_) {
              var f = _.stack.trim().match(/\n( *(at )?)/);
              fe = f && f[1] || "";
            }
          return `
` + fe + t;
        }
      }
      var X = !1, ye;
      {
        var W = typeof WeakMap == "function" ? WeakMap : Map;
        ye = new W();
      }
      function ce(t, a) {
        if (!t || X)
          return "";
        {
          var d = ye.get(t);
          if (d !== void 0)
            return d;
        }
        var f;
        X = !0;
        var _ = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var S;
        S = Y.current, Y.current = null, ke();
        try {
          if (a) {
            var k = function() {
              throw Error();
            };
            if (Object.defineProperty(k.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(k, []);
              } catch (A) {
                f = A;
              }
              Reflect.construct(t, [], k);
            } else {
              try {
                k.call();
              } catch (A) {
                f = A;
              }
              t.call(k.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (A) {
              f = A;
            }
            t();
          }
        } catch (A) {
          if (A && f && typeof A.stack == "string") {
            for (var g = A.stack.split(`
`), L = f.stack.split(`
`), I = g.length - 1, O = L.length - 1; I >= 1 && O >= 0 && g[I] !== L[O]; )
              O--;
            for (; I >= 1 && O >= 0; I--, O--)
              if (g[I] !== L[O]) {
                if (I !== 1 || O !== 1)
                  do
                    if (I--, O--, O < 0 || g[I] !== L[O]) {
                      var re = `
` + g[I].replace(" at new ", " at ");
                      return typeof t == "function" && ye.set(t, re), re;
                    }
                  while (I >= 1 && O >= 0);
                break;
              }
          }
        } finally {
          X = !1, Y.current = S, Oe(), Error.prepareStackTrace = _;
        }
        var Ce = t ? t.displayName || t.name : "", j = Ce ? ge(Ce) : "";
        return typeof t == "function" && ye.set(t, j), j;
      }
      function ie(t, a, d) {
        return ce(t, !1);
      }
      function oe(t) {
        var a = t.prototype;
        return !!(a && a.isReactComponent);
      }
      function be(t, a, d) {
        if (t == null)
          return "";
        if (typeof t == "function")
          return ce(t, oe(t));
        if (typeof t == "string")
          return ge(t);
        switch (t) {
          case m:
            return ge("Suspense");
          case v:
            return ge("SuspenseList");
        }
        if (typeof t == "object")
          switch (t.$$typeof) {
            case p:
              return ie(t.render);
            case y:
              return be(t.type, a, d);
            case N:
              return ie(t._render);
            case b: {
              var f = t, _ = f._payload, S = f._init;
              try {
                return be(S(_), a, d);
              } catch {
              }
            }
          }
        return "";
      }
      var Ee = {}, Ie = R.ReactDebugCurrentFrame;
      function we(t) {
        if (t) {
          var a = t._owner, d = be(t.type, t._source, a ? a.type : null);
          Ie.setExtraStackFrame(d);
        } else
          Ie.setExtraStackFrame(null);
      }
      function Ge(t, a, d, f, _) {
        {
          var S = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var k in t)
            if (S(t, k)) {
              var g = void 0;
              try {
                if (typeof t[k] != "function") {
                  var L = Error((f || "React class") + ": " + d + " type `" + k + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[k] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw L.name = "Invariant Violation", L;
                }
                g = t[k](a, k, f, d, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (I) {
                g = I;
              }
              g && !(g instanceof Error) && (we(_), w("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", f || "React class", d, k, typeof g), we(null)), g instanceof Error && !(g.message in Ee) && (Ee[g.message] = !0, we(_), w("Failed %s type: %s", d, g.message), we(null));
            }
        }
      }
      var je = R.ReactCurrentOwner, Te = Object.prototype.hasOwnProperty, Ye = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, Ae, Be, De;
      De = {};
      function cn(t) {
        if (Te.call(t, "ref")) {
          var a = Object.getOwnPropertyDescriptor(t, "ref").get;
          if (a && a.isReactWarning)
            return !1;
        }
        return t.ref !== void 0;
      }
      function en(t) {
        if (Te.call(t, "key")) {
          var a = Object.getOwnPropertyDescriptor(t, "key").get;
          if (a && a.isReactWarning)
            return !1;
        }
        return t.key !== void 0;
      }
      function yn(t, a) {
        if (typeof t.ref == "string" && je.current && a && je.current.stateNode !== a) {
          var d = D(je.current.type);
          De[d] || (w('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', D(je.current.type), t.ref), De[d] = !0);
        }
      }
      function pn(t, a) {
        {
          var d = function() {
            Ae || (Ae = !0, w("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", a));
          };
          d.isReactWarning = !0, Object.defineProperty(t, "key", {
            get: d,
            configurable: !0
          });
        }
      }
      function gn(t, a) {
        {
          var d = function() {
            Be || (Be = !0, w("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", a));
          };
          d.isReactWarning = !0, Object.defineProperty(t, "ref", {
            get: d,
            configurable: !0
          });
        }
      }
      var dn = function(t, a, d, f, _, S, k) {
        var g = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: i,
          // Built-in properties that belong on the element
          type: t,
          key: a,
          ref: d,
          props: k,
          // Record the component responsible for creating this element.
          _owner: S
        };
        return g._store = {}, Object.defineProperty(g._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(g, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: f
        }), Object.defineProperty(g, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: _
        }), Object.freeze && (Object.freeze(g.props), Object.freeze(g)), g;
      };
      function un(t, a, d, f, _) {
        {
          var S, k = {}, g = null, L = null;
          d !== void 0 && (g = "" + d), en(a) && (g = "" + a.key), cn(a) && (L = a.ref, yn(a, _));
          for (S in a)
            Te.call(a, S) && !Ye.hasOwnProperty(S) && (k[S] = a[S]);
          if (t && t.defaultProps) {
            var I = t.defaultProps;
            for (S in I)
              k[S] === void 0 && (k[S] = I[S]);
          }
          if (g || L) {
            var O = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
            g && pn(k, O), L && gn(k, O);
          }
          return dn(t, g, L, _, f, je.current, k);
        }
      }
      var Re = R.ReactCurrentOwner, He = R.ReactDebugCurrentFrame;
      function Ne(t) {
        if (t) {
          var a = t._owner, d = be(t.type, t._source, a ? a.type : null);
          He.setExtraStackFrame(d);
        } else
          He.setExtraStackFrame(null);
      }
      var Le;
      Le = !1;
      function Me(t) {
        return typeof t == "object" && t !== null && t.$$typeof === i;
      }
      function ze() {
        {
          if (Re.current) {
            var t = D(Re.current.type);
            if (t)
              return `

Check the render method of \`` + t + "`.";
          }
          return "";
        }
      }
      function _n(t) {
        {
          if (t !== void 0) {
            var a = t.fileName.replace(/^.*[\\\/]/, ""), d = t.lineNumber;
            return `

Check your code at ` + a + ":" + d + ".";
          }
          return "";
        }
      }
      var Je = {};
      function qe(t) {
        {
          var a = ze();
          if (!a) {
            var d = typeof t == "string" ? t : t.displayName || t.name;
            d && (a = `

Check the top-level render call using <` + d + ">.");
          }
          return a;
        }
      }
      function Ke(t, a) {
        {
          if (!t._store || t._store.validated || t.key != null)
            return;
          t._store.validated = !0;
          var d = qe(a);
          if (Je[d])
            return;
          Je[d] = !0;
          var f = "";
          t && t._owner && t._owner !== Re.current && (f = " It was passed a child from " + D(t._owner.type) + "."), Ne(t), w('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', d, f), Ne(null);
        }
      }
      function Ze(t, a) {
        {
          if (typeof t != "object")
            return;
          if (Array.isArray(t))
            for (var d = 0; d < t.length; d++) {
              var f = t[d];
              Me(f) && Ke(f, a);
            }
          else if (Me(t))
            t._store && (t._store.validated = !0);
          else if (t) {
            var _ = M(t);
            if (typeof _ == "function" && _ !== t.entries)
              for (var S = _.call(t), k; !(k = S.next()).done; )
                Me(k.value) && Ke(k.value, a);
          }
        }
      }
      function hn(t) {
        {
          var a = t.type;
          if (a == null || typeof a == "string")
            return;
          var d;
          if (typeof a == "function")
            d = a.propTypes;
          else if (typeof a == "object" && (a.$$typeof === p || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          a.$$typeof === y))
            d = a.propTypes;
          else
            return;
          if (d) {
            var f = D(a);
            Ge(d, t.props, "prop", f, t);
          } else if (a.PropTypes !== void 0 && !Le) {
            Le = !0;
            var _ = D(a);
            w("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _ || "Unknown");
          }
          typeof a.getDefaultProps == "function" && !a.getDefaultProps.isReactClassApproved && w("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function fn(t) {
        {
          for (var a = Object.keys(t.props), d = 0; d < a.length; d++) {
            var f = a[d];
            if (f !== "children" && f !== "key") {
              Ne(t), w("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", f), Ne(null);
              break;
            }
          }
          t.ref !== null && (Ne(t), w("Invalid attribute `ref` supplied to `React.Fragment`."), Ne(null));
        }
      }
      function Qe(t, a, d, f, _, S) {
        {
          var k = le(t);
          if (!k) {
            var g = "";
            (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (g += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var L = _n(_);
            L ? g += L : g += ze();
            var I;
            t === null ? I = "null" : Array.isArray(t) ? I = "array" : t !== void 0 && t.$$typeof === i ? (I = "<" + (D(t.type) || "Unknown") + " />", g = " Did you accidentally export a JSX literal instead of a component?") : I = typeof t, w("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", I, g);
          }
          var O = un(t, a, d, _, S);
          if (O == null)
            return O;
          if (k) {
            var re = a.children;
            if (re !== void 0)
              if (f)
                if (Array.isArray(re)) {
                  for (var Ce = 0; Ce < re.length; Ce++)
                    Ze(re[Ce], t);
                  Object.freeze && Object.freeze(re);
                } else
                  w("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                Ze(re, t);
          }
          return t === e.Fragment ? fn(O) : hn(O), O;
        }
      }
      function kn(t, a, d) {
        return Qe(t, a, d, !0);
      }
      function Sn(t, a, d) {
        return Qe(t, a, d, !1);
      }
      var mn = Sn, vn = kn;
      e.jsx = mn, e.jsxs = vn;
    }();
  }(gu)), gu;
}
process.env.NODE_ENV === "production" ? Zs.exports = qj() : Zs.exports = zj();
var U = Zs.exports;
const ec = (e, n) => {
  const r = (s) => (e.marks || []).map((l) => {
    var c;
    return {
      formatterFunction: (c = n.marks[e.type]) == null ? void 0 : c[l.type],
      mark: l
    };
  }).reduce(
    (l, c) => () => {
      var u;
      return ((u = c.formatterFunction) == null ? void 0 : u.call(c, c.mark, l)) || s;
    },
    () => s
  )(), i = (s, l) => () => s.content ? s.content.map((c) => ec(c, l)) : [], o = n.nodes[e.type] || n.default;
  return r(
    o(e, i(e, n))
  );
}, Hj = "_jiraCode_gv3ah_27", Kj = "_jiraCodeInline_gv3ah_34", Ho = {
  jiraCode: Hj,
  jiraCodeInline: Kj
}, Wf = {
  default: (e, n) => n().every((r) => typeof r == "string") ? n().join(" ") : /* @__PURE__ */ U.jsx(U.Fragment, { children: n() }),
  nodes: {
    doc: (e, n) => /* @__PURE__ */ U.jsx("div", { children: n() }),
    paragraph: (e, n) => /* @__PURE__ */ U.jsx("p", { children: n() }),
    text: (e) => e.text || "",
    hardBreak: () => /* @__PURE__ */ U.jsx("br", {}),
    bulletList: (e, n) => /* @__PURE__ */ U.jsx("ul", { children: n() }),
    orderedList: (e, n) => /* @__PURE__ */ U.jsx("ol", { children: n() }),
    listItem: (e, n) => /* @__PURE__ */ U.jsx("li", { children: n() }),
    codeBlock: (e, n) => /* @__PURE__ */ U.jsx("pre", { children: /* @__PURE__ */ U.jsx("code", { className: Ho.jiraCode, children: n() }) }),
    heading: (e, n) => {
      var r;
      switch ((r = e.attrs) == null ? void 0 : r.level) {
        case 1:
          return /* @__PURE__ */ U.jsx("h3", { children: n() });
        case 2:
          return /* @__PURE__ */ U.jsx("h4", { children: n() });
        case 3:
          return /* @__PURE__ */ U.jsx("h5", { children: n() });
        case 4:
          return /* @__PURE__ */ U.jsx("h6", { children: n() });
        case 5:
          return /* @__PURE__ */ U.jsx("b", { children: n() });
        case 6:
          return /* @__PURE__ */ U.jsx("b", { children: n() });
        default:
          return /* @__PURE__ */ U.jsx("h4", { children: n() });
      }
    }
  },
  marks: {
    text: {
      em: (e, n) => /* @__PURE__ */ U.jsx("em", { children: n() }),
      strong: (e, n) => /* @__PURE__ */ U.jsx("b", { children: n() }),
      underline: (e, n) => /* @__PURE__ */ U.jsx("u", { children: n() }),
      link: (e, n) => {
        var r;
        return /* @__PURE__ */ U.jsx("a", { href: ((r = e.attrs) == null ? void 0 : r.href) || "", target: "_blank", rel: "noreferrer", children: n() });
      },
      code: (e, n) => /* @__PURE__ */ U.jsx("code", { className: It(Ho.jiraCode, Ho.jiraCodeInline), children: n() })
      // Removing color support for now.
      // textColor: (mark, next) => (
      // 	<span style={{ color: mark.attrs?.['color'] }}>{next()}</span>
      // ),
    }
  }
}, Gj = "rest/api/3/universal_avatar/view/type/issuetype/avatar/10300", pa = ({
  iconUrl: e,
  className: n,
  width: r,
  jiraInstanceUrl: i
}) => !e || !i ? /* @__PURE__ */ U.jsx(Fe, { name: "question", className: n }) : /* @__PURE__ */ U.jsx(
  "img",
  {
    src: e,
    width: r,
    className: n,
    onError: ({ currentTarget: o }) => {
      o.onerror = null, o.src = `${i}/${Gj}`;
    }
  }
), Wj = "_collapse_197xn_27", Yj = "_collapseHeader_197xn_36", Qj = "_collapseHeaderLink_197xn_57", Jj = "_collapseHeaderStatus_197xn_66", Zj = "_collapseHeaderIcon_197xn_72", Xj = "_collapseHeaderTitle_197xn_77", eC = "_collapseContent_197xn_85", nC = "_collapseContentHeadline_197xn_88", tC = "_collapseContentButtonSpacer_197xn_94", rC = "_collapseContentButtonLink_197xn_97", iC = "_collapseContentStatusTag_197xn_100", aC = "_collapseContentDescription_197xn_103", Jn = {
  collapse: Wj,
  collapseHeader: Yj,
  collapseHeaderLink: Qj,
  collapseHeaderStatus: Jj,
  collapseHeaderIcon: Zj,
  collapseHeaderTitle: Xj,
  collapseContent: eC,
  collapseContentHeadline: nC,
  collapseContentButtonSpacer: tC,
  collapseContentButtonLink: rC,
  collapseContentStatusTag: iC,
  collapseContentDescription: aC
}, Yf = ({
  jiraInstanceUrl: e,
  avatarId: n,
  iconUrl: r
}) => n ? `${e}/rest/api/3/universal_avatar/view/type/issuetype/avatar/${n}?size=medium` : r, oC = ({
  issues: e,
  jiraInstanceUrl: n,
  unlinkIssue: r
}) => {
  const i = e.reduce(
    (u, p) => p != null && p.id ? { ...u, [p.id]: !1 } : u,
    {}
  ), [o, s] = G(i), { track: l } = sn(), c = (u, p) => {
    s({ ...o, [u]: p });
  };
  return /* @__PURE__ */ U.jsx(C, { flexDirection: "column", gap: "250", children: e != null && e.length ? e.map((u) => {
    const { summary: p, description: m, status: v, issuetype: y } = (u == null ? void 0 : u.fields) || {}, b = Yf({
      avatarId: y == null ? void 0 : y.avatarId,
      iconUrl: y == null ? void 0 : y.iconUrl,
      jiraInstanceUrl: n
    }), N = !!(u != null && u.id && o[u.id]);
    return /* @__PURE__ */ U.jsxs(
      Kn,
      {
        onToggle: () => (u == null ? void 0 : u.id) && c(u.id, !o[u.id]),
        isOpen: N,
        className: Jn.collapse,
        children: [
          /* @__PURE__ */ U.jsx(Kn.Header, { className: Jn.collapseHeader, children: /* @__PURE__ */ U.jsxs(
            C,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ U.jsxs(C, { flexDirection: "row", justifyContent: "space-between", children: [
                  /* @__PURE__ */ U.jsxs(C, { alignItems: "center", gap: "200", children: [
                    /* @__PURE__ */ U.jsx(
                      pa,
                      {
                        width: 16,
                        iconUrl: b,
                        jiraInstanceUrl: n
                      }
                    ),
                    /* @__PURE__ */ U.jsx(
                      "a",
                      {
                        className: Jn.collapseHeaderLink,
                        href: `${n}/browse/${u == null ? void 0 : u.key}`,
                        target: "_blank",
                        rel: "noreferrer",
                        onClick: (x) => {
                          x.stopPropagation(), u != null && u.key && l("jira:view:issue:clicked", {
                            jiraIssueKey: u.key,
                            jiraInstanceUrl: n
                          });
                        },
                        children: /* @__PURE__ */ U.jsxs(C, { alignItems: "center", gap: "200", children: [
                          u == null ? void 0 : u.key,
                          /* @__PURE__ */ U.jsx(Fe, { name: "external-link", size: 16 })
                        ] })
                      },
                      u == null ? void 0 : u.key
                    )
                  ] }),
                  /* @__PURE__ */ U.jsx("span", { className: Jn.collapseHeaderStatus, children: (v == null ? void 0 : v.name) && /* @__PURE__ */ U.jsx(an, { className: Jn.collapseContentStatusTag, children: v.name }) })
                ] }),
                /* @__PURE__ */ U.jsx("div", { className: Jn.collapseHeaderTitle, children: p })
              ]
            }
          ) }),
          /* @__PURE__ */ U.jsx(Kn.Content, { className: Jn.collapseContent, children: /* @__PURE__ */ U.jsxs(C, { flexDirection: "column", gap: "250", margin: "0 0 200 0", children: [
            /* @__PURE__ */ U.jsx("div", { className: Jn.collapseContentHeadline, children: "Description" }),
            /* @__PURE__ */ U.jsx(nn, { className: Jn.collapseContentDescription, children: m ? ec(m, Wf) : "" }),
            /* @__PURE__ */ U.jsx(
              On,
              {
                icon: "link-slash",
                variant: "secondary",
                className: Jn.collapseContentButtonSpacer,
                onClick: () => (u == null ? void 0 : u.key) && r(u.key),
                children: "Unlink issue from Jira"
              }
            ),
            /* @__PURE__ */ U.jsx(
              rt,
              {
                slotEnd: /* @__PURE__ */ U.jsx(Fe, { name: "external-link" }),
                variant: "tertiary",
                className: Jn.collapseContentButtonLink,
                navigate: () => {
                  var x;
                  u != null && u.key && (l("jira:view:issue:clicked", {
                    jiraIssueKey: u.key,
                    jiraInstanceUrl: n
                  }), (x = window.open(
                    `${n}/browse/${u.key}`,
                    "_blank"
                  )) == null || x.focus());
                },
                children: "View issue in Jira"
              }
            )
          ] }) })
        ]
      },
      u == null ? void 0 : u.id
    );
  }) : /* @__PURE__ */ U.jsx(U.Fragment, {}) });
}, sC = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "title" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "url" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createOrUpdateRemoteIssueLink" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "application" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "name" }, value: { kind: "StringValue", value: "Dixa Conversations", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "StringValue", value: "com.dixa.conversations", block: !1 } }] } }, { kind: "ObjectField", name: { kind: "Name", value: "relationship" }, value: { kind: "StringValue", value: "dixa-backlink", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "object" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "title" } } }, { kind: "ObjectField", name: { kind: "Name", value: "url" }, value: { kind: "Variable", name: { kind: "Name", value: "url" } } }, { kind: "ObjectField", name: { kind: "Name", value: "icon" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "url16x16" }, value: { kind: "StringValue", value: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "StringValue", value: "Dixa", block: !1 } }] } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }] } }] } }] } }] }, lC = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removeBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "deleteRemoteIssueLinkByGlobalId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }] }] } }] } }] }, cC = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Jira_IssueUpdateDetails_Input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_CreatedIssue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_ErrorCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorMessages" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "errors" } }] } }] } }] } }] } }] }, dC = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAllProjects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, uC = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCreateIssueMeta" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectKey" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCreateIssueMeta" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "projectKeys" }, value: { kind: "ListValue", values: [{ kind: "Variable", name: { kind: "Name", value: "projectKey" } }] } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "StringValue", value: "projects.issuetypes.fields", block: !1 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "issuetypes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "iconUrl" } }, { kind: "Field", name: { kind: "Name", value: "entityId" } }, { kind: "Field", name: { kind: "Name", value: "hierarchyLevel" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "scope" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalProperties" } }] } }, { kind: "Field", name: { kind: "Name", value: "expand" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "required" } }, { kind: "Field", name: { kind: "Name", value: "hasDefaultValue" } }, { kind: "Field", name: { kind: "Name", value: "schema" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "system" } }, { kind: "Field", name: { kind: "Name", value: "items" } }, { kind: "Field", name: { kind: "Name", value: "custom" } }, { kind: "Field", name: { kind: "Name", value: "customId" } }] } }, { kind: "Field", name: { kind: "Name", value: "allowedValues" } }, { kind: "Field", name: { kind: "Name", value: "defaultValue" } }, { kind: "Field", name: { kind: "Name", value: "operations" } }, { kind: "Field", name: { kind: "Name", value: "autoCompleteUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, mC = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchForIssuesUsingJql" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "jql" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchForIssuesUsingJql" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "jql" }, value: { kind: "Variable", name: { kind: "Name", value: "jql" } } }, { kind: "Argument", name: { kind: "Name", value: "maxResults" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "fields" }, value: { kind: "ListValue", values: [{ kind: "StringValue", value: "summary", block: !1 }, { kind: "StringValue", value: "description", block: !1 }, { kind: "StringValue", value: "status", block: !1 }, { kind: "StringValue", value: "updated", block: !1 }, { kind: "StringValue", value: "issuetype", block: !1 }, { kind: "StringValue", value: "project", block: !1 }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "fields" } }] } }] } }] } }] } }] }, pC = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "findUsers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findUsers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountId" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "self" } }, { kind: "Field", name: { kind: "Name", value: "active" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, fC = {
  '\n  mutation createBacklink(\n    $issueKey: String!\n    $title: String!\n    $url: String!\n    $globalId: String!\n  ) {\n    Jira {\n      createOrUpdateRemoteIssueLink(\n        issueIdOrKey: $issueKey\n        input: {\n          globalId: $globalId\n          application: {\n            name: "Dixa Conversations"\n            type: "com.dixa.conversations"\n          }\n          relationship: "dixa-backlink"\n          object: {\n            title: $title\n            url: $url\n            icon: {\n              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"\n              title: "Dixa"\n            }\n          }\n        }\n      ) {\n        __typename\n      }\n    }\n  }\n': sC,
  "\n  mutation removeBacklink($issueKey: String!, $globalId: String!) {\n    Jira {\n      deleteRemoteIssueLinkByGlobalId(\n        issueIdOrKey: $issueKey\n        globalId: $globalId\n      )\n    }\n  }\n": lC,
  "\n  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {\n    Jira {\n      createIssue(input: $input) {\n        ... on Jira_CreatedIssue {\n          id\n          key\n        }\n        ... on Jira_ErrorCollection {\n          errorMessages\n          status\n          errors\n        }\n      }\n    }\n  }\n": cC,
  "\n  query jira {\n    Jira {\n      getAllProjects {\n        id\n        key\n        name\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": dC,
  '\n  query getCreateIssueMeta($projectKey: String) {\n    Jira {\n      getCreateIssueMeta(\n        projectKeys: [$projectKey]\n        expand: "projects.issuetypes.fields"\n      ) {\n        projects {\n          id\n          key\n          name\n          issuetypes {\n            id\n            name\n            iconUrl\n            entityId\n            hierarchyLevel\n            subtask\n            scope {\n              type\n              project {\n                id\n                key\n                name\n              }\n              additionalProperties\n            }\n            expand\n            subtask\n            description\n            fields {\n              additionalProperties {\n                key\n                value {\n                  key\n                  name\n                  required\n                  hasDefaultValue\n                  schema {\n                    type\n                    system\n                    items\n                    custom\n                    customId\n                  }\n                  allowedValues\n                  defaultValue\n                  operations\n                  autoCompleteUrl\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n': uC,
  '\n  query searchForIssuesUsingJql($jql: String!, $maxResults: Int) {\n    Jira {\n      searchForIssuesUsingJql(\n        jql: $jql\n        maxResults: $maxResults\n        fields: [\n          "summary"\n          "description"\n          "status"\n          "updated"\n          "issuetype"\n          "project"\n        ]\n      ) {\n        issues {\n          id\n          key\n          fields\n        }\n      }\n    }\n  }\n': mC,
  "\n  query findUsers($query: String) {\n    Jira {\n      findUsers(query: $query) {\n        accountId\n        displayName\n        self\n        active\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": pC
};
function tr(e) {
  return fC[e] ?? {};
}
const Qf = tr(
  /* GraphQL */
  `
  query searchForIssuesUsingJql($jql: String!, $maxResults: Int) {
    Jira {
      searchForIssuesUsingJql(
        jql: $jql
        maxResults: $maxResults
        fields: [
          "summary"
          "description"
          "status"
          "updated"
          "issuetype"
          "project"
        ]
      ) {
        issues {
          id
          key
          fields
        }
      }
    }
  }
`
), vC = tr(
  /* GraphQL */
  `
  mutation createBacklink(
    $issueKey: String!
    $title: String!
    $url: String!
    $globalId: String!
  ) {
    Jira {
      createOrUpdateRemoteIssueLink(
        issueIdOrKey: $issueKey
        input: {
          globalId: $globalId
          application: {
            name: "Dixa Conversations"
            type: "com.dixa.conversations"
          }
          relationship: "dixa-backlink"
          object: {
            title: $title
            url: $url
            icon: {
              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"
              title: "Dixa"
            }
          }
        }
      ) {
        __typename
      }
    }
  }
`
), yC = tr(
  /* GraphQL */
  `
  mutation removeBacklink($issueKey: String!, $globalId: String!) {
    Jira {
      deleteRemoteIssueLinkByGlobalId(
        issueIdOrKey: $issueKey
        globalId: $globalId
      )
    }
  }
`
), gC = tr(
  /* GraphQL */
  `
  query jira {
    Jira {
      getAllProjects {
        id
        key
        name
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), hC = tr(
  /* GraphQL */
  `
  query getCreateIssueMeta($projectKey: String) {
    Jira {
      getCreateIssueMeta(
        projectKeys: [$projectKey]
        expand: "projects.issuetypes.fields"
      ) {
        projects {
          id
          key
          name
          issuetypes {
            id
            name
            iconUrl
            entityId
            hierarchyLevel
            subtask
            scope {
              type
              project {
                id
                key
                name
              }
              additionalProperties
            }
            expand
            subtask
            description
            fields {
              additionalProperties {
                key
                value {
                  key
                  name
                  required
                  hasDefaultValue
                  schema {
                    type
                    system
                    items
                    custom
                    customId
                  }
                  allowedValues
                  defaultValue
                  operations
                  autoCompleteUrl
                }
              }
            }
          }
        }
      }
    }
  }
`
), kC = tr(
  /* GraphQL */
  `
  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {
    Jira {
      createIssue(input: $input) {
        ... on Jira_CreatedIssue {
          id
          key
        }
        ... on Jira_ErrorCollection {
          errorMessages
          status
          errors
        }
      }
    }
  }
`
), bC = tr(
  /* GraphQL */
  `
  query findUsers($query: String) {
    Jira {
      findUsers(query: $query) {
        accountId
        displayName
        self
        active
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), nc = new RegExp("[a-zA-Z0-9_]{2,}-[0-9]+"), _C = new RegExp(`^${nc.source}$`), SC = new RegExp(`/${nc.source}$`), ku = new RegExp(
  `.+?[&?]selectedIssue=(${nc.source})[&?]?.*`
);
function Jf(e, n) {
  var r, i;
  const o = { jira: { issues: [] } }, [s, l] = G([]), [c, u] = G([]), [p, m] = G(), { track: v } = sn(), { showNotification: y, showModal: b, useLazyQuery: N, useMutation: x } = rn(), {
    loading: T,
    data: $,
    error: P,
    store: h
  } = fl(e ?? null), [
    E,
    { loading: q, error: M, data: R }
  ] = N(Qf, {
    notifyOnNetworkStatusChange: !0
  });
  Pe(() => {
    var Z, J;
    const z = ((J = (Z = R == null ? void 0 : R.Jira) == null ? void 0 : Z.searchForIssuesUsingJql) == null ? void 0 : J.issues) || [];
    z != null && z.length && (u(z), l(z.map((me) => me == null ? void 0 : me.key).filter(Boolean)));
  }, [R]), Pe(
    () => m(P || M || void 0),
    [P, M]
  ), Pe(
    () => {
      T || D();
    },
    // Only trigger when data is loaded, not when the loading status changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [$]
  );
  const w = async (Z, J) => {
    await h(Z).then(() => {
      y({
        icon: "check-circle-filled",
        severity: "success",
        title: J.success.title,
        text: J.success.text
      });
    }).catch((z) => {
      y({
        title: J.error.title,
        text: `${J.error.text} ${z.message && " (" + z.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, [H] = x(vC, {
    onError: (Z) => {
      y({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to create a link back from the issue to the conversation. Please create it manually in Jira.
				${Z.message && " (" + Z.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), pe = (Z) => {
    const J = window.location.href;
    H({
      variables: {
        issueKey: Z,
        title: `# ${e}`,
        url: J,
        globalId: `system=${J}`
      }
    });
  }, [le] = x(yC, {
    onError: (Z) => {
      y({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to remove a link back from the issue to the conversation. Please remove it manually from Jira.
					${Z.message && " (" + Z.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), Se = (Z) => {
    const J = window.location.href;
    le({
      variables: {
        issueKey: Z,
        globalId: `system=${J}`
      }
    });
  }, ae = (Z) => ({
    jiraInstanceUrl: n,
    jiraIssueKey: Z
  }), D = () => {
    var Z, J, z;
    !((J = (Z = $ == null ? void 0 : $.jira) == null ? void 0 : Z.issues) != null && J.length) && !T ? u([]) : E({
      variables: {
        jql: `key in (${(z = $ == null ? void 0 : $.jira) == null ? void 0 : z.issues.join(",")})`,
        maxResults: 15
      }
    });
  }, V = async (Z) => {
    var J;
    v("jira:issue:link:clicked", ae(Z));
    const z = (J = $ == null ? void 0 : $.jira) != null && J.issues ? $ : o;
    z.jira.issues = Array.from(
      new Set(z.jira.issues).add(Z)
    ), await h(z).then(() => pe(Z)).catch((me) => {
      y({
        title: "Linking failed",
        text: `Linking ${Z} failed. Please try again. ${me.message && " (" + me.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, de = (Z) => {
    var J;
    v("jira:issue:link:clicked", ae(Z));
    const z = (J = $ == null ? void 0 : $.jira) != null && J.issues ? $ : o;
    z.jira.issues = Array.from(
      new Set(z.jira.issues).add(Z)
    ), w(z, {
      success: {
        title: "Jira issue linked",
        text: `You linked the Jira issue ${Z} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${Z} failed. Please try again.`
      }
    }).then(() => pe(Z));
  }, te = (Z) => {
    v("jira:issue:unlink:clicked", ae(Z)), b({
      headline: `Unlink issue ${Z}?`,
      text: `You are about to unlink the issue ${Z}. Do you want to proceed?`,
      confirmLabel: "Unlink Jira issue",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        var J;
        v("jira:issue:unlink:confirmed", ae(Z));
        const z = {
          ...$,
          jira: {
            ...$ == null ? void 0 : $.jira,
            issues: ((J = $ == null ? void 0 : $.jira) == null ? void 0 : J.issues.filter((me) => me !== Z)) || []
          }
        };
        w(z, {
          success: {
            title: "Jira issue unlinked",
            text: `You unlinked the Jira issue ${Z}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${Z} failed.`
          }
        }), Se(Z);
      },
      onCancel: () => v("jira:issue:unlink:cancelled", ae(Z))
    });
  }, he = () => {
    v("jira:issue:unlink-all:clicked", { jiraInstanceUrl: n }), b({
      headline: "Unlink all Jira issues?",
      text: "You are about to unlink the all Jira issues from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        v("jira:issue:unlink-all:confirmed", { jiraInstanceUrl: n }), c == null || c.forEach((Z) => (Z == null ? void 0 : Z.key) && Se(Z.key)), w(o, {
          success: {
            title: "Unlinking successful",
            text: "All Jira issues were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues failed."
          }
        });
      },
      onCancel: () => v("jira:issue:unlink-all:cancelled", { jiraInstanceUrl: n })
    });
  }, _e = ((i = (r = $ == null ? void 0 : $.jira) == null ? void 0 : r.issues) == null ? void 0 : i.filter(
    (Z) => !(s != null && s.includes(Z))
  )) || [];
  return {
    linkIssue: de,
    linkIssueQuietly: V,
    unlinkIssue: te,
    loadIssues: D,
    removeDanglingIssueLinks: () => {
      var Z;
      v("jira:issue:unlink-all-dangling:clicked", {
        jiraInstanceUrl: n
      });
      const J = {
        ...$,
        jira: {
          ...$ == null ? void 0 : $.jira,
          issues: ((Z = $ == null ? void 0 : $.jira) == null ? void 0 : Z.issues.filter(
            (z) => !_e.includes(z)
          )) || []
        }
      };
      h(J);
    },
    unlinkAllIssues: he,
    maybeExtractIssueKey: (Z) => {
      var J;
      const z = Z.replace(/\s/g, "");
      if (_C.test(z))
        return z;
      if (ku.test(Z))
        return (J = Z.match(ku)) == null ? void 0 : J[1];
      if (Z.startsWith(n) && SC.test(Z))
        return Z.substring(Z.lastIndexOf("/") + 1);
    },
    isLoadingIssueLinks: T,
    danglingIssueLinks: _e,
    isLoadingIssues: q,
    issues: c,
    error: p
  };
}
const NC = "_result_14091_27", xC = "_resultName_14091_47", wC = "_resultNameIcon_14091_55", jC = "_resultDescription_14091_60", CC = "_resultLinkIcon_14091_72", EC = "_tooltip_14091_81", FC = "_tooltipName_14091_87", IC = "_tooltipNameIcon_14091_92", $C = "_tooltipDescription_14091_97", TC = "_tooltipSummary_14091_103", OC = "_tooltipTag_14091_107", Zn = {
  result: NC,
  resultName: xC,
  resultNameIcon: wC,
  resultDescription: jC,
  resultLinkIcon: CC,
  tooltip: EC,
  tooltipName: FC,
  tooltipNameIcon: IC,
  tooltipDescription: $C,
  tooltipSummary: TC,
  tooltipTag: OC
}, RC = ({
  item: e,
  jiraInstanceUrl: n,
  onSelect: r,
  disableTooltip: i = !1,
  ...o
}) => {
  const { issuetype: s, name: l, status: c, text: u, description: p } = e, [m, v] = G(!1), y = Yf({
    avatarId: s == null ? void 0 : s.avatarId,
    iconUrl: s == null ? void 0 : s.iconUrl,
    jiraInstanceUrl: n
  });
  return /* @__PURE__ */ U.jsx(
    jn,
    {
      disabled: i,
      className: Zn.tooltip,
      content: /* @__PURE__ */ U.jsxs(C, { flexDirection: "column", justifyContent: "center", width: "100%", children: [
        /* @__PURE__ */ U.jsxs(
          C,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            children: [
              /* @__PURE__ */ U.jsxs("span", { className: Zn.tooltipName, children: [
                /* @__PURE__ */ U.jsx(
                  pa,
                  {
                    width: 16,
                    iconUrl: y,
                    className: Zn.tooltipNameIcon,
                    jiraInstanceUrl: n
                  }
                ),
                " ",
                l
              ] }),
              /* @__PURE__ */ U.jsx(an, { className: Zn.tooltipTag, children: c.name })
            ]
          }
        ),
        p && /* @__PURE__ */ U.jsx("div", { className: Zn.tooltipSummary, children: p }),
        u && /* @__PURE__ */ U.jsx("div", { className: Zn.tooltipDescription, children: u })
      ] }),
      side: "left",
      children: /* @__PURE__ */ U.jsxs(
        "button",
        {
          ...o,
          className: Zn.result,
          type: "button",
          onClick: () => {
            r(e);
          },
          onMouseEnter: () => v(!0),
          onMouseLeave: () => v(!1),
          children: [
            /* @__PURE__ */ U.jsxs(
              C,
              {
                flexDirection: "column",
                justifyContent: "center",
                style: {
                  width: m ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ U.jsx(C, { flexDirection: "row", children: /* @__PURE__ */ U.jsxs("span", { className: Zn.resultName, children: [
                    /* @__PURE__ */ U.jsx(
                      pa,
                      {
                        width: 16,
                        iconUrl: y,
                        className: Zn.resultNameIcon,
                        jiraInstanceUrl: n
                      }
                    ),
                    " ",
                    l
                  ] }) }),
                  p && /* @__PURE__ */ U.jsx("div", { className: Zn.resultDescription, children: p })
                ]
              }
            ),
            m && /* @__PURE__ */ U.jsx(
              Fe,
              {
                className: Zn.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, DC = ({
  className: e,
  searched: n,
  jiraInstanceUrl: r
}) => /* @__PURE__ */ U.jsx(
  rt,
  {
    slotEnd: /* @__PURE__ */ U.jsx(Fe, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      var i;
      (i = window.open(
        `${r}/secure/QuickSearch.jspa?searchString=${n}`,
        "_blank"
      )) == null || i.focus();
    },
    children: "View matching issues in Jira"
  }
), PC = ({
  onSelectIssue: e,
  jiraInstanceUrl: n,
  filterByProjectKey: r,
  disableTooltip: i
}) => {
  const { useLazyQuery: o } = rn(), [s, l] = G([]), [c, u] = G(""), [p, { loading: m, error: v, data: y, networkStatus: b }] = o(Qf, {
    notifyOnNetworkStatusChange: !0
  }), { maybeExtractIssueKey: N } = Jf(null, n);
  Lr(
    () => {
      !m && c && b === Yn.ready ? p({
        variables: {
          jql: c,
          maxResults: 25
        }
      }) : l([]);
    },
    500,
    [c]
  ), Pe(() => {
    var E, q;
    const M = ((q = (E = y == null ? void 0 : y.Jira) == null ? void 0 : E.searchForIssuesUsingJql) == null ? void 0 : q.issues) || [];
    l(
      M.map((R) => ({
        id: (R == null ? void 0 : R.key) ?? "",
        name: (R == null ? void 0 : R.key) ?? "",
        description: R == null ? void 0 : R.fields.summary,
        status: R == null ? void 0 : R.fields.status,
        issuetype: R == null ? void 0 : R.fields.issuetype,
        text: R != null && R.fields.description ? ec(R == null ? void 0 : R.fields.description, Wf) : /* @__PURE__ */ U.jsx(U.Fragment, {})
      }))
    );
  }, [y]);
  const x = (E) => {
    e(E.id), u("");
  }, T = (E) => {
    const q = N(E);
    q ? u(`key = '${q}'`) : E !== "" && u(
      `text ~ '${E}'${r ? " and project = " + r : ""}`
    );
  }, $ = () => {
    u("");
  }, P = (E) => /* @__PURE__ */ U.jsx(DC, { ...E, jiraInstanceUrl: n }), h = (E) => /* @__PURE__ */ U.jsx(
    RC,
    {
      ...E,
      jiraInstanceUrl: n,
      disableTooltip: i
    }
  );
  return !m && v ? /* @__PURE__ */ U.jsx(bn, { error: v }) : /* @__PURE__ */ U.jsx(
    Wn,
    {
      items: s,
      loading: m,
      onSearch: T,
      onSelect: x,
      onClear: $,
      emptyMessage: c ? m ? "" : "No Jira Issues found" : "Enter Jira issue key, link or search terms",
      suggestionComponent: P,
      itemComponent: h,
      placeholder: "Search and link existing issue",
      searchable: !0,
      clearable: !0
    }
  );
}, AC = ({
  field: e,
  value: n,
  onChange: r
}) => {
  var i;
  const [o, s] = G(n ? [n] : []), l = (c, u) => {
    s(
      u ? [...o, c] : o.filter(({ id: p }) => p !== c.id)
    );
  };
  return Pe(() => {
    r(o);
  }, [o]), /* @__PURE__ */ U.jsx(
    Wn,
    {
      multiple: !0,
      onChange: l,
      selectedItems: o,
      items: (i = e == null ? void 0 : e.allowedValues) == null ? void 0 : i.map(
        ({ id: c, name: u, value: p }) => ({
          id: c,
          name: u || p
        })
      )
    }
  );
}, LC = "_itemButton_veukg_27", UC = "_result_veukg_32", MC = "_resultIcon_veukg_52", BC = "_resultName_veukg_56", VC = "_resultCheckIcon_veukg_64", Yr = {
  itemButton: LC,
  result: UC,
  resultIcon: MC,
  resultName: BC,
  resultCheckIcon: VC
}, Xs = ({
  item: e,
  checked: n = !1,
  onSelectItem: r,
  jiraInstanceUrl: i
}) => {
  var o;
  const s = (c) => {
    const u = c == null ? void 0 : c.indexOf("/rest/api/");
    return u ? `${i}${c == null ? void 0 : c.substring(u)}` : c;
  };
  let l = (e == null ? void 0 : e.iconUrl) || ((o = e == null ? void 0 : e.avatarUrls) == null ? void 0 : o._24x24) || null;
  return l && (l = l != null && l.startsWith("https://api.atlassian.com/ex/") ? s(l) : l), /* @__PURE__ */ U.jsx(
    C,
    {
      flexDirection: "column",
      justifyContent: "center",
      width: "100%",
      "data-testid": "jira-select-item-component",
      children: /* @__PURE__ */ U.jsx(
        "button",
        {
          onClick: () => {
            r(e);
          },
          className: Yr.itemButton,
          children: /* @__PURE__ */ U.jsxs(C, { className: Yr.result, flexDirection: "row", width: "100%", children: [
            /* @__PURE__ */ U.jsx(
              pa,
              {
                width: 36,
                iconUrl: l || "",
                className: Yr.resultIcon,
                jiraInstanceUrl: i
              }
            ),
            /* @__PURE__ */ U.jsx(nn, { className: Yr.resultName, children: e.name }),
            n && /* @__PURE__ */ U.jsx(nn, { className: Yr.resultCheckIcon, children: /* @__PURE__ */ U.jsx(Fe, { name: "done" }) })
          ] })
        }
      )
    }
  );
}, qC = ({
  selectedItems: e,
  agentEmail: n,
  onSelect: r,
  jiraInstanceUrl: i
}) => {
  const { useLazyQuery: o } = rn(), [s, l] = G([]), [c, u] = G(), p = 2, [m, { loading: v, error: y, data: b, networkStatus: N }] = o(bC, {
    notifyOnNetworkStatusChange: !0
  });
  return Lr(
    () => {
      !v && c && c.length >= p && N === Yn.ready ? m({
        variables: {
          query: c,
          maxResults: 10
        }
      }) : l([]);
    },
    500,
    [c]
  ), Pe(() => {
    n && m({
      variables: {
        query: n,
        maxResults: 1
      }
    }).then((x) => {
      var T, $, P, h;
      if ((($ = (T = x == null ? void 0 : x.data) == null ? void 0 : T.Jira.findUsers) == null ? void 0 : $.length) === 1) {
        const E = (h = (P = x == null ? void 0 : x.data) == null ? void 0 : P.Jira) == null ? void 0 : h.findUsers[0];
        r(E.accountId), l([
          {
            id: E.accountId,
            name: E.displayName
          }
        ]);
      }
    });
  }, []), Pe(() => {
    var x;
    const T = ((x = b == null ? void 0 : b.Jira) == null ? void 0 : x.findUsers) || [];
    l(
      T.filter(({ active: $ }) => $).map(({ accountId: $, displayName: P, avatarUrls: h, active: E }) => ({
        id: $,
        name: P,
        avatarUrls: h,
        active: E
      }))
    );
  }, [b]), !v && y ? /* @__PURE__ */ U.jsx(bn, { error: y }) : /* @__PURE__ */ U.jsx(
    Wn,
    {
      clearable: !0,
      searchable: !0,
      items: s,
      loading: v,
      onSearch: (x) => u(x),
      onSelect: r,
      onClear: () => u(void 0),
      selectedItems: e,
      emptyMessage: c ? v ? "" : "No user found" : "Enter keyword to search for user",
      itemComponent: ({ item: x, onSelect: T, checked: $ }) => /* @__PURE__ */ U.jsx(
        Xs,
        {
          item: x,
          checked: $,
          onSelectItem: T,
          jiraInstanceUrl: i
        }
      ),
      placeholder: "Search Jira users"
    }
  );
}, bu = ({
  field: e
}) => {
  const [n, r] = G(!1), [i, o] = hl();
  return Pe(() => {
    const s = n ? window.setTimeout(() => r(!1), 2e3) : void 0;
    return () => window.clearTimeout(s);
  }, [n]), /* @__PURE__ */ U.jsxs(C, { alignItems: "center", gap: "400", justifyContent: "space-between", children: [
    /* @__PURE__ */ U.jsx(
      Fe,
      {
        size: 24,
        name: "exclamation-triangle-filled",
        color: $e.red[500]
      }
    ),
    /* @__PURE__ */ U.jsx(se.Paragraph, { children: "Your organizations Jira configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field. Please, attach a copy of the field details when contacting us. You can use the copy button to do so." }),
    /* @__PURE__ */ U.jsx(jn, { content: n ? "Copied" : "Copy field details", dark: !0, children: /* @__PURE__ */ U.jsx(
      Bt,
      {
        variant: "secondary",
        icon: n ? "done" : "copy",
        onClick: () => {
          o(JSON.stringify(e, null, 2)), r(!0);
        }
      }
    ) })
  ] });
}, zC = ({
  field: e,
  onChange: n,
  value: r,
  conversationContext: i,
  jiraInstanceUrl: o
}) => {
  var s, l;
  const { type: c, system: u } = e.schema;
  if (["array", "option", "priority"].includes(c) && (!(e != null && e.allowedValues) || e.allowedValues.length === 0))
    return /* @__PURE__ */ U.jsx(bu, { field: e });
  switch (c) {
    case "issuelink":
    case "environment":
    case "any":
      return /* @__PURE__ */ U.jsx(St, { onChange: n, value: r });
    case "string":
      return u === "description" ? /* @__PURE__ */ U.jsx(ys, { onChange: n, value: r }) : /* @__PURE__ */ U.jsx(St, { onChange: n, value: r });
    case "textarea":
      return /* @__PURE__ */ U.jsx(ys, { onChange: n, value: r });
    case "number":
      return /* @__PURE__ */ U.jsx(St, { type: "number", onChange: n, value: r });
    case "user":
      return /* @__PURE__ */ U.jsx(
        qC,
        {
          onSelect: n,
          selectedItems: r ? [r] : [],
          agentEmail: e.key === "reporter" && ((s = i == null ? void 0 : i.agent) == null ? void 0 : s.email) || void 0,
          jiraInstanceUrl: o
        }
      );
    case "option":
    case "priority":
      return /* @__PURE__ */ U.jsx(
        Wn,
        {
          onSelect: n,
          selectedItems: r ? [r] : [],
          items: ((l = e == null ? void 0 : e.allowedValues) == null ? void 0 : l.map(
            ({ id: p, name: m, value: v }) => ({
              id: p,
              name: m || v
            })
          )) || []
        }
      );
    case "array":
      return /* @__PURE__ */ U.jsx(AC, { field: e, value: r, onChange: n });
    default:
      return /* @__PURE__ */ U.jsx(bu, { field: e });
  }
}, HC = ["description", "reporter", "summary"], KC = ({
  issueTypeFields: e,
  control: n,
  jiraInstanceUrl: r,
  conversationContext: i,
  errors: o
}) => /* @__PURE__ */ U.jsx(U.Fragment, { children: e.filter(({ key: s }) => s !== "project" && s !== "issuetype").filter(
  ({ key: s, required: l }) => l || HC.includes(s)
).map((s) => /* @__PURE__ */ U.jsx(
  nt,
  {
    control: n,
    render: ({ field: { onChange: l, value: c } }) => /* @__PURE__ */ U.jsx(
      Fn,
      {
        meta: {
          error: o && s.key in o ? o[s.key].message : null
        },
        label: s.name,
        required: s.required,
        children: zC({
          field: s,
          onChange: l,
          value: c,
          conversationContext: i,
          jiraInstanceUrl: r
        })
      },
      s.key
    ),
    name: s.key,
    rules: {
      required: s.required ? "This field is required" : !1
    }
  },
  s.key
)) }), GC = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: r,
  setIssueLinkCopied: i,
  copyToClipboard: o
}) => /* @__PURE__ */ U.jsxs(
  C,
  {
    flexDirection: "column",
    gap: "400",
    "data-testid": "jira-create-issue-success-message",
    children: [
      /* @__PURE__ */ U.jsxs(se.Paragraph, { children: [
        "You can visit your new issue by following",
        " ",
        /* @__PURE__ */ U.jsxs(
          se.ExternalLink,
          {
            href: `${n}/${e.key}`,
            target: "_blank",
            children: [
              "this link ",
              /* @__PURE__ */ U.jsx(Fe, { name: "external-link" })
            ]
          }
        ),
        " ",
        "or copy it from the field below."
      ] }),
      /* @__PURE__ */ U.jsx(Fn, { label: "Jira issue link", children: /* @__PURE__ */ U.jsx(
        St,
        {
          readOnly: !0,
          value: `${n}/${e.key}`,
          suffix: {
            type: "button",
            button: {
              icon: r ? "done" : "copy",
              onClick: () => {
                i(!0), o(`${n}/${e.key}`);
              }
            }
          }
        }
      ) })
    ]
  }
), WC = "_modalBody_15ysb_27", YC = "_modalBodyFormFields_15ysb_30", _u = {
  modalBody: WC,
  modalBodyFormFields: YC
}, QC = (e) => ({
  version: 1,
  type: "doc",
  content: e == null ? void 0 : e.split(`
`).filter((n) => n !== "").map((n) => ({
    type: "paragraph",
    content: [
      {
        type: "text",
        text: n
      }
    ]
  }))
}), JC = ({
  isOpen: e,
  onClose: n,
  linkIssueQuietly: r,
  conversationContext: i,
  jiraInstanceUrl: o
}) => {
  const [s, l] = G([]), [c, u] = G(), [p, m] = G(0), [v, y] = G([]), [b, N] = G([]), [x, T] = G(!1), [$, P] = G(!1), [h, E] = hl(), { useMutation: q, useLazyQuery: M, showNotification: R } = rn(), {
    control: w,
    handleSubmit: H,
    formState: { errors: pe },
    reset: le,
    setValue: Se,
    getValues: ae
  } = kl(), D = b.length > 0, V = `${o}/browse`, [de, { loading: te, error: he }] = M(gC, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (X) => {
      l(X.Jira.getAllProjects);
    },
    onError: (X) => {
      R({
        title: "Could not get project list",
        text: "We could not fetch the list of your projects. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error response when fetching projects", X), l([]);
    }
  }), [
    _e,
    { loading: Z, error: J }
  ] = M(hC, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (X) => {
      var ye, W;
      m(0);
      const ce = (W = (ye = X == null ? void 0 : X.Jira) == null ? void 0 : ye.getCreateIssueMeta) == null ? void 0 : W.projects[0];
      if (ce) {
        const ie = ce == null ? void 0 : ce.issuetypes.filter(
          ({ subtask: oe }) => !oe
        );
        y(ie || []), Se(
          "issuetype",
          ie.length > 0 ? ie[0] : void 0
        );
      } else
        R({
          title: "Could not get issue-type list",
          text: "It seems that there are no issue-types for this project or you might not have the necessary access rights to view them.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), y([]), N([]);
    },
    onError: (X) => {
      R({
        title: "Could not get issue list",
        text: "We could not fetch the list of issue-types for this project. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error in getCreateIssueMeta", X), y([]), N([]), m(0);
    }
  }), [z, { error: me }] = q(
    kC,
    {
      onError: (X) => {
        T(!1), R({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), console.warn("Error in createMutation", X);
      },
      onCompleted: (X) => {
        var ye, W, ce;
        if (T(!1), X != null && X.Jira && "key" in X.Jira.createIssue)
          u((ye = X == null ? void 0 : X.Jira) == null ? void 0 : ye.createIssue), R({
            title: "Success",
            text: `Jira issue '${X.Jira.createIssue.key}' created`,
            icon: "check-circle-filled",
            severity: "success"
          }), r(X.Jira.createIssue.key);
        else if ("errorMessages" in X.Jira.createIssue || "errors" in X.Jira.createIssue) {
          const ie = (ce = (W = X == null ? void 0 : X.Jira) == null ? void 0 : W.createIssue) == null ? void 0 : ce.errors;
          console.warn("There was a problem creating a Jira issue.", ie), R({
            title: "Creation was not successful",
            text: "Something went wrong. Please get in contact with Dixa.",
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
        }
      }
    }
  ), ke = (X) => {
    var ye, W;
    T(!0);
    const ce = ["environment", "textarea", "description"], ie = {
      fields: {
        ...Object.entries(X).reduce((oe, [be, Ee]) => {
          var Ie, we, Ge;
          if (!Ee || Ee === "")
            delete X[be];
          else {
            let je = be;
            if (be.startsWith("customfield_")) {
              const Te = b.find(
                (Ae) => Ae.key === be
              ), Ye = (Ge = (we = (Ie = Te == null ? void 0 : Te.schema) == null ? void 0 : Ie.custom) == null ? void 0 : we.split(":")) == null ? void 0 : Ge[1];
              Ye && (je = Ye);
            }
            oe[be] = ce.includes(je) ? QC(Ee) : Ee;
          }
          return oe;
        }, {}),
        summary: X.summary,
        project: { id: X.project.id },
        issuetype: { id: X.issuetype.id },
        ...(X == null ? void 0 : X.parent) && { parent: { key: X.parent } },
        ...(X == null ? void 0 : X.reporter) && {
          reporter: { id: ((ye = X.reporter) == null ? void 0 : ye.id) ?? X.reporter }
        },
        ...(X == null ? void 0 : X.assignee) && {
          assignee: { id: ((W = X.assignee) == null ? void 0 : W.id) ?? X.assignee }
        }
      }
    };
    z({
      variables: {
        input: ie
      }
    });
  };
  Pe(() => {
    if (e)
      try {
        de();
      } catch (X) {
        console.warn("Error when fetching initial projects", X);
      }
  }, [e]), Pe(() => {
    const X = $ ? window.setTimeout(() => P(!1), 2e3) : void 0;
    return () => window.clearTimeout(X);
  }, [$]), Pe(() => {
    var X, ye;
    if ((v == null ? void 0 : v.length) > 0) {
      Se("issuetype", v[p]);
      const W = (ye = (X = v[p]) == null ? void 0 : X.fields) == null ? void 0 : ye.additionalProperties;
      if ((W == null ? void 0 : W.length) > 0) {
        const ce = W.map(
          ({ value: be }) => be
        ).sort(
          ({ required: be }, { required: Ee }) => Number(Ee) - Number(be)
        ), { project: ie, issuetype: oe } = ae();
        le({ project: ie, issuetype: oe }), N(ce);
      }
    } else
      N([]), Se("issuetype", void 0);
  }, [v, Se, p]);
  const Oe = () => {
    l([]), N([]), y([]), u(void 0), m(0), T(!1);
  }, Y = () => {
    Oe(), le(), n();
  }, fe = (X) => {
    X && _e({
      variables: {
        projectKey: X
      }
    });
  }, ge = (X) => {
    const ye = v.map((W) => W.id).indexOf(X);
    m(ye ?? 0);
  };
  return /* @__PURE__ */ U.jsxs(
    jt,
    {
      isOpen: e,
      "data-testid": "jira-create-issue-modal",
      onClose: Y,
      children: [
        /* @__PURE__ */ U.jsx(
          Ct,
          {
            title: c ? "Issue creation successful" : "Create new Jira issue",
            onClose: Y
          }
        ),
        /* @__PURE__ */ U.jsxs(Et, { className: _u.modalBody, children: [
          !te && he && /* @__PURE__ */ U.jsx(bn, { error: he, retry: de }),
          !Z && J && /* @__PURE__ */ U.jsx(
            bn,
            {
              error: J,
              retry: _e
            }
          ),
          !x && me && /* @__PURE__ */ U.jsx(bn, { error: me }),
          c ? /* @__PURE__ */ U.jsx(
            GC,
            {
              createdIssue: c,
              issueBaseLink: V,
              issueLinkCopied: $,
              setIssueLinkCopied: P,
              copyToClipboard: E
            }
          ) : /* @__PURE__ */ U.jsx(
            "form",
            {
              "data-testid": "jira-create-issue-form",
              onSubmit: H(ke),
              children: /* @__PURE__ */ U.jsxs(Ar, { children: [
                /* @__PURE__ */ U.jsx(wn, { span: 3, children: /* @__PURE__ */ U.jsx(Fn, { label: "Project", required: !0, children: /* @__PURE__ */ U.jsx(
                  nt,
                  {
                    control: w,
                    name: "project",
                    rules: { required: "Please select a project" },
                    render: ({ field: { onChange: X, value: ye } }) => /* @__PURE__ */ U.jsx(
                      Wn,
                      {
                        searchable: !0,
                        loading: te,
                        onSelect: (W) => {
                          fe(W.key), X(W);
                        },
                        selectedItems: [ye],
                        placeholder: "Select Jira project",
                        emptyMessage: he ? "No projects found" : "No projects available",
                        items: s || [],
                        itemComponent: ({ item: W, onSelect: ce, checked: ie }) => /* @__PURE__ */ U.jsx(
                          Xs,
                          {
                            item: W,
                            checked: ie,
                            onSelectItem: ce,
                            jiraInstanceUrl: o
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ U.jsx(wn, { span: 3, children: /* @__PURE__ */ U.jsx(Fn, { label: "Issue type", required: !0, children: /* @__PURE__ */ U.jsx(
                  nt,
                  {
                    control: w,
                    name: "issuetype",
                    rules: { required: "Please select an issue type" },
                    render: ({ field: { onChange: X, value: ye } }) => /* @__PURE__ */ U.jsx(
                      Wn,
                      {
                        disabled: v.length === 0,
                        loading: Z,
                        onSelect: (W) => {
                          ge(W.id), X(W);
                        },
                        selectedItems: [ye],
                        placeholder: v.length > 0 ? "Select Jira issue type" : "",
                        emptyMessage: J ? "No issues found" : "No issues available",
                        items: v,
                        itemComponent: ({ item: W, onSelect: ce, checked: ie }) => /* @__PURE__ */ U.jsx(
                          Xs,
                          {
                            item: W,
                            checked: ie,
                            onSelectItem: ce,
                            jiraInstanceUrl: o
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                D && // Wrapping all dynamic input fields inside one `FormField`
                // which can handle the overflow scrolling in case we get many
                // input fields in the form
                /* @__PURE__ */ U.jsx(wn, { className: _u.modalBodyFormFields, children: /* @__PURE__ */ U.jsx(
                  KC,
                  {
                    control: w,
                    errors: pe,
                    getValues: ae,
                    conversationContext: i,
                    jiraInstanceUrl: o,
                    issueTypeFields: b
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ U.jsx(
          Mt,
          {
            confirmOnClick: c ? Y : H(ke),
            confirmProps: {
              disabled: !D,
              isLoading: x,
              loadingIndicator: /* @__PURE__ */ U.jsx(ln, { size: 16 })
            },
            confirmName: c ? "Close" : "Save",
            cancelOnClick: c ? void 0 : Y
          }
        )
      ]
    }
  );
}, ZC = (e) => {
  if (!e)
    return "";
  const n = "https://", r = (e.startsWith(n) ? e.slice(n.length) : e).split("/")[0];
  return `${n}${r}`;
}, XC = (e) => {
  if (!(e != null && e.trim()))
    return "Please add a value";
  const n = "https://";
  if (e.startsWith(" ") || e.endsWith(" "))
    return "Please remove any empty spaces before or after the URL";
  const r = e.startsWith(n);
  if (r) {
    const i = e.slice(n.length).split("/");
    if (i.length > 1) {
      const o = r ? n.length + i[0].length : i[0].length;
      return i.length === 2 && i[1] === "" ? "Please remove the trailing slash `/`" : `Please remove the trailing path \`${e.slice(o)}\``;
    }
  } else {
    const i = "://";
    return e.includes(i) ? `The protocol \`${e.substring(
      0,
      e.indexOf(i) + i.length
    )}\` is not supported` : `Please add \`${n}\` as protocol`;
  }
}, eE = "_wrapper_18e01_27", nE = "_inputWrapper_18e01_32", tE = "_inputField_18e01_41", rE = "_inputSeparator_18e01_45", iE = "_buttonLink_18e01_49", aE = "_noIssuesFound_18e01_53", Qr = {
  wrapper: eE,
  inputWrapper: nE,
  inputField: tE,
  inputSeparator: rE,
  buttonLink: iE,
  noIssuesFound: aE
}, oE = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: r } = sn(), i = ZC(n == null ? void 0 : n.jiraSiteUrl), [o, s] = G(!1), l = !!(e != null && e.conversationId), {
    linkIssue: c,
    linkIssueQuietly: u,
    unlinkIssue: p,
    unlinkAllIssues: m,
    loadIssues: v,
    removeDanglingIssueLinks: y,
    danglingIssueLinks: b,
    isLoadingIssueLinks: N,
    isLoadingIssues: x,
    issues: T,
    error: $
  } = Jf(
    l ? e.conversationId : null,
    i
  ), P = n == null ? void 0 : n.enableCreateIssue, h = !!(T != null && T.length || b != null && b.length), E = !!(n != null && n.enableRemoveAllLinks) && h, q = !N && !x && (b == null ? void 0 : b.length) > 0 && !!(n != null && n.showDanglingLinks);
  return !x && $ ? /* @__PURE__ */ U.jsx(bn, { error: $, retry: () => v() }) : /* @__PURE__ */ U.jsxs(U.Fragment, { children: [
    /* @__PURE__ */ U.jsxs(C, { className: Qr.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ U.jsxs(C, { className: Qr.inputWrapper, flexDirection: "column", children: [
        P && /* @__PURE__ */ U.jsxs(U.Fragment, { children: [
          /* @__PURE__ */ U.jsx(
            On,
            {
              variant: "primary",
              onClick: () => s(!0),
              style: {
                minHeight: "38px"
              },
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ U.jsx("div", { className: Qr.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ U.jsx(
          PC,
          {
            onSelectIssue: c,
            jiraInstanceUrl: i
          }
        )
      ] }),
      x ? /* @__PURE__ */ U.jsx(C, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ U.jsx(ln, { "data-testid": "jira-widget-issue-spinner" }) }) : T != null && T.length ? /* @__PURE__ */ U.jsx(
        oC,
        {
          issues: T,
          jiraInstanceUrl: i,
          unlinkIssue: p
        }
      ) : /* @__PURE__ */ U.jsx(se.Paragraph, { align: "center", className: Qr.noIssuesFound, children: "No linked issues found" }),
      E && (T == null ? void 0 : T.length) > 0 && /* @__PURE__ */ U.jsx(
        On,
        {
          variant: "secondary",
          disabled: !(T != null && T.length) && !(b != null && b.length),
          onClick: m,
          children: "Unlink all issues"
        }
      ),
      q && /* @__PURE__ */ U.jsxs(
        C,
        {
          background: $e.neutral[100],
          padding: tn.spacer[300],
          borderRadius: tn["border-radius"][100],
          flexDirection: "column",
          gap: tn.spacer[200],
          children: [
            /* @__PURE__ */ U.jsx(se.Heading, { variant: "heading-3", children: "Unresolved linked issues" }),
            /* @__PURE__ */ U.jsx(
              C,
              {
                flexDirection: "row",
                flexWrap: "wrap",
                gap: tn.spacer[100],
                children: b.map((M) => /* @__PURE__ */ U.jsx(an, { onDelete: () => p(M), children: M }, M))
              }
            ),
            /* @__PURE__ */ U.jsx(
              On,
              {
                variant: "secondary",
                onClick: () => y(),
                icon: "link-slash",
                children: "Remove all unresolved issues"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ U.jsx(
        rt,
        {
          slotEnd: /* @__PURE__ */ U.jsx(Fe, { name: "external-link" }),
          variant: "tertiary",
          className: Qr.buttonLink,
          navigate: () => {
            var M;
            r("jira:view:jira:clicked", { jiraInstanceUrl: i }), (M = window.open(i, "_blank")) == null || M.focus();
          },
          children: "Open Jira"
        }
      )
    ] }),
    /* @__PURE__ */ U.jsx(
      JC,
      {
        isOpen: o,
        onClose: () => s(!1),
        linkIssueQuietly: u,
        conversationContext: e,
        jiraInstanceUrl: i
      }
    )
  ] });
}, sE = "https://support.dixa.help/articles/1379-configuring-the-jira-integration", Su = [
  {
    key: "jiraSiteUrl",
    label: "Jira site URL",
    placeholder: 'Insert your Jira site URL, e.g. "https://your-site.atlassian.net/"',
    secret: !1,
    type: "input",
    required: !0,
    customValidation: (e) => XC(e),
    defaultValue: ""
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: ga
  },
  {
    key: "enableRemoveAllLinks",
    label: 'Enable the "Remove all links" button',
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    label: "Show unresolved links to Jira issues",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._notificationText_13cgk_27{color:#8193b0}._message_uevo0_27{padding:12px;border-radius:4px;border:1px solid #d7dfea}._message_uevo0_27:hover,._messageIsOpen_uevo0_35{border-color:#b5c1d4}._messageHeader_uevo0_38{cursor:pointer}._messageUnattended_uevo0_41{text-decoration:line-through}._messageLabel_uevo0_44{color:#46597c}._messageText_uevo0_47{max-height:150px;overflow:scroll;padding:4px 8px;border:1px solid #e7ecf3;border-radius:4px;overflow:hidden;overflow-y:auto;overflow-x:auto}._messageText_uevo0_47::-webkit-scrollbar{width:7px;height:7px}._messageText_uevo0_47::-webkit-scrollbar-track{background-color:#e7ecf3}._messageText_uevo0_47::-webkit-scrollbar-thumb{background-color:#b5c1d4;border-radius:5px}._list_19xkr_27{padding:0}._listItem_19xkr_30{padding:4px;border-bottom:1px solid #e7ecf3}._listItem_19xkr_30:last-child{border-bottom:none}._tagHover_1tvfi_27:hover{cursor:pointer;border-color:#b5c1d4}._channelUnsubscribed_1tvfi_32{color:#8193b0}._subscriptionError_1fpwj_27{color:#c11d1d;font-size:12px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var el = { exports: {} }, fr = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Ko, Nu;
function Zf() {
  if (Nu)
    return Ko;
  Nu = 1;
  var e = Object.getOwnPropertySymbols, n = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function i(s) {
    if (s == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(s);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var s = new String("abc");
      if (s[5] = "de", Object.getOwnPropertyNames(s)[0] === "5")
        return !1;
      for (var l = {}, c = 0; c < 10; c++)
        l["_" + String.fromCharCode(c)] = c;
      var u = Object.getOwnPropertyNames(l).map(function(m) {
        return l[m];
      });
      if (u.join("") !== "0123456789")
        return !1;
      var p = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(m) {
        p[m] = m;
      }), Object.keys(Object.assign({}, p)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Ko = o() ? Object.assign : function(s, l) {
    for (var c, u = i(s), p, m = 1; m < arguments.length; m++) {
      c = Object(arguments[m]);
      for (var v in c)
        n.call(c, v) && (u[v] = c[v]);
      if (e) {
        p = e(c);
        for (var y = 0; y < p.length; y++)
          r.call(c, p[y]) && (u[p[y]] = c[p[y]]);
      }
    }
    return u;
  }, Ko;
}
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var xu;
function lE() {
  if (xu)
    return fr;
  xu = 1, Zf();
  var e = Cn, n = 60103;
  if (fr.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var r = Symbol.for;
    n = r("react.element"), fr.Fragment = r("react.fragment");
  }
  var i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = Object.prototype.hasOwnProperty, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(c, u, p) {
    var m, v = {}, y = null, b = null;
    p !== void 0 && (y = "" + p), u.key !== void 0 && (y = "" + u.key), u.ref !== void 0 && (b = u.ref);
    for (m in u)
      o.call(u, m) && !s.hasOwnProperty(m) && (v[m] = u[m]);
    if (c && c.defaultProps)
      for (m in u = c.defaultProps, u)
        v[m] === void 0 && (v[m] = u[m]);
    return { $$typeof: n, type: c, key: y, ref: b, props: v, _owner: i.current };
  }
  return fr.jsx = l, fr.jsxs = l, fr;
}
var wu = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ju;
function cE() {
  return ju || (ju = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      var n = Cn, r = Zf(), i = 60103, o = 60106;
      e.Fragment = 60107;
      var s = 60108, l = 60114, c = 60109, u = 60110, p = 60112, m = 60113, v = 60120, y = 60115, b = 60116, N = 60121, x = 60122, T = 60117, $ = 60129, P = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var h = Symbol.for;
        i = h("react.element"), o = h("react.portal"), e.Fragment = h("react.fragment"), s = h("react.strict_mode"), l = h("react.profiler"), c = h("react.provider"), u = h("react.context"), p = h("react.forward_ref"), m = h("react.suspense"), v = h("react.suspense_list"), y = h("react.memo"), b = h("react.lazy"), N = h("react.block"), x = h("react.server.block"), T = h("react.fundamental"), h("react.scope"), h("react.opaque.id"), $ = h("react.debug_trace_mode"), h("react.offscreen"), P = h("react.legacy_hidden");
      }
      var E = typeof Symbol == "function" && Symbol.iterator, q = "@@iterator";
      function M(t) {
        if (t === null || typeof t != "object")
          return null;
        var a = E && t[E] || t[q];
        return typeof a == "function" ? a : null;
      }
      var R = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function w(t) {
        {
          for (var a = arguments.length, d = new Array(a > 1 ? a - 1 : 0), f = 1; f < a; f++)
            d[f - 1] = arguments[f];
          H("error", t, d);
        }
      }
      function H(t, a, d) {
        {
          var f = R.ReactDebugCurrentFrame, _ = f.getStackAddendum();
          _ !== "" && (a += "%s", d = d.concat([_]));
          var S = d.map(function(k) {
            return "" + k;
          });
          S.unshift("Warning: " + a), Function.prototype.apply.call(console[t], console, S);
        }
      }
      var pe = !1;
      function le(t) {
        return !!(typeof t == "string" || typeof t == "function" || t === e.Fragment || t === l || t === $ || t === s || t === m || t === v || t === P || pe || typeof t == "object" && t !== null && (t.$$typeof === b || t.$$typeof === y || t.$$typeof === c || t.$$typeof === u || t.$$typeof === p || t.$$typeof === T || t.$$typeof === N || t[0] === x));
      }
      function Se(t, a, d) {
        var f = a.displayName || a.name || "";
        return t.displayName || (f !== "" ? d + "(" + f + ")" : d);
      }
      function ae(t) {
        return t.displayName || "Context";
      }
      function D(t) {
        if (t == null)
          return null;
        if (typeof t.tag == "number" && w("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof t == "function")
          return t.displayName || t.name || null;
        if (typeof t == "string")
          return t;
        switch (t) {
          case e.Fragment:
            return "Fragment";
          case o:
            return "Portal";
          case l:
            return "Profiler";
          case s:
            return "StrictMode";
          case m:
            return "Suspense";
          case v:
            return "SuspenseList";
        }
        if (typeof t == "object")
          switch (t.$$typeof) {
            case u:
              var a = t;
              return ae(a) + ".Consumer";
            case c:
              var d = t;
              return ae(d._context) + ".Provider";
            case p:
              return Se(t, t.render, "ForwardRef");
            case y:
              return D(t.type);
            case N:
              return D(t._render);
            case b: {
              var f = t, _ = f._payload, S = f._init;
              try {
                return D(S(_));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var V = 0, de, te, he, _e, Z, J, z;
      function me() {
      }
      me.__reactDisabledLog = !0;
      function ke() {
        {
          if (V === 0) {
            de = console.log, te = console.info, he = console.warn, _e = console.error, Z = console.group, J = console.groupCollapsed, z = console.groupEnd;
            var t = {
              configurable: !0,
              enumerable: !0,
              value: me,
              writable: !0
            };
            Object.defineProperties(console, {
              info: t,
              log: t,
              warn: t,
              error: t,
              group: t,
              groupCollapsed: t,
              groupEnd: t
            });
          }
          V++;
        }
      }
      function Oe() {
        {
          if (V--, V === 0) {
            var t = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: r({}, t, {
                value: de
              }),
              info: r({}, t, {
                value: te
              }),
              warn: r({}, t, {
                value: he
              }),
              error: r({}, t, {
                value: _e
              }),
              group: r({}, t, {
                value: Z
              }),
              groupCollapsed: r({}, t, {
                value: J
              }),
              groupEnd: r({}, t, {
                value: z
              })
            });
          }
          V < 0 && w("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var Y = R.ReactCurrentDispatcher, fe;
      function ge(t, a, d) {
        {
          if (fe === void 0)
            try {
              throw Error();
            } catch (_) {
              var f = _.stack.trim().match(/\n( *(at )?)/);
              fe = f && f[1] || "";
            }
          return `
` + fe + t;
        }
      }
      var X = !1, ye;
      {
        var W = typeof WeakMap == "function" ? WeakMap : Map;
        ye = new W();
      }
      function ce(t, a) {
        if (!t || X)
          return "";
        {
          var d = ye.get(t);
          if (d !== void 0)
            return d;
        }
        var f;
        X = !0;
        var _ = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var S;
        S = Y.current, Y.current = null, ke();
        try {
          if (a) {
            var k = function() {
              throw Error();
            };
            if (Object.defineProperty(k.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(k, []);
              } catch (A) {
                f = A;
              }
              Reflect.construct(t, [], k);
            } else {
              try {
                k.call();
              } catch (A) {
                f = A;
              }
              t.call(k.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (A) {
              f = A;
            }
            t();
          }
        } catch (A) {
          if (A && f && typeof A.stack == "string") {
            for (var g = A.stack.split(`
`), L = f.stack.split(`
`), I = g.length - 1, O = L.length - 1; I >= 1 && O >= 0 && g[I] !== L[O]; )
              O--;
            for (; I >= 1 && O >= 0; I--, O--)
              if (g[I] !== L[O]) {
                if (I !== 1 || O !== 1)
                  do
                    if (I--, O--, O < 0 || g[I] !== L[O]) {
                      var re = `
` + g[I].replace(" at new ", " at ");
                      return typeof t == "function" && ye.set(t, re), re;
                    }
                  while (I >= 1 && O >= 0);
                break;
              }
          }
        } finally {
          X = !1, Y.current = S, Oe(), Error.prepareStackTrace = _;
        }
        var Ce = t ? t.displayName || t.name : "", j = Ce ? ge(Ce) : "";
        return typeof t == "function" && ye.set(t, j), j;
      }
      function ie(t, a, d) {
        return ce(t, !1);
      }
      function oe(t) {
        var a = t.prototype;
        return !!(a && a.isReactComponent);
      }
      function be(t, a, d) {
        if (t == null)
          return "";
        if (typeof t == "function")
          return ce(t, oe(t));
        if (typeof t == "string")
          return ge(t);
        switch (t) {
          case m:
            return ge("Suspense");
          case v:
            return ge("SuspenseList");
        }
        if (typeof t == "object")
          switch (t.$$typeof) {
            case p:
              return ie(t.render);
            case y:
              return be(t.type, a, d);
            case N:
              return ie(t._render);
            case b: {
              var f = t, _ = f._payload, S = f._init;
              try {
                return be(S(_), a, d);
              } catch {
              }
            }
          }
        return "";
      }
      var Ee = {}, Ie = R.ReactDebugCurrentFrame;
      function we(t) {
        if (t) {
          var a = t._owner, d = be(t.type, t._source, a ? a.type : null);
          Ie.setExtraStackFrame(d);
        } else
          Ie.setExtraStackFrame(null);
      }
      function Ge(t, a, d, f, _) {
        {
          var S = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var k in t)
            if (S(t, k)) {
              var g = void 0;
              try {
                if (typeof t[k] != "function") {
                  var L = Error((f || "React class") + ": " + d + " type `" + k + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[k] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw L.name = "Invariant Violation", L;
                }
                g = t[k](a, k, f, d, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (I) {
                g = I;
              }
              g && !(g instanceof Error) && (we(_), w("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", f || "React class", d, k, typeof g), we(null)), g instanceof Error && !(g.message in Ee) && (Ee[g.message] = !0, we(_), w("Failed %s type: %s", d, g.message), we(null));
            }
        }
      }
      var je = R.ReactCurrentOwner, Te = Object.prototype.hasOwnProperty, Ye = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, Ae, Be, De;
      De = {};
      function cn(t) {
        if (Te.call(t, "ref")) {
          var a = Object.getOwnPropertyDescriptor(t, "ref").get;
          if (a && a.isReactWarning)
            return !1;
        }
        return t.ref !== void 0;
      }
      function en(t) {
        if (Te.call(t, "key")) {
          var a = Object.getOwnPropertyDescriptor(t, "key").get;
          if (a && a.isReactWarning)
            return !1;
        }
        return t.key !== void 0;
      }
      function yn(t, a) {
        if (typeof t.ref == "string" && je.current && a && je.current.stateNode !== a) {
          var d = D(je.current.type);
          De[d] || (w('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', D(je.current.type), t.ref), De[d] = !0);
        }
      }
      function pn(t, a) {
        {
          var d = function() {
            Ae || (Ae = !0, w("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", a));
          };
          d.isReactWarning = !0, Object.defineProperty(t, "key", {
            get: d,
            configurable: !0
          });
        }
      }
      function gn(t, a) {
        {
          var d = function() {
            Be || (Be = !0, w("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", a));
          };
          d.isReactWarning = !0, Object.defineProperty(t, "ref", {
            get: d,
            configurable: !0
          });
        }
      }
      var dn = function(t, a, d, f, _, S, k) {
        var g = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: i,
          // Built-in properties that belong on the element
          type: t,
          key: a,
          ref: d,
          props: k,
          // Record the component responsible for creating this element.
          _owner: S
        };
        return g._store = {}, Object.defineProperty(g._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(g, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: f
        }), Object.defineProperty(g, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: _
        }), Object.freeze && (Object.freeze(g.props), Object.freeze(g)), g;
      };
      function un(t, a, d, f, _) {
        {
          var S, k = {}, g = null, L = null;
          d !== void 0 && (g = "" + d), en(a) && (g = "" + a.key), cn(a) && (L = a.ref, yn(a, _));
          for (S in a)
            Te.call(a, S) && !Ye.hasOwnProperty(S) && (k[S] = a[S]);
          if (t && t.defaultProps) {
            var I = t.defaultProps;
            for (S in I)
              k[S] === void 0 && (k[S] = I[S]);
          }
          if (g || L) {
            var O = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
            g && pn(k, O), L && gn(k, O);
          }
          return dn(t, g, L, _, f, je.current, k);
        }
      }
      var Re = R.ReactCurrentOwner, He = R.ReactDebugCurrentFrame;
      function Ne(t) {
        if (t) {
          var a = t._owner, d = be(t.type, t._source, a ? a.type : null);
          He.setExtraStackFrame(d);
        } else
          He.setExtraStackFrame(null);
      }
      var Le;
      Le = !1;
      function Me(t) {
        return typeof t == "object" && t !== null && t.$$typeof === i;
      }
      function ze() {
        {
          if (Re.current) {
            var t = D(Re.current.type);
            if (t)
              return `

Check the render method of \`` + t + "`.";
          }
          return "";
        }
      }
      function _n(t) {
        {
          if (t !== void 0) {
            var a = t.fileName.replace(/^.*[\\\/]/, ""), d = t.lineNumber;
            return `

Check your code at ` + a + ":" + d + ".";
          }
          return "";
        }
      }
      var Je = {};
      function qe(t) {
        {
          var a = ze();
          if (!a) {
            var d = typeof t == "string" ? t : t.displayName || t.name;
            d && (a = `

Check the top-level render call using <` + d + ">.");
          }
          return a;
        }
      }
      function Ke(t, a) {
        {
          if (!t._store || t._store.validated || t.key != null)
            return;
          t._store.validated = !0;
          var d = qe(a);
          if (Je[d])
            return;
          Je[d] = !0;
          var f = "";
          t && t._owner && t._owner !== Re.current && (f = " It was passed a child from " + D(t._owner.type) + "."), Ne(t), w('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', d, f), Ne(null);
        }
      }
      function Ze(t, a) {
        {
          if (typeof t != "object")
            return;
          if (Array.isArray(t))
            for (var d = 0; d < t.length; d++) {
              var f = t[d];
              Me(f) && Ke(f, a);
            }
          else if (Me(t))
            t._store && (t._store.validated = !0);
          else if (t) {
            var _ = M(t);
            if (typeof _ == "function" && _ !== t.entries)
              for (var S = _.call(t), k; !(k = S.next()).done; )
                Me(k.value) && Ke(k.value, a);
          }
        }
      }
      function hn(t) {
        {
          var a = t.type;
          if (a == null || typeof a == "string")
            return;
          var d;
          if (typeof a == "function")
            d = a.propTypes;
          else if (typeof a == "object" && (a.$$typeof === p || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          a.$$typeof === y))
            d = a.propTypes;
          else
            return;
          if (d) {
            var f = D(a);
            Ge(d, t.props, "prop", f, t);
          } else if (a.PropTypes !== void 0 && !Le) {
            Le = !0;
            var _ = D(a);
            w("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _ || "Unknown");
          }
          typeof a.getDefaultProps == "function" && !a.getDefaultProps.isReactClassApproved && w("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function fn(t) {
        {
          for (var a = Object.keys(t.props), d = 0; d < a.length; d++) {
            var f = a[d];
            if (f !== "children" && f !== "key") {
              Ne(t), w("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", f), Ne(null);
              break;
            }
          }
          t.ref !== null && (Ne(t), w("Invalid attribute `ref` supplied to `React.Fragment`."), Ne(null));
        }
      }
      function Qe(t, a, d, f, _, S) {
        {
          var k = le(t);
          if (!k) {
            var g = "";
            (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (g += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var L = _n(_);
            L ? g += L : g += ze();
            var I;
            t === null ? I = "null" : Array.isArray(t) ? I = "array" : t !== void 0 && t.$$typeof === i ? (I = "<" + (D(t.type) || "Unknown") + " />", g = " Did you accidentally export a JSX literal instead of a component?") : I = typeof t, w("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", I, g);
          }
          var O = un(t, a, d, _, S);
          if (O == null)
            return O;
          if (k) {
            var re = a.children;
            if (re !== void 0)
              if (f)
                if (Array.isArray(re)) {
                  for (var Ce = 0; Ce < re.length; Ce++)
                    Ze(re[Ce], t);
                  Object.freeze && Object.freeze(re);
                } else
                  w("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                Ze(re, t);
          }
          return t === e.Fragment ? fn(O) : hn(O), O;
        }
      }
      function kn(t, a, d) {
        return Qe(t, a, d, !0);
      }
      function Sn(t, a, d) {
        return Qe(t, a, d, !1);
      }
      var mn = Sn, vn = kn;
      e.jsx = mn, e.jsxs = vn;
    }();
  }(wu)), wu;
}
process.env.NODE_ENV === "production" ? el.exports = lE() : el.exports = cE();
var ue = el.exports;
function dE({
  query: e,
  options: n,
  delayMs: r
}) {
  const { useLazyQuery: i } = rn(), [o, s] = G([]), [l] = i(e, n), [c, u] = G(
    []
  );
  return Pe(() => () => {
    c.forEach((p) => window.clearTimeout(p));
  }, []), [async (p) => {
    const m = [];
    for (const [v, y] of p.entries()) {
      v !== 0 && await new Promise((N) => {
        const x = setTimeout(N, r);
        u([...c, x]);
      });
      const b = await l({
        variables: y
      });
      m.push(b);
    }
    s(m);
  }, o];
}
const uE = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, mE = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, pE = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "datetime" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }] }, fE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "subscribeProfileToChannel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_subscribe_profiles_input_data_attributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_create_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, vE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "unsubscribeProfileByContact" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_unsubscribe_profiles_input_data_attributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "unsubscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_unsubscription_bulk_create_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, yE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getEvents" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "pageSize" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_PositiveInt" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "receivedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "StringValue", value: "-datetime", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "openedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "StringValue", value: "-datetime", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "clickedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "StringValue", value: "-datetime", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "bouncedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "StringValue", value: "-datetime", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "receivedSms" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "StringValue", value: "-datetime", block: !1 } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "datetime" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, gE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getFlowMessage" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "messageId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_flow_message" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "messageId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetFlowMessageResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "content" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_EmailMessageContent" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "preview_text" } }] } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, hE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getMetrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_metrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetMetricResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, kE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileByFilter" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "profileByEmail" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "profileByPhoneNumber" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, bE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "include" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "lists" }, { kind: "EnumValue", value: "segments" }] } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "subscriptions" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "sms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "included" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ListResponseObjectResource" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", alias: { kind: "Name", value: "listType" }, name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_SegmentResponseObjectResource" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", alias: { kind: "Name", value: "segmentType" }, name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, _E = {
  "\n  fragment ClientErrorResponseFragment on Klaviyo_ClientError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": uE,
  "\n  fragment ServerErrorResponseFragment on Klaviyo_ServerError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": mE,
  "\n  mutation subscribeProfileToChannel(\n    $attributes: Klaviyo_mutationInput_subscribe_profiles_input_data_attributes_Input!\n  ) {\n    Klaviyo {\n      subscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_create_job\n            attributes: $attributes\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": fE,
  "\n  mutation unsubscribeProfileByContact(\n    $attributes: Klaviyo_mutationInput_unsubscribe_profiles_input_data_attributes_Input!\n  ) {\n    Klaviyo {\n      unsubscribe_profiles(\n        input: {\n          data: {\n            type: profile_unsubscription_bulk_create_job\n            attributes: $attributes\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": vE,
  "\n  fragment GetEventResponseFragment on Klaviyo_GetEventResponseCollectionCompoundDocument {\n    data {\n      id\n      type\n      attributes {\n        timestamp\n        datetime\n        event_properties\n      }\n    }\n  }\n": pE,
  '\n  query getEvents(\n    $receivedEmailEventsFilter: String!\n    $openedEmailEventsFilter: String!\n    $clickedEmailEventsFilter: String!\n    $bouncedEmailEventsFilter: String!\n    $receivedSmsEventsFilter: String!\n    $pageSize: Klaviyo_PositiveInt!\n  ) {\n    Klaviyo {\n      receivedEmail: get_events(\n        filter: $receivedEmailEventsFilter\n        sort: "-datetime"\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      openedEmail: get_events(\n        filter: $openedEmailEventsFilter\n        sort: "-datetime"\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      clickedEmail: get_events(\n        filter: $clickedEmailEventsFilter\n        sort: "-datetime"\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      bouncedEmail: get_events(\n        filter: $bouncedEmailEventsFilter\n        sort: "-datetime"\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      receivedSms: get_events(\n        filter: $receivedSmsEventsFilter\n        sort: "-datetime"\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n': yE,
  "\n  query getFlowMessage($messageId: String!) {\n    Klaviyo {\n      get_flow_message(id: $messageId) {\n        ... on Klaviyo_GetFlowMessageResponseCompoundDocument {\n          data {\n            id\n            type\n            attributes {\n              content {\n                ... on Klaviyo_EmailMessageContent {\n                  preview_text\n                }\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": gE,
  "\n  query getMetrics {\n    Klaviyo {\n      get_metrics {\n        ... on Klaviyo_GetMetricResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": hE,
  "\n  query getProfileByFilter($emailFilter: String, $phoneNumberFilter: String) {\n    Klaviyo {\n      profileByEmail: get_profiles(\n        filter: $emailFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      profileByPhoneNumber: get_profiles(\n        filter: $phoneNumberFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": kE,
  "\n  query getProfileById($profileId: String!) {\n    Klaviyo {\n      get_profile(\n        id: $profileId\n        include: [lists, segments]\n        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]\n        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]\n        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [subscriptions]\n      ) {\n        ... on Klaviyo_GetProfileResponseCompoundDocument {\n          data {\n            attributes {\n              subscriptions {\n                email {\n                  marketing {\n                    consent\n                  }\n                }\n                sms {\n                  marketing {\n                    consent\n                  }\n                }\n              }\n            }\n          }\n          included {\n            ... on Klaviyo_ListResponseObjectResource {\n              id\n              listType: type\n              attributes {\n                name\n              }\n            }\n            ... on Klaviyo_SegmentResponseObjectResource {\n              id\n              segmentType: type\n              attributes {\n                name\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": bE
};
function rr(e) {
  return _E[e] ?? {};
}
const SE = rr(
  /* GraphQL */
  `
  query getEvents(
    $receivedEmailEventsFilter: String!
    $openedEmailEventsFilter: String!
    $clickedEmailEventsFilter: String!
    $bouncedEmailEventsFilter: String!
    $receivedSmsEventsFilter: String!
    $pageSize: Klaviyo_PositiveInt!
  ) {
    Klaviyo {
      receivedEmail: get_events(
        filter: $receivedEmailEventsFilter
        sort: "-datetime"
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      openedEmail: get_events(
        filter: $openedEmailEventsFilter
        sort: "-datetime"
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      clickedEmail: get_events(
        filter: $clickedEmailEventsFilter
        sort: "-datetime"
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      bouncedEmail: get_events(
        filter: $bouncedEmailEventsFilter
        sort: "-datetime"
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      receivedSms: get_events(
        filter: $receivedSmsEventsFilter
        sort: "-datetime"
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), NE = rr(
  /* GraphQL */
  `
  query getFlowMessage($messageId: String!) {
    Klaviyo {
      get_flow_message(id: $messageId) {
        ... on Klaviyo_GetFlowMessageResponseCompoundDocument {
          data {
            id
            type
            attributes {
              content {
                ... on Klaviyo_EmailMessageContent {
                  preview_text
                }
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), xE = rr(
  /* GraphQL */
  `
  query getMetrics {
    Klaviyo {
      get_metrics {
        ... on Klaviyo_GetMetricResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), wE = rr(
  /* GraphQL */
  `
  query getProfileByFilter($emailFilter: String, $phoneNumberFilter: String) {
    Klaviyo {
      profileByEmail: get_profiles(
        filter: $emailFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      profileByPhoneNumber: get_profiles(
        filter: $phoneNumberFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), jE = rr(
  /* GraphQL */
  `
  query getProfileById($profileId: String!) {
    Klaviyo {
      get_profile(
        id: $profileId
        include: [lists, segments]
        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]
        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]
        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [subscriptions]
      ) {
        ... on Klaviyo_GetProfileResponseCompoundDocument {
          data {
            attributes {
              subscriptions {
                email {
                  marketing {
                    consent
                  }
                }
                sms {
                  marketing {
                    consent
                  }
                }
              }
            }
          }
          included {
            ... on Klaviyo_ListResponseObjectResource {
              id
              listType: type
              attributes {
                name
              }
            }
            ... on Klaviyo_SegmentResponseObjectResource {
              id
              segmentType: type
              attributes {
                name
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), CE = rr(
  /* GraphQL */
  `
  mutation subscribeProfileToChannel(
    $attributes: Klaviyo_mutationInput_subscribe_profiles_input_data_attributes_Input!
  ) {
    Klaviyo {
      subscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_create_job
            attributes: $attributes
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), EE = rr(
  /* GraphQL */
  `
  mutation unsubscribeProfileByContact(
    $attributes: Klaviyo_mutationInput_unsubscribe_profiles_input_data_attributes_Input!
  ) {
    Klaviyo {
      unsubscribe_profiles(
        input: {
          data: {
            type: profile_unsubscription_bulk_create_job
            attributes: $attributes
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
);
function nl(e) {
  var n, r;
  return ((r = (n = e == null ? void 0 : e.attributes) == null ? void 0 : n.event_properties) == null ? void 0 : r.$flow) !== void 0;
}
function Cu(e) {
  var n, r;
  return nl(e) && ((r = (n = e == null ? void 0 : e.attributes) == null ? void 0 : n.event_properties) == null ? void 0 : r.$message);
}
function FE(e) {
  var n, r;
  return ((r = (n = e == null ? void 0 : e.attributes) == null ? void 0 : n.event_properties) == null ? void 0 : r["Bounce Type"]) !== void 0;
}
function Eu(e) {
  var n;
  const r = (n = e == null ? void 0 : e.attributes) == null ? void 0 : n.timestamp;
  if (r)
    return parseInt(r, 10);
}
function IE(e) {
  var n, r;
  return ((r = (n = e.Klaviyo) == null ? void 0 : n.get_metrics) == null ? void 0 : r.__typename) === "Klaviyo_GetMetricResponseCollection" && e.Klaviyo.get_metrics.data || [];
}
function $E(e) {
  var n, r, i;
  return (i = ((r = (n = e == null ? void 0 : e.Klaviyo) == null ? void 0 : n.receivedEmail) == null ? void 0 : r.__typename) === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedEmail.data || []) == null ? void 0 : i.map((o) => ({
    ...o,
    eventType: "EMAIL"
  }));
}
function TE(e) {
  var n, r, i;
  return (i = ((r = (n = e == null ? void 0 : e.Klaviyo) == null ? void 0 : n.receivedSms) == null ? void 0 : r.__typename) === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedSms.data || []) == null ? void 0 : i.map((o) => ({
    ...o,
    eventType: "SMS"
  }));
}
function OE(e) {
  var n, r, i;
  return (i = ((r = (n = e == null ? void 0 : e.Klaviyo) == null ? void 0 : n.openedEmail) == null ? void 0 : r.__typename) === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.openedEmail.data || []) == null ? void 0 : i.map((o) => ({
    ...o,
    eventType: "EMAIL"
  }));
}
function RE(e) {
  var n, r, i;
  return (i = ((r = (n = e == null ? void 0 : e.Klaviyo) == null ? void 0 : n.clickedEmail) == null ? void 0 : r.__typename) === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.clickedEmail.data || []) == null ? void 0 : i.map((o) => ({
    ...o,
    eventType: "EMAIL"
  }));
}
function DE(e) {
  var n, r, i;
  return (i = ((r = (n = e == null ? void 0 : e.Klaviyo) == null ? void 0 : n.bouncedEmail) == null ? void 0 : r.__typename) === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.bouncedEmail.data || []) == null ? void 0 : i.map((o) => ({
    ...o,
    eventType: "EMAIL"
  }));
}
function Fu(e) {
  var n, r;
  return ((r = (n = e == null ? void 0 : e.Klaviyo) == null ? void 0 : n.get_flow_message) == null ? void 0 : r.__typename) === "Klaviyo_GetFlowMessageResponseCompoundDocument" && e.Klaviyo.get_flow_message.data || void 0;
}
function PE(e) {
  var n, r;
  return ((r = (n = e == null ? void 0 : e.attributes) == null ? void 0 : n.content) == null ? void 0 : r.__typename) === "Klaviyo_EmailMessageContent" && e.attributes.content.preview_text || void 0;
}
function AE(e) {
  try {
    return JSON.parse(JSON.stringify(e));
  } catch {
    return console.error(`Could not make a copy of ${JSON.stringify(e)}`), {};
  }
}
const Xf = (e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase();
function LE(e) {
  var n, r, i, o, s;
  return ((s = (o = (i = (r = (n = e == null ? void 0 : e.data) == null ? void 0 : n.attributes) == null ? void 0 : r.subscriptions) == null ? void 0 : i.email) == null ? void 0 : o.marketing) == null ? void 0 : s.consent) === "SUBSCRIBED";
}
function UE(e) {
  var n, r, i, o, s;
  return ((s = (o = (i = (r = (n = e == null ? void 0 : e.data) == null ? void 0 : n.attributes) == null ? void 0 : r.subscriptions) == null ? void 0 : i.sms) == null ? void 0 : o.marketing) == null ? void 0 : s.consent) === "SUBSCRIBED";
}
function ME({
  profileId: e,
  noOfMessagesToShow: n
}) {
  const { useLazyQuery: r, useQuery: i } = rn(), { track: o } = sn(), [s, l] = G(null), [c, u] = G(
    null
  ), [p, m] = G(null), [v, y] = G(null), [b, N] = G(
    null
  ), [x, T] = G([]), {
    data: $,
    error: P,
    loading: h,
    networkStatus: E
  } = i(xE, {
    /*
    	Since metrics should rarely be changed, query once when the client initializes
    	and then read from the cache for the subsequent queries.
    */
    fetchPolicy: "network-only",
    // Used for first execution
    nextFetchPolicy: "cache-first",
    // Used for subsequent executions
    notifyOnNetworkStatusChange: !0
  }), [
    q,
    {
      data: M,
      error: R,
      loading: w,
      networkStatus: H
    }
  ] = r(SE, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  return Pe(() => {
    var pe, le, Se, ae, D;
    if ($ && !h && E === Yn.ready) {
      const V = IE($);
      l(
        ((pe = V.find((de) => {
          var te;
          return ((te = de == null ? void 0 : de.attributes) == null ? void 0 : te.name) === "Received Email";
        })) == null ? void 0 : pe.id) || null
      ), u(
        ((le = V.find((de) => {
          var te;
          return ((te = de == null ? void 0 : de.attributes) == null ? void 0 : te.name) === "Opened Email";
        })) == null ? void 0 : le.id) || null
      ), m(
        ((Se = V.find((de) => {
          var te;
          return ((te = de == null ? void 0 : de.attributes) == null ? void 0 : te.name) === "Clicked Email";
        })) == null ? void 0 : Se.id) || null
      ), y(
        ((ae = V.find((de) => {
          var te;
          return ((te = de == null ? void 0 : de.attributes) == null ? void 0 : te.name) === "Bounced Email";
        })) == null ? void 0 : ae.id) || null
      ), N(
        ((D = V.find((de) => {
          var te;
          return ((te = de == null ? void 0 : de.attributes) == null ? void 0 : te.name) === "Received SMS";
        })) == null ? void 0 : D.id) || null
      );
    } else
      l(null), u(null), m(null), y(null), N(null);
  }, [$]), Pe(() => {
    s && c && p && v && b && !w && H === Yn.ready ? q({
      variables: {
        receivedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${s}")`,
        openedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${c}")`,
        clickedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${p}")`,
        bouncedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${v}")`,
        receivedSmsEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${b}")`,
        pageSize: n
      }
    }) : T([]);
  }, [
    s,
    c,
    p,
    v,
    b
  ]), Pe(() => {
    if (!w && M) {
      const pe = $E(M), le = OE(
        M
      ).map(
        (te) => {
          var he;
          return (he = te == null ? void 0 : te.attributes) == null ? void 0 : he.event_properties.$message;
        }
      ), Se = RE(
        M
      ).map(
        (te) => {
          var he;
          return (he = te == null ? void 0 : te.attributes) == null ? void 0 : he.event_properties.$message;
        }
      );
      pe.forEach((te) => {
        var he;
        const _e = (he = te.attributes) == null ? void 0 : he.event_properties.$message;
        te.opened = le.includes(_e), te.clicked = Se.includes(_e);
      });
      const ae = TE(M), D = DE(M), V = [
        ...pe,
        ...D,
        ...ae
      ].sort((te, he) => {
        const _e = Eu(te), Z = Eu(he);
        return _e == null && Z == null ? 0 : _e == null ? 1 : Z == null ? -1 : Z - _e;
      }).slice(0, n);
      T(V);
      const de = V.map((te) => te.id);
      o("klaviyo:messages:received", {
        emailsReceived: pe.filter(
          (te) => de.includes(te.id)
        ).length,
        emailsBounced: D.filter(
          (te) => de.includes(te.id)
        ).length,
        smsReceived: ae.filter(
          (te) => de.includes(te.id)
        ).length,
        total: de.length
      });
    } else
      T([]);
  }, [w, M]), At(
    () => ({
      receivedMessages: x,
      isLoading: h || w,
      error: P || R
    }),
    [
      x,
      h,
      w,
      P,
      R
    ]
  );
}
function BE({ profileId: e }) {
  const { useQuery: n } = rn(), [r, i] = G(), [o, s] = G(), [l, c] = G(!0), {
    data: u,
    error: p,
    refetch: m
  } = n(jE, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    variables: {
      profileId: e
    },
    onCompleted() {
      c(!1);
    },
    onError() {
      c(!1);
    }
  });
  Pe(() => {
    p && s(p);
  }, [p]), Pe(() => {
    !l && u && i(u.Klaviyo.get_profile);
  }, [l, u]);
  const v = async () => {
    const y = await m();
    y.error ? s(y.error) : y.data && i(
      y.data.Klaviyo.get_profile
    );
  };
  return At(
    () => ({
      profile: r,
      refetchProfile: v,
      isLoading: l,
      error: o
    }),
    // No need to add `refetchProfile` as a dependency here
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [r, l, o]
  );
}
function VE({
  email: e,
  phoneNumber: n
}) {
  const { track: r } = sn(), { useLazyQuery: i } = rn(), [o, s] = G(), [l, c] = G(), [
    u,
    { data: p, error: m, loading: v }
  ] = i(wE, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  Pe(() => {
    var b, N, x, T;
    if (!v && p) {
      const $ = ((N = (b = p.Klaviyo) == null ? void 0 : b.profileByEmail) == null ? void 0 : N.__typename) === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && p.Klaviyo.profileByEmail || void 0, P = ((T = (x = p.Klaviyo) == null ? void 0 : x.profileByPhoneNumber) == null ? void 0 : T.__typename) === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && p.Klaviyo.profileByPhoneNumber || void 0;
      y($, P);
    }
  }, [v, p]);
  const y = (b, N) => {
    var x, T, $, P;
    const h = ((x = b == null ? void 0 : b.data) == null ? void 0 : x.length) === 1 && ((T = b.data[0]) == null ? void 0 : T.id) || void 0, E = (($ = N == null ? void 0 : N.data) == null ? void 0 : $.length) === 1 && ((P = N.data[0]) == null ? void 0 : P.id) || void 0, q = h || E, M = !h || !E || h === E;
    if (q && M) {
      s(h || E), r("klaviyo:profile:received", { hasProfile: !0 });
      return;
    }
    s(void 0), r("klaviyo:profile:received", { hasProfile: !1 }), M || c(
      new Error(
        `Two different profiles were retrieved from Klaviyo for the email ${e} (profile ID ${h}) and phone number ${n} (profile ID ${E}).`
      )
    );
  };
  return At(
    () => ({
      profileId: o,
      getProfileId: u,
      isLoading: v,
      error: m || l
    }),
    [o, v, m, l]
  );
}
const qE = "_notificationText_13cgk_27", La = {
  notificationText: qE
}, tc = ({ error: e }) => {
  const { track: n } = sn();
  let r = e;
  if (Hv(e)) {
    const { graphQLErrors: i } = e, o = i.length === 1 && Ev({ error: i[0] }), s = i.length === 1 && Fv({ error: i[0] });
    if (o)
      n("klaviyo:profile:failed", { reason: "Invalid access token" }), r = new Error(
        "It was not possible to retrieve data from Klaviyo due to an access issue. Please contact your administrator."
      );
    else if (s)
      n("klaviyo:profile:failed", { reason: "Insufficient permissions" }), r = new Error(
        "You don't have enough permissions to see Klaviyo profile data for this conversation. This is typically due to a misconfiguration of the Klaviyo integration."
      );
    else
      return n("klaviyo:profile:failed", { reason: "Unexpected error" }), /* @__PURE__ */ ue.jsx(bn, { error: e });
  }
  return /* @__PURE__ */ ue.jsx(C, { margin: "0 0 300", children: /* @__PURE__ */ ue.jsx(
    Ln.Item,
    {
      contentLeft: /* @__PURE__ */ ue.jsx(
        Fe,
        {
          color: $e.red[500],
          size: 20,
          name: "exclamation-triangle-filled"
        }
      ),
      titleSecondary: r.message,
      title: "Unable to show Klaviyo profile data",
      variant: "dense"
    }
  ) });
}, zE = "_message_uevo0_27", HE = "_messageIsOpen_uevo0_35", KE = "_messageHeader_uevo0_38", GE = "_messageUnattended_uevo0_41", WE = "_messageLabel_uevo0_44", YE = "_messageText_uevo0_47", $r = {
  message: zE,
  messageIsOpen: HE,
  messageHeader: KE,
  messageUnattended: GE,
  messageLabel: WE,
  messageText: YE
}, QE = ({ event: e, isLoadingPreview: n }) => {
  var r;
  const i = (r = e == null ? void 0 : e.attributes) == null ? void 0 : r.event_properties, o = e.flowMessage && PE(e.flowMessage);
  return /* @__PURE__ */ ue.jsxs(ue.Fragment, { children: [
    /* @__PURE__ */ ue.jsxs(C, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
      /* @__PURE__ */ ue.jsx(se.Paragraph, { variant: "4", className: $r.messageLabel, children: "Campaign name" }),
      /* @__PURE__ */ ue.jsx(se.Paragraph, { children: i["Campaign Name"] })
    ] }),
    n ? /* @__PURE__ */ ue.jsx(C, { justifyContent: "center", margin: "100", children: /* @__PURE__ */ ue.jsx(ln, { size: 22 }) }) : o && o.length > 0 && /* @__PURE__ */ ue.jsxs(
      C,
      {
        flexDirection: "column",
        justifyContent: "space-between",
        gap: "100",
        children: [
          /* @__PURE__ */ ue.jsx(C, { children: /* @__PURE__ */ ue.jsx(
            se.Paragraph,
            {
              variant: "4",
              className: $r.messageLabel,
              children: "Preview text"
            }
          ) }),
          /* @__PURE__ */ ue.jsx(se.Paragraph, { variant: "4", className: $r.messageText, children: o })
        ]
      }
    )
  ] });
}, JE = ({ event: e }) => {
  var n, r;
  const i = (n = e == null ? void 0 : e.attributes) == null ? void 0 : n.event_properties;
  return /* @__PURE__ */ ue.jsx(ue.Fragment, { children: /* @__PURE__ */ ue.jsxs(C, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
    /* @__PURE__ */ ue.jsx(C, { children: /* @__PURE__ */ ue.jsx(se.Heading, { variant: "heading-4", children: "Message" }) }),
    /* @__PURE__ */ ue.jsx(C, { children: (r = i == null ? void 0 : i.extra) == null ? void 0 : r["Message Body"] })
  ] }) });
}, ZE = ({
  event: e,
  isLoadingPreview: n,
  openByDefault: r
}) => {
  const [i, o] = G(r), { attributes: s, eventType: l } = e, c = s == null ? void 0 : s.datetime, u = l === "EMAIL", p = l === "SMS", m = u && e.opened, v = u && e.clicked, y = u && (s == null ? void 0 : s.event_properties.Subject), b = p && (s == null ? void 0 : s.event_properties["Message Name"]), N = u ? "mail" : "sms";
  return /* @__PURE__ */ ue.jsxs(
    C,
    {
      gap: "300",
      flexDirection: "column",
      className: It($r.message, {
        [$r.messageIsOpen]: i
      }),
      children: [
        /* @__PURE__ */ ue.jsxs(
          C,
          {
            alignItems: "center",
            justifyContent: "space-between",
            className: $r.messageHeader,
            onClick: () => o(!i),
            children: [
              /* @__PURE__ */ ue.jsxs(C, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ ue.jsxs(C, { gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ ue.jsx(Fe, { size: 16, name: N }),
                  " ",
                  Xf(l),
                  /* @__PURE__ */ ue.jsx(ut, { size: "small", variant: "info", children: Nt(c).format("DD MMM YYYY @ HH:MM") })
                ] }),
                y && y,
                b && b
              ] }),
              /* @__PURE__ */ ue.jsx(
                Bt,
                {
                  variant: "tertiary",
                  icon: i ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        i && /* @__PURE__ */ ue.jsxs(C, { flexDirection: "column", gap: "300", children: [
          /* @__PURE__ */ ue.jsx(yl, {}),
          FE(e) && /* @__PURE__ */ ue.jsx(ut, { size: "medium", variant: "error", children: "Bounced" }),
          u && /* @__PURE__ */ ue.jsxs(ue.Fragment, { children: [
            /* @__PURE__ */ ue.jsxs(C, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
              /* @__PURE__ */ ue.jsx(an, { children: /* @__PURE__ */ ue.jsxs(C, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ ue.jsx(
                  Fe,
                  {
                    size: 16,
                    color: m ? $e.green[400] : $e.red[400],
                    name: m ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Opened"
              ] }) }),
              /* @__PURE__ */ ue.jsx(an, { children: /* @__PURE__ */ ue.jsxs(C, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ ue.jsx(
                  Fe,
                  {
                    size: 16,
                    color: v ? $e.green[400] : $e.red[400],
                    name: v ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Clicked"
              ] }) })
            ] }),
            /* @__PURE__ */ ue.jsx(QE, { event: e, isLoadingPreview: n })
          ] }),
          p && /* @__PURE__ */ ue.jsx(JE, { event: e })
        ] })
      ]
    }
  );
}, XE = {
  /*
  	Compiler needs this casting so as not to complain that the string literal 'no-cache'
  	is actually of type "FetchPolicy", which type is defined as one of many string values,
  	including 'no-cache'.
  */
  fetchPolicy: "no-cache",
  notifyOnNetworkStatusChange: !0
}, eF = ({
  profileId: e,
  noOfMessagesToShow: n
}) => {
  const [r, i] = G(!1), {
    receivedMessages: o,
    isLoading: s,
    error: l
  } = ME({
    profileId: e,
    noOfMessagesToShow: n
  }), [c, u] = dE({
    query: NE,
    options: XE,
    delayMs: 1e3
  }), [p, m] = G([]);
  Pe(() => {
    if (o.length > 0) {
      m(o);
      const y = o.filter((b) => nl(b)).map((b) => Cu(b));
      y.length > 0 && (i(!0), c(
        y.map((b) => ({
          messageId: b
        }))
      ).finally(() => i(!1)));
    }
  }, [o]), Pe(() => {
    u.length > 0 && m(
      o == null ? void 0 : o.map((y) => {
        if (y.eventType === "EMAIL" && nl(y) && !y.flowMessage) {
          const b = Cu(y), N = u.find((T) => {
            const $ = T.data && Fu(T.data);
            return ($ == null ? void 0 : $.id) === b;
          }), x = (N == null ? void 0 : N.data) && Fu(N.data);
          if (x)
            return {
              ...AE(y),
              flowMessage: x
            };
        }
        return y;
      })
    );
  }, [u]);
  const v = [];
  return l && v.push(l), u.length > 0 && v.push(
    ...u.map((y) => y.error).filter((y) => y)
  ), v && v.length > 0 ? /* @__PURE__ */ ue.jsx(ue.Fragment, { children: v.map((y, b) => y.graphQLErrors ? /* @__PURE__ */ ue.jsx(
    bn,
    {
      error: y
    },
    `lastMessagesError${b}`
  ) : /* @__PURE__ */ ue.jsx(
    tc,
    {
      error: y
    },
    `lastMessagesError${b}`
  )) }) : /* @__PURE__ */ ue.jsxs(ue.Fragment, { children: [
    /* @__PURE__ */ ue.jsx(se.Heading, { variant: "heading-3", children: "Messages" }),
    s ? /* @__PURE__ */ ue.jsx(C, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ ue.jsx(ln, {}) }) : /* @__PURE__ */ ue.jsx(ue.Fragment, { children: (p == null ? void 0 : p.length) > 0 ? /* @__PURE__ */ ue.jsx(C, { gap: "200", flexDirection: "column", children: p.map((y, b) => /* @__PURE__ */ ue.jsx(
      ZE,
      {
        event: y,
        isLoadingPreview: r,
        openByDefault: b === 0
      },
      y.id
    )) }) : /* @__PURE__ */ ue.jsx(
      C,
      {
        justifyContent: "center",
        margin: "200",
        className: La.notificationText,
        children: "No messages found for the profile"
      }
    ) })
  ] });
}, nF = "_list_19xkr_27", tF = "_listItem_19xkr_30", Iu = {
  list: nF,
  listItem: tF
}, rF = ({
  profile: e,
  showProfileLists: n,
  showProfileSegments: r
}) => {
  if (!e)
    return null;
  const i = ((e == null ? void 0 : e.included) || []).filter(
    (o) => (o == null ? void 0 : o.listType) === "list" ? n : !0
  ).filter(
    (o) => (o == null ? void 0 : o.segmentType) === "segment" ? r : !0
  );
  return /* @__PURE__ */ ue.jsxs(C, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ue.jsx(se.Heading, { variant: "heading-3", children: "Lists & Segments" }),
    /* @__PURE__ */ ue.jsx(Ln, { className: Iu.list, children: i.length > 0 ? i.map((o, s) => {
      var l;
      const c = (o == null ? void 0 : o.listType) ?? (o == null ? void 0 : o.segmentType);
      return /* @__PURE__ */ ue.jsx(
        Ln.Text,
        {
          variant: "dense",
          className: Iu.listItem,
          children: /* @__PURE__ */ ue.jsxs(C, { justifyContent: "space-between", alignItems: "center", children: [
            /* @__PURE__ */ ue.jsx(se.Paragraph, { variant: "4", children: (l = o == null ? void 0 : o.attributes) == null ? void 0 : l.name }),
            !!c && /* @__PURE__ */ ue.jsx(an, { children: Xf(c) })
          ] })
        },
        s
      );
    }) : /* @__PURE__ */ ue.jsx(
      C,
      {
        justifyContent: "center",
        margin: "200",
        className: La.notificationText,
        children: "No lists or segments available"
      }
    ) })
  ] });
}, iF = "_tagHover_1tvfi_27", aF = "_channelUnsubscribed_1tvfi_32", $u = {
  tagHover: iF,
  channelUnsubscribed: aF
}, Tu = ({
  isSubscribed: e,
  isLoading: n,
  channelName: r,
  channelIcon: i,
  hasReSubscriptionFeature: o,
  handleAction: s
}) => {
  const l = e ? "Unsubscribe" : "Subscribe", c = !e && !o;
  return /* @__PURE__ */ ue.jsx(
    jn,
    {
      content: c ? "You have to select a resubscription list in the settings." : l,
      dark: !0,
      children: /* @__PURE__ */ ue.jsx(
        an,
        {
          className: $u.tagHover,
          color: e ? $e.green[500] : $e.neutral[200],
          children: /* @__PURE__ */ ue.jsxs(
            C,
            {
              "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
              gap: "200",
              alignItems: "center",
              className: It({
                [$u.channelUnsubscribed]: !e || c
              }),
              onClick: () => {
                c || s();
              },
              children: [
                n ? /* @__PURE__ */ ue.jsx(ln, { size: 16 }) : /* @__PURE__ */ ue.jsx(Fe, { size: 16, name: i }),
                r
              ]
            }
          )
        }
      )
    }
  );
}, oF = "_subscriptionError_1fpwj_27", sF = {
  subscriptionError: oF
}, lF = ({
  subscriptionListId: e,
  profile: n,
  email: r,
  phoneNumber: i,
  profileId: o,
  refetchProfile: s
}) => {
  var l, c, u, p, m, v, y, b, N, x;
  const [T, $] = G(!1), [P, h] = G(!1), [E, q] = G(), { track: M } = sn(), [R, w] = Qv({
    channel: null,
    request: null
  }), H = LE(n), pe = UE(n), le = !!e, { useMutation: Se } = rn(), [ae] = Se(
    CE
  ), [D] = Se(
    EE
  ), V = (he) => {
    M("klaviyo:profile:subscribe:clicked", { channel: he }), w.setAll({
      channel: he,
      request: "subscribed"
    }), ((_e) => ae({
      variables: {
        attributes: {
          // eslint-disable-next-line camelcase
          list_id: e,
          subscriptions: [
            {
              channels: {
                ..._e === "EMAIL" && { email: "MARKETING" },
                ..._e === "SMS" && { sms: "MARKETING" }
              },
              email: r,
              // eslint-disable-next-line camelcase
              phone_number: i,
              // eslint-disable-next-line camelcase
              profile_id: o
            }
          ]
        }
      }
    }))(he).then(
      (_e) => te({
        channel: he,
        mutationResponse: _e,
        isSubscriptionRequest: !0
      })
    ).catch(
      (_e) => te({
        channel: he,
        mutationErrorResponse: _e,
        isSubscriptionRequest: !0
      })
    );
  }, de = (he) => {
    M("klaviyo:profile:unsubscribe:clicked", { channel: he }), w.setAll({
      channel: he,
      request: "unsubscribed"
    }), D({
      variables: {
        attributes: {
          ...he === "EMAIL" ? { emails: [r] } : {},
          // eslint-disable-next-line camelcase
          ...he === "SMS" ? { phone_numbers: [i] } : {}
        }
      }
    }).then(
      (_e) => te({
        channel: he,
        mutationResponse: _e,
        isSubscriptionRequest: !1
      })
    ).catch(
      (_e) => te({
        channel: he,
        mutationErrorResponse: _e,
        isSubscriptionRequest: !1
      })
    );
  }, te = async ({
    channel: he,
    mutationResponse: _e,
    mutationErrorResponse: Z,
    isSubscriptionRequest: J
  }) => {
    const z = Z == null ? void 0 : Z.networkError, me = z ? z == null ? void 0 : z.statusCode : NaN, ke = _e == null ? void 0 : _e.errors, Oe = !!ke && km({
      errors: ke
    });
    me === 202 ? (M(
      J ? "klaviyo:profile:subscribe:succeeded" : "klaviyo:profile:unsubscribe:succeeded",
      { channel: he }
    ), await s()) : Oe ? (M(
      J ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: he,
        reason: "Insufficient permissions"
      }
    ), q(
      `Request failed with a permission error. Could not ${J ? "opt-in" : "opt-out"}.`
    )) : (M(
      J ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: he,
        reason: (z == null ? void 0 : z.message) || "Unexpected error"
      }
    ), q(
      `Request failed. Could not ${J ? "opt-in" : "opt-out"}.`
    )), h(!1), $(!1);
  };
  return Pe(() => {
    var he, _e, Z, J, z, me, ke, Oe, Y, fe;
    if (R.request === "subscribed") {
      const ge = `This subscription might be a double opt-in. The customer needs to check if they received a confirmation ${R.channel === "EMAIL" ? "email" : "sms"} to give consent.`;
      R.channel === "EMAIL" && !T && ((z = (J = (Z = (_e = (he = n == null ? void 0 : n.data) == null ? void 0 : he.attributes) == null ? void 0 : _e.subscriptions) == null ? void 0 : Z.email) == null ? void 0 : J.marketing) == null ? void 0 : z.consent) !== "SUBSCRIBED" && (q(ge), w.reset()), R.channel === "SMS" && !P && ((fe = (Y = (Oe = (ke = (me = n == null ? void 0 : n.data) == null ? void 0 : me.attributes) == null ? void 0 : ke.subscriptions) == null ? void 0 : Oe.sms) == null ? void 0 : Y.marketing) == null ? void 0 : fe.consent) !== "SUBSCRIBED" && (q(ge), w.reset());
    }
  }, [
    (m = (p = (u = (c = (l = n == null ? void 0 : n.data) == null ? void 0 : l.attributes) == null ? void 0 : c.subscriptions) == null ? void 0 : u.email) == null ? void 0 : p.marketing) == null ? void 0 : m.consent,
    (x = (N = (b = (y = (v = n == null ? void 0 : n.data) == null ? void 0 : v.attributes) == null ? void 0 : y.subscriptions) == null ? void 0 : b.sms) == null ? void 0 : N.marketing) == null ? void 0 : x.consent,
    T,
    P
  ]), /* @__PURE__ */ ue.jsx(
    C,
    {
      "data-testid": "subscription-channels",
      gap: "200",
      flexDirection: "column",
      children: /* @__PURE__ */ ue.jsxs(C, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ ue.jsx(se.Heading, { variant: "heading-3", children: "Subscription channels" }),
        /* @__PURE__ */ ue.jsxs(C, { gap: "100", flexDirection: "row", children: [
          /* @__PURE__ */ ue.jsx(
            Tu,
            {
              "data-testid": "subscription-channels-email-button",
              isLoading: T,
              isSubscribed: H,
              channelName: "Email",
              channelIcon: "mail",
              hasReSubscriptionFeature: le,
              handleAction: () => {
                $(!0), q(void 0), H ? de("EMAIL") : V("EMAIL");
              }
            }
          ),
          /* @__PURE__ */ ue.jsx(
            Tu,
            {
              "data-testid": "subscription-channels-sms-button",
              isLoading: P,
              isSubscribed: pe,
              channelName: "Sms",
              channelIcon: "sms",
              hasReSubscriptionFeature: le,
              handleAction: () => {
                h(!0), q(void 0), pe ? de("SMS") : V("SMS");
              }
            }
          )
        ] }),
        E && /* @__PURE__ */ ue.jsx(C, { className: sF.subscriptionError, children: E })
      ] })
    }
  );
}, cF = ({
  profileId: e,
  email: n,
  phoneNumber: r,
  showProfileLists: i,
  showProfileSegments: o,
  showSubscriptions: s,
  noOfMessagesToShow: l,
  subscriptionListId: c
}) => {
  const {
    profile: u,
    error: p,
    isLoading: m,
    refetchProfile: v
  } = BE({ profileId: e });
  return p ? /* @__PURE__ */ ue.jsx(tc, { error: p }) : m ? /* @__PURE__ */ ue.jsx(C, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ ue.jsx(ln, {}) }) : !u && !m ? /* @__PURE__ */ ue.jsx(
    C,
    {
      justifyContent: "center",
      margin: "200",
      className: La.notificationText,
      children: "No Klaviyo profile data found"
    }
  ) : /* @__PURE__ */ ue.jsxs(C, { flexDirection: "column", gap: "300", margin: "200 0 300", children: [
    /* @__PURE__ */ ue.jsx(
      rF,
      {
        profile: u,
        showProfileLists: i,
        showProfileSegments: o
      }
    ),
    u && e && s && /* @__PURE__ */ ue.jsx(
      lF,
      {
        profile: u,
        profileId: e,
        subscriptionListId: c,
        refetchProfile: v,
        email: n,
        phoneNumber: r
      }
    ),
    /* @__PURE__ */ ue.jsx(
      eF,
      {
        profileId: e,
        noOfMessagesToShow: l
      }
    )
  ] });
}, dF = ({
  conversationContext: e,
  settings: n
}) => {
  var r, i;
  const o = ((r = e.customer) == null ? void 0 : r.email) || void 0, s = ((i = e.customer) == null ? void 0 : i.phoneNumber) || void 0, l = n == null ? void 0 : n.showProfileLists, c = n == null ? void 0 : n.showProfileSegments, u = n == null ? void 0 : n.showSubscriptions, p = Number(n == null ? void 0 : n.noOfMessagesToShow), m = n == null ? void 0 : n.subscriptionListId, {
    profileId: v,
    getProfileId: y,
    isLoading: b,
    error: N
  } = VE({ email: o, phoneNumber: s });
  return Iv(() => {
    (o || s) && y({
      variables: {
        emailFilter: `equals(email,"${o}")`,
        phoneNumberFilter: `equals(phone_number,"${s}")`
      }
    });
  }, [o, s]), !o && !s ? /* @__PURE__ */ ue.jsx(C, { justifyContent: "center", margin: "0 0 300 0", children: "The customer does not have an email nor a phone number" }) : b ? /* @__PURE__ */ ue.jsx(C, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ ue.jsx(ln, {}) }) : N ? /* @__PURE__ */ ue.jsx(tc, { error: N }) : v ? /* @__PURE__ */ ue.jsx(
    cF,
    {
      profileId: v,
      email: o,
      phoneNumber: s,
      showProfileLists: l,
      showProfileSegments: c,
      showSubscriptions: u,
      noOfMessagesToShow: p,
      subscriptionListId: m
    }
  ) : /* @__PURE__ */ ue.jsx(
    C,
    {
      justifyContent: "center",
      margin: "0 0 300 0",
      className: La.notificationText,
      children: "No profile ID found"
    }
  );
}, uF = [
  {
    key: "klaviyoApiKey",
    label: "API key",
    placeholder: "API key from Klaviyo",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "showProfileLists",
    label: "Show Klaviyo lists for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showProfileSegments",
    label: "Show Klaviyo segments for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showSubscriptions",
    label: "Show subscription channels for Klaviyo messages",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "subscriptionListId",
    label: "Activate re-/subscription list selection",
    secret: !1,
    type: "hidden",
    hideOnCreate: !0
  },
  {
    key: "subscriptionListComponent",
    label: "Select a list to subscribe to",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Cv
  },
  {
    key: "noOfMessagesToShow",
    label: "Choose how many messages to show",
    required: !0,
    secret: !1,
    type: "select",
    defaultValue: "5",
    selectItems: [
      { value: "3", label: "The three latest messages" },
      { value: "4", label: "The four latest messages" },
      { value: "5", label: "The five latest messages" }
    ]
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('._code_girvf_27{background-color:#e7ecf3;font-family:Courier,Consolas,Monaco,Lucida Console,Liberation Mono;color:#46597c;padding:2px 4px;font-size:14px;border:none;border-radius:2px}._codeBlock_girvf_36{font-size:12px;background-color:#e7ecf3;font-family:Courier,Consolas,Monaco,Lucida Console,Liberation Mono;color:#46597c;padding:4px 8px;border:none;border-radius:2px;margin:16px 0}._link_girvf_47{color:#0079cc;text-decoration:none}._link_girvf_47:hover{color:#69bbf6;text-decoration:underline}._blockQuote_girvf_56{padding:4px 4px 4px 16px;background-color:#f5f7fa;margin:16px 0;border-left:2px solid #8193b0;color:#46597c;font-size:14px}._blockQuote_girvf_56 p{margin:8px}._list_girvf_68{padding-left:32px;margin:16px 0}._userMention_girvf_73{color:#132244;font-weight:600}._checkbox_girvf_78 p{margin:8px 0}._checkboxIcon_girvf_81{align-self:center;pointer-events:none}._linearImage_girvf_86{max-width:100%;margin:4px 0}._issueAvatar_5a41w_27{margin:4px 0}._issueAvatar_5a41w_27 h2{font-weight:400;align-items:center;display:flex}._issueField_5a41w_35{font-weight:400}._issueDescription_5a41w_38{font-weight:400;color:#263758}._issueDescription_5a41w_38 p,._issueDescription_5a41w_38 h1,._issueDescription_5a41w_38 h2,._issueDescription_5a41w_38 h3,._issueDescription_5a41w_38 h4,._issueDescription_5a41w_38 h5{margin:8px 0}._issueDescription_5a41w_38>div{margin-top:4px}._issueDescription_5a41w_38>div>*:first-child{margin-top:4px}._wrapper_mk443_27{width:400px;padding:0 0 8px;max-height:400px;overflow:hidden;position:relative}._wrapper_mk443_27 ._description_mk443_34{color:#617598}._wrapper_mk443_27:after{width:100%;height:24px;content:"";position:absolute;bottom:0;left:0;background:linear-gradient(0deg,#fff,#ffffffbc 19%,#ffffff8a 34%,#ffffff61 47%,#ffffff47 56.5%,#ffffff31 65%,#ffffff20 73%,#ffffff13 80.2%,#ffffff0b 86.1%,#ffffff05 91%,#ffffff02 95.2%,#ffffff01 98.2%,#fff0)}._resultTitle_mk443_47{text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:#617598}._resultTooltipTitle_mk443_54{margin-bottom:8px}._resultLinkIcon_mk443_57{position:absolute;right:16px;background-color:#fff;border:1px solid #d7dfea;border-radius:4px;color:#8193b0}._loader_1lxnr_27{width:100%;display:flex;padding:8px;justify-content:center}._dropdown_1lxnr_34{max-height:300px;overflow-y:scroll}._loadMore_1lxnr_39{cursor:pointer}._loadMore_1lxnr_39:hover{background-color:#f5f7fa}._loadMore_1lxnr_39:hover p{color:#392aa7}._loadMore_1lxnr_39 p{color:#5644d8}._collapse_1rxyf_27{border:1px solid #d7dfea;border-radius:4px;font-size:12px;line-height:16px;padding:4px}._collapseHeader_1rxyf_34{padding:12px;width:100%;box-sizing:border-box;background-color:transparent;gap:4px}._collapseHeader_1rxyf_34>div:first-of-type{padding:0!important;padding-right:16px;width:100%}._collapseHeader_1rxyf_34>div>div:first-of-type{padding:0!important;width:100%}._collapseHeader_1rxyf_34 p>div:first-of-type{justify-content:space-between}._collapseHeader_1rxyf_34>div>div>p{white-space:unset!important;margin:0}._collapseContent_1rxyf_57{padding:0 12px 12px}._url_1rxyf_61{align-items:center;display:flex;flex-direction:row;gap:4px;color:#5644d8;font-weight:600;cursor:pointer;font-size:12px;line-height:16px}._empty_1rxyf_73 p{color:#b5c1d4}._externalLink_1rxyf_77{color:#0079cc}._emptyState_1rxyf_81{font-weight:400}._modalBody_d4g53_27{width:600px}._error_d4g53_31{border:1px solid #C11D1D}._emptyState_d4g53_35{padding:4px 8px 8px}._emptyState_d4g53_35 p{color:#b5c1d4}._dropdown_d4g53_42{max-height:300px;overflow-y:scroll}._modalWrapper_epi3e_27{min-width:600px;position:relative}._copyButton_epi3e_32{height:32px;width:32px}._copyButton_epi3e_32 button{background-color:#f5f7fa;border-radius:0 4px 4px 0}._copyWrapper_epi3e_41{box-sizing:border-box}._copyWrapper_epi3e_41:focus-within{border-radius:4px;outline:solid 1px #5644d8;box-shadow:0 0 0 3px #c1b9f8}._copyField_epi3e_50{cursor:pointer;min-width:62ch;height:32px;border-radius:4px 0 0 4px;border:none}._copyField_epi3e_50:hover{border:none}._copyField_epi3e_50:focus-within{box-shadow:none;border:none;outline:none}._copyField_epi3e_50 input{color:#263758;background-color:#f5f7fa;cursor:pointer;border:1px solid #e7ecf3;border-right:none}._externalLink_epi3e_73{display:flex;align-items:center}._externalLinkIcon_epi3e_78{align-self:center}._textWrapper_epi3e_82{display:flex;gap:4px}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var tl = { exports: {} }, vr = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Go, Ou;
function ev() {
  if (Ou)
    return Go;
  Ou = 1;
  var e = Object.getOwnPropertySymbols, n = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function i(s) {
    if (s == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(s);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var s = new String("abc");
      if (s[5] = "de", Object.getOwnPropertyNames(s)[0] === "5")
        return !1;
      for (var l = {}, c = 0; c < 10; c++)
        l["_" + String.fromCharCode(c)] = c;
      var u = Object.getOwnPropertyNames(l).map(function(m) {
        return l[m];
      });
      if (u.join("") !== "0123456789")
        return !1;
      var p = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(m) {
        p[m] = m;
      }), Object.keys(Object.assign({}, p)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Go = o() ? Object.assign : function(s, l) {
    for (var c, u = i(s), p, m = 1; m < arguments.length; m++) {
      c = Object(arguments[m]);
      for (var v in c)
        n.call(c, v) && (u[v] = c[v]);
      if (e) {
        p = e(c);
        for (var y = 0; y < p.length; y++)
          r.call(c, p[y]) && (u[p[y]] = c[p[y]]);
      }
    }
    return u;
  }, Go;
}
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ru;
function mF() {
  if (Ru)
    return vr;
  Ru = 1, ev();
  var e = Cn, n = 60103;
  if (vr.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var r = Symbol.for;
    n = r("react.element"), vr.Fragment = r("react.fragment");
  }
  var i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = Object.prototype.hasOwnProperty, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(c, u, p) {
    var m, v = {}, y = null, b = null;
    p !== void 0 && (y = "" + p), u.key !== void 0 && (y = "" + u.key), u.ref !== void 0 && (b = u.ref);
    for (m in u)
      o.call(u, m) && !s.hasOwnProperty(m) && (v[m] = u[m]);
    if (c && c.defaultProps)
      for (m in u = c.defaultProps, u)
        v[m] === void 0 && (v[m] = u[m]);
    return { $$typeof: n, type: c, key: y, ref: b, props: v, _owner: i.current };
  }
  return vr.jsx = l, vr.jsxs = l, vr;
}
var Du = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Pu;
function pF() {
  return Pu || (Pu = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      var n = Cn, r = ev(), i = 60103, o = 60106;
      e.Fragment = 60107;
      var s = 60108, l = 60114, c = 60109, u = 60110, p = 60112, m = 60113, v = 60120, y = 60115, b = 60116, N = 60121, x = 60122, T = 60117, $ = 60129, P = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var h = Symbol.for;
        i = h("react.element"), o = h("react.portal"), e.Fragment = h("react.fragment"), s = h("react.strict_mode"), l = h("react.profiler"), c = h("react.provider"), u = h("react.context"), p = h("react.forward_ref"), m = h("react.suspense"), v = h("react.suspense_list"), y = h("react.memo"), b = h("react.lazy"), N = h("react.block"), x = h("react.server.block"), T = h("react.fundamental"), h("react.scope"), h("react.opaque.id"), $ = h("react.debug_trace_mode"), h("react.offscreen"), P = h("react.legacy_hidden");
      }
      var E = typeof Symbol == "function" && Symbol.iterator, q = "@@iterator";
      function M(t) {
        if (t === null || typeof t != "object")
          return null;
        var a = E && t[E] || t[q];
        return typeof a == "function" ? a : null;
      }
      var R = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function w(t) {
        {
          for (var a = arguments.length, d = new Array(a > 1 ? a - 1 : 0), f = 1; f < a; f++)
            d[f - 1] = arguments[f];
          H("error", t, d);
        }
      }
      function H(t, a, d) {
        {
          var f = R.ReactDebugCurrentFrame, _ = f.getStackAddendum();
          _ !== "" && (a += "%s", d = d.concat([_]));
          var S = d.map(function(k) {
            return "" + k;
          });
          S.unshift("Warning: " + a), Function.prototype.apply.call(console[t], console, S);
        }
      }
      var pe = !1;
      function le(t) {
        return !!(typeof t == "string" || typeof t == "function" || t === e.Fragment || t === l || t === $ || t === s || t === m || t === v || t === P || pe || typeof t == "object" && t !== null && (t.$$typeof === b || t.$$typeof === y || t.$$typeof === c || t.$$typeof === u || t.$$typeof === p || t.$$typeof === T || t.$$typeof === N || t[0] === x));
      }
      function Se(t, a, d) {
        var f = a.displayName || a.name || "";
        return t.displayName || (f !== "" ? d + "(" + f + ")" : d);
      }
      function ae(t) {
        return t.displayName || "Context";
      }
      function D(t) {
        if (t == null)
          return null;
        if (typeof t.tag == "number" && w("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof t == "function")
          return t.displayName || t.name || null;
        if (typeof t == "string")
          return t;
        switch (t) {
          case e.Fragment:
            return "Fragment";
          case o:
            return "Portal";
          case l:
            return "Profiler";
          case s:
            return "StrictMode";
          case m:
            return "Suspense";
          case v:
            return "SuspenseList";
        }
        if (typeof t == "object")
          switch (t.$$typeof) {
            case u:
              var a = t;
              return ae(a) + ".Consumer";
            case c:
              var d = t;
              return ae(d._context) + ".Provider";
            case p:
              return Se(t, t.render, "ForwardRef");
            case y:
              return D(t.type);
            case N:
              return D(t._render);
            case b: {
              var f = t, _ = f._payload, S = f._init;
              try {
                return D(S(_));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var V = 0, de, te, he, _e, Z, J, z;
      function me() {
      }
      me.__reactDisabledLog = !0;
      function ke() {
        {
          if (V === 0) {
            de = console.log, te = console.info, he = console.warn, _e = console.error, Z = console.group, J = console.groupCollapsed, z = console.groupEnd;
            var t = {
              configurable: !0,
              enumerable: !0,
              value: me,
              writable: !0
            };
            Object.defineProperties(console, {
              info: t,
              log: t,
              warn: t,
              error: t,
              group: t,
              groupCollapsed: t,
              groupEnd: t
            });
          }
          V++;
        }
      }
      function Oe() {
        {
          if (V--, V === 0) {
            var t = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: r({}, t, {
                value: de
              }),
              info: r({}, t, {
                value: te
              }),
              warn: r({}, t, {
                value: he
              }),
              error: r({}, t, {
                value: _e
              }),
              group: r({}, t, {
                value: Z
              }),
              groupCollapsed: r({}, t, {
                value: J
              }),
              groupEnd: r({}, t, {
                value: z
              })
            });
          }
          V < 0 && w("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var Y = R.ReactCurrentDispatcher, fe;
      function ge(t, a, d) {
        {
          if (fe === void 0)
            try {
              throw Error();
            } catch (_) {
              var f = _.stack.trim().match(/\n( *(at )?)/);
              fe = f && f[1] || "";
            }
          return `
` + fe + t;
        }
      }
      var X = !1, ye;
      {
        var W = typeof WeakMap == "function" ? WeakMap : Map;
        ye = new W();
      }
      function ce(t, a) {
        if (!t || X)
          return "";
        {
          var d = ye.get(t);
          if (d !== void 0)
            return d;
        }
        var f;
        X = !0;
        var _ = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var S;
        S = Y.current, Y.current = null, ke();
        try {
          if (a) {
            var k = function() {
              throw Error();
            };
            if (Object.defineProperty(k.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(k, []);
              } catch (A) {
                f = A;
              }
              Reflect.construct(t, [], k);
            } else {
              try {
                k.call();
              } catch (A) {
                f = A;
              }
              t.call(k.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (A) {
              f = A;
            }
            t();
          }
        } catch (A) {
          if (A && f && typeof A.stack == "string") {
            for (var g = A.stack.split(`
`), L = f.stack.split(`
`), I = g.length - 1, O = L.length - 1; I >= 1 && O >= 0 && g[I] !== L[O]; )
              O--;
            for (; I >= 1 && O >= 0; I--, O--)
              if (g[I] !== L[O]) {
                if (I !== 1 || O !== 1)
                  do
                    if (I--, O--, O < 0 || g[I] !== L[O]) {
                      var re = `
` + g[I].replace(" at new ", " at ");
                      return typeof t == "function" && ye.set(t, re), re;
                    }
                  while (I >= 1 && O >= 0);
                break;
              }
          }
        } finally {
          X = !1, Y.current = S, Oe(), Error.prepareStackTrace = _;
        }
        var Ce = t ? t.displayName || t.name : "", j = Ce ? ge(Ce) : "";
        return typeof t == "function" && ye.set(t, j), j;
      }
      function ie(t, a, d) {
        return ce(t, !1);
      }
      function oe(t) {
        var a = t.prototype;
        return !!(a && a.isReactComponent);
      }
      function be(t, a, d) {
        if (t == null)
          return "";
        if (typeof t == "function")
          return ce(t, oe(t));
        if (typeof t == "string")
          return ge(t);
        switch (t) {
          case m:
            return ge("Suspense");
          case v:
            return ge("SuspenseList");
        }
        if (typeof t == "object")
          switch (t.$$typeof) {
            case p:
              return ie(t.render);
            case y:
              return be(t.type, a, d);
            case N:
              return ie(t._render);
            case b: {
              var f = t, _ = f._payload, S = f._init;
              try {
                return be(S(_), a, d);
              } catch {
              }
            }
          }
        return "";
      }
      var Ee = {}, Ie = R.ReactDebugCurrentFrame;
      function we(t) {
        if (t) {
          var a = t._owner, d = be(t.type, t._source, a ? a.type : null);
          Ie.setExtraStackFrame(d);
        } else
          Ie.setExtraStackFrame(null);
      }
      function Ge(t, a, d, f, _) {
        {
          var S = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var k in t)
            if (S(t, k)) {
              var g = void 0;
              try {
                if (typeof t[k] != "function") {
                  var L = Error((f || "React class") + ": " + d + " type `" + k + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[k] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw L.name = "Invariant Violation", L;
                }
                g = t[k](a, k, f, d, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (I) {
                g = I;
              }
              g && !(g instanceof Error) && (we(_), w("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", f || "React class", d, k, typeof g), we(null)), g instanceof Error && !(g.message in Ee) && (Ee[g.message] = !0, we(_), w("Failed %s type: %s", d, g.message), we(null));
            }
        }
      }
      var je = R.ReactCurrentOwner, Te = Object.prototype.hasOwnProperty, Ye = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, Ae, Be, De;
      De = {};
      function cn(t) {
        if (Te.call(t, "ref")) {
          var a = Object.getOwnPropertyDescriptor(t, "ref").get;
          if (a && a.isReactWarning)
            return !1;
        }
        return t.ref !== void 0;
      }
      function en(t) {
        if (Te.call(t, "key")) {
          var a = Object.getOwnPropertyDescriptor(t, "key").get;
          if (a && a.isReactWarning)
            return !1;
        }
        return t.key !== void 0;
      }
      function yn(t, a) {
        if (typeof t.ref == "string" && je.current && a && je.current.stateNode !== a) {
          var d = D(je.current.type);
          De[d] || (w('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', D(je.current.type), t.ref), De[d] = !0);
        }
      }
      function pn(t, a) {
        {
          var d = function() {
            Ae || (Ae = !0, w("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", a));
          };
          d.isReactWarning = !0, Object.defineProperty(t, "key", {
            get: d,
            configurable: !0
          });
        }
      }
      function gn(t, a) {
        {
          var d = function() {
            Be || (Be = !0, w("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", a));
          };
          d.isReactWarning = !0, Object.defineProperty(t, "ref", {
            get: d,
            configurable: !0
          });
        }
      }
      var dn = function(t, a, d, f, _, S, k) {
        var g = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: i,
          // Built-in properties that belong on the element
          type: t,
          key: a,
          ref: d,
          props: k,
          // Record the component responsible for creating this element.
          _owner: S
        };
        return g._store = {}, Object.defineProperty(g._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(g, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: f
        }), Object.defineProperty(g, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: _
        }), Object.freeze && (Object.freeze(g.props), Object.freeze(g)), g;
      };
      function un(t, a, d, f, _) {
        {
          var S, k = {}, g = null, L = null;
          d !== void 0 && (g = "" + d), en(a) && (g = "" + a.key), cn(a) && (L = a.ref, yn(a, _));
          for (S in a)
            Te.call(a, S) && !Ye.hasOwnProperty(S) && (k[S] = a[S]);
          if (t && t.defaultProps) {
            var I = t.defaultProps;
            for (S in I)
              k[S] === void 0 && (k[S] = I[S]);
          }
          if (g || L) {
            var O = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
            g && pn(k, O), L && gn(k, O);
          }
          return dn(t, g, L, _, f, je.current, k);
        }
      }
      var Re = R.ReactCurrentOwner, He = R.ReactDebugCurrentFrame;
      function Ne(t) {
        if (t) {
          var a = t._owner, d = be(t.type, t._source, a ? a.type : null);
          He.setExtraStackFrame(d);
        } else
          He.setExtraStackFrame(null);
      }
      var Le;
      Le = !1;
      function Me(t) {
        return typeof t == "object" && t !== null && t.$$typeof === i;
      }
      function ze() {
        {
          if (Re.current) {
            var t = D(Re.current.type);
            if (t)
              return `

Check the render method of \`` + t + "`.";
          }
          return "";
        }
      }
      function _n(t) {
        {
          if (t !== void 0) {
            var a = t.fileName.replace(/^.*[\\\/]/, ""), d = t.lineNumber;
            return `

Check your code at ` + a + ":" + d + ".";
          }
          return "";
        }
      }
      var Je = {};
      function qe(t) {
        {
          var a = ze();
          if (!a) {
            var d = typeof t == "string" ? t : t.displayName || t.name;
            d && (a = `

Check the top-level render call using <` + d + ">.");
          }
          return a;
        }
      }
      function Ke(t, a) {
        {
          if (!t._store || t._store.validated || t.key != null)
            return;
          t._store.validated = !0;
          var d = qe(a);
          if (Je[d])
            return;
          Je[d] = !0;
          var f = "";
          t && t._owner && t._owner !== Re.current && (f = " It was passed a child from " + D(t._owner.type) + "."), Ne(t), w('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', d, f), Ne(null);
        }
      }
      function Ze(t, a) {
        {
          if (typeof t != "object")
            return;
          if (Array.isArray(t))
            for (var d = 0; d < t.length; d++) {
              var f = t[d];
              Me(f) && Ke(f, a);
            }
          else if (Me(t))
            t._store && (t._store.validated = !0);
          else if (t) {
            var _ = M(t);
            if (typeof _ == "function" && _ !== t.entries)
              for (var S = _.call(t), k; !(k = S.next()).done; )
                Me(k.value) && Ke(k.value, a);
          }
        }
      }
      function hn(t) {
        {
          var a = t.type;
          if (a == null || typeof a == "string")
            return;
          var d;
          if (typeof a == "function")
            d = a.propTypes;
          else if (typeof a == "object" && (a.$$typeof === p || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          a.$$typeof === y))
            d = a.propTypes;
          else
            return;
          if (d) {
            var f = D(a);
            Ge(d, t.props, "prop", f, t);
          } else if (a.PropTypes !== void 0 && !Le) {
            Le = !0;
            var _ = D(a);
            w("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _ || "Unknown");
          }
          typeof a.getDefaultProps == "function" && !a.getDefaultProps.isReactClassApproved && w("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function fn(t) {
        {
          for (var a = Object.keys(t.props), d = 0; d < a.length; d++) {
            var f = a[d];
            if (f !== "children" && f !== "key") {
              Ne(t), w("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", f), Ne(null);
              break;
            }
          }
          t.ref !== null && (Ne(t), w("Invalid attribute `ref` supplied to `React.Fragment`."), Ne(null));
        }
      }
      function Qe(t, a, d, f, _, S) {
        {
          var k = le(t);
          if (!k) {
            var g = "";
            (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (g += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var L = _n(_);
            L ? g += L : g += ze();
            var I;
            t === null ? I = "null" : Array.isArray(t) ? I = "array" : t !== void 0 && t.$$typeof === i ? (I = "<" + (D(t.type) || "Unknown") + " />", g = " Did you accidentally export a JSX literal instead of a component?") : I = typeof t, w("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", I, g);
          }
          var O = un(t, a, d, _, S);
          if (O == null)
            return O;
          if (k) {
            var re = a.children;
            if (re !== void 0)
              if (f)
                if (Array.isArray(re)) {
                  for (var Ce = 0; Ce < re.length; Ce++)
                    Ze(re[Ce], t);
                  Object.freeze && Object.freeze(re);
                } else
                  w("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                Ze(re, t);
          }
          return t === e.Fragment ? fn(O) : hn(O), O;
        }
      }
      function kn(t, a, d) {
        return Qe(t, a, d, !0);
      }
      function Sn(t, a, d) {
        return Qe(t, a, d, !1);
      }
      var mn = Sn, vn = kn;
      e.jsx = mn, e.jsxs = vn;
    }();
  }(Du)), Du;
}
process.env.NODE_ENV === "production" ? tl.exports = mF() : tl.exports = pF();
var F = tl.exports;
const fF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "statusId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "priority" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } } }, { kind: "ObjectField", name: { kind: "Name", value: "description" }, value: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } } }, { kind: "ObjectField", name: { kind: "Name", value: "teamId" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "projectId" }, value: { kind: "Variable", name: { kind: "Name", value: "projectId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "stateId" }, value: { kind: "Variable", name: { kind: "Name", value: "statusId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "priority" }, value: { kind: "Variable", name: { kind: "Name", value: "priority" } } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "success" } }, { kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] }, vF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "staticData" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "issuePriorityValues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "label" } }] } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] }, yF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "teamData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "team" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "states" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "templates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "templateData" } }] } }] } }] } }] } }] } }] } }] }, gF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "after" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }, { kind: "Argument", name: { kind: "Name", value: "after" }, value: { kind: "Variable", name: { kind: "Name", value: "after" } } }, { kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "or" }, value: { kind: "ListValue", values: [{ kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "containsIgnoreCase" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }] } }] }, { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "description" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "containsIgnoreCase" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }] } }] }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "descriptionData" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "pageInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "hasNextPage" } }, { kind: "Field", name: { kind: "Name", value: "endCursor" } }] } }] } }] } }] } }] }, hF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchLinkedIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } }, type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "id" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "in" }, value: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "descriptionData" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, kF = {
  "\n  mutation createIssue(\n    $issueTitle: String!\n    $issueDescription: String\n    $teamId: String!\n    $projectId: String\n    $statusId: String\n    $priority: Int\n  ) {\n    Linear {\n      issueCreate(\n        input: {\n          title: $issueTitle\n          description: $issueDescription\n          teamId: $teamId\n          projectId: $projectId\n          stateId: $statusId\n          priority: $priority\n        }\n      ) {\n        success\n        issue {\n          id\n          title\n          identifier\n          url\n        }\n      }\n    }\n  }\n": fF,
  "\n  query staticData {\n    Linear {\n      teams {\n        edges {\n          node {\n            id\n            name\n            organization {\n              urlKey\n            }\n          }\n        }\n      }\n      issuePriorityValues {\n        priority\n        label\n      }\n      organization {\n        urlKey\n      }\n    }\n  }\n": vF,
  "\n  query teamData($teamId: String!) {\n    Linear {\n      team(id: $teamId) {\n        projects {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n        states {\n          edges {\n            node {\n              id\n              name\n              type\n              color\n            }\n          }\n        }\n        templates {\n          edges {\n            node {\n              id\n              name\n              type\n              templateData\n            }\n          }\n        }\n      }\n    }\n  }\n": yF,
  "\n  query searchIssues($issueQuery: String! $after: String, $first: Int ) {\n    Linear {\n      issues(\n        first:$first\n        after:$after\n        filter: {\n          or: [\n            { title: { containsIgnoreCase: $issueQuery } }\n            { description: { containsIgnoreCase: $issueQuery } }\n          ]\n        }\n      ) {\n        edges {\n          node {\n            id\n            title\n            description\n            descriptionData\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n    }\n  }\n": gF,
  "\n  query searchLinkedIssues($linkedIssues: [ID!]) {\n    Linear {\n      issues(filter: { id: { in: $linkedIssues } }) {\n        edges {\n          node {\n            id\n            title\n            description\n            descriptionData\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": hF
};
function bi(e) {
  return kF[e] ?? {};
}
const bF = bi(
  /* GraphQL */
  `
  query searchIssues($issueQuery: String! $after: String, $first: Int ) {
    Linear {
      issues(
        first:$first
        after:$after
        filter: {
          or: [
            { title: { containsIgnoreCase: $issueQuery } }
            { description: { containsIgnoreCase: $issueQuery } }
          ]
        }
      ) {
        edges {
          node {
            id
            title
            description
            descriptionData
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`
), _F = bi(
  /* GraphQL */
  `
  query searchLinkedIssues($linkedIssues: [ID!]) {
    Linear {
      issues(filter: { id: { in: $linkedIssues } }) {
        edges {
          node {
            id
            title
            description
            descriptionData
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
      }
    }
  }
`
), SF = "_code_girvf_27", NF = "_codeBlock_girvf_36", xF = "_link_girvf_47", wF = "_blockQuote_girvf_56", jF = "_list_girvf_68", CF = "_userMention_girvf_73", EF = "_checkbox_girvf_78", FF = "_checkboxIcon_girvf_81", IF = "_linearImage_girvf_86", lt = {
  code: SF,
  codeBlock: NF,
  link: xF,
  blockQuote: wF,
  list: jF,
  userMention: CF,
  checkbox: EF,
  checkboxIcon: FF,
  linearImage: IF
}, $F = {
  default: (e, n) => n().every((r) => typeof r == "string") ? n().join(" ") : /* @__PURE__ */ F.jsx(F.Fragment, { children: n() }),
  nodes: {
    doc: (e, n) => /* @__PURE__ */ F.jsx("div", { children: n() }),
    paragraph: (e, n) => /* @__PURE__ */ F.jsx("p", { children: n() }),
    text: (e) => e.text || "",
    hard_break: () => /* @__PURE__ */ F.jsx("br", {}),
    blockquote: (e, n) => /* @__PURE__ */ F.jsx("blockquote", { className: lt.blockQuote, children: n() }),
    bullet_list: (e, n) => /* @__PURE__ */ F.jsx("ul", { className: lt.list, children: n() }),
    ordered_list: (e, n) => /* @__PURE__ */ F.jsx("ol", { className: lt.list, children: n() }),
    list_item: (e, n) => /* @__PURE__ */ F.jsx("li", { children: n() }),
    code_block: (e, n) => /* @__PURE__ */ F.jsx("pre", { className: lt.codeBlock, children: /* @__PURE__ */ F.jsx("code", { children: n() }) }),
    suggestion_userMentions: (e) => {
      var n;
      return /* @__PURE__ */ F.jsx("span", { className: lt.userMention, children: `@${(n = e.attrs) == null ? void 0 : n.label}` });
    },
    todo_item: (e, n) => {
      var r;
      return /* @__PURE__ */ F.jsxs(C, { className: lt.checkbox, flexDirection: "row", gap: "200", children: [
        /* @__PURE__ */ F.jsx(
          Av,
          {
            className: lt.checkboxIcon,
            checked: !!((r = e.attrs) != null && r.done)
          }
        ),
        n()
      ] });
    },
    image: (e) => {
      var n, r, i, o;
      return (n = e.attrs) != null && n.src && (r = e.attrs) != null && r.alt ? /* @__PURE__ */ F.jsx(
        bm,
        {
          src: (i = e.attrs) == null ? void 0 : i.src,
          alt: (o = e.attrs) == null ? void 0 : o.alt,
          className: lt.linearImage
        }
      ) : /* @__PURE__ */ F.jsx(F.Fragment, {});
    },
    heading: (e, n) => {
      var r;
      switch ((r = e.attrs) == null ? void 0 : r.level) {
        case 1:
          return /* @__PURE__ */ F.jsx("h3", { children: n() });
        case 2:
          return /* @__PURE__ */ F.jsx("h4", { children: n() });
        case 3:
          return /* @__PURE__ */ F.jsx("h5", { children: n() });
        case 4:
          return /* @__PURE__ */ F.jsx("h6", { children: n() });
        case 5:
          return /* @__PURE__ */ F.jsx("b", { children: n() });
        case 6:
          return /* @__PURE__ */ F.jsx("b", { children: n() });
        default:
          return /* @__PURE__ */ F.jsx("h4", { children: n() });
      }
    }
  },
  marks: {
    text: {
      em: (e, n) => /* @__PURE__ */ F.jsx("em", { children: n() }),
      strong: (e, n) => /* @__PURE__ */ F.jsx("b", { children: n() }),
      underline: (e, n) => /* @__PURE__ */ F.jsx("u", { children: n() }),
      link: (e, n) => {
        var r;
        return /* @__PURE__ */ F.jsx(
          "a",
          {
            href: ((r = e.attrs) == null ? void 0 : r.href) || "",
            className: lt.link,
            target: "_blank",
            rel: "noreferrer",
            children: n()
          }
        );
      },
      code: (e, n) => /* @__PURE__ */ F.jsx("code", { className: lt.code, children: n() }),
      strike: (e, n) => /* @__PURE__ */ F.jsx("s", { children: n() })
    }
  }
}, TF = {
  default: (e, n) => (n() ?? []).join(""),
  nodes: {
    doc: (e, n) => (n() ?? []).join(""),
    heading: (e, n) => {
      var r;
      return `
${"#".repeat(
        parseInt((r = e.attrs) == null ? void 0 : r.level) || 1
      )} ${n()}

`;
    },
    bullet_list: (e, n) => `
` + n().map((r) => `- ${r}`).join(""),
    ordered_list: (e, n) => `
` + n().map((r) => `1. ${r}`).join(""),
    // We're not emitting list items from the listItem formatter but from the
    // ordered/bullet list nodes above, as markdown does not encapsulate list items
    //listItem: (_node, children) => '- ' + children(),
    paragraph: (e, n) => n().join("") + `
`,
    text: (e) => e.text ?? "",
    hard_break: () => `
`,
    blockquote: (e, n) => `> ${n().join("")}
`,
    code_block: (e, n) => {
      var r;
      return "\n```" + (((r = e.attrs) == null ? void 0 : r.language) || "") + `
` + n() + "\n```\n";
    }
  },
  marks: {
    text: {
      strong: (e, n) => `**${n()}**`,
      strike: (e, n) => `~~${n()}~~`,
      subsup: (e, n) => {
        var r;
        switch ((r = e.attrs) == null ? void 0 : r.type) {
          case "sub":
            return `<sub>${n()}</sub>`;
          case "sup":
            return `<sup>${n()}</sup>`;
          default:
            return n();
        }
      },
      underline: (e, n) => `<u>${n()}</u>`,
      em: (e, n) => `*${n()}*`,
      link: (e, n) => {
        var r;
        return `[${n()}](${(r = e.attrs) == null ? void 0 : r.href})`;
      },
      code: (e, n) => `\`${n()}\``
    }
  }
}, rc = (e, n) => {
  const r = (s) => (e.marks || []).map((l) => {
    var c;
    return {
      formatterFunction: (c = n.marks[e.type]) == null ? void 0 : c[l.type],
      mark: l
    };
  }).reduce(
    (l, c) => () => {
      var u;
      return ((u = c.formatterFunction) == null ? void 0 : u.call(c, c.mark, l)) || s;
    },
    () => s
  )(), i = (s, l) => () => s.content ? s.content.map((c) => rc(c, l)) : [], o = n.nodes[e.type] || n.default;
  return r(
    o(e, i(e, n))
  );
}, OF = (e) => {
  try {
    const n = JSON.parse(e);
    return rc(n, $F);
  } catch {
    return;
  }
}, Li = ({
  title: e,
  children: n
}) => /* @__PURE__ */ F.jsxs(C, { flexDirection: "column", gap: "100", children: [
  /* @__PURE__ */ F.jsx(se.Paragraph, { variant: "5", color: $e.neutral[500], children: e }),
  n
] }), RF = "_issueAvatar_5a41w_27", DF = "_issueField_5a41w_35", PF = "_issueDescription_5a41w_38", Ui = {
  issueAvatar: RF,
  issueField: DF,
  issueDescription: PF
}, nv = ({ issue: e }) => {
  var n, r;
  const i = e.descriptionData ? OF(e.descriptionData) : void 0;
  return /* @__PURE__ */ F.jsxs(F.Fragment, { children: [
    /* @__PURE__ */ F.jsx(Li, { title: "Assignee", children: /* @__PURE__ */ F.jsxs(
      C,
      {
        gap: "200",
        flexDirection: "row",
        alignContent: "center",
        className: Ui.issueAvatar,
        children: [
          /* @__PURE__ */ F.jsx(
            gl,
            {
              size: "24",
              user: e.assignee ? {
                name: e.assignee.name || null,
                // eslint-disable-next-line camelcase
                avatar_url: e.assignee.avatarUrl || null,
                email: e.assignee.email
              } : void 0
            }
          ),
          /* @__PURE__ */ F.jsx(se.Heading, { variant: "heading-4", children: e.assignee ? e.assignee.name : "Unassigned" })
        ]
      }
    ) }),
    ((n = e.team) == null ? void 0 : n.name) && /* @__PURE__ */ F.jsx(Li, { title: "Team", children: /* @__PURE__ */ F.jsx(
      se.Paragraph,
      {
        variant: "3",
        color: $e.neutral[800],
        className: Ui.issueField,
        children: e.team.name
      }
    ) }),
    ((r = e.project) == null ? void 0 : r.name) && /* @__PURE__ */ F.jsx(Li, { title: "Project", children: /* @__PURE__ */ F.jsx(
      se.Paragraph,
      {
        variant: "3",
        color: $e.neutral[800],
        className: Ui.issueField,
        children: e.project.name
      }
    ) }),
    i && /* @__PURE__ */ F.jsx(Li, { title: "Description", children: /* @__PURE__ */ F.jsx(se.Paragraph, { variant: "2", className: Ui.issueDescription, children: i }) })
  ] });
}, AF = /* @__PURE__ */ F.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: $e.neutral[500],
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "No Priority",
    "data-testid": "noPriorityIcon",
    children: [
      /* @__PURE__ */ F.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 5 7)" }),
      /* @__PURE__ */ F.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 8 7)" }),
      /* @__PURE__ */ F.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 11 7)" })
    ]
  }
), LF = /* @__PURE__ */ F.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: $e.neutral[500],
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Low Priority",
    children: [
      /* @__PURE__ */ F.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ F.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1", fillOpacity: "0.4" }),
      /* @__PURE__ */ F.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), UF = /* @__PURE__ */ F.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: $e.neutral[500],
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Medium Priority",
    children: [
      /* @__PURE__ */ F.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ F.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ F.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), MF = /* @__PURE__ */ F.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: $e.neutral[500],
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "High Priority",
    children: [
      /* @__PURE__ */ F.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ F.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ F.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1" })
    ]
  }
), BF = /* @__PURE__ */ F.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "-1 -1 15 15",
    "aria-label": "Urgent Priority",
    fill: $e.orange[400],
    children: /* @__PURE__ */ F.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 0a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V2a2 2 0 00-2-2H2zm3.914 3h1.738L7.5 8.602H6.07L5.914 3zm1.809 7.164a.95.95 0 01-.938.938.934.934 0 110-1.867c.5 0 .934.417.938.93z"
      }
    )
  }
), tv = {
  0: AF,
  1: BF,
  2: MF,
  3: UF,
  4: LF
}, VF = (e) => e in tv, fa = ({ priority: e }) => VF(e) ? tv[e] : /* @__PURE__ */ F.jsx(an, { "data-testid": "defaultPriorityTag", children: e }), qF = (e, n) => /* @__PURE__ */ F.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    "data-testid": "defaultStatusIcon",
    children: /* @__PURE__ */ F.jsx(
      "path",
      {
        d: "M13.9408 7.91426L11.9576 7.65557C11.9855 7.4419 12 7.22314 12 7C12 6.77686 11.9855 6.5581 11.9576 6.34443L13.9408 6.08573C13.9799 6.38496 14 6.69013 14 7C14 7.30987 13.9799 7.61504 13.9408 7.91426ZM13.4688 4.32049C13.2328 3.7514 12.9239 3.22019 12.5538 2.73851L10.968 3.95716C11.2328 4.30185 11.4533 4.68119 11.6214 5.08659L13.4688 4.32049ZM11.2615 1.4462L10.0428 3.03204C9.69815 2.76716 9.31881 2.54673 8.91341 2.37862L9.67951 0.531163C10.2486 0.767153 10.7798 1.07605 11.2615 1.4462ZM7.91426 0.0591659L7.65557 2.04237C7.4419 2.01449 7.22314 2 7 2C6.77686 2 6.5581 2.01449 6.34443 2.04237L6.08574 0.059166C6.38496 0.0201343 6.69013 0 7 0C7.30987 0 7.61504 0.0201343 7.91426 0.0591659ZM4.32049 0.531164L5.08659 2.37862C4.68119 2.54673 4.30185 2.76716 3.95716 3.03204L2.73851 1.4462C3.22019 1.07605 3.7514 0.767153 4.32049 0.531164ZM1.4462 2.73851L3.03204 3.95716C2.76716 4.30185 2.54673 4.68119 2.37862 5.08659L0.531164 4.32049C0.767153 3.7514 1.07605 3.22019 1.4462 2.73851ZM0.0591659 6.08574C0.0201343 6.38496 0 6.69013 0 7C0 7.30987 0.0201343 7.61504 0.059166 7.91426L2.04237 7.65557C2.01449 7.4419 2 7.22314 2 7C2 6.77686 2.01449 6.5581 2.04237 6.34443L0.0591659 6.08574ZM0.531164 9.67951L2.37862 8.91341C2.54673 9.31881 2.76716 9.69815 3.03204 10.0428L1.4462 11.2615C1.07605 10.7798 0.767153 10.2486 0.531164 9.67951ZM2.73851 12.5538L3.95716 10.968C4.30185 11.2328 4.68119 11.4533 5.08659 11.6214L4.32049 13.4688C3.7514 13.2328 3.22019 12.9239 2.73851 12.5538ZM6.08574 13.9408L6.34443 11.9576C6.5581 11.9855 6.77686 12 7 12C7.22314 12 7.4419 11.9855 7.65557 11.9576L7.91427 13.9408C7.61504 13.9799 7.30987 14 7 14C6.69013 14 6.38496 13.9799 6.08574 13.9408ZM9.67951 13.4688L8.91341 11.6214C9.31881 11.4533 9.69815 11.2328 10.0428 10.968L11.2615 12.5538C10.7798 12.9239 10.2486 13.2328 9.67951 13.4688ZM12.5538 11.2615L10.968 10.0428C11.2328 9.69815 11.4533 9.31881 11.6214 8.91341L13.4688 9.67951C13.2328 10.2486 12.924 10.7798 12.5538 11.2615Z",
        stroke: "none"
      }
    )
  }
), zF = (e, n) => /* @__PURE__ */ F.jsxs(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    "aria-label": n,
    "data-testid": "unstartedStatusIcon",
    children: [
      /* @__PURE__ */ F.jsx(
        "rect",
        {
          x: "1",
          y: "1",
          width: "12",
          height: "12",
          rx: "6",
          stroke: e,
          strokeWidth: "2",
          fill: "none"
        }
      ),
      /* @__PURE__ */ F.jsx(
        "path",
        {
          fill: e,
          stroke: "none",
          d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 0 z",
          transform: "translate(3.5,3.5)"
        }
      )
    ]
  }
), HF = (e, n) => /* @__PURE__ */ F.jsxs("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", "aria-label": n, children: [
  /* @__PURE__ */ F.jsx(
    "rect",
    {
      x: "1",
      y: "1",
      width: "12",
      height: "12",
      rx: "6",
      stroke: e,
      strokeWidth: "2",
      fill: "none"
    }
  ),
  /* @__PURE__ */ F.jsx(
    "path",
    {
      fill: e,
      stroke: "none",
      d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 7 z",
      transform: "translate(3.5,3.5)"
    }
  )
] }), KF = (e, n) => /* @__PURE__ */ F.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ F.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), GF = (e, n) => /* @__PURE__ */ F.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ F.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM5.03033 3.96967C4.73744 3.67678 4.26256 3.67678 3.96967 3.96967C3.67678 4.26256 3.67678 4.73744 3.96967 5.03033L5.93934 7L3.96967 8.96967C3.67678 9.26256 3.67678 9.73744 3.96967 10.0303C4.26256 10.3232 4.73744 10.3232 5.03033 10.0303L7 8.06066L8.96967 10.0303C9.26256 10.3232 9.73744 10.3232 10.0303 10.0303C10.3232 9.73744 10.3232 9.26256 10.0303 8.96967L8.06066 7L10.0303 5.03033C10.3232 4.73744 10.3232 4.26256 10.0303 3.96967C9.73744 3.67678 9.26256 3.67678 8.96967 3.96967L7 5.93934L5.03033 3.96967Z",
        stroke: "none"
      }
    )
  }
), WF = (e, n) => /* @__PURE__ */ F.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ F.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), rl = {
  backlog: (e, n) => qF(e, n),
  unstarted: (e, n) => zF(e, n),
  started: (e, n) => HF(e, n),
  done: (e, n) => KF(e, n),
  canceled: (e, n) => GF(e, n),
  completed: (e, n) => WF(e, n)
}, YF = (e) => e in rl, va = ({
  type: e = "backlog",
  color: n = $e.neutral[400],
  name: r = "linear-backlog-icon"
}) => YF(e) ? rl[e](n, r) : rl.backlog($e.neutral[400], "linear-backlog-icon"), QF = "_wrapper_mk443_27", JF = "_description_mk443_34", ZF = "_resultTitle_mk443_47", XF = "_resultTooltipTitle_mk443_54", eI = "_resultLinkIcon_mk443_57", Jr = {
  wrapper: QF,
  description: JF,
  resultTitle: ZF,
  resultTooltipTitle: XF,
  resultLinkIcon: eI
}, nI = ({
  issue: e
}) => {
  const [n, r] = G(!1);
  return /* @__PURE__ */ F.jsx(
    jn,
    {
      side: "left",
      content: /* @__PURE__ */ F.jsxs(C, { flexDirection: "column", gap: "300", className: Jr.wrapper, children: [
        /* @__PURE__ */ F.jsxs(C, { flexDirection: "row", justifyContent: "space-between", gap: "300", children: [
          /* @__PURE__ */ F.jsxs(C, { flexDirection: "row", gap: "200", alignItems: "center", children: [
            /* @__PURE__ */ F.jsx(
              va,
              {
                type: e.state.type,
                name: e.state.name,
                color: e.state.color
              }
            ),
            /* @__PURE__ */ F.jsx(se.Heading, { variant: "heading-3", children: e.identifier }),
            /* @__PURE__ */ F.jsx(fa, { priority: e.priority })
          ] }),
          /* @__PURE__ */ F.jsx(an, { children: e.state.name })
        ] }),
        /* @__PURE__ */ F.jsxs(C, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ F.jsx(
            se.Heading,
            {
              variant: "heading-3",
              className: Jr.resultTooltipTitle,
              children: e.title
            }
          ),
          /* @__PURE__ */ F.jsx(nv, { issue: e })
        ] })
      ] }),
      children: /* @__PURE__ */ F.jsx(
        Jt.Item,
        {
          value: e,
          noFixedSelectionStateSpace: !0,
          className: Jr.result,
          onMouseEnter: () => r(!0),
          onMouseLeave: () => r(!1),
          "data-testid": "selectionListItemWrapper",
          children: /* @__PURE__ */ F.jsxs(
            C,
            {
              flexDirection: "column",
              style: {
                width: n ? "calc(100% - 32px)" : "100%"
              },
              children: [
                /* @__PURE__ */ F.jsxs(C, { flexDirection: "row", gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ F.jsx(
                    va,
                    {
                      type: e.state.type,
                      color: e.state.color,
                      name: e.state.name
                    }
                  ),
                  /* @__PURE__ */ F.jsx(se.Heading, { variant: "heading-3", children: e.identifier }),
                  /* @__PURE__ */ F.jsx(fa, { priority: e.priority })
                ] }),
                /* @__PURE__ */ F.jsx(se.Paragraph, { variant: "4", className: Jr.resultTitle, children: e.title }),
                n && /* @__PURE__ */ F.jsx(
                  Fe,
                  {
                    className: Jr.resultLinkIcon,
                    name: "plus",
                    size: 32
                  }
                )
              ]
            }
          )
        },
        e.id
      )
    }
  );
}, tI = "_loader_1lxnr_27", rI = "_dropdown_1lxnr_34", iI = "_loadMore_1lxnr_39", Wo = {
  loader: tI,
  dropdown: rI,
  loadMore: iI
}, aI = ({
  handleSelect: e,
  linkedIssues: n
}) => {
  const [r, i] = G(), [o, s] = G([]), [l, c] = G(""), [u, p] = G(!1), { useLazyQuery: m } = rn(), [v, { data: y, loading: b, networkStatus: N }] = m(
    bF,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0
    }
  );
  Lr(
    () => {
      !b && l !== "" && N === Yn.ready ? v({
        variables: {
          issueQuery: l,
          first: 8
        }
      }) : s([]);
    },
    500,
    [l]
  ), Pe(() => {
    b || s([]);
  }, [l]), Pe(() => {
    var T, $, P;
    if (y && Object.keys(y).length > 0) {
      const h = y.Linear.issues.edges.map(
        ({ node: R }) => R
      ), E = o.filter(
        (R) => !n.find((w) => w.id === R.id)
      ), q = E.filter(
        (R) => !h.find(
          (w) => w.id === R.id
        )
      ), M = h.filter(
        (R) => !n.find((w) => w.id === R.id)
      );
      n.length > 0 ? s(
        u ? [...q, ...M] : M
      ) : ($ = (T = y == null ? void 0 : y.Linear) == null ? void 0 : T.issues) != null && $.edges && s(
        u ? [...E, ...h] : h
      ), y.Linear.issues.pageInfo.hasNextPage && p(!1), i((P = y.Linear.issues) == null ? void 0 : P.pageInfo);
    }
  }, [y, n]);
  const x = () => {
    !b && l !== "" && N === Yn.ready ? (p(!0), v({
      variables: {
        issueQuery: l,
        first: 8,
        after: r == null ? void 0 : r.endCursor
      }
    })) : s([]);
  };
  return /* @__PURE__ */ F.jsx(C, { flexDirection: "column", gap: "200", "data-testid": "searchBarWrapper", children: /* @__PURE__ */ F.jsxs(
    Qt,
    {
      "data-testid": "searchBarComponent",
      clearable: !0,
      getItemTitleByValue: (T) => T == null ? void 0 : T.title,
      onChange: (T) => e(T.selectedValues[0]),
      dropdownProps: { className: Wo.dropdown },
      filter: {
        value: l,
        onChange: (T) => {
          const $ = T.target.value;
          c($);
        }
      },
      placeholder: "Search Linear issues",
      children: [
        o == null ? void 0 : o.map((T) => /* @__PURE__ */ F.jsx(nI, { issue: T }, T.id)),
        (r == null ? void 0 : r.hasNextPage) && !b && l !== "" && o.length && /* @__PURE__ */ F.jsx(
          C,
          {
            gap: "100",
            justifyContent: "center",
            padding: "200",
            alignItems: "center",
            onClick: () => x(),
            className: Wo.loadMore,
            children: /* @__PURE__ */ F.jsx(se.Paragraph, { variant: "3", children: "Load more ..." })
          }
        ),
        b && l !== "" && /* @__PURE__ */ F.jsx(C, { justifyContent: "center", className: Wo.loader, children: /* @__PURE__ */ F.jsx(ln, { size: 24 }) }),
        l === "" && o.length === 0 && /* @__PURE__ */ F.jsx(
          C,
          {
            justifyContent: "center",
            style: { margin: tn.spacer[250] },
            children: /* @__PURE__ */ F.jsx(se.Paragraph, { variant: "3", color: $e.neutral[400], children: "Enter issue title or description" })
          }
        ),
        o.length === 0 && l !== "" && !b && /* @__PURE__ */ F.jsx(
          C,
          {
            justifyContent: "center",
            style: { margin: tn.spacer[250] },
            children: /* @__PURE__ */ F.jsx(se.Paragraph, { variant: "3", color: $e.neutral[400], children: "No Linear issues found" })
          }
        )
      ]
    }
  ) });
}, oI = "_collapse_1rxyf_27", sI = "_collapseHeader_1rxyf_34", lI = "_collapseContent_1rxyf_57", cI = "_url_1rxyf_61", dI = "_empty_1rxyf_73", uI = "_externalLink_1rxyf_77", mI = "_emptyState_1rxyf_81", Tt = {
  collapse: oI,
  collapseHeader: sI,
  collapseContent: lI,
  url: cI,
  empty: dI,
  externalLink: uI,
  emptyState: mI
}, pI = ({
  linkedIssues: e,
  isLoading: n,
  handleUnlinkIssue: r,
  showUnlinkAllModal: i,
  showUnlinkAllButton: o,
  organizationUrl: s
}) => {
  const l = e.reduce(
    (m, v) => ({ ...m, [v.id]: !1 }),
    {}
  ), [c, u] = G(l), { track: p } = sn();
  return n ? /* @__PURE__ */ F.jsx(
    C,
    {
      flexDirection: "column",
      margin: "0 0 400 0",
      justifyContent: "center",
      alignItems: "center",
      children: /* @__PURE__ */ F.jsx(ln, { size: 24 })
    }
  ) : e.length === 0 ? /* @__PURE__ */ F.jsxs(
    C,
    {
      flexDirection: "column",
      justifyContent: "center",
      margin: "0 0 300 0",
      gap: "300",
      children: [
        /* @__PURE__ */ F.jsx(
          se.Paragraph,
          {
            align: "center",
            variant: "3",
            color: $e.neutral[400],
            className: Tt.emptyState,
            children: "No linked issues found"
          }
        ),
        /* @__PURE__ */ F.jsx(
          rt,
          {
            slotEnd: /* @__PURE__ */ F.jsx(Fe, { name: "external-link" }),
            variant: "tertiary",
            className: Tt.externalLink,
            navigate: () => {
              var m, v, y;
              return (y = window.open(
                `https://linear.app/${((v = (m = e[0]) == null ? void 0 : m.team) == null ? void 0 : v.organization.urlKey) ?? ""}`,
                "_blank"
              )) == null ? void 0 : y.focus();
            },
            children: "Open Linear"
          }
        )
      ]
    }
  ) : /* @__PURE__ */ F.jsxs(
    C,
    {
      flexDirection: "column",
      gap: "250",
      margin: "0 0 400 0",
      "data-testid": "linkedIssueWrapper",
      children: [
        e.map((m) => {
          var v, y, b;
          const N = c[m.id];
          return /* @__PURE__ */ F.jsxs(
            Kn,
            {
              "data-testid": "collapseCard",
              onToggle: () => u({ ...c, [m.id]: !c[m.id] }),
              isOpen: N,
              className: Tt.collapse,
              children: [
                /* @__PURE__ */ F.jsx(Kn.Header, { className: Tt.collapseHeader, children: /* @__PURE__ */ F.jsxs(C, { flexDirection: "column", gap: "100", children: [
                  /* @__PURE__ */ F.jsxs(C, { flexDirection: "row", justifyContent: "space-between", children: [
                    /* @__PURE__ */ F.jsxs(C, { gap: "100", alignItems: "center", children: [
                      /* @__PURE__ */ F.jsx(
                        jn,
                        {
                          content: /* @__PURE__ */ F.jsx(C, { children: m.state.name }),
                          dark: !0,
                          children: /* @__PURE__ */ F.jsx(C, { alignSelf: "center", children: /* @__PURE__ */ F.jsx(
                            va,
                            {
                              type: m.state.type,
                              color: m.state.color,
                              name: m.state.name
                            }
                          ) })
                        }
                      ),
                      /* @__PURE__ */ F.jsxs(
                        se.ExternalLink,
                        {
                          className: Tt.url,
                          href: m.url,
                          target: "_blank",
                          rel: "noreferrer",
                          children: [
                            m.identifier,
                            /* @__PURE__ */ F.jsx(Fe, { name: "external-link" })
                          ]
                        }
                      ),
                      /* @__PURE__ */ F.jsx(
                        jn,
                        {
                          content: /* @__PURE__ */ F.jsx(C, { children: m.priorityLabel }),
                          dark: !0,
                          children: /* @__PURE__ */ F.jsx(C, { alignSelf: "center", children: /* @__PURE__ */ F.jsx(fa, { priority: m.priority }) })
                        }
                      )
                    ] }),
                    /* @__PURE__ */ F.jsx(an, { children: m.state.name })
                  ] }),
                  m.title
                ] }) }),
                /* @__PURE__ */ F.jsx(Kn.Content, { className: Tt.collapseContent, children: /* @__PURE__ */ F.jsxs(C, { flexDirection: "column", gap: "300", children: [
                  (m == null ? void 0 : m.labels) && ((y = (v = m == null ? void 0 : m.labels) == null ? void 0 : v.edges) == null ? void 0 : y.length) > 0 && /* @__PURE__ */ F.jsx(
                    C,
                    {
                      flexDirection: "row",
                      gap: "200",
                      alignItems: "center",
                      flexWrap: "wrap",
                      children: (b = m.labels) == null ? void 0 : b.edges.map((x) => /* @__PURE__ */ F.jsx(an, { color: x.node.color, children: x.node.name }, x.node.id))
                    }
                  ),
                  /* @__PURE__ */ F.jsx(nv, { issue: m }),
                  /* @__PURE__ */ F.jsx(
                    On,
                    {
                      slotStart: /* @__PURE__ */ F.jsx(Fe, { name: "link-slash" }),
                      variant: "secondary",
                      onClick: () => r(m.id),
                      style: { marginTop: tn.spacer[200] },
                      children: "Unlink issue from Linear"
                    }
                  ),
                  /* @__PURE__ */ F.jsxs(
                    rt,
                    {
                      slotEnd: /* @__PURE__ */ F.jsx(Fe, { name: "external-link" }),
                      variant: "tertiary",
                      className: Tt.externalLink,
                      onClick: () => {
                        p("linear:open:issue:clicked", {
                          linearInstanceUrl: s,
                          linearIssueKey: m.id
                        });
                      },
                      navigate: () => {
                        var x;
                        return (x = window.open(m.url, "_blank")) == null ? void 0 : x.focus();
                      },
                      children: [
                        "View ",
                        m.identifier,
                        " in Linear"
                      ]
                    }
                  )
                ] }) })
              ]
            },
            m.id
          );
        }),
        e.length > 1 && o && /* @__PURE__ */ F.jsx(
          On,
          {
            slotStart: /* @__PURE__ */ F.jsx(Fe, { name: "link-slash" }),
            variant: "secondary",
            onClick: () => i(!0),
            children: "Unlink all issues"
          }
        ),
        /* @__PURE__ */ F.jsx(
          rt,
          {
            slotEnd: /* @__PURE__ */ F.jsx(Fe, { name: "external-link" }),
            variant: "tertiary",
            className: Tt.externalLink,
            onClick: () => {
              p("linear:open:linear:clicked", {
                // we check against empty linkedIssues earlier in the code.
                // function is using item at index 0 since all teams belong in the same organization/workspace,
                linearInstanceUrl: s,
                linearIssueKey: e[0].id
              });
            },
            disabled: !s,
            navigate: () => {
              var m;
              return (m = window.open(s, "_blank")) == null ? void 0 : m.focus();
            },
            children: "Open Linear"
          }
        )
      ]
    }
  );
}, fI = "_modalBody_d4g53_27", vI = "_error_d4g53_31", yI = "_emptyState_d4g53_35", gI = "_dropdown_d4g53_42", yr = {
  modalBody: fI,
  error: vI,
  emptyState: yI,
  dropdown: gI
}, hI = bi(
  /* GraphQL */
  `
  mutation createIssue(
    $issueTitle: String!
    $issueDescription: String
    $teamId: String!
    $projectId: String
    $statusId: String
    $priority: Int
  ) {
    Linear {
      issueCreate(
        input: {
          title: $issueTitle
          description: $issueDescription
          teamId: $teamId
          projectId: $projectId
          stateId: $statusId
          priority: $priority
        }
      ) {
        success
        issue {
          id
          title
          identifier
          url
        }
      }
    }
  }
`
), kI = bi(
  /* GraphQL */
  `
  query staticData {
    Linear {
      teams {
        edges {
          node {
            id
            name
            organization {
              urlKey
            }
          }
        }
      }
      issuePriorityValues {
        priority
        label
      }
      organization {
        urlKey
      }
    }
  }
`
), bI = bi(
  /* GraphQL */
  `
  query teamData($teamId: String!) {
    Linear {
      team(id: $teamId) {
        projects {
          edges {
            node {
              id
              name
            }
          }
        }
        states {
          edges {
            node {
              id
              name
              type
              color
            }
          }
        }
        templates {
          edges {
            node {
              id
              name
              type
              templateData
            }
          }
        }
      }
    }
  }
`
), _I = ({
  setCreatedIssue: e,
  isCreateIssueModalOpen: n,
  setIsCreateIssueModalOpen: r,
  setIsCreationSuccessfulModalOpen: i,
  addToLinkedIssueIds: o,
  organizationUrl: s,
  setOrganizationUrl: l
}) => {
  const { useLazyQuery: c, showNotification: u } = rn(), { control: p, handleSubmit: m, reset: v } = kl(), [y, b] = G([]), [N, x] = G(), [T, $] = G([]), [P, h] = G(), [E, q] = G([]), [M, R] = G(), [w, H] = G([]), [pe, le] = G(), [Se, ae] = G([]), [D, V] = G(), [de, te] = G(!1), { useMutation: he } = rn(), { track: _e } = sn(), [Z, { loading: J }] = he(
    hI,
    {
      onError: () => u({
        title: "Creation was not successful",
        text: "Please try again later or contact your admin.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }),
      onCompleted: (W) => {
        var ce, ie, oe, be, Ee, Ie, we, Ge, je, Te, Ye, Ae;
        const Be = {
          identifier: (oe = (ie = (ce = W.Linear) == null ? void 0 : ce.issueCreate) == null ? void 0 : ie.issue) == null ? void 0 : oe.identifier,
          url: (Ie = (Ee = (be = W.Linear) == null ? void 0 : be.issueCreate) == null ? void 0 : Ee.issue) == null ? void 0 : Ie.url
        };
        W.Linear && !J && (je = (Ge = (we = W.Linear) == null ? void 0 : we.issueCreate) == null ? void 0 : Ge.issue) != null && je.id && (o((Ae = (Ye = (Te = W.Linear) == null ? void 0 : Te.issueCreate) == null ? void 0 : Ye.issue) == null ? void 0 : Ae.id), ge(Be), te(!1), u({
          title: "Issue was created and linked to the conversation",
          text: `Issue ${W.Linear.issueCreate.issue.identifier} was created and added to the active conversation`,
          icon: "exclamation-triangle-filled",
          severity: "success"
        }), _e("linear:create:new:issue:confirmed", {
          linearInstanceUrl: s
        }));
      }
    }
  ), [z, { data: me, loading: ke }] = c(kI, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => u({
      title: "Error while fetching team ID",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (W) => {
      const ce = W.Linear.teams.edges.map(
        ({ node: ie }) => ie
      );
      b(ce), H(W.Linear.issuePriorityValues), l(`${II}${W.Linear.organization.urlKey}`);
    }
  }), [Oe, { data: Y, loading: fe }] = c(bI, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => u({
      title: "Error while fetching team projects",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (W) => {
      var ce, ie, oe, be, Ee, Ie, we, Ge, je, Te, Ye, Ae;
      const Be = (be = (oe = (ie = (ce = W == null ? void 0 : W.Linear) == null ? void 0 : ce.team) == null ? void 0 : ie.projects) == null ? void 0 : oe.edges) == null ? void 0 : be.map(
        ({ node: en }) => en
      );
      $(Be);
      const De = (Ge = (we = (Ie = (Ee = W == null ? void 0 : W.Linear) == null ? void 0 : Ee.team) == null ? void 0 : Ie.states) == null ? void 0 : we.edges) == null ? void 0 : Ge.map(
        ({ node: en }) => en
      );
      q(De);
      const cn = (Ae = (Ye = (Te = (je = W == null ? void 0 : W.Linear) == null ? void 0 : je.team) == null ? void 0 : Te.templates) == null ? void 0 : Ye.edges) == null ? void 0 : Ae.map(
        ({ node: en }) => en
      );
      ae(
        cn.filter(
          (en) => en.type === "issue"
        )
      );
    }
  }), ge = (W) => {
    r(!1), h(void 0), x(void 0), R(void 0), le(void 0), V(void 0), W && (e(W), i(!0)), v({
      title: "",
      description: "",
      projectId: "",
      teamId: "",
      statusId: "",
      priority: void 0
    });
  }, X = (W) => {
    var ce, ie, oe;
    me && !ke && (Z({
      variables: {
        issueTitle: W.title,
        issueDescription: W == null ? void 0 : W.description,
        teamId: W.team.id,
        projectId: (ce = W == null ? void 0 : W.project) == null ? void 0 : ce.id,
        statusId: (ie = W == null ? void 0 : W.status) == null ? void 0 : ie.id,
        priority: (oe = W == null ? void 0 : W.priority) == null ? void 0 : oe.priority
      }
    }), te(!0));
  };
  Jv(() => {
    z();
  });
  const ye = () => {
    _e("linear:create:new:issue:cancelled", {
      linearInstanceUrl: s
    });
  };
  return /* @__PURE__ */ F.jsxs(
    jt,
    {
      isOpen: n,
      onClose: () => {
        ye(), ge();
      },
      children: [
        /* @__PURE__ */ F.jsx(
          Ct,
          {
            title: "Create new Linear issue",
            onClose: () => {
              ye(), ge();
            }
          }
        ),
        /* @__PURE__ */ F.jsx(
          Et,
          {
            className: yr.modalBody,
            "data-testid": "createIssueModalBody",
            children: /* @__PURE__ */ F.jsx("form", { onSubmit: m(X), id: "issueCreationForm", children: /* @__PURE__ */ F.jsxs(Ar, { children: [
              /* @__PURE__ */ F.jsx(wn, { span: 3, children: /* @__PURE__ */ F.jsx(
                nt,
                {
                  control: p,
                  name: "team",
                  rules: {
                    required: "Team is required"
                  },
                  render: ({
                    field: { value: W, onChange: ce },
                    fieldState: { error: ie }
                  }) => /* @__PURE__ */ F.jsx(
                    Fn,
                    {
                      required: !0,
                      label: "Team",
                      meta: {
                        error: (ie == null ? void 0 : ie.message) ?? null
                      },
                      children: /* @__PURE__ */ F.jsx(
                        Qt,
                        {
                          dropdownProps: { className: yr.dropdown },
                          placeholder: "Select Linear team",
                          className: It({ [yr.error]: ie }),
                          getItemTitleByValue: (oe) => oe == null ? void 0 : oe.name,
                          onChange: (oe) => {
                            h(void 0), R(void 0), le(void 0), V(void 0), x(oe.selectedValues[0]), Oe({
                              variables: { teamId: oe.selectedValues[0].id }
                            }), ce(oe.selectedValues[0]);
                          },
                          value: N ? [W] : void 0,
                          children: y == null ? void 0 : y.map((oe) => /* @__PURE__ */ F.jsx(
                            Jt.Item,
                            {
                              value: oe,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ F.jsx(se.Paragraph, { children: oe.name })
                            },
                            oe.id
                          ))
                        }
                      )
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ F.jsx(wn, { span: 3, children: /* @__PURE__ */ F.jsx(
                nt,
                {
                  control: p,
                  name: "project",
                  render: ({ field: { value: W, onChange: ce } }) => {
                    const ie = fe ? [{ name: "Loading projects...", id: "" }] : void 0;
                    return /* @__PURE__ */ F.jsx(Fn, { label: "Project", children: /* @__PURE__ */ F.jsx(
                      Qt,
                      {
                        dropdownProps: { className: yr.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (oe) => oe == null ? void 0 : oe.name,
                        disabled: N === void 0,
                        placeholder: N ? "Select Linear project" : "Select a Team first",
                        onChange: (oe) => {
                          h(oe.selectedValues[0]), ce(oe.selectedValues[0]);
                        },
                        value: P ? [W] : ie,
                        children: /* @__PURE__ */ F.jsxs(F.Fragment, { children: [
                          fe && /* @__PURE__ */ F.jsx(
                            C,
                            {
                              justifyContent: "center",
                              style: { padding: tn.spacer[200] },
                              children: /* @__PURE__ */ F.jsx(ln, { size: 24 })
                            }
                          ),
                          Y && !fe && T.map((oe) => /* @__PURE__ */ F.jsx(
                            Jt.Item,
                            {
                              value: oe,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ F.jsx(se.Paragraph, { children: oe.name })
                            },
                            oe.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ F.jsx(wn, { span: 6, children: /* @__PURE__ */ F.jsx(Fn, { label: "Template", children: /* @__PURE__ */ F.jsx(
                Qt,
                {
                  clearable: !0,
                  dropdownProps: { className: yr.dropdown },
                  disabled: !N || fe,
                  placeholder: N ? "Select template" : "Select a Team first",
                  getItemTitleByValue: (W) => W == null ? void 0 : W.name,
                  onChange: (W) => {
                    if (W.selectedValues.length > 0) {
                      V(W.selectedValues[0]);
                      const ce = JSON.parse(
                        W.selectedValues[0].templateData
                      ), ie = w.filter(
                        (Ie) => Ie.priority === ce.priority
                      );
                      le(
                        ie ? ie[0] : void 0
                      );
                      const oe = E.filter(
                        (Ie) => Ie.id === ce.stateId
                      );
                      R(
                        oe ? oe[0] : void 0
                      );
                      const be = T.filter(
                        (Ie) => Ie.id === ce.projectId
                      );
                      h(
                        be ? be[0] : void 0
                      );
                      const Ee = ce.descriptionData;
                      v({
                        title: ce == null ? void 0 : ce.title,
                        priority: ie[0],
                        status: oe[0],
                        project: be[0],
                        description: Ee ? rc(Ee, TF) : "",
                        team: N
                      });
                    } else
                      v({
                        title: "",
                        description: "",
                        team: N
                      }), h(void 0), le(void 0), R(void 0), V(void 0);
                  },
                  value: D ? [D] : void 0,
                  children: Se == null ? void 0 : Se.map((W) => /* @__PURE__ */ F.jsx(
                    Jt.Item,
                    {
                      value: W,
                      noFixedSelectionStateSpace: !0,
                      children: /* @__PURE__ */ F.jsx(se.Paragraph, { children: W.name })
                    },
                    W.id
                  ))
                }
              ) }) }),
              /* @__PURE__ */ F.jsx(wn, { span: 6, children: /* @__PURE__ */ F.jsx(
                nt,
                {
                  control: p,
                  name: "title",
                  rules: {
                    required: "Title field is required",
                    minLength: 2
                  },
                  render: ({
                    field: { onChange: W, value: ce },
                    fieldState: { error: ie }
                  }) => /* @__PURE__ */ F.jsx(
                    Lt,
                    {
                      required: !0,
                      label: "Title",
                      placeholder: "Insert issue title here",
                      input: {
                        name: "issueTitle",
                        value: ce || "",
                        onChange: W
                      },
                      meta: {
                        error: (ie == null ? void 0 : ie.message) ?? null
                      }
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ F.jsx(wn, { span: 3, children: /* @__PURE__ */ F.jsx(
                nt,
                {
                  control: p,
                  name: "status",
                  render: ({ field: { value: W, onChange: ce } }) => {
                    const ie = fe ? [
                      {
                        name: "Loading statuses...",
                        id: "",
                        type: "",
                        color: ""
                      }
                    ] : void 0;
                    return /* @__PURE__ */ F.jsx(Fn, { label: "Status", children: /* @__PURE__ */ F.jsx(
                      Qt,
                      {
                        dropdownProps: { className: yr.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (oe) => oe == null ? void 0 : oe.name,
                        disabled: N === void 0,
                        placeholder: N ? "Select Issue status" : "Select a Team first",
                        onChange: (oe) => {
                          R(oe.selectedValues[0]), ce(oe.selectedValues[0]);
                        },
                        value: M ? [W] : ie,
                        children: /* @__PURE__ */ F.jsxs(F.Fragment, { children: [
                          fe && /* @__PURE__ */ F.jsx(
                            C,
                            {
                              justifyContent: "center",
                              style: { padding: tn.spacer[200] },
                              children: /* @__PURE__ */ F.jsx(ln, { size: 24 })
                            }
                          ),
                          Y && !fe && E.map((oe) => /* @__PURE__ */ F.jsx(
                            Jt.Item,
                            {
                              value: oe,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ F.jsxs(
                                C,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ F.jsx(
                                      va,
                                      {
                                        type: oe.type,
                                        color: oe.color,
                                        name: oe.name
                                      }
                                    ),
                                    /* @__PURE__ */ F.jsx(se.Paragraph, { children: oe.name })
                                  ]
                                }
                              )
                            },
                            oe.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ F.jsx(wn, { span: 3, children: /* @__PURE__ */ F.jsx(
                nt,
                {
                  control: p,
                  name: "priority",
                  render: ({ field: { value: W, onChange: ce } }) => {
                    const ie = ke ? [
                      {
                        label: "Loading Priorities...",
                        priority: 0
                      }
                    ] : void 0;
                    return /* @__PURE__ */ F.jsx(Fn, { label: "Priority", children: /* @__PURE__ */ F.jsx(
                      Qt,
                      {
                        clearable: !0,
                        getItemTitleByValue: (oe) => oe == null ? void 0 : oe.label,
                        disabled: N === void 0,
                        placeholder: N ? "Select Issue priority" : "Select a Team first",
                        onChange: (oe) => {
                          le(oe.selectedValues[0]), ce(oe.selectedValues[0]);
                        },
                        value: pe ? [W] : ie,
                        children: /* @__PURE__ */ F.jsxs(F.Fragment, { children: [
                          fe && /* @__PURE__ */ F.jsx(
                            C,
                            {
                              justifyContent: "center",
                              style: { padding: tn.spacer[200] },
                              children: /* @__PURE__ */ F.jsx(ln, { size: 24 })
                            }
                          ),
                          me && !ke && w.map((oe) => /* @__PURE__ */ F.jsx(
                            Jt.Item,
                            {
                              value: oe,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ F.jsxs(
                                C,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ F.jsx(fa, { priority: oe.priority }),
                                    /* @__PURE__ */ F.jsx(se.Paragraph, { children: oe.label })
                                  ]
                                }
                              )
                            },
                            oe.priority
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ F.jsx(wn, { children: /* @__PURE__ */ F.jsx(
                nt,
                {
                  control: p,
                  name: "description",
                  render: ({
                    field: { onChange: W, value: ce },
                    fieldState: { error: ie }
                  }) => /* @__PURE__ */ F.jsx(
                    Dv,
                    {
                      label: "Description",
                      placeholder: "Insert Issue description here",
                      input: {
                        name: "description",
                        value: ce || "",
                        onChange: W
                      },
                      meta: {
                        error: (ie == null ? void 0 : ie.message) ?? null
                      }
                    }
                  )
                }
              ) })
            ] }) })
          }
        ),
        /* @__PURE__ */ F.jsx(
          Mt,
          {
            confirmOnClick: m(X),
            confirmProps: {
              disabled: J || !me,
              isLoading: de || ke || fe,
              loadingIndicator: /* @__PURE__ */ F.jsx(ln, { size: 16 })
            },
            confirmName: "Save",
            cancelOnClick: () => {
              ye(), ge();
            }
          }
        )
      ]
    }
  );
}, SI = "_modalWrapper_epi3e_27", NI = "_copyButton_epi3e_32", xI = "_copyWrapper_epi3e_41", wI = "_copyField_epi3e_50", jI = "_externalLink_epi3e_73", CI = "_externalLinkIcon_epi3e_78", EI = "_textWrapper_epi3e_82", Gt = {
  modalWrapper: SI,
  copyButton: NI,
  copyWrapper: xI,
  copyField: wI,
  externalLink: jI,
  externalLinkIcon: CI,
  textWrapper: EI
}, FI = ({
  isCreationSuccessfulModalOpen: e,
  createdIssueData: n,
  setIsCreationSuccessfulModalOpen: r
}) => /* @__PURE__ */ F.jsxs(
  jt,
  {
    isOpen: !!n && e,
    className: Gt.modalWrapper,
    onClose: () => r(!1),
    children: [
      /* @__PURE__ */ F.jsx(
        Ct,
        {
          title: "Issue creation successful",
          onClose: () => r(!1)
        }
      ),
      /* @__PURE__ */ F.jsx(Et, { children: /* @__PURE__ */ F.jsxs(
        C,
        {
          gap: "300",
          flexDirection: "column",
          "data-testid": "creationSuccessfulModal",
          children: [
            /* @__PURE__ */ F.jsxs(se.Paragraph, { className: Gt.textWrapper, children: [
              `You can visit issue ${n == null ? void 0 : n.identifier} by following `,
              " ",
              /* @__PURE__ */ F.jsxs(
                se.ExternalLink,
                {
                  href: n == null ? void 0 : n.url,
                  target: "_blank",
                  className: Gt.externalLink,
                  children: [
                    "this link",
                    " ",
                    /* @__PURE__ */ F.jsx(Fe, { name: "external-link", className: Gt.externalLinkIcon })
                  ]
                }
              ),
              "or copy it from the field below."
            ] }),
            /* @__PURE__ */ F.jsx(Fn, { label: "Linear issue link", children: /* @__PURE__ */ F.jsxs(
              C,
              {
                flexDirection: "row",
                alignItems: "center",
                "data-testid": "copyInputField",
                className: Gt.copyWrapper,
                children: [
                  /* @__PURE__ */ F.jsx(
                    St,
                    {
                      readOnly: !0,
                      value: n == null ? void 0 : n.url,
                      className: Gt.copyField
                    }
                  ),
                  /* @__PURE__ */ F.jsx(
                    Pv,
                    {
                      className: Gt.copyButton,
                      textToCopy: (n == null ? void 0 : n.url) || "",
                      clickedProps: {
                        icon: "check-circle-filled"
                      }
                    }
                  )
                ]
              }
            ) })
          ]
        }
      ) }),
      /* @__PURE__ */ F.jsx(
        Mt,
        {
          cancelOnClick: () => r(!1),
          cancelProps: { variant: "primary" },
          cancelName: "Close"
        }
      )
    ]
  }
), II = "https://linear.app/", $I = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = G([]), [o, s] = G([]), [l, c] = G(!1), [u, p] = G(!1), [m, v] = G(!1), [y, b] = G(), { useLazyQuery: N } = rn(), [x, T] = G(""), $ = n == null ? void 0 : n.enableCreateIssue, P = !!(n != null && n.enableUnlinkAll), { track: h } = sn(), {
    loading: E,
    data: q,
    error: M,
    store: R
  } = fl((e == null ? void 0 : e.conversationId) ?? null), [w, { data: H, loading: pe, networkStatus: le }] = N(
    _F,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0
    }
  );
  Pe(() => {
    var V, de;
    !E && !M && q && ((de = (V = q == null ? void 0 : q.linear) == null ? void 0 : V.issues) == null ? void 0 : de.length) > 0 && (s(q.linear.issues), w({
      variables: {
        linkedIssues: q.linear.issues
      }
    }));
  }, [q, E, M]), Pe(() => {
    var V, de;
    H && H != null && H.Linear && !pe && le === Yn.ready && Object.keys(H).length > 0 && i((de = (V = H.Linear.issues) == null ? void 0 : V.edges) == null ? void 0 : de.map(({ node: te }) => te));
  }, [H, pe, le]);
  const Se = (V) => {
    var de, te;
    V && (te = (de = V == null ? void 0 : V.team) == null ? void 0 : de.organization) != null && te.urlKey && h("linear:link:issue:clicked", {
      linearInstanceUrl: x,
      linearIssueKey: V.id
    });
    const he = (_e) => _e.id === (V == null ? void 0 : V.id);
    r.some((_e) => _e && he(_e)) || (q && o.length === 0 && s([]), R({
      linear: {
        issues: [...o, V.id]
      }
    }));
  }, ae = (V) => {
    const de = (q == null ? void 0 : q.linear.issues.filter((te) => te !== V)) || [];
    h("linear:unlink:issue:clicked", {
      linearInstanceUrl: x,
      linearIssueKey: V
    }), i(r.filter(({ id: te }) => te !== V)), s(de), R({
      linear: {
        issues: de
      }
    });
  }, D = () => {
    c(!1), i([]), s([]), R({
      linear: {
        issues: []
      }
    });
  };
  return /* @__PURE__ */ F.jsxs(C, { flexDirection: "column", gap: "300", children: [
    /* @__PURE__ */ F.jsxs(
      jt,
      {
        isOpen: l,
        onClose: () => c(!1),
        children: [
          /* @__PURE__ */ F.jsx(
            Ct,
            {
              title: "Unlink all Linear issues?",
              onClose: () => c(!1)
            }
          ),
          /* @__PURE__ */ F.jsx(Et, { "data-testid": "unlinkAllIssuesModalBody", children: "You are about to unlink all Linear issues from the conversation. Do you want to proceed?" }),
          /* @__PURE__ */ F.jsx(
            Mt,
            {
              confirmOnClick: () => D(),
              confirmName: "Unlink all",
              cancelOnClick: () => c(!1)
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ F.jsx(
      _I,
      {
        isCreateIssueModalOpen: u,
        setIsCreateIssueModalOpen: (V) => p(V),
        setIsCreationSuccessfulModalOpen: (V) => v(V),
        addToLinkedIssueIds: (V) => {
          R({
            linear: {
              issues: [...o, V]
            }
          });
        },
        setCreatedIssue: (V) => b(V),
        organizationUrl: x,
        setOrganizationUrl: (V) => T(V)
      }
    ),
    /* @__PURE__ */ F.jsx(
      FI,
      {
        isCreationSuccessfulModalOpen: m,
        setIsCreationSuccessfulModalOpen: (V) => v(V),
        createdIssueData: y
      }
    ),
    /* @__PURE__ */ F.jsxs(
      C,
      {
        flexDirection: "column",
        background: $e.neutral[100],
        padding: tn.spacer[300],
        borderRadius: tn["border-radius"][100],
        gap: "250",
        children: [
          $ && /* @__PURE__ */ F.jsxs(F.Fragment, { children: [
            /* @__PURE__ */ F.jsx(
              On,
              {
                variant: "primary",
                onClick: () => {
                  h("linear:create:new:issue:clicked", {
                    linearInstanceUrl: x
                  }), p(!0);
                },
                style: { minHeight: "38px" },
                children: "Create new issue"
              }
            ),
            /* @__PURE__ */ F.jsx(se.Paragraph, { color: $e.neutral[600], align: "center", children: "or" })
          ] }),
          /* @__PURE__ */ F.jsx(aI, { handleSelect: Se, linkedIssues: r })
        ]
      }
    ),
    /* @__PURE__ */ F.jsx(
      pI,
      {
        linkedIssues: r,
        isLoading: pe,
        handleUnlinkIssue: ae,
        showUnlinkAllModal: (V) => c(V),
        showUnlinkAllButton: P,
        organizationUrl: x
      }
    )
  ] });
}, TI = [
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableUnlinkAll",
    label: 'Enable the "Unlink all" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: ga
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._wrapper_1h8wu_27{border-radius:4px;padding:16px;background-color:#f5f7fa}._textVariant_1h8wu_33{color:#46597c;font-size:14px}._copyIcon_1h8wu_38{cursor:pointer;color:#46597c}._labelText_q61tw_27{color:#46597c}._list_q61tw_31{padding:0}._listItem_q61tw_34{padding:4px;border-bottom:1px solid #e7ecf3}._listItem_q61tw_34:last-child{border-bottom:none}._listItemEdit_q61tw_41{cursor:pointer}._notificationText_q61tw_45{color:#8193b0}._modalBody_e1wm6_27{width:400px}._reward_gayxn_27{border:1px solid #d7dfea;border-radius:4px;padding:12px}._reward_gayxn_27:hover{border-color:#b5c1d4}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var il = { exports: {} }, gr = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Yo, Au;
function rv() {
  if (Au)
    return Yo;
  Au = 1;
  var e = Object.getOwnPropertySymbols, n = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function i(s) {
    if (s == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(s);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var s = new String("abc");
      if (s[5] = "de", Object.getOwnPropertyNames(s)[0] === "5")
        return !1;
      for (var l = {}, c = 0; c < 10; c++)
        l["_" + String.fromCharCode(c)] = c;
      var u = Object.getOwnPropertyNames(l).map(function(m) {
        return l[m];
      });
      if (u.join("") !== "0123456789")
        return !1;
      var p = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(m) {
        p[m] = m;
      }), Object.keys(Object.assign({}, p)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Yo = o() ? Object.assign : function(s, l) {
    for (var c, u = i(s), p, m = 1; m < arguments.length; m++) {
      c = Object(arguments[m]);
      for (var v in c)
        n.call(c, v) && (u[v] = c[v]);
      if (e) {
        p = e(c);
        for (var y = 0; y < p.length; y++)
          r.call(c, p[y]) && (u[p[y]] = c[p[y]]);
      }
    }
    return u;
  }, Yo;
}
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Lu;
function OI() {
  if (Lu)
    return gr;
  Lu = 1, rv();
  var e = Cn, n = 60103;
  if (gr.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var r = Symbol.for;
    n = r("react.element"), gr.Fragment = r("react.fragment");
  }
  var i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = Object.prototype.hasOwnProperty, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(c, u, p) {
    var m, v = {}, y = null, b = null;
    p !== void 0 && (y = "" + p), u.key !== void 0 && (y = "" + u.key), u.ref !== void 0 && (b = u.ref);
    for (m in u)
      o.call(u, m) && !s.hasOwnProperty(m) && (v[m] = u[m]);
    if (c && c.defaultProps)
      for (m in u = c.defaultProps, u)
        v[m] === void 0 && (v[m] = u[m]);
    return { $$typeof: n, type: c, key: y, ref: b, props: v, _owner: i.current };
  }
  return gr.jsx = l, gr.jsxs = l, gr;
}
var Uu = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Mu;
function RI() {
  return Mu || (Mu = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      var n = Cn, r = rv(), i = 60103, o = 60106;
      e.Fragment = 60107;
      var s = 60108, l = 60114, c = 60109, u = 60110, p = 60112, m = 60113, v = 60120, y = 60115, b = 60116, N = 60121, x = 60122, T = 60117, $ = 60129, P = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var h = Symbol.for;
        i = h("react.element"), o = h("react.portal"), e.Fragment = h("react.fragment"), s = h("react.strict_mode"), l = h("react.profiler"), c = h("react.provider"), u = h("react.context"), p = h("react.forward_ref"), m = h("react.suspense"), v = h("react.suspense_list"), y = h("react.memo"), b = h("react.lazy"), N = h("react.block"), x = h("react.server.block"), T = h("react.fundamental"), h("react.scope"), h("react.opaque.id"), $ = h("react.debug_trace_mode"), h("react.offscreen"), P = h("react.legacy_hidden");
      }
      var E = typeof Symbol == "function" && Symbol.iterator, q = "@@iterator";
      function M(t) {
        if (t === null || typeof t != "object")
          return null;
        var a = E && t[E] || t[q];
        return typeof a == "function" ? a : null;
      }
      var R = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function w(t) {
        {
          for (var a = arguments.length, d = new Array(a > 1 ? a - 1 : 0), f = 1; f < a; f++)
            d[f - 1] = arguments[f];
          H("error", t, d);
        }
      }
      function H(t, a, d) {
        {
          var f = R.ReactDebugCurrentFrame, _ = f.getStackAddendum();
          _ !== "" && (a += "%s", d = d.concat([_]));
          var S = d.map(function(k) {
            return "" + k;
          });
          S.unshift("Warning: " + a), Function.prototype.apply.call(console[t], console, S);
        }
      }
      var pe = !1;
      function le(t) {
        return !!(typeof t == "string" || typeof t == "function" || t === e.Fragment || t === l || t === $ || t === s || t === m || t === v || t === P || pe || typeof t == "object" && t !== null && (t.$$typeof === b || t.$$typeof === y || t.$$typeof === c || t.$$typeof === u || t.$$typeof === p || t.$$typeof === T || t.$$typeof === N || t[0] === x));
      }
      function Se(t, a, d) {
        var f = a.displayName || a.name || "";
        return t.displayName || (f !== "" ? d + "(" + f + ")" : d);
      }
      function ae(t) {
        return t.displayName || "Context";
      }
      function D(t) {
        if (t == null)
          return null;
        if (typeof t.tag == "number" && w("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof t == "function")
          return t.displayName || t.name || null;
        if (typeof t == "string")
          return t;
        switch (t) {
          case e.Fragment:
            return "Fragment";
          case o:
            return "Portal";
          case l:
            return "Profiler";
          case s:
            return "StrictMode";
          case m:
            return "Suspense";
          case v:
            return "SuspenseList";
        }
        if (typeof t == "object")
          switch (t.$$typeof) {
            case u:
              var a = t;
              return ae(a) + ".Consumer";
            case c:
              var d = t;
              return ae(d._context) + ".Provider";
            case p:
              return Se(t, t.render, "ForwardRef");
            case y:
              return D(t.type);
            case N:
              return D(t._render);
            case b: {
              var f = t, _ = f._payload, S = f._init;
              try {
                return D(S(_));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var V = 0, de, te, he, _e, Z, J, z;
      function me() {
      }
      me.__reactDisabledLog = !0;
      function ke() {
        {
          if (V === 0) {
            de = console.log, te = console.info, he = console.warn, _e = console.error, Z = console.group, J = console.groupCollapsed, z = console.groupEnd;
            var t = {
              configurable: !0,
              enumerable: !0,
              value: me,
              writable: !0
            };
            Object.defineProperties(console, {
              info: t,
              log: t,
              warn: t,
              error: t,
              group: t,
              groupCollapsed: t,
              groupEnd: t
            });
          }
          V++;
        }
      }
      function Oe() {
        {
          if (V--, V === 0) {
            var t = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: r({}, t, {
                value: de
              }),
              info: r({}, t, {
                value: te
              }),
              warn: r({}, t, {
                value: he
              }),
              error: r({}, t, {
                value: _e
              }),
              group: r({}, t, {
                value: Z
              }),
              groupCollapsed: r({}, t, {
                value: J
              }),
              groupEnd: r({}, t, {
                value: z
              })
            });
          }
          V < 0 && w("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var Y = R.ReactCurrentDispatcher, fe;
      function ge(t, a, d) {
        {
          if (fe === void 0)
            try {
              throw Error();
            } catch (_) {
              var f = _.stack.trim().match(/\n( *(at )?)/);
              fe = f && f[1] || "";
            }
          return `
` + fe + t;
        }
      }
      var X = !1, ye;
      {
        var W = typeof WeakMap == "function" ? WeakMap : Map;
        ye = new W();
      }
      function ce(t, a) {
        if (!t || X)
          return "";
        {
          var d = ye.get(t);
          if (d !== void 0)
            return d;
        }
        var f;
        X = !0;
        var _ = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var S;
        S = Y.current, Y.current = null, ke();
        try {
          if (a) {
            var k = function() {
              throw Error();
            };
            if (Object.defineProperty(k.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(k, []);
              } catch (A) {
                f = A;
              }
              Reflect.construct(t, [], k);
            } else {
              try {
                k.call();
              } catch (A) {
                f = A;
              }
              t.call(k.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (A) {
              f = A;
            }
            t();
          }
        } catch (A) {
          if (A && f && typeof A.stack == "string") {
            for (var g = A.stack.split(`
`), L = f.stack.split(`
`), I = g.length - 1, O = L.length - 1; I >= 1 && O >= 0 && g[I] !== L[O]; )
              O--;
            for (; I >= 1 && O >= 0; I--, O--)
              if (g[I] !== L[O]) {
                if (I !== 1 || O !== 1)
                  do
                    if (I--, O--, O < 0 || g[I] !== L[O]) {
                      var re = `
` + g[I].replace(" at new ", " at ");
                      return typeof t == "function" && ye.set(t, re), re;
                    }
                  while (I >= 1 && O >= 0);
                break;
              }
          }
        } finally {
          X = !1, Y.current = S, Oe(), Error.prepareStackTrace = _;
        }
        var Ce = t ? t.displayName || t.name : "", j = Ce ? ge(Ce) : "";
        return typeof t == "function" && ye.set(t, j), j;
      }
      function ie(t, a, d) {
        return ce(t, !1);
      }
      function oe(t) {
        var a = t.prototype;
        return !!(a && a.isReactComponent);
      }
      function be(t, a, d) {
        if (t == null)
          return "";
        if (typeof t == "function")
          return ce(t, oe(t));
        if (typeof t == "string")
          return ge(t);
        switch (t) {
          case m:
            return ge("Suspense");
          case v:
            return ge("SuspenseList");
        }
        if (typeof t == "object")
          switch (t.$$typeof) {
            case p:
              return ie(t.render);
            case y:
              return be(t.type, a, d);
            case N:
              return ie(t._render);
            case b: {
              var f = t, _ = f._payload, S = f._init;
              try {
                return be(S(_), a, d);
              } catch {
              }
            }
          }
        return "";
      }
      var Ee = {}, Ie = R.ReactDebugCurrentFrame;
      function we(t) {
        if (t) {
          var a = t._owner, d = be(t.type, t._source, a ? a.type : null);
          Ie.setExtraStackFrame(d);
        } else
          Ie.setExtraStackFrame(null);
      }
      function Ge(t, a, d, f, _) {
        {
          var S = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var k in t)
            if (S(t, k)) {
              var g = void 0;
              try {
                if (typeof t[k] != "function") {
                  var L = Error((f || "React class") + ": " + d + " type `" + k + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[k] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw L.name = "Invariant Violation", L;
                }
                g = t[k](a, k, f, d, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (I) {
                g = I;
              }
              g && !(g instanceof Error) && (we(_), w("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", f || "React class", d, k, typeof g), we(null)), g instanceof Error && !(g.message in Ee) && (Ee[g.message] = !0, we(_), w("Failed %s type: %s", d, g.message), we(null));
            }
        }
      }
      var je = R.ReactCurrentOwner, Te = Object.prototype.hasOwnProperty, Ye = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, Ae, Be, De;
      De = {};
      function cn(t) {
        if (Te.call(t, "ref")) {
          var a = Object.getOwnPropertyDescriptor(t, "ref").get;
          if (a && a.isReactWarning)
            return !1;
        }
        return t.ref !== void 0;
      }
      function en(t) {
        if (Te.call(t, "key")) {
          var a = Object.getOwnPropertyDescriptor(t, "key").get;
          if (a && a.isReactWarning)
            return !1;
        }
        return t.key !== void 0;
      }
      function yn(t, a) {
        if (typeof t.ref == "string" && je.current && a && je.current.stateNode !== a) {
          var d = D(je.current.type);
          De[d] || (w('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', D(je.current.type), t.ref), De[d] = !0);
        }
      }
      function pn(t, a) {
        {
          var d = function() {
            Ae || (Ae = !0, w("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", a));
          };
          d.isReactWarning = !0, Object.defineProperty(t, "key", {
            get: d,
            configurable: !0
          });
        }
      }
      function gn(t, a) {
        {
          var d = function() {
            Be || (Be = !0, w("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", a));
          };
          d.isReactWarning = !0, Object.defineProperty(t, "ref", {
            get: d,
            configurable: !0
          });
        }
      }
      var dn = function(t, a, d, f, _, S, k) {
        var g = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: i,
          // Built-in properties that belong on the element
          type: t,
          key: a,
          ref: d,
          props: k,
          // Record the component responsible for creating this element.
          _owner: S
        };
        return g._store = {}, Object.defineProperty(g._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(g, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: f
        }), Object.defineProperty(g, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: _
        }), Object.freeze && (Object.freeze(g.props), Object.freeze(g)), g;
      };
      function un(t, a, d, f, _) {
        {
          var S, k = {}, g = null, L = null;
          d !== void 0 && (g = "" + d), en(a) && (g = "" + a.key), cn(a) && (L = a.ref, yn(a, _));
          for (S in a)
            Te.call(a, S) && !Ye.hasOwnProperty(S) && (k[S] = a[S]);
          if (t && t.defaultProps) {
            var I = t.defaultProps;
            for (S in I)
              k[S] === void 0 && (k[S] = I[S]);
          }
          if (g || L) {
            var O = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
            g && pn(k, O), L && gn(k, O);
          }
          return dn(t, g, L, _, f, je.current, k);
        }
      }
      var Re = R.ReactCurrentOwner, He = R.ReactDebugCurrentFrame;
      function Ne(t) {
        if (t) {
          var a = t._owner, d = be(t.type, t._source, a ? a.type : null);
          He.setExtraStackFrame(d);
        } else
          He.setExtraStackFrame(null);
      }
      var Le;
      Le = !1;
      function Me(t) {
        return typeof t == "object" && t !== null && t.$$typeof === i;
      }
      function ze() {
        {
          if (Re.current) {
            var t = D(Re.current.type);
            if (t)
              return `

Check the render method of \`` + t + "`.";
          }
          return "";
        }
      }
      function _n(t) {
        {
          if (t !== void 0) {
            var a = t.fileName.replace(/^.*[\\\/]/, ""), d = t.lineNumber;
            return `

Check your code at ` + a + ":" + d + ".";
          }
          return "";
        }
      }
      var Je = {};
      function qe(t) {
        {
          var a = ze();
          if (!a) {
            var d = typeof t == "string" ? t : t.displayName || t.name;
            d && (a = `

Check the top-level render call using <` + d + ">.");
          }
          return a;
        }
      }
      function Ke(t, a) {
        {
          if (!t._store || t._store.validated || t.key != null)
            return;
          t._store.validated = !0;
          var d = qe(a);
          if (Je[d])
            return;
          Je[d] = !0;
          var f = "";
          t && t._owner && t._owner !== Re.current && (f = " It was passed a child from " + D(t._owner.type) + "."), Ne(t), w('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', d, f), Ne(null);
        }
      }
      function Ze(t, a) {
        {
          if (typeof t != "object")
            return;
          if (Array.isArray(t))
            for (var d = 0; d < t.length; d++) {
              var f = t[d];
              Me(f) && Ke(f, a);
            }
          else if (Me(t))
            t._store && (t._store.validated = !0);
          else if (t) {
            var _ = M(t);
            if (typeof _ == "function" && _ !== t.entries)
              for (var S = _.call(t), k; !(k = S.next()).done; )
                Me(k.value) && Ke(k.value, a);
          }
        }
      }
      function hn(t) {
        {
          var a = t.type;
          if (a == null || typeof a == "string")
            return;
          var d;
          if (typeof a == "function")
            d = a.propTypes;
          else if (typeof a == "object" && (a.$$typeof === p || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          a.$$typeof === y))
            d = a.propTypes;
          else
            return;
          if (d) {
            var f = D(a);
            Ge(d, t.props, "prop", f, t);
          } else if (a.PropTypes !== void 0 && !Le) {
            Le = !0;
            var _ = D(a);
            w("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _ || "Unknown");
          }
          typeof a.getDefaultProps == "function" && !a.getDefaultProps.isReactClassApproved && w("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function fn(t) {
        {
          for (var a = Object.keys(t.props), d = 0; d < a.length; d++) {
            var f = a[d];
            if (f !== "children" && f !== "key") {
              Ne(t), w("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", f), Ne(null);
              break;
            }
          }
          t.ref !== null && (Ne(t), w("Invalid attribute `ref` supplied to `React.Fragment`."), Ne(null));
        }
      }
      function Qe(t, a, d, f, _, S) {
        {
          var k = le(t);
          if (!k) {
            var g = "";
            (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (g += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var L = _n(_);
            L ? g += L : g += ze();
            var I;
            t === null ? I = "null" : Array.isArray(t) ? I = "array" : t !== void 0 && t.$$typeof === i ? (I = "<" + (D(t.type) || "Unknown") + " />", g = " Did you accidentally export a JSX literal instead of a component?") : I = typeof t, w("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", I, g);
          }
          var O = un(t, a, d, _, S);
          if (O == null)
            return O;
          if (k) {
            var re = a.children;
            if (re !== void 0)
              if (f)
                if (Array.isArray(re)) {
                  for (var Ce = 0; Ce < re.length; Ce++)
                    Ze(re[Ce], t);
                  Object.freeze && Object.freeze(re);
                } else
                  w("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                Ze(re, t);
          }
          return t === e.Fragment ? fn(O) : hn(O), O;
        }
      }
      function kn(t, a, d) {
        return Qe(t, a, d, !0);
      }
      function Sn(t, a, d) {
        return Qe(t, a, d, !1);
      }
      var mn = Sn, vn = kn;
      e.jsx = mn, e.jsxs = vn;
    }();
  }(Uu)), Uu;
}
process.env.NODE_ENV === "production" ? il.exports = OI() : il.exports = RI();
var ne = il.exports;
const DI = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, PI = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "addPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UpdateCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UpdateCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, AI = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "removeCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RemoveCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "RemoveCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, LI = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "points_approved" } }, { kind: "Field", name: { kind: "Name", value: "points_pending" } }, { kind: "Field", name: { kind: "Name", value: "points_spent" } }, { kind: "Field", name: { kind: "Name", value: "rewards_claimed" } }, { kind: "Field", name: { kind: "Name", value: "birthday" } }, { kind: "Field", name: { kind: "Name", value: "guest" } }, { kind: "Field", name: { kind: "Name", value: "blocked" } }, { kind: "Field", name: { kind: "Name", value: "enrolled" } }, { kind: "Field", name: { kind: "Name", value: "enrolled_at" } }, { kind: "Field", name: { kind: "Name", value: "referral_id" } }, { kind: "Field", name: { kind: "Name", value: "referred_by" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }] } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier_membership" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "started_at" } }, { kind: "Field", name: { kind: "Name", value: "expires_at" } }, { kind: "Field", name: { kind: "Name", value: "manual" } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "position" } }, { kind: "Field", name: { kind: "Name", value: "default" } }, { kind: "Field", name: { kind: "Name", value: "hidden" } }, { kind: "Field", name: { kind: "Name", value: "lower_bound" } }, { kind: "Field", name: { kind: "Name", value: "upper_bound" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "insights_segment" } }, { kind: "Field", name: { kind: "Name", value: "referral_url" } }, { kind: "Field", name: { kind: "Name", value: "metadata" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopify_source_url" } }] } }, { kind: "Field", name: { kind: "Name", value: "properties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }] } }] } }] } }] } }] } }] } }] } }] }, UI = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getRewards" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAvailableRewards" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getAvailableRewards_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Rewards" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "rewards" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "site_id" } }, { kind: "Field", name: { kind: "Name", value: "target_site" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "content" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "point_cost" } }] } }] } }, { kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, MI = {
  "\n  fragment BadRequest on LoyaltyLion_BadRequest {\n    message\n  }\n  fragment Unauthorized on LoyaltyLion_Unauthorized {\n    message\n  }\n  fragment Forbidden on LoyaltyLion_Forbidden {\n    message\n  }\n  fragment NotFound on LoyaltyLion_NotFound {\n    message\n  }\n  fragment UnprocessableEntity on LoyaltyLion_UnprocessableEntity {\n    message\n  }\n  fragment ServerError on LoyaltyLion_ServerError {\n    message\n  }\n\n  fragment UpdateCustomersPointsResponse on LoyaltyLion_updateCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n\n  fragment RemoveCustomersPointsResponse on LoyaltyLion_removeCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n": DI,
  "\n  mutation addPoints(\n    $merchantId: String!\n    $input: LoyaltyLion_updateCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      updateCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_updateCustomersPoints_response {\n          ...UpdateCustomersPointsResponse\n        }\n      }\n    }\n  }\n": PI,
  "\n  mutation removePoints(\n    $merchantId: String!\n    $input: LoyaltyLion_removeCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      removeCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_removeCustomersPoints_response {\n          ...RemoveCustomersPointsResponse\n        }\n      }\n    }\n  }\n": AI,
  "\n  query getCustomers($email: String!) {\n    LoyaltyLion {\n      getCustomers(email: $email) {\n        ... on LoyaltyLion_getCustomers_response {\n          ... on LoyaltyLion_Customers {\n            customers {\n              id\n              merchant_id\n              email\n              points_approved\n              points_pending\n              points_spent\n              rewards_claimed\n              birthday\n              guest\n              blocked\n              enrolled\n              enrolled_at\n              referral_id\n              referred_by {\n                id\n                merchant_id\n              }\n              loyalty_tier_membership {\n                started_at\n                expires_at\n                manual\n                loyalty_tier {\n                  id\n                  name\n                  position\n                  default\n                  hidden\n                  lower_bound\n                  upper_bound\n                }\n              }\n              insights_segment\n              referral_url\n              metadata {\n                shopify_source_url\n              }\n              properties {\n                name\n                first_name\n                last_name\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": LI,
  "\n  query getRewards($merchantId: String!) {\n    LoyaltyLion {\n      getAvailableRewards(merchant_id: $merchantId) {\n        ... on LoyaltyLion_getAvailableRewards_response {\n          ... on LoyaltyLion_Rewards {\n            rewards {\n              id\n              title\n              description\n              site_id\n              target_site {\n                id\n                name\n                url\n              }\n              content\n              kind\n              point_cost\n            }\n          }\n          ...BadRequest\n          ...Unauthorized\n          ...Forbidden\n          ...NotFound\n          ...ServerError\n        }\n      }\n    }\n  }\n": UI
};
function Ua(e) {
  return MI[e] ?? {};
}
const BI = Ua(
  /* GraphQL */
  `
  query getCustomers($email: String!) {
    LoyaltyLion {
      getCustomers(email: $email) {
        ... on LoyaltyLion_getCustomers_response {
          ... on LoyaltyLion_Customers {
            customers {
              id
              merchant_id
              email
              points_approved
              points_pending
              points_spent
              rewards_claimed
              birthday
              guest
              blocked
              enrolled
              enrolled_at
              referral_id
              referred_by {
                id
                merchant_id
              }
              loyalty_tier_membership {
                started_at
                expires_at
                manual
                loyalty_tier {
                  id
                  name
                  position
                  default
                  hidden
                  lower_bound
                  upper_bound
                }
              }
              insights_segment
              referral_url
              metadata {
                shopify_source_url
              }
              properties {
                name
                first_name
                last_name
              }
            }
          }
        }
      }
    }
  }
`
), VI = Ua(
  /* GraphQL */
  `
  query getRewards($merchantId: String!) {
    LoyaltyLion {
      getAvailableRewards(merchant_id: $merchantId) {
        ... on LoyaltyLion_getAvailableRewards_response {
          ... on LoyaltyLion_Rewards {
            rewards {
              id
              title
              description
              site_id
              target_site {
                id
                name
                url
              }
              content
              kind
              point_cost
            }
          }
          ...BadRequest
          ...Unauthorized
          ...Forbidden
          ...NotFound
          ...ServerError
        }
      }
    }
  }
`
), qI = Ua(
  /* GraphQL */
  `
  mutation addPoints(
    $merchantId: String!
    $input: LoyaltyLion_updateCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      updateCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_updateCustomersPoints_response {
          ...UpdateCustomersPointsResponse
        }
      }
    }
  }
`
), zI = Ua(
  /* GraphQL */
  `
  mutation removePoints(
    $merchantId: String!
    $input: LoyaltyLion_removeCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      removeCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_removeCustomersPoints_response {
          ...RemoveCustomersPointsResponse
        }
      }
    }
  }
`
);
function Qo(e = !1, n) {
  const [r, i] = G(e);
  return Pe(() => {
    const o = r ? window.setTimeout(() => i(!1), n || 2e3) : void 0;
    return () => window.clearTimeout(o);
  }, [n, r]), { isCopied: r, copy: (o) => {
    navigator.clipboard.writeText(o), i(!0);
  } };
}
const HI = "_wrapper_1h8wu_27", KI = "_textVariant_1h8wu_33", GI = "_copyIcon_1h8wu_38", Zr = {
  wrapper: HI,
  textVariant: KI,
  copyIcon: GI
}, WI = ({
  customer: e
}) => {
  const { isCopied: n, copy: r } = Qo(), { isCopied: i, copy: o } = Qo(), { isCopied: s, copy: l } = Qo();
  if (!e)
    return null;
  const c = 14, {
    email: u,
    properties: p,
    metadata: m,
    birthday: v,
    created_at: y,
    enrolled: b,
    enrolled_at: N,
    referral_url: x
  } = e, T = v ? Nt(v).isSame(Date.now(), "day") : !1, { name: $, first_name: P, last_name: h } = p ?? {}, E = $ ?? `${P} ${h}` ?? "A customer has no name", q = m != null && m.shopify_source_url ? m.shopify_source_url.startsWith("https://") ? m.shopify_source_url : `https://${m.shopify_source_url}` : "";
  return /* @__PURE__ */ ne.jsx(C, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ ne.jsxs(C, { className: Zr.wrapper, gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ ne.jsxs(
      C,
      {
        justifyContent: "space-between",
        className: Zr.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ ne.jsx(se.Heading, { variant: "heading-2", children: E }),
          T && /* @__PURE__ */ ne.jsx(se.Paragraph, { variant: "4", color: "primary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    /* @__PURE__ */ ne.jsxs(C, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ne.jsx(se.Paragraph, { variant: "4", color: "secondary", children: "Member since" }),
      /* @__PURE__ */ ne.jsx(se.Paragraph, { variant: "4", color: "secondary", children: Nt(y).format("DD MMM YYYY @ HH:MM") })
    ] }),
    b && /* @__PURE__ */ ne.jsx(C, { gap: "200", children: /* @__PURE__ */ ne.jsxs(se.Paragraph, { variant: "4", color: "secondary", children: [
      "Enrolled since ",
      Nt(N).format("DD MMM YYYY @ HH:MM")
    ] }) }),
    /* @__PURE__ */ ne.jsxs(C, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ne.jsxs(C, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ ne.jsx(Fe, { size: c, name: "mail" }),
        /* @__PURE__ */ ne.jsx(se.ExternalLink, { href: `mailto:${u}`, children: u })
      ] }),
      /* @__PURE__ */ ne.jsx(jn, { content: n ? "Copied" : "Copy", dark: !0, children: /* @__PURE__ */ ne.jsx(
        Fe,
        {
          size: c,
          name: n ? "done" : "copy",
          onClick: () => r(u),
          className: Zr.copyIcon
        }
      ) })
    ] }),
    q && /* @__PURE__ */ ne.jsxs(C, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ne.jsxs(C, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ ne.jsx(Fe, { size: c, name: "link" }),
        /* @__PURE__ */ ne.jsx(jn, { content: "Shopify shop", dark: !0, children: /* @__PURE__ */ ne.jsx(
          se.ExternalLink,
          {
            href: q,
            target: "_blank",
            rel: "noreferrer",
            children: q.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ ne.jsx(jn, { content: i ? "Copied" : "Copy", dark: !0, children: /* @__PURE__ */ ne.jsx(
        Fe,
        {
          size: c,
          name: i ? "done" : "copy",
          onClick: () => o(q),
          className: Zr.copyIcon
        }
      ) })
    ] }),
    x && /* @__PURE__ */ ne.jsxs(C, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ne.jsxs(C, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ ne.jsx(Fe, { size: c, name: "external-link" }),
        /* @__PURE__ */ ne.jsx(jn, { content: "Referral link", dark: !0, children: /* @__PURE__ */ ne.jsx(
          se.ExternalLink,
          {
            href: x,
            target: "_blank",
            rel: "noreferrer",
            children: x.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ ne.jsx(jn, { content: s ? "Copied" : "Copy", dark: !0, children: /* @__PURE__ */ ne.jsx(
        Fe,
        {
          size: c,
          name: s ? "done" : "copy",
          onClick: () => l(x),
          className: Zr.copyIcon
        }
      ) })
    ] })
  ] }) });
}, YI = "_labelText_q61tw_27", QI = "_list_q61tw_31", JI = "_listItem_q61tw_34", ZI = "_listItemEdit_q61tw_41", XI = "_notificationText_q61tw_45", Pr = {
  labelText: YI,
  list: QI,
  listItem: JI,
  listItemEdit: ZI,
  notificationText: XI
}, e$ = "_modalBody_e1wm6_27", n$ = {
  modalBody: e$
}, t$ = ({
  isOpen: e,
  points: n,
  merchantId: r,
  onClose: i,
  refetchCustomerData: o
}) => {
  const { useMutation: s, showNotification: l } = rn(), { track: c } = sn(), [u, p] = G(n), [m, v] = G(""), [y, b] = G(), [N, { loading: x }] = s(
    qI,
    {
      onCompleted: () => {
        l({
          title: "Success",
          text: "Added points successfully",
          icon: "check-circle-filled",
          severity: "success"
        }), c("loyaltylion:add:points:succeeded"), le();
      }
    }
  ), [T, { loading: $ }] = s(zI), P = x || $, h = !!y, E = n === u ? "Change the value to update the points" : "", q = isNaN(u), M = q ? "Points can not be empty" : "", R = u > n && u - n > 1e6, w = R ? "Points can not exceed 1,000,000" : "", H = () => {
    u > n && N({
      variables: {
        input: {
          points: u - n,
          reason: m
        },
        merchantId: r
      }
    }).catch((Se) => {
      const ae = Se == null ? void 0 : Se.networkError;
      (ae ? ae == null ? void 0 : ae.statusCode : NaN) === 201 ? (c("loyaltylion:add:points:succeeded"), l({
        title: "Success",
        text: "Added points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), le()) : (c("loyaltylion:add:points:failed"), b(["Failed to add points, try again later."]));
    }), u < n && T({
      variables: {
        input: {
          points: n - u,
          reason: m
        },
        merchantId: r
      }
    }).then((Se) => {
      var ae, D, V, de;
      ((V = (D = (ae = Se.data) == null ? void 0 : ae.LoyaltyLion) == null ? void 0 : D.removeCustomersPoints) == null ? void 0 : V.__typename) === "LoyaltyLion_Void_container" ? (c("loyaltylion:remove:points:succeeded"), l({
        title: "Success",
        text: "Removed points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), le()) : "errors" in Se && (c("loyaltylion:remove:points:failed"), b(
        ((de = Se.errors) == null ? void 0 : de.map((te) => te.message)) ?? [
          "Failed to remove points, try again later."
        ]
      ));
    }).catch(() => {
      c("loyaltylion:remove:points:failed"), b(["Failed to remove points, try again later."]);
    });
  }, pe = () => {
    q && p(n), v(""), i();
  }, le = () => {
    o(), pe();
  };
  return /* @__PURE__ */ ne.jsxs(
    jt,
    {
      isOpen: e,
      onClose: pe,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ ne.jsx(Ct, { title: "Change points", onClose: pe }),
        /* @__PURE__ */ ne.jsxs(Et, { className: n$.modalBody, children: [
          /* @__PURE__ */ ne.jsxs(Ar, { children: [
            /* @__PURE__ */ ne.jsx(wn, { span: 6, children: /* @__PURE__ */ ne.jsx(
              Lt,
              {
                required: !0,
                label: "New points",
                type: "number",
                placeholder: "Insert new points",
                min: 0,
                max: 1e5,
                meta: {
                  error: w || M,
                  warning: E
                },
                input: {
                  name: "points",
                  value: u.toString(),
                  onChange: (Se) => p((Se == null ? void 0 : Se.target.valueAsNumber) ?? 0)
                },
                "data-testid": "points-input"
              }
            ) }),
            /* @__PURE__ */ ne.jsx(wn, { span: 6, children: /* @__PURE__ */ ne.jsx(
              Lt,
              {
                label: "Reason",
                placeholder: "Insert an optional reason",
                input: {
                  name: "reason",
                  value: m,
                  onChange: (Se) => v((Se == null ? void 0 : Se.target.value) ?? "")
                }
              }
            ) })
          ] }),
          !P && h && /* @__PURE__ */ ne.jsx(C, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ ne.jsx(Ln, { children: y == null ? void 0 : y.map((Se, ae) => /* @__PURE__ */ ne.jsx(
            Ln.Item,
            {
              variant: "dense",
              title: Se,
              contentLeft: /* @__PURE__ */ ne.jsx(
                Fe,
                {
                  color: $e.red[500],
                  size: 16,
                  name: "exclamation-triangle-filled"
                }
              )
            },
            ae
          )) }) })
        ] }),
        /* @__PURE__ */ ne.jsx(
          Mt,
          {
            confirmName: "Save",
            confirmOnClick: () => H(),
            confirmProps: {
              isLoading: P,
              disabled: q || R || n === u,
              loadingIndicator: /* @__PURE__ */ ne.jsx(ln, { size: 16 })
            },
            cancelOnClick: pe
          }
        )
      ]
    }
  );
}, r$ = ({
  label: e,
  points: n,
  setIsModalOpen: r
}) => {
  const i = n > 0 ? $e.green[500] : $e.neutral[400], o = n > 0 ? "warning" : "secondary", s = 10;
  return /* @__PURE__ */ ne.jsx(Ln.Text, { variant: "dense", className: Pr.listItem, children: /* @__PURE__ */ ne.jsxs(C, { justifyContent: "space-between", children: [
    /* @__PURE__ */ ne.jsxs(C, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ ne.jsx(Fe, { color: i, size: s, name: "star-full" }),
      /* @__PURE__ */ ne.jsx(se.Paragraph, { variant: "4", children: e })
    ] }),
    /* @__PURE__ */ ne.jsxs(C, { gap: "200", alignItems: "center", children: [
      r && /* @__PURE__ */ ne.jsx(jn, { content: "Edit points", dark: !0, children: /* @__PURE__ */ ne.jsx(
        Fe,
        {
          name: "pen",
          size: s,
          "aria-label": "Edit points",
          className: Pr.listItemEdit,
          onClick: () => r(!0)
        }
      ) }),
      /* @__PURE__ */ ne.jsx(ut, { size: "small", variant: o, children: n })
    ] })
  ] }) });
}, i$ = ({
  customer: e,
  refetchCustomerData: n
}) => {
  const [r, i] = G(!1);
  if (!e)
    return null;
  const {
    merchant_id: o,
    points_approved: s,
    points_pending: l,
    points_spent: c,
    rewards_claimed: u
  } = e, p = [
    {
      id: "pointsApproved",
      label: "Points approved",
      points: s ?? 0,
      setIsModalOpen: i
    },
    {
      id: "pointsPending",
      label: "Points pending",
      points: l ?? 0
    },
    {
      id: "pointsSpent",
      label: "Points spent",
      points: c ?? 0
    },
    {
      id: "rewardClaimed",
      label: "Rewards claimed",
      points: u ?? 0
    }
  ];
  return /* @__PURE__ */ ne.jsxs(C, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ne.jsx(se.Heading, { variant: "heading-3", children: "Points balance" }),
    /* @__PURE__ */ ne.jsx(Ln, { className: Pr.list, children: p.map(({ id: m, points: v, label: y, setIsModalOpen: b }) => /* @__PURE__ */ ne.jsx(
      r$,
      {
        points: v,
        label: y,
        setIsModalOpen: b
      },
      m
    )) }),
    /* @__PURE__ */ ne.jsx(
      t$,
      {
        isOpen: r,
        points: s,
        merchantId: o,
        onClose: () => i(!1),
        refetchCustomerData: n
      }
    )
  ] });
}, a$ = "_reward_gayxn_27", o$ = {
  reward: a$
}, s$ = ({ reward: e }) => {
  const {
    title: n,
    point_cost: r,
    target_site: i,
    description: o
  } = e, s = i == null ? void 0 : i.name, l = i == null ? void 0 : i.url;
  return /* @__PURE__ */ ne.jsx(C, { gap: "100", flexDirection: "column", className: o$.reward, children: /* @__PURE__ */ ne.jsx(jn, { content: o ?? "No description", dark: !0, children: /* @__PURE__ */ ne.jsxs(C, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ ne.jsxs(C, { justifyContent: "space-between", children: [
      /* @__PURE__ */ ne.jsxs(C, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ ne.jsx(
          Fe,
          {
            name: "star",
            size: 12,
            color: $e.neutral[500]
          }
        ),
        n
      ] }),
      /* @__PURE__ */ ne.jsxs(ut, { size: "small", variant: "info", children: [
        r ?? 0,
        " points"
      ] })
    ] }),
    s && l && /* @__PURE__ */ ne.jsxs(C, { gap: "100", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ ne.jsx(Fe, { size: 14, name: "external-link" }),
      /* @__PURE__ */ ne.jsx(
        se.ExternalLink,
        {
          href: l,
          target: "_blank",
          rel: "noreferrer",
          children: s
        }
      )
    ] })
  ] }) }) });
}, l$ = ({ customer: e }) => {
  const { useQuery: n } = rn(), [r, i] = G(), { merchant_id: o } = e, {
    loading: s,
    error: l,
    data: c
  } = n(VI, {
    skip: !o,
    variables: {
      merchantId: o
    }
  });
  return Pe(() => {
    var u, p;
    if (c != null && c.LoyaltyLion) {
      const m = (p = (u = c.LoyaltyLion) == null ? void 0 : u.getAvailableRewards) == null ? void 0 : p.rewards;
      m && i(m);
    }
  }, [c]), l ? vl({ errors: l.graphQLErrors }) ? /* @__PURE__ */ ne.jsx(
    C,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      className: Pr.notificationText,
      children: "No rewards found"
    }
  ) : km({ errors: l.graphQLErrors }) ? /* @__PURE__ */ ne.jsx(
    C,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      className: Pr.notificationText,
      children: "You don't have permissions to view rewards"
    }
  ) : /* @__PURE__ */ ne.jsx(bn, { error: l }) : /* @__PURE__ */ ne.jsxs(C, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ne.jsx(se.Heading, { variant: "heading-3", children: "Available rewards" }),
    s ? /* @__PURE__ */ ne.jsx(C, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ ne.jsx(ln, {}) }) : /* @__PURE__ */ ne.jsx(C, { gap: "200", flexDirection: "column", children: r == null ? void 0 : r.map((u) => /* @__PURE__ */ ne.jsx(s$, { reward: u }, u.id)) })
  ] });
}, c$ = ({ customer: e }) => {
  const { blocked: n, guest: r, insights_segment: i } = e ?? {}, o = n || r || i, s = 14;
  return o ? /* @__PURE__ */ ne.jsxs(C, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
    n && /* @__PURE__ */ ne.jsx(C, { alignItems: "start", children: /* @__PURE__ */ ne.jsx(an, { children: /* @__PURE__ */ ne.jsxs(C, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ ne.jsx(
        Fe,
        {
          size: s,
          color: $e.red[500],
          name: "exclamation-triangle-filled"
        }
      ),
      "Blocked"
    ] }) }) }),
    r && /* @__PURE__ */ ne.jsx(C, { alignItems: "start", children: /* @__PURE__ */ ne.jsx(an, { children: /* @__PURE__ */ ne.jsxs(C, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ ne.jsx(
        Fe,
        {
          size: s,
          color: $e.green[500],
          name: "user"
        }
      ),
      "Guest"
    ] }) }) }),
    i && /* @__PURE__ */ ne.jsx(C, { alignItems: "start", children: /* @__PURE__ */ ne.jsx(jn, { content: "Insights segment", dark: !0, children: /* @__PURE__ */ ne.jsx(an, { children: /* @__PURE__ */ ne.jsxs(C, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ ne.jsx(
        Fe,
        {
          size: s,
          color: $e.green[500],
          name: "team"
        }
      ),
      i
    ] }) }) }) })
  ] }) : null;
}, d$ = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = rn(), { track: i } = sn(), [o, s] = G(null), { customer: l } = e, {
    showCustomerSummary: c,
    showTags: u,
    showPointsBalance: p,
    showAvailableRewards: m
  } = n, v = !c && !u && !p && !m, {
    loading: y,
    error: b,
    data: N,
    refetch: x
  } = r(BI, {
    skip: !(l != null && l.email),
    variables: {
      email: (l == null ? void 0 : l.email) ?? ""
    }
  });
  return Pe(() => {
    var T;
    if (N && !y) {
      const $ = ((T = N == null ? void 0 : N.LoyaltyLion) == null ? void 0 : T.getCustomers).customers;
      $ && $.length > 0 && (s($[0]), i("loyaltylion:customer:received"));
    }
  }, [N, y]), l != null && l.email ? b ? vl({ errors: b.graphQLErrors }) ? /* @__PURE__ */ ne.jsxs(
    C,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      className: Pr.notificationText,
      children: [
        "No user found for email: ",
        l == null ? void 0 : l.email
      ]
    }
  ) : /* @__PURE__ */ ne.jsx(bn, { error: b }) : y ? /* @__PURE__ */ ne.jsx(C, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ ne.jsx(ln, {}) }) : v ? /* @__PURE__ */ ne.jsx(
    C,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-feature-enabled-message",
      children: "All features toggles in the integration settings are disabled"
    }
  ) : /* @__PURE__ */ ne.jsx(
    C,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: o ? /* @__PURE__ */ ne.jsxs(ne.Fragment, { children: [
        c && /* @__PURE__ */ ne.jsx(WI, { customer: o }),
        u && /* @__PURE__ */ ne.jsx(c$, { customer: o }),
        p && /* @__PURE__ */ ne.jsx(
          i$,
          {
            customer: o,
            refetchCustomerData: x
          }
        ),
        m && /* @__PURE__ */ ne.jsx(l$, { customer: o })
      ] }) : /* @__PURE__ */ ne.jsx(C, { justifyContent: "center", padding: "200", children: "Nothing found" })
    }
  ) : /* @__PURE__ */ ne.jsx(
    C,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-email-message",
      children: "We can only search LoyaltyLion with an email and there seems to be no email in this conversation"
    }
  );
}, u$ = [
  {
    key: "basicAuthorization",
    label: "LoyaltyLion authorization",
    required: !0,
    secret: !0,
    type: "basicAuthInput",
    defaultValue: "",
    additionalProperties: {
      username: {
        label: "Token"
      },
      password: {
        label: "Secret"
      }
    }
  },
  {
    key: "showCustomerSummary",
    label: "Show customer summary",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showTags",
    label: "Show tags",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showPointsBalance",
    label: "Show points balance",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showAvailableRewards",
    label: "Show available rewards",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._messageContainer_81q22_27{padding:12px;border-radius:4px;border:1px solid}._chip_81q22_33{color:#46597c}._chipLabel_81q22_36{font-weight:600}._chipValue_81q22_39{font-weight:400}._conversation_18up1_27{border:1px solid #d7dfea;border-radius:4px;padding:12px}._conversation_18up1_27:hover{border-color:#b5c1d4}._conversationSubLine_18up1_35{font-size:12px;color:#8294b0}._modal_18up1_40{width:800px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var al = { exports: {} }, hr = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Jo, Bu;
function iv() {
  if (Bu)
    return Jo;
  Bu = 1;
  var e = Object.getOwnPropertySymbols, n = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function i(s) {
    if (s == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(s);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var s = new String("abc");
      if (s[5] = "de", Object.getOwnPropertyNames(s)[0] === "5")
        return !1;
      for (var l = {}, c = 0; c < 10; c++)
        l["_" + String.fromCharCode(c)] = c;
      var u = Object.getOwnPropertyNames(l).map(function(m) {
        return l[m];
      });
      if (u.join("") !== "0123456789")
        return !1;
      var p = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(m) {
        p[m] = m;
      }), Object.keys(Object.assign({}, p)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Jo = o() ? Object.assign : function(s, l) {
    for (var c, u = i(s), p, m = 1; m < arguments.length; m++) {
      c = Object(arguments[m]);
      for (var v in c)
        n.call(c, v) && (u[v] = c[v]);
      if (e) {
        p = e(c);
        for (var y = 0; y < p.length; y++)
          r.call(c, p[y]) && (u[p[y]] = c[p[y]]);
      }
    }
    return u;
  }, Jo;
}
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Vu;
function m$() {
  if (Vu)
    return hr;
  Vu = 1, iv();
  var e = Cn, n = 60103;
  if (hr.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var r = Symbol.for;
    n = r("react.element"), hr.Fragment = r("react.fragment");
  }
  var i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = Object.prototype.hasOwnProperty, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(c, u, p) {
    var m, v = {}, y = null, b = null;
    p !== void 0 && (y = "" + p), u.key !== void 0 && (y = "" + u.key), u.ref !== void 0 && (b = u.ref);
    for (m in u)
      o.call(u, m) && !s.hasOwnProperty(m) && (v[m] = u[m]);
    if (c && c.defaultProps)
      for (m in u = c.defaultProps, u)
        v[m] === void 0 && (v[m] = u[m]);
    return { $$typeof: n, type: c, key: y, ref: b, props: v, _owner: i.current };
  }
  return hr.jsx = l, hr.jsxs = l, hr;
}
var qu = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var zu;
function p$() {
  return zu || (zu = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      var n = Cn, r = iv(), i = 60103, o = 60106;
      e.Fragment = 60107;
      var s = 60108, l = 60114, c = 60109, u = 60110, p = 60112, m = 60113, v = 60120, y = 60115, b = 60116, N = 60121, x = 60122, T = 60117, $ = 60129, P = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var h = Symbol.for;
        i = h("react.element"), o = h("react.portal"), e.Fragment = h("react.fragment"), s = h("react.strict_mode"), l = h("react.profiler"), c = h("react.provider"), u = h("react.context"), p = h("react.forward_ref"), m = h("react.suspense"), v = h("react.suspense_list"), y = h("react.memo"), b = h("react.lazy"), N = h("react.block"), x = h("react.server.block"), T = h("react.fundamental"), h("react.scope"), h("react.opaque.id"), $ = h("react.debug_trace_mode"), h("react.offscreen"), P = h("react.legacy_hidden");
      }
      var E = typeof Symbol == "function" && Symbol.iterator, q = "@@iterator";
      function M(t) {
        if (t === null || typeof t != "object")
          return null;
        var a = E && t[E] || t[q];
        return typeof a == "function" ? a : null;
      }
      var R = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function w(t) {
        {
          for (var a = arguments.length, d = new Array(a > 1 ? a - 1 : 0), f = 1; f < a; f++)
            d[f - 1] = arguments[f];
          H("error", t, d);
        }
      }
      function H(t, a, d) {
        {
          var f = R.ReactDebugCurrentFrame, _ = f.getStackAddendum();
          _ !== "" && (a += "%s", d = d.concat([_]));
          var S = d.map(function(k) {
            return "" + k;
          });
          S.unshift("Warning: " + a), Function.prototype.apply.call(console[t], console, S);
        }
      }
      var pe = !1;
      function le(t) {
        return !!(typeof t == "string" || typeof t == "function" || t === e.Fragment || t === l || t === $ || t === s || t === m || t === v || t === P || pe || typeof t == "object" && t !== null && (t.$$typeof === b || t.$$typeof === y || t.$$typeof === c || t.$$typeof === u || t.$$typeof === p || t.$$typeof === T || t.$$typeof === N || t[0] === x));
      }
      function Se(t, a, d) {
        var f = a.displayName || a.name || "";
        return t.displayName || (f !== "" ? d + "(" + f + ")" : d);
      }
      function ae(t) {
        return t.displayName || "Context";
      }
      function D(t) {
        if (t == null)
          return null;
        if (typeof t.tag == "number" && w("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof t == "function")
          return t.displayName || t.name || null;
        if (typeof t == "string")
          return t;
        switch (t) {
          case e.Fragment:
            return "Fragment";
          case o:
            return "Portal";
          case l:
            return "Profiler";
          case s:
            return "StrictMode";
          case m:
            return "Suspense";
          case v:
            return "SuspenseList";
        }
        if (typeof t == "object")
          switch (t.$$typeof) {
            case u:
              var a = t;
              return ae(a) + ".Consumer";
            case c:
              var d = t;
              return ae(d._context) + ".Provider";
            case p:
              return Se(t, t.render, "ForwardRef");
            case y:
              return D(t.type);
            case N:
              return D(t._render);
            case b: {
              var f = t, _ = f._payload, S = f._init;
              try {
                return D(S(_));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var V = 0, de, te, he, _e, Z, J, z;
      function me() {
      }
      me.__reactDisabledLog = !0;
      function ke() {
        {
          if (V === 0) {
            de = console.log, te = console.info, he = console.warn, _e = console.error, Z = console.group, J = console.groupCollapsed, z = console.groupEnd;
            var t = {
              configurable: !0,
              enumerable: !0,
              value: me,
              writable: !0
            };
            Object.defineProperties(console, {
              info: t,
              log: t,
              warn: t,
              error: t,
              group: t,
              groupCollapsed: t,
              groupEnd: t
            });
          }
          V++;
        }
      }
      function Oe() {
        {
          if (V--, V === 0) {
            var t = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: r({}, t, {
                value: de
              }),
              info: r({}, t, {
                value: te
              }),
              warn: r({}, t, {
                value: he
              }),
              error: r({}, t, {
                value: _e
              }),
              group: r({}, t, {
                value: Z
              }),
              groupCollapsed: r({}, t, {
                value: J
              }),
              groupEnd: r({}, t, {
                value: z
              })
            });
          }
          V < 0 && w("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var Y = R.ReactCurrentDispatcher, fe;
      function ge(t, a, d) {
        {
          if (fe === void 0)
            try {
              throw Error();
            } catch (_) {
              var f = _.stack.trim().match(/\n( *(at )?)/);
              fe = f && f[1] || "";
            }
          return `
` + fe + t;
        }
      }
      var X = !1, ye;
      {
        var W = typeof WeakMap == "function" ? WeakMap : Map;
        ye = new W();
      }
      function ce(t, a) {
        if (!t || X)
          return "";
        {
          var d = ye.get(t);
          if (d !== void 0)
            return d;
        }
        var f;
        X = !0;
        var _ = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var S;
        S = Y.current, Y.current = null, ke();
        try {
          if (a) {
            var k = function() {
              throw Error();
            };
            if (Object.defineProperty(k.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(k, []);
              } catch (A) {
                f = A;
              }
              Reflect.construct(t, [], k);
            } else {
              try {
                k.call();
              } catch (A) {
                f = A;
              }
              t.call(k.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (A) {
              f = A;
            }
            t();
          }
        } catch (A) {
          if (A && f && typeof A.stack == "string") {
            for (var g = A.stack.split(`
`), L = f.stack.split(`
`), I = g.length - 1, O = L.length - 1; I >= 1 && O >= 0 && g[I] !== L[O]; )
              O--;
            for (; I >= 1 && O >= 0; I--, O--)
              if (g[I] !== L[O]) {
                if (I !== 1 || O !== 1)
                  do
                    if (I--, O--, O < 0 || g[I] !== L[O]) {
                      var re = `
` + g[I].replace(" at new ", " at ");
                      return typeof t == "function" && ye.set(t, re), re;
                    }
                  while (I >= 1 && O >= 0);
                break;
              }
          }
        } finally {
          X = !1, Y.current = S, Oe(), Error.prepareStackTrace = _;
        }
        var Ce = t ? t.displayName || t.name : "", j = Ce ? ge(Ce) : "";
        return typeof t == "function" && ye.set(t, j), j;
      }
      function ie(t, a, d) {
        return ce(t, !1);
      }
      function oe(t) {
        var a = t.prototype;
        return !!(a && a.isReactComponent);
      }
      function be(t, a, d) {
        if (t == null)
          return "";
        if (typeof t == "function")
          return ce(t, oe(t));
        if (typeof t == "string")
          return ge(t);
        switch (t) {
          case m:
            return ge("Suspense");
          case v:
            return ge("SuspenseList");
        }
        if (typeof t == "object")
          switch (t.$$typeof) {
            case p:
              return ie(t.render);
            case y:
              return be(t.type, a, d);
            case N:
              return ie(t._render);
            case b: {
              var f = t, _ = f._payload, S = f._init;
              try {
                return be(S(_), a, d);
              } catch {
              }
            }
          }
        return "";
      }
      var Ee = {}, Ie = R.ReactDebugCurrentFrame;
      function we(t) {
        if (t) {
          var a = t._owner, d = be(t.type, t._source, a ? a.type : null);
          Ie.setExtraStackFrame(d);
        } else
          Ie.setExtraStackFrame(null);
      }
      function Ge(t, a, d, f, _) {
        {
          var S = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var k in t)
            if (S(t, k)) {
              var g = void 0;
              try {
                if (typeof t[k] != "function") {
                  var L = Error((f || "React class") + ": " + d + " type `" + k + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[k] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw L.name = "Invariant Violation", L;
                }
                g = t[k](a, k, f, d, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (I) {
                g = I;
              }
              g && !(g instanceof Error) && (we(_), w("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", f || "React class", d, k, typeof g), we(null)), g instanceof Error && !(g.message in Ee) && (Ee[g.message] = !0, we(_), w("Failed %s type: %s", d, g.message), we(null));
            }
        }
      }
      var je = R.ReactCurrentOwner, Te = Object.prototype.hasOwnProperty, Ye = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, Ae, Be, De;
      De = {};
      function cn(t) {
        if (Te.call(t, "ref")) {
          var a = Object.getOwnPropertyDescriptor(t, "ref").get;
          if (a && a.isReactWarning)
            return !1;
        }
        return t.ref !== void 0;
      }
      function en(t) {
        if (Te.call(t, "key")) {
          var a = Object.getOwnPropertyDescriptor(t, "key").get;
          if (a && a.isReactWarning)
            return !1;
        }
        return t.key !== void 0;
      }
      function yn(t, a) {
        if (typeof t.ref == "string" && je.current && a && je.current.stateNode !== a) {
          var d = D(je.current.type);
          De[d] || (w('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', D(je.current.type), t.ref), De[d] = !0);
        }
      }
      function pn(t, a) {
        {
          var d = function() {
            Ae || (Ae = !0, w("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", a));
          };
          d.isReactWarning = !0, Object.defineProperty(t, "key", {
            get: d,
            configurable: !0
          });
        }
      }
      function gn(t, a) {
        {
          var d = function() {
            Be || (Be = !0, w("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", a));
          };
          d.isReactWarning = !0, Object.defineProperty(t, "ref", {
            get: d,
            configurable: !0
          });
        }
      }
      var dn = function(t, a, d, f, _, S, k) {
        var g = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: i,
          // Built-in properties that belong on the element
          type: t,
          key: a,
          ref: d,
          props: k,
          // Record the component responsible for creating this element.
          _owner: S
        };
        return g._store = {}, Object.defineProperty(g._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(g, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: f
        }), Object.defineProperty(g, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: _
        }), Object.freeze && (Object.freeze(g.props), Object.freeze(g)), g;
      };
      function un(t, a, d, f, _) {
        {
          var S, k = {}, g = null, L = null;
          d !== void 0 && (g = "" + d), en(a) && (g = "" + a.key), cn(a) && (L = a.ref, yn(a, _));
          for (S in a)
            Te.call(a, S) && !Ye.hasOwnProperty(S) && (k[S] = a[S]);
          if (t && t.defaultProps) {
            var I = t.defaultProps;
            for (S in I)
              k[S] === void 0 && (k[S] = I[S]);
          }
          if (g || L) {
            var O = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
            g && pn(k, O), L && gn(k, O);
          }
          return dn(t, g, L, _, f, je.current, k);
        }
      }
      var Re = R.ReactCurrentOwner, He = R.ReactDebugCurrentFrame;
      function Ne(t) {
        if (t) {
          var a = t._owner, d = be(t.type, t._source, a ? a.type : null);
          He.setExtraStackFrame(d);
        } else
          He.setExtraStackFrame(null);
      }
      var Le;
      Le = !1;
      function Me(t) {
        return typeof t == "object" && t !== null && t.$$typeof === i;
      }
      function ze() {
        {
          if (Re.current) {
            var t = D(Re.current.type);
            if (t)
              return `

Check the render method of \`` + t + "`.";
          }
          return "";
        }
      }
      function _n(t) {
        {
          if (t !== void 0) {
            var a = t.fileName.replace(/^.*[\\\/]/, ""), d = t.lineNumber;
            return `

Check your code at ` + a + ":" + d + ".";
          }
          return "";
        }
      }
      var Je = {};
      function qe(t) {
        {
          var a = ze();
          if (!a) {
            var d = typeof t == "string" ? t : t.displayName || t.name;
            d && (a = `

Check the top-level render call using <` + d + ">.");
          }
          return a;
        }
      }
      function Ke(t, a) {
        {
          if (!t._store || t._store.validated || t.key != null)
            return;
          t._store.validated = !0;
          var d = qe(a);
          if (Je[d])
            return;
          Je[d] = !0;
          var f = "";
          t && t._owner && t._owner !== Re.current && (f = " It was passed a child from " + D(t._owner.type) + "."), Ne(t), w('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', d, f), Ne(null);
        }
      }
      function Ze(t, a) {
        {
          if (typeof t != "object")
            return;
          if (Array.isArray(t))
            for (var d = 0; d < t.length; d++) {
              var f = t[d];
              Me(f) && Ke(f, a);
            }
          else if (Me(t))
            t._store && (t._store.validated = !0);
          else if (t) {
            var _ = M(t);
            if (typeof _ == "function" && _ !== t.entries)
              for (var S = _.call(t), k; !(k = S.next()).done; )
                Me(k.value) && Ke(k.value, a);
          }
        }
      }
      function hn(t) {
        {
          var a = t.type;
          if (a == null || typeof a == "string")
            return;
          var d;
          if (typeof a == "function")
            d = a.propTypes;
          else if (typeof a == "object" && (a.$$typeof === p || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          a.$$typeof === y))
            d = a.propTypes;
          else
            return;
          if (d) {
            var f = D(a);
            Ge(d, t.props, "prop", f, t);
          } else if (a.PropTypes !== void 0 && !Le) {
            Le = !0;
            var _ = D(a);
            w("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _ || "Unknown");
          }
          typeof a.getDefaultProps == "function" && !a.getDefaultProps.isReactClassApproved && w("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function fn(t) {
        {
          for (var a = Object.keys(t.props), d = 0; d < a.length; d++) {
            var f = a[d];
            if (f !== "children" && f !== "key") {
              Ne(t), w("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", f), Ne(null);
              break;
            }
          }
          t.ref !== null && (Ne(t), w("Invalid attribute `ref` supplied to `React.Fragment`."), Ne(null));
        }
      }
      function Qe(t, a, d, f, _, S) {
        {
          var k = le(t);
          if (!k) {
            var g = "";
            (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (g += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var L = _n(_);
            L ? g += L : g += ze();
            var I;
            t === null ? I = "null" : Array.isArray(t) ? I = "array" : t !== void 0 && t.$$typeof === i ? (I = "<" + (D(t.type) || "Unknown") + " />", g = " Did you accidentally export a JSX literal instead of a component?") : I = typeof t, w("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", I, g);
          }
          var O = un(t, a, d, _, S);
          if (O == null)
            return O;
          if (k) {
            var re = a.children;
            if (re !== void 0)
              if (f)
                if (Array.isArray(re)) {
                  for (var Ce = 0; Ce < re.length; Ce++)
                    Ze(re[Ce], t);
                  Object.freeze && Object.freeze(re);
                } else
                  w("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                Ze(re, t);
          }
          return t === e.Fragment ? fn(O) : hn(O), O;
        }
      }
      function kn(t, a, d) {
        return Qe(t, a, d, !0);
      }
      function Sn(t, a, d) {
        return Qe(t, a, d, !1);
      }
      var mn = Sn, vn = kn;
      e.jsx = mn, e.jsxs = vn;
    }();
  }(qu)), qu;
}
process.env.NODE_ENV === "production" ? al.exports = m$() : al.exports = p$();
var Ue = al.exports;
const f$ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "conversationsQuery" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Miuros" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findTickets" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "page_size" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "labels" } }, { kind: "Field", name: { kind: "Name", value: "subject" } }, { kind: "Field", name: { kind: "Name", value: "messages" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "direction" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "agent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_fields" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }] } }] } }] } }] }, v$ = {
  "\n  query conversationsQuery($query: String) {\n    Miuros {\n      findTickets(query: $query, page_size: 10) {\n        data {\n          id\n          labels\n          subject\n          messages {\n            direction\n            body\n            agent {\n              email\n              name\n            }\n            created_at\n          }\n          custom_fields\n          created_at\n        }\n      }\n    }\n  }\n": f$
};
function y$(e) {
  return v$[e] ?? {};
}
/*! @license DOMPurify 2.4.3 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.4.3/LICENSE */
function Pt(e) {
  "@babel/helpers - typeof";
  return Pt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
    return typeof n;
  } : function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Pt(e);
}
function ol(e, n) {
  return ol = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, ol(e, n);
}
function g$() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Xi(e, n, r) {
  return g$() ? Xi = Reflect.construct : Xi = function(i, o, s) {
    var l = [null];
    l.push.apply(l, o);
    var c = Function.bind.apply(i, l), u = new c();
    return s && ol(u, s.prototype), u;
  }, Xi.apply(null, arguments);
}
function et(e) {
  return h$(e) || k$(e) || b$(e) || _$();
}
function h$(e) {
  if (Array.isArray(e))
    return sl(e);
}
function k$(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function b$(e, n) {
  if (e) {
    if (typeof e == "string")
      return sl(e, n);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return sl(e, n);
  }
}
function sl(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var r = 0, i = new Array(n); r < n; r++)
    i[r] = e[r];
  return i;
}
function _$() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var S$ = Object.hasOwnProperty, Hu = Object.setPrototypeOf, N$ = Object.isFrozen, x$ = Object.getPrototypeOf, w$ = Object.getOwnPropertyDescriptor, Pn = Object.freeze, it = Object.seal, j$ = Object.create, av = typeof Reflect < "u" && Reflect, ya = av.apply, ll = av.construct;
ya || (ya = function(e, n, r) {
  return e.apply(n, r);
});
Pn || (Pn = function(e) {
  return e;
});
it || (it = function(e) {
  return e;
});
ll || (ll = function(e, n) {
  return Xi(e, et(n));
});
var C$ = Qn(Array.prototype.forEach), Ku = Qn(Array.prototype.pop), Xr = Qn(Array.prototype.push), ea = Qn(String.prototype.toLowerCase), Zo = Qn(String.prototype.toString), E$ = Qn(String.prototype.match), Xn = Qn(String.prototype.replace), F$ = Qn(String.prototype.indexOf), I$ = Qn(String.prototype.trim), Dn = Qn(RegExp.prototype.test), Xo = $$(TypeError);
function Qn(e) {
  return function(n) {
    for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++)
      i[o - 1] = arguments[o];
    return ya(e, n, i);
  };
}
function $$(e) {
  return function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return ll(e, r);
  };
}
function Ve(e, n, r) {
  r = r || ea, Hu && Hu(e, null);
  for (var i = n.length; i--; ) {
    var o = n[i];
    if (typeof o == "string") {
      var s = r(o);
      s !== o && (N$(n) || (n[i] = s), o = s);
    }
    e[o] = !0;
  }
  return e;
}
function Wt(e) {
  var n = j$(null), r;
  for (r in e)
    ya(S$, e, [r]) === !0 && (n[r] = e[r]);
  return n;
}
function Mi(e, n) {
  for (; e !== null; ) {
    var r = w$(e, n);
    if (r) {
      if (r.get)
        return Qn(r.get);
      if (typeof r.value == "function")
        return Qn(r.value);
    }
    e = x$(e);
  }
  function i(o) {
    return console.warn("fallback value for", o), null;
  }
  return i;
}
var Gu = Pn(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), es = Pn(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), ns = Pn(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), T$ = Pn(["animate", "color-profile", "cursor", "discard", "fedropshadow", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), ts = Pn(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover"]), O$ = Pn(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), Wu = Pn(["#text"]), Yu = Pn(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "xmlns", "slot"]), rs = Pn(["accent-height", "accumulate", "additive", "alignment-baseline", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), Qu = Pn(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), Bi = Pn(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), R$ = it(/\{\{[\w\W]*|[\w\W]*\}\}/gm), D$ = it(/<%[\w\W]*|[\w\W]*%>/gm), P$ = it(/\${[\w\W]*}/gm), A$ = it(/^data-[\-\w.\u00B7-\uFFFF]/), L$ = it(/^aria-[\-\w]+$/), U$ = it(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), M$ = it(/^(?:\w+script|data):/i), B$ = it(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), V$ = it(/^html$/i), q$ = function() {
  return typeof window > "u" ? null : window;
}, z$ = function(e, n) {
  if (Pt(e) !== "object" || typeof e.createPolicy != "function")
    return null;
  var r = null, i = "data-tt-policy-suffix";
  n.currentScript && n.currentScript.hasAttribute(i) && (r = n.currentScript.getAttribute(i));
  var o = "dompurify" + (r ? "#" + r : "");
  try {
    return e.createPolicy(o, {
      createHTML: function(s) {
        return s;
      },
      createScriptURL: function(s) {
        return s;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + o + " could not be created."), null;
  }
};
function ov() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : q$(), n = function(j) {
    return ov(j);
  };
  if (n.version = "2.4.3", n.removed = [], !e || !e.document || e.document.nodeType !== 9)
    return n.isSupported = !1, n;
  var r = e.document, i = e.document, o = e.DocumentFragment, s = e.HTMLTemplateElement, l = e.Node, c = e.Element, u = e.NodeFilter, p = e.NamedNodeMap, m = p === void 0 ? e.NamedNodeMap || e.MozNamedAttrMap : p, v = e.HTMLFormElement, y = e.DOMParser, b = e.trustedTypes, N = c.prototype, x = Mi(N, "cloneNode"), T = Mi(N, "nextSibling"), $ = Mi(N, "childNodes"), P = Mi(N, "parentNode");
  if (typeof s == "function") {
    var h = i.createElement("template");
    h.content && h.content.ownerDocument && (i = h.content.ownerDocument);
  }
  var E = z$(b, r), q = E ? E.createHTML("") : "", M = i, R = M.implementation, w = M.createNodeIterator, H = M.createDocumentFragment, pe = M.getElementsByTagName, le = r.importNode, Se = {};
  try {
    Se = Wt(i).documentMode ? i.documentMode : {};
  } catch {
  }
  var ae = {};
  n.isSupported = typeof P == "function" && R && typeof R.createHTMLDocument < "u" && Se !== 9;
  var D = R$, V = D$, de = P$, te = A$, he = L$, _e = M$, Z = B$, J = U$, z = null, me = Ve({}, [].concat(et(Gu), et(es), et(ns), et(ts), et(Wu))), ke = null, Oe = Ve({}, [].concat(et(Yu), et(rs), et(Qu), et(Bi))), Y = Object.seal(Object.create(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), fe = null, ge = null, X = !0, ye = !0, W = !1, ce = !1, ie = !1, oe = !1, be = !1, Ee = !1, Ie = !1, we = !1, Ge = !0, je = !1, Te = "user-content-", Ye = !0, Ae = !1, Be = {}, De = null, cn = Ve({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]), en = null, yn = Ve({}, ["audio", "video", "img", "source", "image", "track"]), pn = null, gn = Ve({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), dn = "http://www.w3.org/1998/Math/MathML", un = "http://www.w3.org/2000/svg", Re = "http://www.w3.org/1999/xhtml", He = Re, Ne = !1, Le = null, Me = Ve({}, [dn, un, Re], Zo), ze, _n = ["application/xhtml+xml", "text/html"], Je = "text/html", qe, Ke = null, Ze = i.createElement("form"), hn = function(j) {
    return j instanceof RegExp || j instanceof Function;
  }, fn = function(j) {
    Ke && Ke === j || ((!j || Pt(j) !== "object") && (j = {}), j = Wt(j), ze = // eslint-disable-next-line unicorn/prefer-includes
    _n.indexOf(j.PARSER_MEDIA_TYPE) === -1 ? ze = Je : ze = j.PARSER_MEDIA_TYPE, qe = ze === "application/xhtml+xml" ? Zo : ea, z = "ALLOWED_TAGS" in j ? Ve({}, j.ALLOWED_TAGS, qe) : me, ke = "ALLOWED_ATTR" in j ? Ve({}, j.ALLOWED_ATTR, qe) : Oe, Le = "ALLOWED_NAMESPACES" in j ? Ve({}, j.ALLOWED_NAMESPACES, Zo) : Me, pn = "ADD_URI_SAFE_ATTR" in j ? Ve(
      Wt(gn),
      // eslint-disable-line indent
      j.ADD_URI_SAFE_ATTR,
      // eslint-disable-line indent
      qe
      // eslint-disable-line indent
    ) : gn, en = "ADD_DATA_URI_TAGS" in j ? Ve(
      Wt(yn),
      // eslint-disable-line indent
      j.ADD_DATA_URI_TAGS,
      // eslint-disable-line indent
      qe
      // eslint-disable-line indent
    ) : yn, De = "FORBID_CONTENTS" in j ? Ve({}, j.FORBID_CONTENTS, qe) : cn, fe = "FORBID_TAGS" in j ? Ve({}, j.FORBID_TAGS, qe) : {}, ge = "FORBID_ATTR" in j ? Ve({}, j.FORBID_ATTR, qe) : {}, Be = "USE_PROFILES" in j ? j.USE_PROFILES : !1, X = j.ALLOW_ARIA_ATTR !== !1, ye = j.ALLOW_DATA_ATTR !== !1, W = j.ALLOW_UNKNOWN_PROTOCOLS || !1, ce = j.SAFE_FOR_TEMPLATES || !1, ie = j.WHOLE_DOCUMENT || !1, Ee = j.RETURN_DOM || !1, Ie = j.RETURN_DOM_FRAGMENT || !1, we = j.RETURN_TRUSTED_TYPE || !1, be = j.FORCE_BODY || !1, Ge = j.SANITIZE_DOM !== !1, je = j.SANITIZE_NAMED_PROPS || !1, Ye = j.KEEP_CONTENT !== !1, Ae = j.IN_PLACE || !1, J = j.ALLOWED_URI_REGEXP || J, He = j.NAMESPACE || Re, j.CUSTOM_ELEMENT_HANDLING && hn(j.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (Y.tagNameCheck = j.CUSTOM_ELEMENT_HANDLING.tagNameCheck), j.CUSTOM_ELEMENT_HANDLING && hn(j.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (Y.attributeNameCheck = j.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), j.CUSTOM_ELEMENT_HANDLING && typeof j.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (Y.allowCustomizedBuiltInElements = j.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), ce && (ye = !1), Ie && (Ee = !0), Be && (z = Ve({}, et(Wu)), ke = [], Be.html === !0 && (Ve(z, Gu), Ve(ke, Yu)), Be.svg === !0 && (Ve(z, es), Ve(ke, rs), Ve(ke, Bi)), Be.svgFilters === !0 && (Ve(z, ns), Ve(ke, rs), Ve(ke, Bi)), Be.mathMl === !0 && (Ve(z, ts), Ve(ke, Qu), Ve(ke, Bi))), j.ADD_TAGS && (z === me && (z = Wt(z)), Ve(z, j.ADD_TAGS, qe)), j.ADD_ATTR && (ke === Oe && (ke = Wt(ke)), Ve(ke, j.ADD_ATTR, qe)), j.ADD_URI_SAFE_ATTR && Ve(pn, j.ADD_URI_SAFE_ATTR, qe), j.FORBID_CONTENTS && (De === cn && (De = Wt(De)), Ve(De, j.FORBID_CONTENTS, qe)), Ye && (z["#text"] = !0), ie && Ve(z, ["html", "head", "body"]), z.table && (Ve(z, ["tbody"]), delete fe.tbody), Pn && Pn(j), Ke = j);
  }, Qe = Ve({}, ["mi", "mo", "mn", "ms", "mtext"]), kn = Ve({}, ["foreignobject", "desc", "title", "annotation-xml"]), Sn = Ve({}, ["title", "style", "font", "a", "script"]), mn = Ve({}, es);
  Ve(mn, ns), Ve(mn, T$);
  var vn = Ve({}, ts);
  Ve(vn, O$);
  var t = function(j) {
    var A = P(j);
    (!A || !A.tagName) && (A = {
      namespaceURI: He,
      tagName: "template"
    });
    var ve = ea(j.tagName), Xe = ea(A.tagName);
    return Le[j.namespaceURI] ? j.namespaceURI === un ? A.namespaceURI === Re ? ve === "svg" : A.namespaceURI === dn ? ve === "svg" && (Xe === "annotation-xml" || Qe[Xe]) : !!mn[ve] : j.namespaceURI === dn ? A.namespaceURI === Re ? ve === "math" : A.namespaceURI === un ? ve === "math" && kn[Xe] : !!vn[ve] : j.namespaceURI === Re ? A.namespaceURI === un && !kn[Xe] || A.namespaceURI === dn && !Qe[Xe] ? !1 : !vn[ve] && (Sn[ve] || !mn[ve]) : !!(ze === "application/xhtml+xml" && Le[j.namespaceURI]) : !1;
  }, a = function(j) {
    Xr(n.removed, {
      element: j
    });
    try {
      j.parentNode.removeChild(j);
    } catch {
      try {
        j.outerHTML = q;
      } catch {
        j.remove();
      }
    }
  }, d = function(j, A) {
    try {
      Xr(n.removed, {
        attribute: A.getAttributeNode(j),
        from: A
      });
    } catch {
      Xr(n.removed, {
        attribute: null,
        from: A
      });
    }
    if (A.removeAttribute(j), j === "is" && !ke[j])
      if (Ee || Ie)
        try {
          a(A);
        } catch {
        }
      else
        try {
          A.setAttribute(j, "");
        } catch {
        }
  }, f = function(j) {
    var A, ve;
    if (be)
      j = "<remove></remove>" + j;
    else {
      var Xe = E$(j, /^[\r\n\t ]+/);
      ve = Xe && Xe[0];
    }
    ze === "application/xhtml+xml" && He === Re && (j = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + j + "</body></html>");
    var Nn = E ? E.createHTML(j) : j;
    if (He === Re)
      try {
        A = new y().parseFromString(Nn, ze);
      } catch {
      }
    if (!A || !A.documentElement) {
      A = R.createDocument(He, "template", null);
      try {
        A.documentElement.innerHTML = Ne ? q : Nn;
      } catch {
      }
    }
    var Bn = A.body || A.documentElement;
    return j && ve && Bn.insertBefore(i.createTextNode(ve), Bn.childNodes[0] || null), He === Re ? pe.call(A, ie ? "html" : "body")[0] : ie ? A.documentElement : Bn;
  }, _ = function(j) {
    return w.call(
      j.ownerDocument || j,
      j,
      // eslint-disable-next-line no-bitwise
      u.SHOW_ELEMENT | u.SHOW_COMMENT | u.SHOW_TEXT,
      null,
      !1
    );
  }, S = function(j) {
    return j instanceof v && (typeof j.nodeName != "string" || typeof j.textContent != "string" || typeof j.removeChild != "function" || !(j.attributes instanceof m) || typeof j.removeAttribute != "function" || typeof j.setAttribute != "function" || typeof j.namespaceURI != "string" || typeof j.insertBefore != "function" || typeof j.hasChildNodes != "function");
  }, k = function(j) {
    return Pt(l) === "object" ? j instanceof l : j && Pt(j) === "object" && typeof j.nodeType == "number" && typeof j.nodeName == "string";
  }, g = function(j, A, ve) {
    ae[j] && C$(ae[j], function(Xe) {
      Xe.call(n, A, ve, Ke);
    });
  }, L = function(j) {
    var A;
    if (g("beforeSanitizeElements", j, null), S(j) || Dn(/[\u0080-\uFFFF]/, j.nodeName))
      return a(j), !0;
    var ve = qe(j.nodeName);
    if (g("uponSanitizeElement", j, {
      tagName: ve,
      allowedTags: z
    }), j.hasChildNodes() && !k(j.firstElementChild) && (!k(j.content) || !k(j.content.firstElementChild)) && Dn(/<[/\w]/g, j.innerHTML) && Dn(/<[/\w]/g, j.textContent) || ve === "select" && Dn(/<template/i, j.innerHTML))
      return a(j), !0;
    if (!z[ve] || fe[ve]) {
      if (!fe[ve] && O(ve) && (Y.tagNameCheck instanceof RegExp && Dn(Y.tagNameCheck, ve) || Y.tagNameCheck instanceof Function && Y.tagNameCheck(ve)))
        return !1;
      if (Ye && !De[ve]) {
        var Xe = P(j) || j.parentNode, Nn = $(j) || j.childNodes;
        if (Nn && Xe)
          for (var Bn = Nn.length, En = Bn - 1; En >= 0; --En)
            Xe.insertBefore(x(Nn[En], !0), T(j));
      }
      return a(j), !0;
    }
    return j instanceof c && !t(j) || (ve === "noscript" || ve === "noembed") && Dn(/<\/no(script|embed)/i, j.innerHTML) ? (a(j), !0) : (ce && j.nodeType === 3 && (A = j.textContent, A = Xn(A, D, " "), A = Xn(A, V, " "), A = Xn(A, de, " "), j.textContent !== A && (Xr(n.removed, {
      element: j.cloneNode()
    }), j.textContent = A)), g("afterSanitizeElements", j, null), !1);
  }, I = function(j, A, ve) {
    if (Ge && (A === "id" || A === "name") && (ve in i || ve in Ze))
      return !1;
    if (!(ye && !ge[A] && Dn(te, A)) && !(X && Dn(he, A))) {
      if (!ke[A] || ge[A]) {
        if (
          // First condition does a very basic check if a) it's basically a valid custom element tagname AND
          // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
          !(O(j) && (Y.tagNameCheck instanceof RegExp && Dn(Y.tagNameCheck, j) || Y.tagNameCheck instanceof Function && Y.tagNameCheck(j)) && (Y.attributeNameCheck instanceof RegExp && Dn(Y.attributeNameCheck, A) || Y.attributeNameCheck instanceof Function && Y.attributeNameCheck(A)) || // Alternative, second condition checks if it's an `is`-attribute, AND
          // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          A === "is" && Y.allowCustomizedBuiltInElements && (Y.tagNameCheck instanceof RegExp && Dn(Y.tagNameCheck, ve) || Y.tagNameCheck instanceof Function && Y.tagNameCheck(ve)))
        )
          return !1;
      } else if (!pn[A] && !Dn(J, Xn(ve, Z, "")) && !((A === "src" || A === "xlink:href" || A === "href") && j !== "script" && F$(ve, "data:") === 0 && en[j]) && !(W && !Dn(_e, Xn(ve, Z, ""))) && ve)
        return !1;
    }
    return !0;
  }, O = function(j) {
    return j.indexOf("-") > 0;
  }, re = function(j) {
    var A, ve, Xe, Nn;
    g("beforeSanitizeAttributes", j, null);
    var Bn = j.attributes;
    if (Bn) {
      var En = {
        attrName: "",
        attrValue: "",
        keepAttr: !0,
        allowedAttributes: ke
      };
      for (Nn = Bn.length; Nn--; ) {
        A = Bn[Nn];
        var qr = A, yt = qr.name, An = qr.namespaceURI;
        if (ve = yt === "value" ? A.value : I$(A.value), Xe = qe(yt), En.attrName = Xe, En.attrValue = ve, En.keepAttr = !0, En.forceKeepAttr = void 0, g("uponSanitizeAttribute", j, En), ve = En.attrValue, !En.forceKeepAttr && (d(yt, j), !!En.keepAttr)) {
          if (Dn(/\/>/i, ve)) {
            d(yt, j);
            continue;
          }
          ce && (ve = Xn(ve, D, " "), ve = Xn(ve, V, " "), ve = Xn(ve, de, " "));
          var sc = qe(j.nodeName);
          if (I(sc, Xe, ve)) {
            if (je && (Xe === "id" || Xe === "name") && (d(yt, j), ve = Te + ve), E && Pt(b) === "object" && typeof b.getAttributeType == "function" && !An)
              switch (b.getAttributeType(sc, Xe)) {
                case "TrustedHTML":
                  ve = E.createHTML(ve);
                  break;
                case "TrustedScriptURL":
                  ve = E.createScriptURL(ve);
                  break;
              }
            try {
              An ? j.setAttributeNS(An, yt, ve) : j.setAttribute(yt, ve), Ku(n.removed);
            } catch {
            }
          }
        }
      }
      g("afterSanitizeAttributes", j, null);
    }
  }, Ce = function j(A) {
    var ve, Xe = _(A);
    for (g("beforeSanitizeShadowDOM", A, null); ve = Xe.nextNode(); )
      g("uponSanitizeShadowNode", ve, null), !L(ve) && (ve.content instanceof o && j(ve.content), re(ve));
    g("afterSanitizeShadowDOM", A, null);
  };
  return n.sanitize = function(j) {
    var A = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, ve, Xe, Nn, Bn, En;
    if (Ne = !j, Ne && (j = "<!-->"), typeof j != "string" && !k(j)) {
      if (typeof j.toString != "function")
        throw Xo("toString is not a function");
      if (j = j.toString(), typeof j != "string")
        throw Xo("dirty is not a string, aborting");
    }
    if (!n.isSupported) {
      if (Pt(e.toStaticHTML) === "object" || typeof e.toStaticHTML == "function") {
        if (typeof j == "string")
          return e.toStaticHTML(j);
        if (k(j))
          return e.toStaticHTML(j.outerHTML);
      }
      return j;
    }
    if (oe || fn(A), n.removed = [], typeof j == "string" && (Ae = !1), Ae) {
      if (j.nodeName) {
        var qr = qe(j.nodeName);
        if (!z[qr] || fe[qr])
          throw Xo("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (j instanceof l)
      ve = f("<!---->"), Xe = ve.ownerDocument.importNode(j, !0), Xe.nodeType === 1 && Xe.nodeName === "BODY" || Xe.nodeName === "HTML" ? ve = Xe : ve.appendChild(Xe);
    else {
      if (!Ee && !ce && !ie && // eslint-disable-next-line unicorn/prefer-includes
      j.indexOf("<") === -1)
        return E && we ? E.createHTML(j) : j;
      if (ve = f(j), !ve)
        return Ee ? null : we ? q : "";
    }
    ve && be && a(ve.firstChild);
    for (var yt = _(Ae ? j : ve); Nn = yt.nextNode(); )
      Nn.nodeType === 3 && Nn === Bn || L(Nn) || (Nn.content instanceof o && Ce(Nn.content), re(Nn), Bn = Nn);
    if (Bn = null, Ae)
      return j;
    if (Ee) {
      if (Ie)
        for (En = H.call(ve.ownerDocument); ve.firstChild; )
          En.appendChild(ve.firstChild);
      else
        En = ve;
      return ke.shadowroot && (En = le.call(r, En, !0)), En;
    }
    var An = ie ? ve.outerHTML : ve.innerHTML;
    return ie && z["!doctype"] && ve.ownerDocument && ve.ownerDocument.doctype && ve.ownerDocument.doctype.name && Dn(V$, ve.ownerDocument.doctype.name) && (An = "<!DOCTYPE " + ve.ownerDocument.doctype.name + `>
` + An), ce && (An = Xn(An, D, " "), An = Xn(An, V, " "), An = Xn(An, de, " ")), E && we ? E.createHTML(An) : An;
  }, n.setConfig = function(j) {
    fn(j), oe = !0;
  }, n.clearConfig = function() {
    Ke = null, oe = !1;
  }, n.isValidAttribute = function(j, A, ve) {
    Ke || fn({});
    var Xe = qe(j), Nn = qe(A);
    return I(Xe, Nn, ve);
  }, n.addHook = function(j, A) {
    typeof A == "function" && (ae[j] = ae[j] || [], Xr(ae[j], A));
  }, n.removeHook = function(j) {
    if (ae[j])
      return Ku(ae[j]);
  }, n.removeHooks = function(j) {
    ae[j] && (ae[j] = []);
  }, n.removeAllHooks = function() {
    ae = {};
  }, n;
}
var H$ = ov();
const K$ = "_messageContainer_81q22_27", G$ = "_chip_81q22_33", W$ = "_chipLabel_81q22_36", Y$ = "_chipValue_81q22_39", Vi = {
  messageContainer: K$,
  chip: G$,
  chipLabel: W$,
  chipValue: Y$
}, Ju = {
  INBOUND: {
    background: $e.neutral["000"],
    borderColor: $e.neutral[100]
  },
  OUTBOUND: {
    background: $e.neutral[100],
    borderColor: $e.neutral[200]
  },
  INTERNAL: {
    background: $e.orange[100],
    borderColor: $e.orange[200]
  }
}, Q$ = ({
  messages: e,
  customFields: n,
  attachments: r,
  conversationContext: i
}) => {
  Pe(() => {
    var s;
    document.getElementById("endOfConversationAnchor") && ((s = document.getElementById("endOfConversationAnchor")) == null || s.scrollIntoView({ behavior: "smooth" }));
  }, [e]);
  const o = () => {
    const s = "End User";
    if (!(i != null && i.customer))
      return s;
    const { displayName: l, name: c, givenName: u, familyName: p, email: m, phoneNumber: v } = i.customer;
    return l ?? c ?? u ?? p ?? m ?? v ?? s;
  };
  return /* @__PURE__ */ Ue.jsxs(C, { flexDirection: "column", gap: "200", children: [
    /* @__PURE__ */ Ue.jsx(C, { flexDirection: "row", flexWrap: "wrap", margin: "0 0 300", children: !!(n != null && n.length) && /* @__PURE__ */ Ue.jsxs(C, { gap: "100", children: [
      /* @__PURE__ */ Ue.jsx(jn, { content: "Conversation Attributes", dark: !0, children: /* @__PURE__ */ Ue.jsx(
        gl,
        {
          icon: "input",
          color: {
            contentColor: $e.neutral[700],
            backgroundColor: $e.neutral[200]
          }
        }
      ) }),
      n.map((s, l) => /* @__PURE__ */ Ue.jsx(C, { alignItems: "center", children: /* @__PURE__ */ Ue.jsx(an, { className: Vi.chip, children: /* @__PURE__ */ Ue.jsxs(C, { gap: "100", children: [
        /* @__PURE__ */ Ue.jsxs(nn, { className: Vi.chipLabel, children: [
          s.name,
          ":"
        ] }),
        /* @__PURE__ */ Ue.jsx(nn, { className: Vi.chipValue, children: s.value })
      ] }) }) }, `${l}-${s.name}`))
    ] }) }),
    e == null ? void 0 : e.map((s) => {
      var l, c;
      return /* @__PURE__ */ Ue.jsx(
        C,
        {
          className: Vi.messageContainer,
          gap: "200",
          style: {
            backgroundColor: s != null && s.direction ? Ju[s.direction].background : $e.neutral["000"],
            borderColor: s != null && s.direction ? Ju[s.direction].borderColor : $e.neutral[100]
          },
          children: /* @__PURE__ */ Ue.jsxs(C, { flexDirection: "column", gap: "200", width: "100%", children: [
            /* @__PURE__ */ Ue.jsxs(C, { flexDirection: "row", justifyContent: "space-between", children: [
              /* @__PURE__ */ Ue.jsx(se.Heading, { variant: "heading-3", children: (s == null ? void 0 : s.direction) == "INBOUND" ? o() : (l = s == null ? void 0 : s.agent) == null ? void 0 : l.name }),
              /* @__PURE__ */ Ue.jsx(se.Paragraph, { variant: "4", children: /* @__PURE__ */ Ue.jsx(_m, { relative: !0, time: s == null ? void 0 : s.created_at }) })
            ] }),
            /* @__PURE__ */ Ue.jsx(
              "div",
              {
                dangerouslySetInnerHTML: {
                  __html: H$.sanitize(
                    ((c = s == null ? void 0 : s.body) == null ? void 0 : c.replaceAll(/\r\n?|\n/g, "<br />")) || ""
                  )
                }
              }
            )
          ] })
        },
        s == null ? void 0 : s.created_at
      );
    }),
    /* @__PURE__ */ Ue.jsx(C, { gap: "200", flexDirection: "row", flexWrap: "wrap", margin: "300 0 0", children: r.map((s, l) => /* @__PURE__ */ Ue.jsx(
      Lv,
      {
        fileName: s.url,
        label: s.label,
        onDownload: () => {
          var c;
          (c = window.open(s.url, "_blank")) == null || c.focus();
        }
      },
      `${l}-${s.url}`
    )) }),
    /* @__PURE__ */ Ue.jsx("div", { id: "endOfConversationAnchor", children: " " })
  ] });
}, J$ = "_conversation_18up1_27", Z$ = "_conversationSubLine_18up1_35", X$ = "_modal_18up1_40", is = {
  conversation: J$,
  conversationSubLine: Z$,
  modal: X$
}, eT = (e) => (e && JSON.parse(e) || []).map((n) => ({
  url: n.URL__c,
  label: n.Name,
  type: n.File_Type__c
})), nT = (e) => Object.entries(e || {}).filter(([n]) => n.endsWith("__c")).map(([n, r]) => ({
  name: n.replace("__c", "").replaceAll("_", " "),
  // transform key into readable name
  value: r != null && r.value ? r.value.toString() : ""
})), tT = ({
  conversation: e,
  conversationContext: n
}) => {
  var r, i, o;
  const [s, l] = G(!1);
  return /* @__PURE__ */ Ue.jsxs(C, { className: is.conversation, gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ Ue.jsxs(C, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ Ue.jsxs(C, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ Ue.jsxs(C, { flexDirection: "row", gap: "100", children: [
          /* @__PURE__ */ Ue.jsx(se.Heading, { variant: "heading-4", children: e == null ? void 0 : e.id }),
          /* @__PURE__ */ Ue.jsx(ut, { size: "small", variant: "info", children: Nt(e == null ? void 0 : e.created_at).format("DD MMM YYYY @ HH:MM") })
        ] }),
        /* @__PURE__ */ Ue.jsx(
          se.Heading,
          {
            variant: "heading-4",
            className: is.conversationSubLine,
            children: e == null ? void 0 : e.subject
          }
        ),
        !!((r = e == null ? void 0 : e.labels) != null && r.length) && /* @__PURE__ */ Ue.jsx(C, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [...new Set(e.labels)].map((c) => /* @__PURE__ */ Ue.jsx(an, { children: c }, `${e.id}-${c}`)) })
      ] }),
      /* @__PURE__ */ Ue.jsx(jn, { content: "Show conversation preview", dark: !0, children: /* @__PURE__ */ Ue.jsx(
        Bt,
        {
          variant: "secondary",
          icon: "eye",
          onClick: () => l(!0),
          "data-testid": "open-messages-preview"
        }
      ) })
    ] }),
    /* @__PURE__ */ Ue.jsxs(
      jt,
      {
        isOpen: s,
        allowEscClose: !0,
        onClose: () => l(!1),
        className: is.modal,
        children: [
          /* @__PURE__ */ Ue.jsx(
            Ct,
            {
              title: "Conversation preview",
              onClose: () => l(!1)
            }
          ),
          /* @__PURE__ */ Ue.jsx(Et, { children: /* @__PURE__ */ Ue.jsx(
            Q$,
            {
              messages: (e == null ? void 0 : e.messages) || [],
              attachments: eT(
                (o = (i = e == null ? void 0 : e.custom_fields) == null ? void 0 : i.attachments) == null ? void 0 : o.value
              ),
              conversationContext: n,
              customFields: nT(
                e == null ? void 0 : e.custom_fields
              )
            }
          ) })
        ]
      }
    )
  ] });
}, rT = ({
  conversations: e,
  conversationContext: n,
  conversationsToShow: r
}) => {
  const [i, o] = G(!1), s = r > 0 ? r : 1, l = (e == null ? void 0 : e.length) > s, c = At(
    () => e == null ? void 0 : e.sort((u, p) => p == null ? void 0 : p.created_at.localeCompare(u == null ? void 0 : u.created_at)).slice(
      0,
      i ? e.length : s
    ),
    [e, i, s]
  );
  return /* @__PURE__ */ Ue.jsxs(C, { flexDirection: "column", gap: "200", margin: "200 0 300 0", children: [
    c.map((u, p) => /* @__PURE__ */ Ue.jsx(
      tT,
      {
        conversation: u,
        conversationContext: n
      },
      `${p}-${u == null ? void 0 : u.id}`
    )),
    l && /* @__PURE__ */ Ue.jsxs(
      On,
      {
        variant: "secondary",
        onClick: () => o(!i),
        children: [
          "Show ",
          i ? "less" : "all"
        ]
      }
    )
  ] });
}, iT = y$(
  /* GraphQL*/
  `
  query conversationsQuery($query: String) {
    Miuros {
      findTickets(query: $query, page_size: 10) {
        data {
          id
          labels
          subject
          messages {
            direction
            body
            agent {
              email
              name
            }
            created_at
          }
          custom_fields
          created_at
        }
      }
    }
  }
`
), aT = ({
  conversationContext: e,
  settings: n
}) => {
  var r, i;
  const [o, s] = G([]), l = Number.parseInt(n == null ? void 0 : n.amountOfConversationsToShow) || 1, c = [
    (r = e.customer) == null ? void 0 : r.email,
    (i = e.customer) == null ? void 0 : i.phoneNumber
  ].filter((y) => !!y).map((y) => `'${y}'`).join(","), { useQuery: u } = rn(), { data: p, loading: m, error: v } = u(iT, {
    skip: c.length === 0,
    variables: {
      query: `requester_id=in=(${c})`
    }
  });
  return Pe(() => {
    var y, b;
    if (p != null && p.Miuros) {
      const N = (b = (y = p == null ? void 0 : p.Miuros) == null ? void 0 : y.findTickets) == null ? void 0 : b.data;
      N && s(N);
    }
  }, [p]), v ? /* @__PURE__ */ Ue.jsx(bn, { error: v }) : m ? /* @__PURE__ */ Ue.jsx(C, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Ue.jsx(ln, {}) }) : (o == null ? void 0 : o.length) === 0 ? /* @__PURE__ */ Ue.jsx(C, { justifyContent: "center", margin: "200 0 300 0", children: "No conversations found for this customer" }) : /* @__PURE__ */ Ue.jsx(
    rT,
    {
      "data-testid": "conversation-list",
      conversationsToShow: l,
      conversations: o,
      conversationContext: e
    }
  );
}, oT = [
  {
    key: "miurosClientId",
    label: "Authorization: Client ID",
    placeholder: "Insert client ID",
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "miurosClientSecret",
    label: "Authorization: Client Secret",
    placeholder: "Insert client secret",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: ga
  },
  {
    key: "amountOfConversationsToShow",
    label: "Number of conversation to show before the fold",
    placeholder: "Enter number",
    required: !0,
    defaultValue: "1",
    secret: !1,
    type: "input",
    customValidation: (e) => isNaN(Number.parseInt(e)) ? "Please enter a number" : void 0
  }
], sT = "https://support.dixa.help/articles/1205", Zu = [
  {
    key: "enableRefundOrder",
    label: 'Enable the "refund order" button',
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "enableEditShippingAddress",
    label: 'Enable the "edit shipping address" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
];
var cl = { exports: {} }, kr = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var as, Xu;
function sv() {
  if (Xu)
    return as;
  Xu = 1;
  var e = Object.getOwnPropertySymbols, n = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function i(s) {
    if (s == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(s);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var s = new String("abc");
      if (s[5] = "de", Object.getOwnPropertyNames(s)[0] === "5")
        return !1;
      for (var l = {}, c = 0; c < 10; c++)
        l["_" + String.fromCharCode(c)] = c;
      var u = Object.getOwnPropertyNames(l).map(function(m) {
        return l[m];
      });
      if (u.join("") !== "0123456789")
        return !1;
      var p = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(m) {
        p[m] = m;
      }), Object.keys(Object.assign({}, p)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return as = o() ? Object.assign : function(s, l) {
    for (var c, u = i(s), p, m = 1; m < arguments.length; m++) {
      c = Object(arguments[m]);
      for (var v in c)
        n.call(c, v) && (u[v] = c[v]);
      if (e) {
        p = e(c);
        for (var y = 0; y < p.length; y++)
          r.call(c, p[y]) && (u[p[y]] = c[p[y]]);
      }
    }
    return u;
  }, as;
}
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var em;
function lT() {
  if (em)
    return kr;
  em = 1, sv();
  var e = Cn, n = 60103;
  if (kr.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var r = Symbol.for;
    n = r("react.element"), kr.Fragment = r("react.fragment");
  }
  var i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = Object.prototype.hasOwnProperty, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(c, u, p) {
    var m, v = {}, y = null, b = null;
    p !== void 0 && (y = "" + p), u.key !== void 0 && (y = "" + u.key), u.ref !== void 0 && (b = u.ref);
    for (m in u)
      o.call(u, m) && !s.hasOwnProperty(m) && (v[m] = u[m]);
    if (c && c.defaultProps)
      for (m in u = c.defaultProps, u)
        v[m] === void 0 && (v[m] = u[m]);
    return { $$typeof: n, type: c, key: y, ref: b, props: v, _owner: i.current };
  }
  return kr.jsx = l, kr.jsxs = l, kr;
}
var nm = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var tm;
function cT() {
  return tm || (tm = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      var n = Cn, r = sv(), i = 60103, o = 60106;
      e.Fragment = 60107;
      var s = 60108, l = 60114, c = 60109, u = 60110, p = 60112, m = 60113, v = 60120, y = 60115, b = 60116, N = 60121, x = 60122, T = 60117, $ = 60129, P = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var h = Symbol.for;
        i = h("react.element"), o = h("react.portal"), e.Fragment = h("react.fragment"), s = h("react.strict_mode"), l = h("react.profiler"), c = h("react.provider"), u = h("react.context"), p = h("react.forward_ref"), m = h("react.suspense"), v = h("react.suspense_list"), y = h("react.memo"), b = h("react.lazy"), N = h("react.block"), x = h("react.server.block"), T = h("react.fundamental"), h("react.scope"), h("react.opaque.id"), $ = h("react.debug_trace_mode"), h("react.offscreen"), P = h("react.legacy_hidden");
      }
      var E = typeof Symbol == "function" && Symbol.iterator, q = "@@iterator";
      function M(t) {
        if (t === null || typeof t != "object")
          return null;
        var a = E && t[E] || t[q];
        return typeof a == "function" ? a : null;
      }
      var R = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function w(t) {
        {
          for (var a = arguments.length, d = new Array(a > 1 ? a - 1 : 0), f = 1; f < a; f++)
            d[f - 1] = arguments[f];
          H("error", t, d);
        }
      }
      function H(t, a, d) {
        {
          var f = R.ReactDebugCurrentFrame, _ = f.getStackAddendum();
          _ !== "" && (a += "%s", d = d.concat([_]));
          var S = d.map(function(k) {
            return "" + k;
          });
          S.unshift("Warning: " + a), Function.prototype.apply.call(console[t], console, S);
        }
      }
      var pe = !1;
      function le(t) {
        return !!(typeof t == "string" || typeof t == "function" || t === e.Fragment || t === l || t === $ || t === s || t === m || t === v || t === P || pe || typeof t == "object" && t !== null && (t.$$typeof === b || t.$$typeof === y || t.$$typeof === c || t.$$typeof === u || t.$$typeof === p || t.$$typeof === T || t.$$typeof === N || t[0] === x));
      }
      function Se(t, a, d) {
        var f = a.displayName || a.name || "";
        return t.displayName || (f !== "" ? d + "(" + f + ")" : d);
      }
      function ae(t) {
        return t.displayName || "Context";
      }
      function D(t) {
        if (t == null)
          return null;
        if (typeof t.tag == "number" && w("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof t == "function")
          return t.displayName || t.name || null;
        if (typeof t == "string")
          return t;
        switch (t) {
          case e.Fragment:
            return "Fragment";
          case o:
            return "Portal";
          case l:
            return "Profiler";
          case s:
            return "StrictMode";
          case m:
            return "Suspense";
          case v:
            return "SuspenseList";
        }
        if (typeof t == "object")
          switch (t.$$typeof) {
            case u:
              var a = t;
              return ae(a) + ".Consumer";
            case c:
              var d = t;
              return ae(d._context) + ".Provider";
            case p:
              return Se(t, t.render, "ForwardRef");
            case y:
              return D(t.type);
            case N:
              return D(t._render);
            case b: {
              var f = t, _ = f._payload, S = f._init;
              try {
                return D(S(_));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var V = 0, de, te, he, _e, Z, J, z;
      function me() {
      }
      me.__reactDisabledLog = !0;
      function ke() {
        {
          if (V === 0) {
            de = console.log, te = console.info, he = console.warn, _e = console.error, Z = console.group, J = console.groupCollapsed, z = console.groupEnd;
            var t = {
              configurable: !0,
              enumerable: !0,
              value: me,
              writable: !0
            };
            Object.defineProperties(console, {
              info: t,
              log: t,
              warn: t,
              error: t,
              group: t,
              groupCollapsed: t,
              groupEnd: t
            });
          }
          V++;
        }
      }
      function Oe() {
        {
          if (V--, V === 0) {
            var t = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: r({}, t, {
                value: de
              }),
              info: r({}, t, {
                value: te
              }),
              warn: r({}, t, {
                value: he
              }),
              error: r({}, t, {
                value: _e
              }),
              group: r({}, t, {
                value: Z
              }),
              groupCollapsed: r({}, t, {
                value: J
              }),
              groupEnd: r({}, t, {
                value: z
              })
            });
          }
          V < 0 && w("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var Y = R.ReactCurrentDispatcher, fe;
      function ge(t, a, d) {
        {
          if (fe === void 0)
            try {
              throw Error();
            } catch (_) {
              var f = _.stack.trim().match(/\n( *(at )?)/);
              fe = f && f[1] || "";
            }
          return `
` + fe + t;
        }
      }
      var X = !1, ye;
      {
        var W = typeof WeakMap == "function" ? WeakMap : Map;
        ye = new W();
      }
      function ce(t, a) {
        if (!t || X)
          return "";
        {
          var d = ye.get(t);
          if (d !== void 0)
            return d;
        }
        var f;
        X = !0;
        var _ = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var S;
        S = Y.current, Y.current = null, ke();
        try {
          if (a) {
            var k = function() {
              throw Error();
            };
            if (Object.defineProperty(k.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(k, []);
              } catch (A) {
                f = A;
              }
              Reflect.construct(t, [], k);
            } else {
              try {
                k.call();
              } catch (A) {
                f = A;
              }
              t.call(k.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (A) {
              f = A;
            }
            t();
          }
        } catch (A) {
          if (A && f && typeof A.stack == "string") {
            for (var g = A.stack.split(`
`), L = f.stack.split(`
`), I = g.length - 1, O = L.length - 1; I >= 1 && O >= 0 && g[I] !== L[O]; )
              O--;
            for (; I >= 1 && O >= 0; I--, O--)
              if (g[I] !== L[O]) {
                if (I !== 1 || O !== 1)
                  do
                    if (I--, O--, O < 0 || g[I] !== L[O]) {
                      var re = `
` + g[I].replace(" at new ", " at ");
                      return typeof t == "function" && ye.set(t, re), re;
                    }
                  while (I >= 1 && O >= 0);
                break;
              }
          }
        } finally {
          X = !1, Y.current = S, Oe(), Error.prepareStackTrace = _;
        }
        var Ce = t ? t.displayName || t.name : "", j = Ce ? ge(Ce) : "";
        return typeof t == "function" && ye.set(t, j), j;
      }
      function ie(t, a, d) {
        return ce(t, !1);
      }
      function oe(t) {
        var a = t.prototype;
        return !!(a && a.isReactComponent);
      }
      function be(t, a, d) {
        if (t == null)
          return "";
        if (typeof t == "function")
          return ce(t, oe(t));
        if (typeof t == "string")
          return ge(t);
        switch (t) {
          case m:
            return ge("Suspense");
          case v:
            return ge("SuspenseList");
        }
        if (typeof t == "object")
          switch (t.$$typeof) {
            case p:
              return ie(t.render);
            case y:
              return be(t.type, a, d);
            case N:
              return ie(t._render);
            case b: {
              var f = t, _ = f._payload, S = f._init;
              try {
                return be(S(_), a, d);
              } catch {
              }
            }
          }
        return "";
      }
      var Ee = {}, Ie = R.ReactDebugCurrentFrame;
      function we(t) {
        if (t) {
          var a = t._owner, d = be(t.type, t._source, a ? a.type : null);
          Ie.setExtraStackFrame(d);
        } else
          Ie.setExtraStackFrame(null);
      }
      function Ge(t, a, d, f, _) {
        {
          var S = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var k in t)
            if (S(t, k)) {
              var g = void 0;
              try {
                if (typeof t[k] != "function") {
                  var L = Error((f || "React class") + ": " + d + " type `" + k + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[k] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw L.name = "Invariant Violation", L;
                }
                g = t[k](a, k, f, d, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (I) {
                g = I;
              }
              g && !(g instanceof Error) && (we(_), w("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", f || "React class", d, k, typeof g), we(null)), g instanceof Error && !(g.message in Ee) && (Ee[g.message] = !0, we(_), w("Failed %s type: %s", d, g.message), we(null));
            }
        }
      }
      var je = R.ReactCurrentOwner, Te = Object.prototype.hasOwnProperty, Ye = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, Ae, Be, De;
      De = {};
      function cn(t) {
        if (Te.call(t, "ref")) {
          var a = Object.getOwnPropertyDescriptor(t, "ref").get;
          if (a && a.isReactWarning)
            return !1;
        }
        return t.ref !== void 0;
      }
      function en(t) {
        if (Te.call(t, "key")) {
          var a = Object.getOwnPropertyDescriptor(t, "key").get;
          if (a && a.isReactWarning)
            return !1;
        }
        return t.key !== void 0;
      }
      function yn(t, a) {
        if (typeof t.ref == "string" && je.current && a && je.current.stateNode !== a) {
          var d = D(je.current.type);
          De[d] || (w('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', D(je.current.type), t.ref), De[d] = !0);
        }
      }
      function pn(t, a) {
        {
          var d = function() {
            Ae || (Ae = !0, w("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", a));
          };
          d.isReactWarning = !0, Object.defineProperty(t, "key", {
            get: d,
            configurable: !0
          });
        }
      }
      function gn(t, a) {
        {
          var d = function() {
            Be || (Be = !0, w("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", a));
          };
          d.isReactWarning = !0, Object.defineProperty(t, "ref", {
            get: d,
            configurable: !0
          });
        }
      }
      var dn = function(t, a, d, f, _, S, k) {
        var g = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: i,
          // Built-in properties that belong on the element
          type: t,
          key: a,
          ref: d,
          props: k,
          // Record the component responsible for creating this element.
          _owner: S
        };
        return g._store = {}, Object.defineProperty(g._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(g, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: f
        }), Object.defineProperty(g, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: _
        }), Object.freeze && (Object.freeze(g.props), Object.freeze(g)), g;
      };
      function un(t, a, d, f, _) {
        {
          var S, k = {}, g = null, L = null;
          d !== void 0 && (g = "" + d), en(a) && (g = "" + a.key), cn(a) && (L = a.ref, yn(a, _));
          for (S in a)
            Te.call(a, S) && !Ye.hasOwnProperty(S) && (k[S] = a[S]);
          if (t && t.defaultProps) {
            var I = t.defaultProps;
            for (S in I)
              k[S] === void 0 && (k[S] = I[S]);
          }
          if (g || L) {
            var O = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
            g && pn(k, O), L && gn(k, O);
          }
          return dn(t, g, L, _, f, je.current, k);
        }
      }
      var Re = R.ReactCurrentOwner, He = R.ReactDebugCurrentFrame;
      function Ne(t) {
        if (t) {
          var a = t._owner, d = be(t.type, t._source, a ? a.type : null);
          He.setExtraStackFrame(d);
        } else
          He.setExtraStackFrame(null);
      }
      var Le;
      Le = !1;
      function Me(t) {
        return typeof t == "object" && t !== null && t.$$typeof === i;
      }
      function ze() {
        {
          if (Re.current) {
            var t = D(Re.current.type);
            if (t)
              return `

Check the render method of \`` + t + "`.";
          }
          return "";
        }
      }
      function _n(t) {
        {
          if (t !== void 0) {
            var a = t.fileName.replace(/^.*[\\\/]/, ""), d = t.lineNumber;
            return `

Check your code at ` + a + ":" + d + ".";
          }
          return "";
        }
      }
      var Je = {};
      function qe(t) {
        {
          var a = ze();
          if (!a) {
            var d = typeof t == "string" ? t : t.displayName || t.name;
            d && (a = `

Check the top-level render call using <` + d + ">.");
          }
          return a;
        }
      }
      function Ke(t, a) {
        {
          if (!t._store || t._store.validated || t.key != null)
            return;
          t._store.validated = !0;
          var d = qe(a);
          if (Je[d])
            return;
          Je[d] = !0;
          var f = "";
          t && t._owner && t._owner !== Re.current && (f = " It was passed a child from " + D(t._owner.type) + "."), Ne(t), w('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', d, f), Ne(null);
        }
      }
      function Ze(t, a) {
        {
          if (typeof t != "object")
            return;
          if (Array.isArray(t))
            for (var d = 0; d < t.length; d++) {
              var f = t[d];
              Me(f) && Ke(f, a);
            }
          else if (Me(t))
            t._store && (t._store.validated = !0);
          else if (t) {
            var _ = M(t);
            if (typeof _ == "function" && _ !== t.entries)
              for (var S = _.call(t), k; !(k = S.next()).done; )
                Me(k.value) && Ke(k.value, a);
          }
        }
      }
      function hn(t) {
        {
          var a = t.type;
          if (a == null || typeof a == "string")
            return;
          var d;
          if (typeof a == "function")
            d = a.propTypes;
          else if (typeof a == "object" && (a.$$typeof === p || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          a.$$typeof === y))
            d = a.propTypes;
          else
            return;
          if (d) {
            var f = D(a);
            Ge(d, t.props, "prop", f, t);
          } else if (a.PropTypes !== void 0 && !Le) {
            Le = !0;
            var _ = D(a);
            w("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _ || "Unknown");
          }
          typeof a.getDefaultProps == "function" && !a.getDefaultProps.isReactClassApproved && w("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function fn(t) {
        {
          for (var a = Object.keys(t.props), d = 0; d < a.length; d++) {
            var f = a[d];
            if (f !== "children" && f !== "key") {
              Ne(t), w("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", f), Ne(null);
              break;
            }
          }
          t.ref !== null && (Ne(t), w("Invalid attribute `ref` supplied to `React.Fragment`."), Ne(null));
        }
      }
      function Qe(t, a, d, f, _, S) {
        {
          var k = le(t);
          if (!k) {
            var g = "";
            (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (g += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var L = _n(_);
            L ? g += L : g += ze();
            var I;
            t === null ? I = "null" : Array.isArray(t) ? I = "array" : t !== void 0 && t.$$typeof === i ? (I = "<" + (D(t.type) || "Unknown") + " />", g = " Did you accidentally export a JSX literal instead of a component?") : I = typeof t, w("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", I, g);
          }
          var O = un(t, a, d, _, S);
          if (O == null)
            return O;
          if (k) {
            var re = a.children;
            if (re !== void 0)
              if (f)
                if (Array.isArray(re)) {
                  for (var Ce = 0; Ce < re.length; Ce++)
                    Ze(re[Ce], t);
                  Object.freeze && Object.freeze(re);
                } else
                  w("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                Ze(re, t);
          }
          return t === e.Fragment ? fn(O) : hn(O), O;
        }
      }
      function kn(t, a, d) {
        return Qe(t, a, d, !0);
      }
      function Sn(t, a, d) {
        return Qe(t, a, d, !1);
      }
      var mn = Sn, vn = kn;
      e.jsx = mn, e.jsxs = vn;
    }();
  }(nm)), nm;
}
process.env.NODE_ENV === "production" ? cl.exports = lT() : cl.exports = cT();
var Q = cl.exports;
const dT = ({
  initialValues: e,
  onSubmit: n
}) => {
  const [r, i] = G(e || []), [o, s] = G({}), l = (T) => i(T), c = () => i([]), u = (T) => !T || T === "", p = (T) => {
    const { [T]: $, ...P } = o;
    s(P);
  }, m = {
    input: "This can not be empty",
    select: "Please select an option"
  }, v = (T) => {
    if (!T)
      return;
    const {
      target: { name: $, value: P }
    } = T;
    o[$] && !u(P) && p($), i(
      r.map(
        (h) => h.key === $ ? { ...h, value: P } : h
      )
    );
  }, y = (T) => {
    console.log("handleSelectChange itemId", T);
  }, b = (T) => r == null ? void 0 : r.find(($) => $.key === T), N = async () => {
    x() && n(r);
  }, x = () => {
    const T = {};
    return r == null || r.forEach(({ key: $, value: P, type: h, required: E }) => {
      E && h !== "hidden" && u(P) && (T[$] = m[h]);
    }), s(T), !Object.keys(T).length;
  };
  return {
    formData: r,
    errors: o,
    handleInputChange: v,
    handleSelectChange: y,
    handleSubmit: N,
    getItemByKey: b,
    initialize: l,
    reset: c,
    validate: x
  };
}, uT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refundCreate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, mT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderUpdate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, pT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countriesInShippingZones" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countryCodes" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "customers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "numberOfOrders" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] } }] }, fT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "5" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "sortKey" }, value: { kind: "EnumValue", value: "CREATED_AT" } }, { kind: "Argument", name: { kind: "Name", value: "reverse" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "cancelledAt" } }, { kind: "Field", name: { kind: "Name", value: "netPaymentSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }, { kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedRefund" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "suggestFullRefund" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedTransactions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountNumber" } }, { kind: "Field", name: { kind: "Name", value: "gateway" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "parentTransaction" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "fulfillments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "2" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "trackingInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "15" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "variantTitle" } }, { kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] } }] } }] } }] } }] } }] }, vT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "test" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "description" } }] } }] } }] } }] }, yT = {
  "\n  mutation refundCreate($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": uT,
  "\n  mutation orderUpdate($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          shippingAddress {\n            firstName\n            lastName\n            company\n            address1\n            address2\n            city\n            countryCodeV2\n            provinceCode\n            zip\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": mT,
  "\n  query shopifyCustomerData($query: String!) {\n    Shopify {\n      shop {\n        countriesInShippingZones {\n          countryCodes\n        }\n      }\n\n      customers(first: 1, query: $query) {\n        edges {\n          node {\n            id\n            displayName\n            email\n            phone\n            numberOfOrders\n            tags\n            amountSpent {\n              amount\n              currencyCode\n            }\n          }\n        }\n      }\n    }\n  }\n": pT,
  "\n  query shopifyCustomerOrders($query: String!) {\n    Shopify {\n      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {\n        edges {\n          node {\n            id\n            name\n            createdAt\n            displayFulfillmentStatus\n            displayFinancialStatus\n            cancelledAt\n            netPaymentSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            totalRefundedSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            billingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n            }\n            shippingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n            }\n            suggestedRefund(suggestFullRefund: true) {\n              amountSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              suggestedTransactions {\n                accountNumber\n                gateway\n                kind\n                parentTransaction {\n                  id\n                }\n                amountSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n              }\n              refundLineItems {\n                lineItem {\n                  id\n                  quantity\n                }\n              }\n            }\n            fulfillments(first: 2) {\n              trackingInfo {\n                company\n                number\n                url\n              }\n            }\n            lineItems(first: 15) {\n              edges {\n                node {\n                  id\n                  title\n                  quantity\n                  variantTitle\n                  image {\n                    url\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": fT,
  "\n  query test {\n    Shopify {\n      shop {\n        name\n        email\n        description\n      }\n    }\n  }\n": vT
};
function Ma(e) {
  return yT[e] ?? {};
}
const gT = Ma(
  /* GraphQL */
  `
  query shopifyCustomerData($query: String!) {
    Shopify {
      shop {
        countriesInShippingZones {
          countryCodes
        }
      }

      customers(first: 1, query: $query) {
        edges {
          node {
            id
            displayName
            email
            phone
            numberOfOrders
            tags
            amountSpent {
              amount
              currencyCode
            }
          }
        }
      }
    }
  }
`
), hT = Ma(
  /* GraphQL */
  `
  mutation orderUpdate($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          shippingAddress {
            firstName
            lastName
            company
            address1
            address2
            city
            countryCodeV2
            provinceCode
            zip
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), kT = Ma(
  /* GraphQL */
  `
  query shopifyCustomerOrders($query: String!) {
    Shopify {
      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {
        edges {
          node {
            id
            name
            createdAt
            displayFulfillmentStatus
            displayFinancialStatus
            cancelledAt
            netPaymentSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            totalRefundedSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            billingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
            }
            shippingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
            }
            suggestedRefund(suggestFullRefund: true) {
              amountSet {
                presentmentMoney {
                  amount
                  currencyCode
                }
              }
              suggestedTransactions {
                accountNumber
                gateway
                kind
                parentTransaction {
                  id
                }
                amountSet {
                  presentmentMoney {
                    amount
                    currencyCode
                  }
                }
              }
              refundLineItems {
                lineItem {
                  id
                  quantity
                }
              }
            }
            fulfillments(first: 2) {
              trackingInfo {
                company
                number
                url
              }
            }
            lineItems(first: 15) {
              edges {
                node {
                  id
                  title
                  quantity
                  variantTitle
                  image {
                    url
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
), bT = Ma(
  /* GraphQL */
  `
  mutation refundCreate($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        userErrors {
          field
          message
        }
      }
    }
  }
`
), _T = ({
  conversationContext: e
}) => {
  var n, r;
  const { useQuery: i } = rn(), o = (n = e.customer) == null ? void 0 : n.email, s = (r = e.customer) == null ? void 0 : r.phoneNumber, l = o ? `email:"${o}"` : null, c = s ? `phone:"${s}"` : null, u = l ?? c ?? null, {
    loading: p,
    error: m,
    data: v,
    refetch: y,
    networkStatus: b
  } = i(gT, {
    skip: !u,
    variables: {
      query: u
    },
    notifyOnNetworkStatusChange: !0
  });
  return {
    isCustomerLoading: p,
    customerError: m,
    customerData: v,
    refetchCustomer: y,
    customerNetworkStatus: b
  };
}, ST = () => {
  const { useLazyQuery: e } = rn(), [
    n,
    {
      loading: r,
      error: i,
      data: o,
      refetch: s
    }
  ] = e(kT);
  return {
    getCustomerOrders: n,
    isCustomerOrdersLoading: r,
    customerOrdersError: i,
    customerOrders: o,
    refetchCustomerOrders: s
  };
}, ic = ({
  target: e,
  children: n,
  trackingAction: r,
  orderId: i,
  shopifyId: o
}) => {
  const { track: s } = sn(), l = () => {
    if (o)
      switch (r) {
        case "viewCustomerInShopify":
          s("shopify:view:customer:clicked", { shopifyId: o });
          break;
        case "viewAllOrdersInShopify":
          s("shopify:view:all:orders:clicked", { shopifyId: o });
          break;
        case "viewOrderInShopify":
          i && s("shopify:view:order:clicked", { shopifyId: o, orderId: i });
          break;
      }
  };
  return /* @__PURE__ */ Q.jsx(Q.Fragment, { children: /* @__PURE__ */ Q.jsx(
    rt,
    {
      onClick: l,
      variant: "tertiary",
      "aria-label": e,
      style: {
        color: _t.color.link,
        padding: tn.spacer[100]
      },
      navigate: () => {
        var c;
        return (c = window.open(e, "_blank")) == null ? void 0 : c.focus();
      },
      slotStart: /* @__PURE__ */ Q.jsx(Fe, { name: "external-link" }),
      children: n
    }
  ) });
}, NT = (e, n) => {
  const [, r, i] = n.match(/^.+shopify\/(\w+)\/(\d+)$/) || [], o = xT(r);
  return `https://${e}/admin/${o}/${i}`;
}, xT = (e) => {
  switch (e) {
    case "Customer":
      return "customers";
    case "Order":
      return "orders";
  }
}, dl = ({
  id: e,
  domain: n,
  children: r,
  trackingAction: i,
  shopifyId: o
}) => /* @__PURE__ */ Q.jsx(
  ic,
  {
    trackingAction: i,
    orderId: e,
    shopifyId: o,
    target: NT(n, e),
    children: r
  }
), qi = () => /* @__PURE__ */ Q.jsx(
  "hr",
  {
    style: {
      borderTop: `.5px solid ${$e.neutral[300]}`,
      width: "100%",
      marginTop: tn.spacer[250],
      marginBottom: tn.spacer[250]
    }
  }
), wT = ({
  id: e,
  name: n,
  email: r,
  phone: i,
  totalOrders: o,
  totalRevenueValue: s,
  totalRevenueCurrencyCode: l,
  tags: c,
  shopifyDomain: u,
  refresh: p,
  loading: m,
  networkStatus: v
}) => {
  const { track: y } = sn();
  return /* @__PURE__ */ Q.jsxs(
    C,
    {
      background: $e.neutral[100],
      padding: tn.spacer[300],
      borderRadius: tn["border-radius"][100],
      flexDirection: "column",
      children: [
        /* @__PURE__ */ Q.jsxs(C, { justifyContent: "space-between", alignItems: "center", children: [
          /* @__PURE__ */ Q.jsx(se.Heading, { variant: "heading-3", children: n }),
          /* @__PURE__ */ Q.jsx(
            Bt,
            {
              isLoading: m && v === Yn.refetch,
              loadingIndicator: /* @__PURE__ */ Q.jsx(ln, { size: 16 }),
              icon: "sync",
              variant: "secondary",
              onClick: () => {
                y("shopify:refreshed", { shopifyId: e }), p();
              }
            }
          )
        ] }),
        /* @__PURE__ */ Q.jsx(qi, {}),
        /* @__PURE__ */ Q.jsx(se.ExternalLink, { href: `mailto:${r}`, children: r }),
        /* @__PURE__ */ Q.jsx(se.ExternalLink, { href: `tel:${i}`, children: i }),
        /* @__PURE__ */ Q.jsx(qi, {}),
        /* @__PURE__ */ Q.jsx("table", { children: /* @__PURE__ */ Q.jsxs("tbody", { children: [
          /* @__PURE__ */ Q.jsxs("tr", { children: [
            /* @__PURE__ */ Q.jsx("td", { children: /* @__PURE__ */ Q.jsx(se.Paragraph, { children: "Total orders" }) }),
            /* @__PURE__ */ Q.jsx("td", { children: /* @__PURE__ */ Q.jsx(se.Paragraph, { variant: "1", children: o }) })
          ] }),
          /* @__PURE__ */ Q.jsxs("tr", { children: [
            /* @__PURE__ */ Q.jsx("td", { children: /* @__PURE__ */ Q.jsx(se.Paragraph, { children: "Total revenue" }) }),
            /* @__PURE__ */ Q.jsx("td", { children: /* @__PURE__ */ Q.jsxs(se.Paragraph, { variant: "1", children: [
              Number.parseFloat(s).toFixed(2),
              " ",
              l
            ] }) })
          ] })
        ] }) }),
        c.length > 0 && /* @__PURE__ */ Q.jsxs(Q.Fragment, { children: [
          /* @__PURE__ */ Q.jsx(qi, {}),
          /* @__PURE__ */ Q.jsx(C, { gap: _t.size[100], flexWrap: "wrap", children: c.map((b) => /* @__PURE__ */ Q.jsx(an, { children: b }, `${e}-${b}`)) })
        ] }),
        /* @__PURE__ */ Q.jsx(qi, {}),
        /* @__PURE__ */ Q.jsx(C, { justifyContent: "space-around", children: /* @__PURE__ */ Q.jsx(
          dl,
          {
            shopifyId: e,
            trackingAction: "viewCustomerInShopify",
            domain: u,
            id: e,
            children: "View customer in Shopify"
          }
        ) })
      ]
    }
  );
}, Rt = ({ children: e }) => /* @__PURE__ */ Q.jsx(se.Paragraph, { variant: "4", as: "div", color: _t.color.primary, children: e }), jT = ({ children: e }) => /* @__PURE__ */ Q.jsx(se.Paragraph, { variant: "5", color: _t.color.tertiary, children: /* @__PURE__ */ Q.jsx("span", { style: { marginBottom: tn.spacer[100] }, children: e }) }), ni = ({ label: e, children: n }) => /* @__PURE__ */ Q.jsxs(nn, { as: "div", children: [
  /* @__PURE__ */ Q.jsx(jT, { children: e }),
  /* @__PURE__ */ Q.jsx(Rt, { children: n })
] }), CT = [
  { id: "AF", name: "Afghanistan" },
  { id: "AX", name: "Åland Islands" },
  { id: "AL", name: "Albania" },
  { id: "DZ", name: "Algeria" },
  { id: "AD", name: "Andorra" },
  { id: "AO", name: "Angola" },
  { id: "AI", name: "Anguilla" },
  { id: "AG", name: "Antigua & Barbuda" },
  { id: "AR", name: "Argentina" },
  { id: "AM", name: "Armenia" },
  { id: "AW", name: "Aruba" },
  { id: "AC", name: "Ascension Island" },
  { id: "AU", name: "Australia" },
  { id: "AT", name: "Austria" },
  { id: "AZ", name: "Azerbaijan" },
  { id: "BS", name: "Bahamas" },
  { id: "BH", name: "Bahrain" },
  { id: "BD", name: "Bangladesh" },
  { id: "BB", name: "Barbados" },
  { id: "BY", name: "Belarus" },
  { id: "BE", name: "Belgium" },
  { id: "BZ", name: "Belize" },
  { id: "BJ", name: "Benin" },
  { id: "BM", name: "Bermuda" },
  { id: "BT", name: "Bhutan" },
  { id: "BO", name: "Bolivia" },
  { id: "BA", name: "Bosnia & Herzegovina" },
  { id: "BW", name: "Botswana" },
  { id: "BV", name: "Bouvet Island" },
  { id: "BR", name: "Brazil" },
  { id: "IO", name: "British Indian Ocean Territory" },
  { id: "BN", name: "Brunei" },
  { id: "BG", name: "Bulgaria" },
  { id: "BF", name: "Burkina Faso" },
  { id: "BI", name: "Burundi" },
  { id: "KH", name: "Cambodia" },
  { id: "CA", name: "Canada" },
  { id: "CV", name: "Cape Verde" },
  { id: "BQ", name: "Caribbean Netherlands" },
  { id: "KY", name: "Cayman Islands" },
  { id: "CF", name: "Central African Republic" },
  { id: "TD", name: "Chad" },
  { id: "CL", name: "Chile" },
  { id: "CN", name: "China" },
  { id: "CX", name: "Christmas Island" },
  { id: "CC", name: "Cocos (Keeling) Islands" },
  { id: "CO", name: "Colombia" },
  { id: "KM", name: "Comoros" },
  { id: "CG", name: "Congo - Brazzaville" },
  { id: "CD", name: "Congo - Kinshasa" },
  { id: "CK", name: "Cook Islands" },
  { id: "CR", name: "Costa Rica" },
  { id: "HR", name: "Croatia" },
  { id: "CU", name: "Cuba" },
  { id: "CW", name: "Curaçao" },
  { id: "CY", name: "Cyprus" },
  { id: "CZ", name: "Czechia" },
  { id: "CI", name: "Côte d’Ivoire" },
  { id: "DK", name: "Denmark" },
  { id: "DJ", name: "Djibouti" },
  { id: "DM", name: "Dominica" },
  { id: "DO", name: "Dominican Republic" },
  { id: "EC", name: "Ecuador" },
  { id: "EG", name: "Egypt" },
  { id: "SV", name: "El Salvador" },
  { id: "GQ", name: "Equatorial Guinea" },
  { id: "ER", name: "Eritrea" },
  { id: "EE", name: "Estonia" },
  { id: "SZ", name: "Eswatini" },
  { id: "ET", name: "Ethiopia" },
  { id: "FK", name: "Falkland Islands" },
  { id: "FO", name: "Faroe Islands" },
  { id: "FJ", name: "Fiji" },
  { id: "FI", name: "Finland" },
  { id: "FR", name: "France" },
  { id: "GF", name: "French Guiana" },
  { id: "PF", name: "French Polynesia" },
  { id: "TF", name: "French Southern Territories" },
  { id: "GA", name: "Gabon" },
  { id: "GM", name: "Gambia" },
  { id: "GE", name: "Georgia" },
  { id: "DE", name: "Germany" },
  { id: "GH", name: "Ghana" },
  { id: "GI", name: "Gibraltar" },
  { id: "GR", name: "Greece" },
  { id: "GL", name: "Greenland" },
  { id: "GD", name: "Grenada" },
  { id: "GP", name: "Guadeloupe" },
  { id: "GT", name: "Guatemala" },
  { id: "GG", name: "Guernsey" },
  { id: "GN", name: "Guinea" },
  { id: "GW", name: "Guinea-Bissau" },
  { id: "GY", name: "Guyana" },
  { id: "HT", name: "Haiti" },
  { id: "HM", name: "Heard & McDonald Islands" },
  { id: "VA", name: "Vatican City" },
  { id: "HN", name: "Honduras" },
  { id: "HK", name: "Hong Kong SAR" },
  { id: "HU", name: "Hungary" },
  { id: "IS", name: "Iceland" },
  { id: "IN", name: "India" },
  { id: "ID", name: "Indonesia" },
  { id: "IR", name: "Iran" },
  { id: "IQ", name: "Iraq" },
  { id: "IE", name: "Ireland" },
  { id: "IM", name: "Isle of Man" },
  { id: "IL", name: "Israel" },
  { id: "IT", name: "Italy" },
  { id: "JM", name: "Jamaica" },
  { id: "JP", name: "Japan" },
  { id: "JE", name: "Jersey" },
  { id: "JO", name: "Jordan" },
  { id: "KZ", name: "Kazakhstan" },
  { id: "KE", name: "Kenya" },
  { id: "KI", name: "Kiribati" },
  { id: "KP", name: "North Korea" },
  { id: "XK", name: "Kosovo" },
  { id: "KW", name: "Kuwait" },
  { id: "KG", name: "Kyrgyzstan" },
  { id: "LA", name: "Laos" },
  { id: "LV", name: "Latvia" },
  { id: "LB", name: "Lebanon" },
  { id: "LS", name: "Lesotho" },
  { id: "LR", name: "Liberia" },
  { id: "LY", name: "Libya" },
  { id: "LI", name: "Liechtenstein" },
  { id: "LT", name: "Lithuania" },
  { id: "LU", name: "Luxembourg" },
  { id: "MO", name: "Macao SAR" },
  { id: "MG", name: "Madagascar" },
  { id: "MW", name: "Malawi" },
  { id: "MY", name: "Malaysia" },
  { id: "MV", name: "Maldives" },
  { id: "ML", name: "Mali" },
  { id: "MT", name: "Malta" },
  { id: "MQ", name: "Martinique" },
  { id: "MR", name: "Mauritania" },
  { id: "MU", name: "Mauritius" },
  { id: "YT", name: "Mayotte" },
  { id: "MX", name: "Mexico" },
  { id: "MD", name: "Moldova" },
  { id: "MC", name: "Monaco" },
  { id: "MN", name: "Mongolia" },
  { id: "ME", name: "Montenegro" },
  { id: "MS", name: "Montserrat" },
  { id: "MA", name: "Morocco" },
  { id: "MZ", name: "Mozambique" },
  { id: "MM", name: "Myanmar (Burma)" },
  { id: "NA", name: "Namibia" },
  { id: "NR", name: "Nauru" },
  { id: "NP", name: "Nepal" },
  { id: "NL", name: "Netherlands" },
  { id: "AN", name: "Netherlands Antilles" },
  { id: "NC", name: "New Caledonia" },
  { id: "NZ", name: "New Zealand" },
  { id: "NI", name: "Nicaragua" },
  { id: "NE", name: "Niger" },
  { id: "NG", name: "Nigeria" },
  { id: "NU", name: "Niue" },
  { id: "NF", name: "Norfolk Island" },
  { id: "MK", name: "North Macedonia" },
  { id: "NO", name: "Norway" },
  { id: "OM", name: "Oman" },
  { id: "PK", name: "Pakistan" },
  { id: "PS", name: "Palestinian Territories" },
  { id: "PA", name: "Panama" },
  { id: "PG", name: "Papua New Guinea" },
  { id: "PY", name: "Paraguay" },
  { id: "PE", name: "Peru" },
  { id: "PH", name: "Philippines" },
  { id: "PN", name: "Pitcairn Islands" },
  { id: "PL", name: "Poland" },
  { id: "PT", name: "Portugal" },
  { id: "QA", name: "Qatar" },
  { id: "CM", name: "Cameroon" },
  { id: "RE", name: "Réunion" },
  { id: "RO", name: "Romania" },
  { id: "RU", name: "Russia" },
  { id: "RW", name: "Rwanda" },
  { id: "BL", name: "St. Barthélemy" },
  { id: "SH", name: "St. Helena" },
  { id: "KN", name: "St. Kitts & Nevis" },
  { id: "LC", name: "St. Lucia" },
  { id: "MF", name: "St. Martin" },
  { id: "PM", name: "St. Pierre & Miquelon" },
  { id: "WS", name: "Samoa" },
  { id: "SM", name: "San Marino" },
  { id: "ST", name: "São Tomé & Príncipe" },
  { id: "SA", name: "Saudi Arabia" },
  { id: "SN", name: "Senegal" },
  { id: "RS", name: "Serbia" },
  { id: "SC", name: "Seychelles" },
  { id: "SL", name: "Sierra Leone" },
  { id: "SG", name: "Singapore" },
  { id: "SX", name: "Sint Maarten" },
  { id: "SK", name: "Slovakia" },
  { id: "SI", name: "Slovenia" },
  { id: "SB", name: "Solomon Islands" },
  { id: "SO", name: "Somalia" },
  { id: "ZA", name: "South Africa" },
  { id: "GS", name: "South Georgia & South Sandwich Islands" },
  { id: "KR", name: "South Korea" },
  { id: "SS", name: "South Sudan" },
  { id: "ES", name: "Spain" },
  { id: "LK", name: "Sri Lanka" },
  { id: "VC", name: "St. Vincent & Grenadines" },
  { id: "SD", name: "Sudan" },
  { id: "SR", name: "Suriname" },
  { id: "SJ", name: "Svalbard & Jan Mayen" },
  { id: "SE", name: "Sweden" },
  { id: "CH", name: "Switzerland" },
  { id: "SY", name: "Syria" },
  { id: "TW", name: "Taiwan" },
  { id: "TJ", name: "Tajikistan" },
  { id: "TZ", name: "Tanzania" },
  { id: "TH", name: "Thailand" },
  { id: "TL", name: "Timor-Leste" },
  { id: "TG", name: "Togo" },
  { id: "TK", name: "Tokelau" },
  { id: "TO", name: "Tonga" },
  { id: "TT", name: "Trinidad & Tobago" },
  { id: "TA", name: "Tristan da Cunha" },
  { id: "TN", name: "Tunisia" },
  { id: "TR", name: "Turkey" },
  { id: "TM", name: "Turkmenistan" },
  { id: "TC", name: "Turks & Caicos Islands" },
  { id: "TV", name: "Tuvalu" },
  { id: "UG", name: "Uganda" },
  { id: "UA", name: "Ukraine" },
  { id: "AE", name: "United Arab Emirates" },
  { id: "GB", name: "United Kingdom" },
  { id: "US", name: "United States" },
  { id: "UM", name: "US Outlying Islands" },
  { id: "UY", name: "Uruguay" },
  { id: "UZ", name: "Uzbekistan" },
  { id: "VU", name: "Vanuatu" },
  { id: "VE", name: "Venezuela" },
  { id: "VN", name: "Vietnam" },
  { id: "VG", name: "British Virgin Islands" },
  { id: "WF", name: "Wallis & Futuna" },
  { id: "EH", name: "Western Sahara" },
  { id: "YE", name: "Yemen" },
  { id: "ZM", name: "Zambia" },
  { id: "ZW", name: "Zimbabwe" },
  { id: "ZZ", name: "Unknown Region" }
], ET = ({
  address: e
}) => Object.entries(e ?? {}).filter(([n]) => n !== "__typename").map(([n, r]) => {
  const i = lv([]).find(
    (o) => o.key === n
  );
  return {
    key: n,
    value: r || "",
    required: i.required,
    type: i.type
  };
}), lv = (e) => [
  {
    key: "firstName",
    required: !0,
    type: "input",
    label: "First name",
    placeholder: "Insert your fist name",
    span: 3
  },
  {
    key: "lastName",
    required: !0,
    type: "input",
    label: "Last name",
    placeholder: "Insert your last name",
    span: 3
  },
  {
    key: "company",
    required: !1,
    type: "input",
    label: "Company",
    placeholder: "Insert your company name"
  },
  {
    key: "address1",
    required: !0,
    type: "input",
    label: "Address",
    placeholder: "Insert your address"
  },
  {
    key: "address2",
    required: !1,
    type: "input",
    label: "Apartment, suite, etc.",
    placeholder: "Insert more address details"
  },
  {
    key: "zip",
    required: !0,
    type: "input",
    label: "Zip / postal code",
    placeholder: "Insert your zip / postal code",
    span: 2
  },
  {
    key: "city",
    required: !0,
    type: "input",
    label: "City",
    placeholder: "Insert your city",
    span: 4
  },
  {
    key: "country",
    required: !0,
    type: "hidden",
    label: "Country",
    placeholder: ""
  },
  {
    key: "countryCodeV2",
    required: !0,
    type: "select",
    options: CT.filter((n) => e.includes(n.id)),
    label: "Country",
    placeholder: "Insert your country"
  },
  {
    key: "province",
    required: !1,
    type: "hidden",
    label: "State/province",
    placeholder: ""
  },
  {
    key: "provinceCode",
    required: !1,
    type: "input",
    label: "State/province",
    placeholder: "Insert your state/province"
  }
], FT = ({
  headline: e,
  address: n,
  isOpen: r,
  setIsOpen: i,
  orderId: o,
  shopifyId: s,
  shippingCountryCodes: l,
  refetch: c
}) => {
  const { useMutation: u, showNotification: p } = rn(), { track: m } = sn(), [v, y] = G(
    {}
  ), {
    formData: b,
    errors: N,
    handleInputChange: x,
    handleSubmit: T,
    getItemByKey: $
  } = dT({
    initialValues: ET({ address: n }),
    onSubmit: (w) => {
      h(!0), E({
        variables: {
          input: {
            id: o,
            shippingAddress: w.map(
              (H) => H.key === "countryCodeV2" ? { ...H, key: "countryCode" } : H
            ).filter((H) => H.type !== "hidden").reduce((H, { key: pe, value: le }) => (H[pe] = le, H), {})
          }
        }
      });
    }
  }), [P, h] = G(!1), [
    E,
    { error: q, reset: M }
  ] = u(hT, {
    onError: () => {
      h(!1), p({
        title: "Something went wrong",
        text: "The address change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (w) => {
      var H, pe;
      h(!1);
      const le = (pe = (H = w == null ? void 0 : w.Shopify) == null ? void 0 : H.orderUpdate) == null ? void 0 : pe.userErrors;
      if ((le == null ? void 0 : le.length) > 0) {
        const Se = le.reduce((ae, D) => (ae[D.field[D.field.length - 1]] = D.message, ae), {});
        y(Se);
      } else
        p({
          title: "Success",
          text: "The address change was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), y({}), i(!1), c();
    }
  }), R = () => {
    s && m("shopify:order:edit:shipping:address:modal:canceled", {
      shopifyId: s,
      orderId: o
    }), i(!1);
  };
  return /* @__PURE__ */ Q.jsxs(
    jt,
    {
      isOpen: r,
      "data-testid": `address-change-modal-${o}`,
      onClose: R,
      children: [
        /* @__PURE__ */ Q.jsx(Ct, { title: e, onClose: () => R() }),
        /* @__PURE__ */ Q.jsx(Et, { children: q ? /* @__PURE__ */ Q.jsx(bn, { error: q }) : b && b.length > 0 && /* @__PURE__ */ Q.jsx("form", { name: `widget-change-address-form-name-${o}`, children: /* @__PURE__ */ Q.jsx(Ar, { children: lv(l).filter((w) => w.type !== "hidden").map(
          ({
            key: w,
            required: H,
            label: pe,
            placeholder: le,
            span: Se,
            type: ae,
            options: D
          }) => /* @__PURE__ */ Q.jsx(
            wn,
            {
              span: Se || void 0,
              children: (() => {
                switch (ae) {
                  case "input":
                    return /* @__PURE__ */ Q.jsx(
                      Lt,
                      {
                        required: H,
                        label: pe,
                        placeholder: le,
                        input: {
                          name: w,
                          value: $(w).value,
                          onChange: x
                        },
                        meta: {
                          error: N[w] || v[w]
                        }
                      }
                    );
                  case "select":
                    return D && /* @__PURE__ */ Q.jsx(Fn, { label: pe, children: /* @__PURE__ */ Q.jsx(
                      Wn,
                      {
                        searchable: !0,
                        items: D,
                        selectedItems: [$(w).value],
                        multiple: !1,
                        onSelect: (V) => {
                          x({
                            target: {
                              name: w,
                              value: V.id
                            }
                          });
                        }
                      }
                    ) });
                }
                return /* @__PURE__ */ Q.jsx(Q.Fragment, {});
              })()
            },
            `form-field-${w}`
          )
        ) }) }) }),
        /* @__PURE__ */ Q.jsx(
          Mt,
          {
            confirmOnClick: () => {
              q ? (M(), i(!1)) : (s && m("shopify:order:edit:shipping:address:modal:submitted", {
                shopifyId: s,
                orderId: o
              }), T());
            },
            confirmProps: {
              isLoading: P,
              loadingIndicator: /* @__PURE__ */ Q.jsx(ln, { size: 16 })
            },
            cancelOnClick: q ? void 0 : () => R(),
            confirmName: q ? "Close" : "Save",
            cancelName: q ? void 0 : "Cancel"
          }
        )
      ]
    }
  );
}, rm = ({
  header: e,
  address: n,
  orderId: r,
  shopifyId: i,
  shippingCountryCodes: o,
  enableEditAddress: s,
  refetch: l
}) => {
  const [c, u] = G(!1), { track: p } = sn();
  return /* @__PURE__ */ Q.jsxs(Q.Fragment, { children: [
    /* @__PURE__ */ Q.jsxs(C, { justifyContent: "space-between", children: [
      /* @__PURE__ */ Q.jsxs(ni, { label: e, children: [
        /* @__PURE__ */ Q.jsxs(Rt, { children: [
          n == null ? void 0 : n.firstName,
          " ",
          n == null ? void 0 : n.lastName
        ] }),
        /* @__PURE__ */ Q.jsx(Rt, { children: n == null ? void 0 : n.company }),
        /* @__PURE__ */ Q.jsx(Rt, { children: n == null ? void 0 : n.address1 }),
        /* @__PURE__ */ Q.jsx(Rt, { children: n == null ? void 0 : n.address2 }),
        /* @__PURE__ */ Q.jsxs(Rt, { children: [
          n == null ? void 0 : n.zip,
          " ",
          n == null ? void 0 : n.city
        ] }),
        /* @__PURE__ */ Q.jsx(Rt, { children: n == null ? void 0 : n.province }),
        /* @__PURE__ */ Q.jsx(Rt, { children: n == null ? void 0 : n.country })
      ] }),
      r && s && /* @__PURE__ */ Q.jsx(
        On,
        {
          onClick: () => {
            i && r && p("shopify:order:edit:shipping:address:modal:opened", {
              shopifyId: i,
              orderId: r
            }), u(!0);
          },
          variant: "secondary",
          icon: "pen",
          "data-testid": `edit_address-${e.toLowerCase().split(" ").join("_")}`,
          children: "Edit"
        }
      )
    ] }),
    r && /* @__PURE__ */ Q.jsx(
      FT,
      {
        headline: `Edit ${e}`,
        address: n,
        isOpen: c,
        setIsOpen: u,
        orderId: r,
        shopifyId: i,
        shippingCountryCodes: o,
        refetch: l
      }
    )
  ] });
}, os = {
  default: "Click to copy tracking number",
  copied: "Tracking number copied"
}, IT = ({
  company: e,
  url: n,
  number: r
}) => {
  const [i, o] = G(!1), [s, l] = G(os.default);
  return /* @__PURE__ */ Q.jsxs(C, { flexDirection: "column", children: [
    e,
    /* @__PURE__ */ Q.jsxs(C, { alignItems: "center", gap: "100", flexDirection: "row", children: [
      r,
      /* @__PURE__ */ Q.jsx(jn, { dark: !0, content: s, alwaysShow: i, children: /* @__PURE__ */ Q.jsx(
        Bt,
        {
          variant: "tertiary",
          icon: "copy",
          onClick: () => {
            l(os.copied), r && (navigator.clipboard.writeText(r), o(!0), setTimeout(() => {
              o(!1), l(os.default);
            }, 3e3));
          }
        }
      ) }),
      /* @__PURE__ */ Q.jsx(ic, { target: n, children: "Track order" })
    ] })
  ] });
}, $T = 48, TT = 64, OT = 5, RT = ({ orderId: e, items: n }) => {
  const r = `${Math.min(n.length, OT) * TT + 12}px`;
  return /* @__PURE__ */ Q.jsx(
    nn,
    {
      style: {
        height: r,
        borderTop: `${tn.border[100]} solid ${$e.neutral[200]}`,
        borderBottom: `${tn.border[100]} solid ${$e.neutral[200]}`,
        overflow: "scroll"
      },
      children: /* @__PURE__ */ Q.jsx(Ln, { children: n.map(({ id: i, title: o, quantity: s, variantTitle: l, image: c }) => /* @__PURE__ */ Q.jsx(
        Ln.Item,
        {
          title: /* @__PURE__ */ Q.jsxs(se.Paragraph, { variant: "4", children: [
            o,
            " ",
            l && `(${l})`
          ] }),
          contentLeft: `${s}×`,
          contentRight: (c == null ? void 0 : c.url) && /* @__PURE__ */ Q.jsx(bm, { src: `${c == null ? void 0 : c.url}&height=${$T}`, alt: o }),
          withHoverEffect: !1
        },
        `list-${e}-${i}`
      )) })
    }
  );
}, DT = ({
  id: e,
  name: n,
  createdAt: r,
  cancelledAt: i,
  status: o,
  value: s,
  suggestedRefund: l,
  suggestedRefundAmount: c,
  initiallyOpen: u,
  currencyCode: p,
  billingAddress: m,
  shippingAddress: v,
  lineItems: y,
  trackingInfos: b,
  shopifyDomain: N,
  enableRefunds: x,
  enableEditShippingAddress: T,
  shopifyId: $,
  shippingCountryCodes: P,
  refetch: h
}) => {
  var E;
  const { useMutation: q, showNotification: M, showModal: R } = rn(), { track: w } = sn(), [H, pe] = G(u), [le] = q(bT, {
    onError: (D) => {
      setTimeout(() => ae(D), 500);
    },
    onCompleted: (D) => {
      var V, de;
      const te = (de = (V = D.Shopify) == null ? void 0 : V.refundCreate) == null ? void 0 : de.userErrors;
      te && te.length > 0 ? ae(
        new Kv({
          graphQLErrors: te.map((he) => ({
            message: he.message
          }))
        })
      ) : (M({
        title: "Order refunded",
        text: `You refunded order ${n}`,
        icon: "check-circle-filled",
        severity: "success"
      }), h());
    }
  }), Se = () => {
    w("shopify:order:refund:requested", { shopifyId: $, orderId: e }), R({
      headline: `Refund Order ${n}?`,
      children: /* @__PURE__ */ Q.jsxs(se.Paragraph, { children: [
        "You are about to refund",
        " ",
        /* @__PURE__ */ Q.jsxs("b", { children: [
          c,
          " ",
          p
        ] }),
        " ",
        "to the customer. Are you sure you want to refund the order?"
      ] }),
      confirmLabel: "Confirm order refund",
      confirmVariant: "primary",
      cancelLabel: "Cancel",
      onConfirm: () => {
        w("shopify:order:refund:confirmed", { shopifyId: $, orderId: e }), le({
          variables: {
            input: l
          }
        });
      },
      onCancel: () => w("shopify:order:refund:canceled", { shopifyId: $, orderId: e })
    });
  }, ae = (D) => {
    R({
      headline: "Something went wrong",
      text: "It looks like something went wrong when trying to refund the order. Please create the refund in Shopify directly.",
      children: /* @__PURE__ */ Q.jsxs(C, { flexDirection: "column", children: [
        /* @__PURE__ */ Q.jsx(bn, { error: D }),
        /* @__PURE__ */ Q.jsx(dl, { id: e, domain: N, children: "Open order in Shopify" })
      ] }),
      confirmLabel: "Ok",
      onConfirm: () => {
      }
    });
  };
  return /* @__PURE__ */ Q.jsxs(
    C,
    {
      borderColor: $e.neutral[200],
      borderRadius: tn["border-radius"][100],
      padding: tn.spacer[300],
      flexDirection: "column",
      gap: tn.spacer[200],
      children: [
        /* @__PURE__ */ Q.jsxs(C, { flexDirection: "row", justifyContent: "space-between", children: [
          /* @__PURE__ */ Q.jsxs(nn, { as: "div", children: [
            /* @__PURE__ */ Q.jsx(se.Paragraph, { variant: "2", color: _t.color.tertiary, children: Nt(r).format("DD MMM YYYY @ HH:MM") }),
            /* @__PURE__ */ Q.jsx(se.Heading, { variant: "heading-2", color: _t.color.primary, children: /* @__PURE__ */ Q.jsxs(
              "span",
              {
                style: {
                  color: i ? _t.color.tertiary : _t.color.primary
                },
                children: [
                  "Order ",
                  n
                ]
              }
            ) })
          ] }),
          /* @__PURE__ */ Q.jsx(nn, { as: "div", children: /* @__PURE__ */ Q.jsx(
            Bt,
            {
              variant: "tertiary",
              color: $e.neutral[700],
              icon: H ? "angle-up" : "angle-down",
              onClick: () => {
                H ? w("shopify:order:collapse:closed", {
                  shopifyId: $,
                  orderId: e
                }) : w("shopify:order:collapse:opened", {
                  shopifyId: $,
                  orderId: e
                }), pe(!H);
              }
            }
          ) })
        ] }),
        /* @__PURE__ */ Q.jsx(
          C,
          {
            gap: tn.spacer[300],
            flexDirection: "column",
            style: { display: H ? "flex" : "none" },
            children: H && /* @__PURE__ */ Q.jsxs(Q.Fragment, { children: [
              /* @__PURE__ */ Q.jsx(ni, { label: "Order status", children: o }),
              /* @__PURE__ */ Q.jsxs(ni, { label: "Order value", children: [
                Number.parseFloat(s).toFixed(2),
                " ",
                p
              ] }),
              i && /* @__PURE__ */ Q.jsx(ni, { label: "Cancelled at", children: Nt(i).format("DD MMM YYYY @ HH:MM") }),
              m && /* @__PURE__ */ Q.jsx(
                rm,
                {
                  header: "Billing address",
                  address: m,
                  shippingCountryCodes: P,
                  refetch: h
                }
              ),
              v && /* @__PURE__ */ Q.jsx(
                rm,
                {
                  shopifyId: $,
                  orderId: e,
                  header: "Shipping address",
                  address: v,
                  shippingCountryCodes: P,
                  enableEditAddress: T,
                  refetch: h
                }
              ),
              y && /* @__PURE__ */ Q.jsx(RT, { orderId: e, items: y }),
              (b == null ? void 0 : b.length) > 0 && /* @__PURE__ */ Q.jsx(ni, { label: "Tracking infos", children: /* @__PURE__ */ Q.jsx(C, { gap: "200", flexDirection: "column", children: b.map((D, V) => /* @__PURE__ */ Q.jsx(IT, { ...D }, V)) }) }),
              x && /* @__PURE__ */ Q.jsx(
                On,
                {
                  variant: "secondary",
                  onClick: Se,
                  disabled: ((E = l == null ? void 0 : l.refundLineItems) == null ? void 0 : E.length) === 0,
                  children: "Refund Order"
                }
              ),
              /* @__PURE__ */ Q.jsx(C, { justifyContent: "space-around", children: /* @__PURE__ */ Q.jsx(
                dl,
                {
                  trackingAction: "viewOrderInShopify",
                  shopifyId: $,
                  domain: N,
                  id: e,
                  children: "View order in Shopify"
                }
              ) })
            ] })
          }
        )
      ]
    }
  );
}, PT = (e, n, r) => {
  const i = Object.entries(r).map(([o, s]) => `${o}=${s}`).join("&");
  return `https://${e}/admin/${n}?${i}`;
}, im = ({
  domain: e,
  type: n,
  params: r,
  children: i,
  trackingAction: o,
  shopifyId: s
}) => /* @__PURE__ */ Q.jsx(
  ic,
  {
    trackingAction: o,
    shopifyId: s,
    target: PT(e, n, r),
    children: i
  }
), AT = (e) => {
  var n;
  return ((n = e == null ? void 0 : e.fulfillments) == null ? void 0 : n.length) > 0 ? e.fulfillments[0].trackingInfo : [];
}, am = (e) => {
  const [, n] = e.match(/^.+shopify\/Customer\/(\d+)$/) || [];
  return n;
}, LT = ({
  conversationContext: e,
  settings: n
}) => {
  var r;
  const {
    isCustomerLoading: i,
    customerError: o,
    customerData: s,
    refetchCustomer: l,
    customerNetworkStatus: c
  } = _T({ conversationContext: e }), { getCustomerOrders: u, isCustomerOrdersLoading: p, customerOrders: m } = ST();
  Pe(() => {
    var E, q, M, R;
    const w = (R = (M = (q = (E = s == null ? void 0 : s.Shopify) == null ? void 0 : E.customers) == null ? void 0 : q.edges[0]) == null ? void 0 : M.node) == null ? void 0 : R.id;
    if (!i && w) {
      const H = am(w);
      u({
        variables: {
          query: `customer_id:${H}`
        }
      });
    }
  }, [i, s]);
  const [v, y] = G(), [b, N] = G(), [x, T] = G(
    []
  ), $ = n.apiHostName, P = n.enableRefundOrder ?? !1, h = n.enableEditShippingAddress ?? !1;
  return Pe(() => {
    var E, q, M, R, w, H, pe, le;
    T(
      ((M = (q = (E = s == null ? void 0 : s.Shopify) == null ? void 0 : E.shop) == null ? void 0 : q.countriesInShippingZones) == null ? void 0 : M.countryCodes) || []
    );
    const Se = (H = (w = (R = s == null ? void 0 : s.Shopify) == null ? void 0 : R.customers) == null ? void 0 : w.edges[0]) == null ? void 0 : H.node;
    y(Se || void 0);
    const ae = (le = (pe = m == null ? void 0 : m.Shopify) == null ? void 0 : pe.orders) == null ? void 0 : le.edges;
    N(
      ae ? ae.map((D) => D.node).map((D) => {
        var V, de, te, he, _e, Z, J, z, me, ke, Oe, Y, fe, ge, X, ye, W, ce;
        return {
          id: D.id,
          name: D.name,
          createdAt: new Date(D.createdAt),
          cancelledAt: D.cancelledAt ? new Date(D.cancelledAt) : void 0,
          status: `${(V = D.displayFulfillmentStatus) == null ? void 0 : V.toLowerCase()}, ${(de = D.displayFinancialStatus) == null ? void 0 : de.toLowerCase()}${D.cancelledAt ? ", cancelled" : ""}`,
          value: (he = (te = D.netPaymentSet) == null ? void 0 : te.presentmentMoney) == null ? void 0 : he.amount,
          currencyCode: (Z = (_e = D.netPaymentSet) == null ? void 0 : _e.presentmentMoney) == null ? void 0 : Z.currencyCode,
          shippingAddress: D.shippingAddress,
          billingAddress: D.billingAddress,
          lineItems: (z = (J = D.lineItems) == null ? void 0 : J.edges) == null ? void 0 : z.map((ie) => ie.node),
          suggestedRefundAmount: (Oe = (ke = (me = D.suggestedRefund) == null ? void 0 : me.amountSet) == null ? void 0 : ke.presentmentMoney) == null ? void 0 : Oe.amount,
          suggestedRefund: {
            orderId: D.id,
            currency: (ge = (fe = (Y = D.suggestedRefund) == null ? void 0 : Y.amountSet) == null ? void 0 : fe.presentmentMoney) == null ? void 0 : ge.currencyCode,
            notify: !0,
            refundLineItems: (ye = (X = D.suggestedRefund) == null ? void 0 : X.refundLineItems) == null ? void 0 : ye.map((ie) => ie.lineItem).map((ie) => ({
              lineItemId: ie.id,
              quantity: ie.quantity
            })),
            transactions: (ce = (W = D.suggestedRefund) == null ? void 0 : W.suggestedTransactions) == null ? void 0 : ce.map(
              (ie) => {
                var oe, be, Ee;
                return {
                  amount: ((be = (oe = ie.amountSet) == null ? void 0 : oe.presentmentMoney) == null ? void 0 : be.amount) || "0.00",
                  gateway: ie.gateway,
                  kind: "REFUND",
                  orderId: D.id,
                  parentId: (Ee = ie.parentTransaction) == null ? void 0 : Ee.id
                };
              }
            ),
            shipping: {
              fullRefund: !0
            }
          },
          trackingInfos: AT(D)
        };
      }) : void 0
    );
  }, [s, m]), /* @__PURE__ */ Q.jsxs(C, { gap: "300", flexDirection: "column", margin: "200 0 300", children: [
    !i && o && /* @__PURE__ */ Q.jsx(bn, { error: o, retry: l }),
    i && c !== Yn.refetch && /* @__PURE__ */ Q.jsx(C, { justifyContent: "center", children: /* @__PURE__ */ Q.jsx(ln, {}) }),
    !i && !o && !v && /* @__PURE__ */ Q.jsxs(
      C,
      {
        justifyContent: "space-around",
        gap: tn.spacer[200],
        flexDirection: "column",
        children: [
          /* @__PURE__ */ Q.jsx(se.Paragraph, { children: "We cannot find the customer in Shopify. Do you want to search for them?" }),
          /* @__PURE__ */ Q.jsx(
            im,
            {
              domain: $,
              type: "customers",
              params: {
                query: ((r = e.customer) == null ? void 0 : r.name) || ""
              },
              children: "Search Customers"
            }
          )
        ]
      }
    ),
    v && /* @__PURE__ */ Q.jsx(
      wT,
      {
        id: v.id,
        name: v.displayName,
        email: v.email ?? "",
        phone: v.phone ?? "",
        totalOrders: v.numberOfOrders,
        totalRevenueValue: v.amountSpent.amount,
        totalRevenueCurrencyCode: v.amountSpent.currencyCode,
        tags: v.tags,
        shopifyDomain: $,
        refresh: l,
        loading: i || p,
        networkStatus: c
      },
      v.id
    ),
    b && b.length > 0 && v && /* @__PURE__ */ Q.jsxs(C, { flexDirection: "column", gap: "200", children: [
      /* @__PURE__ */ Q.jsx(se.Heading, { variant: "heading-2", children: "Customer orders" }),
      b.map((E, q) => /* @__PURE__ */ Q.jsx(
        DT,
        {
          id: E.id,
          name: E.name,
          initiallyOpen: q === 0,
          createdAt: new Date(E.createdAt),
          cancelledAt: E.cancelledAt,
          status: E.status,
          value: E.value,
          lineItems: E.lineItems,
          suggestedRefundAmount: E.suggestedRefundAmount,
          suggestedRefund: E.suggestedRefund,
          currencyCode: E.currencyCode,
          shippingAddress: E.shippingAddress,
          billingAddress: E.billingAddress,
          trackingInfos: E.trackingInfos,
          shopifyDomain: $,
          enableRefunds: P,
          enableEditShippingAddress: h,
          shopifyId: v.id,
          shippingCountryCodes: x,
          refetch: l
        },
        E.id
      ))
    ] }),
    v && /* @__PURE__ */ Q.jsx(C, { justifyContent: "space-around", children: /* @__PURE__ */ Q.jsx(
      im,
      {
        shopifyId: v.id,
        trackingAction: "viewAllOrdersInShopify",
        domain: $,
        type: "orders",
        params: {
          // We need snake case to match the shopify query param
          // eslint-disable-next-line camelcase
          customer_id: am(v.id)
        },
        children: "View all orders in Shopify"
      }
    ) })
  ] });
};
var ul = { exports: {} }, br = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var ss, om;
function cv() {
  if (om)
    return ss;
  om = 1;
  var e = Object.getOwnPropertySymbols, n = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function i(s) {
    if (s == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(s);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var s = new String("abc");
      if (s[5] = "de", Object.getOwnPropertyNames(s)[0] === "5")
        return !1;
      for (var l = {}, c = 0; c < 10; c++)
        l["_" + String.fromCharCode(c)] = c;
      var u = Object.getOwnPropertyNames(l).map(function(m) {
        return l[m];
      });
      if (u.join("") !== "0123456789")
        return !1;
      var p = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(m) {
        p[m] = m;
      }), Object.keys(Object.assign({}, p)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return ss = o() ? Object.assign : function(s, l) {
    for (var c, u = i(s), p, m = 1; m < arguments.length; m++) {
      c = Object(arguments[m]);
      for (var v in c)
        n.call(c, v) && (u[v] = c[v]);
      if (e) {
        p = e(c);
        for (var y = 0; y < p.length; y++)
          r.call(c, p[y]) && (u[p[y]] = c[p[y]]);
      }
    }
    return u;
  }, ss;
}
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var sm;
function UT() {
  if (sm)
    return br;
  sm = 1, cv();
  var e = Cn, n = 60103;
  if (br.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var r = Symbol.for;
    n = r("react.element"), br.Fragment = r("react.fragment");
  }
  var i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = Object.prototype.hasOwnProperty, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(c, u, p) {
    var m, v = {}, y = null, b = null;
    p !== void 0 && (y = "" + p), u.key !== void 0 && (y = "" + u.key), u.ref !== void 0 && (b = u.ref);
    for (m in u)
      o.call(u, m) && !s.hasOwnProperty(m) && (v[m] = u[m]);
    if (c && c.defaultProps)
      for (m in u = c.defaultProps, u)
        v[m] === void 0 && (v[m] = u[m]);
    return { $$typeof: n, type: c, key: y, ref: b, props: v, _owner: i.current };
  }
  return br.jsx = l, br.jsxs = l, br;
}
var lm = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var cm;
function MT() {
  return cm || (cm = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      var n = Cn, r = cv(), i = 60103, o = 60106;
      e.Fragment = 60107;
      var s = 60108, l = 60114, c = 60109, u = 60110, p = 60112, m = 60113, v = 60120, y = 60115, b = 60116, N = 60121, x = 60122, T = 60117, $ = 60129, P = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var h = Symbol.for;
        i = h("react.element"), o = h("react.portal"), e.Fragment = h("react.fragment"), s = h("react.strict_mode"), l = h("react.profiler"), c = h("react.provider"), u = h("react.context"), p = h("react.forward_ref"), m = h("react.suspense"), v = h("react.suspense_list"), y = h("react.memo"), b = h("react.lazy"), N = h("react.block"), x = h("react.server.block"), T = h("react.fundamental"), h("react.scope"), h("react.opaque.id"), $ = h("react.debug_trace_mode"), h("react.offscreen"), P = h("react.legacy_hidden");
      }
      var E = typeof Symbol == "function" && Symbol.iterator, q = "@@iterator";
      function M(t) {
        if (t === null || typeof t != "object")
          return null;
        var a = E && t[E] || t[q];
        return typeof a == "function" ? a : null;
      }
      var R = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function w(t) {
        {
          for (var a = arguments.length, d = new Array(a > 1 ? a - 1 : 0), f = 1; f < a; f++)
            d[f - 1] = arguments[f];
          H("error", t, d);
        }
      }
      function H(t, a, d) {
        {
          var f = R.ReactDebugCurrentFrame, _ = f.getStackAddendum();
          _ !== "" && (a += "%s", d = d.concat([_]));
          var S = d.map(function(k) {
            return "" + k;
          });
          S.unshift("Warning: " + a), Function.prototype.apply.call(console[t], console, S);
        }
      }
      var pe = !1;
      function le(t) {
        return !!(typeof t == "string" || typeof t == "function" || t === e.Fragment || t === l || t === $ || t === s || t === m || t === v || t === P || pe || typeof t == "object" && t !== null && (t.$$typeof === b || t.$$typeof === y || t.$$typeof === c || t.$$typeof === u || t.$$typeof === p || t.$$typeof === T || t.$$typeof === N || t[0] === x));
      }
      function Se(t, a, d) {
        var f = a.displayName || a.name || "";
        return t.displayName || (f !== "" ? d + "(" + f + ")" : d);
      }
      function ae(t) {
        return t.displayName || "Context";
      }
      function D(t) {
        if (t == null)
          return null;
        if (typeof t.tag == "number" && w("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof t == "function")
          return t.displayName || t.name || null;
        if (typeof t == "string")
          return t;
        switch (t) {
          case e.Fragment:
            return "Fragment";
          case o:
            return "Portal";
          case l:
            return "Profiler";
          case s:
            return "StrictMode";
          case m:
            return "Suspense";
          case v:
            return "SuspenseList";
        }
        if (typeof t == "object")
          switch (t.$$typeof) {
            case u:
              var a = t;
              return ae(a) + ".Consumer";
            case c:
              var d = t;
              return ae(d._context) + ".Provider";
            case p:
              return Se(t, t.render, "ForwardRef");
            case y:
              return D(t.type);
            case N:
              return D(t._render);
            case b: {
              var f = t, _ = f._payload, S = f._init;
              try {
                return D(S(_));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var V = 0, de, te, he, _e, Z, J, z;
      function me() {
      }
      me.__reactDisabledLog = !0;
      function ke() {
        {
          if (V === 0) {
            de = console.log, te = console.info, he = console.warn, _e = console.error, Z = console.group, J = console.groupCollapsed, z = console.groupEnd;
            var t = {
              configurable: !0,
              enumerable: !0,
              value: me,
              writable: !0
            };
            Object.defineProperties(console, {
              info: t,
              log: t,
              warn: t,
              error: t,
              group: t,
              groupCollapsed: t,
              groupEnd: t
            });
          }
          V++;
        }
      }
      function Oe() {
        {
          if (V--, V === 0) {
            var t = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: r({}, t, {
                value: de
              }),
              info: r({}, t, {
                value: te
              }),
              warn: r({}, t, {
                value: he
              }),
              error: r({}, t, {
                value: _e
              }),
              group: r({}, t, {
                value: Z
              }),
              groupCollapsed: r({}, t, {
                value: J
              }),
              groupEnd: r({}, t, {
                value: z
              })
            });
          }
          V < 0 && w("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var Y = R.ReactCurrentDispatcher, fe;
      function ge(t, a, d) {
        {
          if (fe === void 0)
            try {
              throw Error();
            } catch (_) {
              var f = _.stack.trim().match(/\n( *(at )?)/);
              fe = f && f[1] || "";
            }
          return `
` + fe + t;
        }
      }
      var X = !1, ye;
      {
        var W = typeof WeakMap == "function" ? WeakMap : Map;
        ye = new W();
      }
      function ce(t, a) {
        if (!t || X)
          return "";
        {
          var d = ye.get(t);
          if (d !== void 0)
            return d;
        }
        var f;
        X = !0;
        var _ = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var S;
        S = Y.current, Y.current = null, ke();
        try {
          if (a) {
            var k = function() {
              throw Error();
            };
            if (Object.defineProperty(k.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(k, []);
              } catch (A) {
                f = A;
              }
              Reflect.construct(t, [], k);
            } else {
              try {
                k.call();
              } catch (A) {
                f = A;
              }
              t.call(k.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (A) {
              f = A;
            }
            t();
          }
        } catch (A) {
          if (A && f && typeof A.stack == "string") {
            for (var g = A.stack.split(`
`), L = f.stack.split(`
`), I = g.length - 1, O = L.length - 1; I >= 1 && O >= 0 && g[I] !== L[O]; )
              O--;
            for (; I >= 1 && O >= 0; I--, O--)
              if (g[I] !== L[O]) {
                if (I !== 1 || O !== 1)
                  do
                    if (I--, O--, O < 0 || g[I] !== L[O]) {
                      var re = `
` + g[I].replace(" at new ", " at ");
                      return typeof t == "function" && ye.set(t, re), re;
                    }
                  while (I >= 1 && O >= 0);
                break;
              }
          }
        } finally {
          X = !1, Y.current = S, Oe(), Error.prepareStackTrace = _;
        }
        var Ce = t ? t.displayName || t.name : "", j = Ce ? ge(Ce) : "";
        return typeof t == "function" && ye.set(t, j), j;
      }
      function ie(t, a, d) {
        return ce(t, !1);
      }
      function oe(t) {
        var a = t.prototype;
        return !!(a && a.isReactComponent);
      }
      function be(t, a, d) {
        if (t == null)
          return "";
        if (typeof t == "function")
          return ce(t, oe(t));
        if (typeof t == "string")
          return ge(t);
        switch (t) {
          case m:
            return ge("Suspense");
          case v:
            return ge("SuspenseList");
        }
        if (typeof t == "object")
          switch (t.$$typeof) {
            case p:
              return ie(t.render);
            case y:
              return be(t.type, a, d);
            case N:
              return ie(t._render);
            case b: {
              var f = t, _ = f._payload, S = f._init;
              try {
                return be(S(_), a, d);
              } catch {
              }
            }
          }
        return "";
      }
      var Ee = {}, Ie = R.ReactDebugCurrentFrame;
      function we(t) {
        if (t) {
          var a = t._owner, d = be(t.type, t._source, a ? a.type : null);
          Ie.setExtraStackFrame(d);
        } else
          Ie.setExtraStackFrame(null);
      }
      function Ge(t, a, d, f, _) {
        {
          var S = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var k in t)
            if (S(t, k)) {
              var g = void 0;
              try {
                if (typeof t[k] != "function") {
                  var L = Error((f || "React class") + ": " + d + " type `" + k + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[k] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw L.name = "Invariant Violation", L;
                }
                g = t[k](a, k, f, d, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (I) {
                g = I;
              }
              g && !(g instanceof Error) && (we(_), w("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", f || "React class", d, k, typeof g), we(null)), g instanceof Error && !(g.message in Ee) && (Ee[g.message] = !0, we(_), w("Failed %s type: %s", d, g.message), we(null));
            }
        }
      }
      var je = R.ReactCurrentOwner, Te = Object.prototype.hasOwnProperty, Ye = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, Ae, Be, De;
      De = {};
      function cn(t) {
        if (Te.call(t, "ref")) {
          var a = Object.getOwnPropertyDescriptor(t, "ref").get;
          if (a && a.isReactWarning)
            return !1;
        }
        return t.ref !== void 0;
      }
      function en(t) {
        if (Te.call(t, "key")) {
          var a = Object.getOwnPropertyDescriptor(t, "key").get;
          if (a && a.isReactWarning)
            return !1;
        }
        return t.key !== void 0;
      }
      function yn(t, a) {
        if (typeof t.ref == "string" && je.current && a && je.current.stateNode !== a) {
          var d = D(je.current.type);
          De[d] || (w('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', D(je.current.type), t.ref), De[d] = !0);
        }
      }
      function pn(t, a) {
        {
          var d = function() {
            Ae || (Ae = !0, w("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", a));
          };
          d.isReactWarning = !0, Object.defineProperty(t, "key", {
            get: d,
            configurable: !0
          });
        }
      }
      function gn(t, a) {
        {
          var d = function() {
            Be || (Be = !0, w("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", a));
          };
          d.isReactWarning = !0, Object.defineProperty(t, "ref", {
            get: d,
            configurable: !0
          });
        }
      }
      var dn = function(t, a, d, f, _, S, k) {
        var g = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: i,
          // Built-in properties that belong on the element
          type: t,
          key: a,
          ref: d,
          props: k,
          // Record the component responsible for creating this element.
          _owner: S
        };
        return g._store = {}, Object.defineProperty(g._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(g, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: f
        }), Object.defineProperty(g, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: _
        }), Object.freeze && (Object.freeze(g.props), Object.freeze(g)), g;
      };
      function un(t, a, d, f, _) {
        {
          var S, k = {}, g = null, L = null;
          d !== void 0 && (g = "" + d), en(a) && (g = "" + a.key), cn(a) && (L = a.ref, yn(a, _));
          for (S in a)
            Te.call(a, S) && !Ye.hasOwnProperty(S) && (k[S] = a[S]);
          if (t && t.defaultProps) {
            var I = t.defaultProps;
            for (S in I)
              k[S] === void 0 && (k[S] = I[S]);
          }
          if (g || L) {
            var O = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
            g && pn(k, O), L && gn(k, O);
          }
          return dn(t, g, L, _, f, je.current, k);
        }
      }
      var Re = R.ReactCurrentOwner, He = R.ReactDebugCurrentFrame;
      function Ne(t) {
        if (t) {
          var a = t._owner, d = be(t.type, t._source, a ? a.type : null);
          He.setExtraStackFrame(d);
        } else
          He.setExtraStackFrame(null);
      }
      var Le;
      Le = !1;
      function Me(t) {
        return typeof t == "object" && t !== null && t.$$typeof === i;
      }
      function ze() {
        {
          if (Re.current) {
            var t = D(Re.current.type);
            if (t)
              return `

Check the render method of \`` + t + "`.";
          }
          return "";
        }
      }
      function _n(t) {
        {
          if (t !== void 0) {
            var a = t.fileName.replace(/^.*[\\\/]/, ""), d = t.lineNumber;
            return `

Check your code at ` + a + ":" + d + ".";
          }
          return "";
        }
      }
      var Je = {};
      function qe(t) {
        {
          var a = ze();
          if (!a) {
            var d = typeof t == "string" ? t : t.displayName || t.name;
            d && (a = `

Check the top-level render call using <` + d + ">.");
          }
          return a;
        }
      }
      function Ke(t, a) {
        {
          if (!t._store || t._store.validated || t.key != null)
            return;
          t._store.validated = !0;
          var d = qe(a);
          if (Je[d])
            return;
          Je[d] = !0;
          var f = "";
          t && t._owner && t._owner !== Re.current && (f = " It was passed a child from " + D(t._owner.type) + "."), Ne(t), w('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', d, f), Ne(null);
        }
      }
      function Ze(t, a) {
        {
          if (typeof t != "object")
            return;
          if (Array.isArray(t))
            for (var d = 0; d < t.length; d++) {
              var f = t[d];
              Me(f) && Ke(f, a);
            }
          else if (Me(t))
            t._store && (t._store.validated = !0);
          else if (t) {
            var _ = M(t);
            if (typeof _ == "function" && _ !== t.entries)
              for (var S = _.call(t), k; !(k = S.next()).done; )
                Me(k.value) && Ke(k.value, a);
          }
        }
      }
      function hn(t) {
        {
          var a = t.type;
          if (a == null || typeof a == "string")
            return;
          var d;
          if (typeof a == "function")
            d = a.propTypes;
          else if (typeof a == "object" && (a.$$typeof === p || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          a.$$typeof === y))
            d = a.propTypes;
          else
            return;
          if (d) {
            var f = D(a);
            Ge(d, t.props, "prop", f, t);
          } else if (a.PropTypes !== void 0 && !Le) {
            Le = !0;
            var _ = D(a);
            w("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _ || "Unknown");
          }
          typeof a.getDefaultProps == "function" && !a.getDefaultProps.isReactClassApproved && w("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function fn(t) {
        {
          for (var a = Object.keys(t.props), d = 0; d < a.length; d++) {
            var f = a[d];
            if (f !== "children" && f !== "key") {
              Ne(t), w("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", f), Ne(null);
              break;
            }
          }
          t.ref !== null && (Ne(t), w("Invalid attribute `ref` supplied to `React.Fragment`."), Ne(null));
        }
      }
      function Qe(t, a, d, f, _, S) {
        {
          var k = le(t);
          if (!k) {
            var g = "";
            (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (g += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var L = _n(_);
            L ? g += L : g += ze();
            var I;
            t === null ? I = "null" : Array.isArray(t) ? I = "array" : t !== void 0 && t.$$typeof === i ? (I = "<" + (D(t.type) || "Unknown") + " />", g = " Did you accidentally export a JSX literal instead of a component?") : I = typeof t, w("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", I, g);
          }
          var O = un(t, a, d, _, S);
          if (O == null)
            return O;
          if (k) {
            var re = a.children;
            if (re !== void 0)
              if (f)
                if (Array.isArray(re)) {
                  for (var Ce = 0; Ce < re.length; Ce++)
                    Ze(re[Ce], t);
                  Object.freeze && Object.freeze(re);
                } else
                  w("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                Ze(re, t);
          }
          return t === e.Fragment ? fn(O) : hn(O), O;
        }
      }
      function kn(t, a, d) {
        return Qe(t, a, d, !0);
      }
      function Sn(t, a, d) {
        return Qe(t, a, d, !1);
      }
      var mn = Sn, vn = kn;
      e.jsx = mn, e.jsxs = vn;
    }();
  }(lm)), lm;
}
process.env.NODE_ENV === "production" ? ul.exports = UT() : ul.exports = MT();
var ls = ul.exports;
const BT = ({
  conversationContext: e,
  settings: n
}) => (console.log("conversationContext", e), console.log("settings", n), /* @__PURE__ */ ls.jsx(ls.Fragment, { children: /* @__PURE__ */ ls.jsx(C, { children: "Truspilot widget goes here" }) })), VT = [
  {
    key: "property1",
    label: "Property 1",
    placeholder: "Insert property 1",
    required: !0,
    secret: !1,
    type: "input",
    prefix: void 0,
    defaultValue: "Value 1"
  },
  {
    key: "property2",
    label: "Property 2",
    placeholder: "Insert property 2",
    required: !0,
    secret: !1,
    type: "switch",
    prefix: void 0,
    defaultValue: !0
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._wrapper_1cyr7_27{border-radius:4px;padding:16px;background-color:#f5f7fa}._textVariant_1cyr7_33{color:#46597c;font-size:14px}._copyIcon_1cyr7_38{cursor:pointer;color:#46597c}._block_1cyr7_43{margin-bottom:12px}._wrapper_1u9t9_27{border:1px solid #d7dfea;border-radius:4px;padding:16px}._timestamp_1u9t9_33{font-size:12px;color:#46597c}._list_1u9t9_38{padding:0}._listItem_1u9t9_42{padding:4px;border-bottom:1px solid #e7ecf3}._listItem_1u9t9_42:last-child{border-bottom:none}._tagHover_1tvfi_27:hover{cursor:pointer;border-color:#b5c1d4}._channelUnsubscribed_1tvfi_32,._notificationText_1q2yz_27{color:#8193b0}._labelText_1q2yz_31{color:#46597c}._list_1sa46_27{padding:4px}._listItem_1sa46_30{padding:8px 4px}._listSum_1sa46_33{margin-top:8px;border-top:1px solid #b5c1d4}._transaction_19x38_27{border:1px solid #d7dfea;border-radius:4px;padding:12px}._transaction_19x38_27:hover,._transactionIsOpen_19x38_35{border-color:#b5c1d4}._transactionHeader_19x38_38{cursor:pointer}._transactionHeaderSubLine_19x38_41{font-size:12px;color:#8294b0}._transactionHeaderAlignItemRight_19x38_45{margin-left:auto;margin-right:8px}._message_31gs2_27{border:1px solid #d7dfea;border-radius:4px;padding:12px}._message_31gs2_27:hover,._messageIsOpen_31gs2_35{border-color:#b5c1d4}._messageHeader_31gs2_39{cursor:pointer}._messageText_31gs2_43{max-height:150px;overflow:scroll;padding:4px 8px;border:1px solid #e7ecf3;border-radius:4px;overflow:hidden;overflow-y:auto;overflow-x:auto}._messageText_31gs2_43::-webkit-scrollbar{width:7px;height:7px}._messageText_31gs2_43::-webkit-scrollbar-track{background-color:#e7ecf3}._messageText_31gs2_43::-webkit-scrollbar-thumb{background-color:#b5c1d4;border-radius:5px}._buttonLink_31gs2_65{color:#0079cc}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var ml = { exports: {} }, _r = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var cs, dm;
function dv() {
  if (dm)
    return cs;
  dm = 1;
  var e = Object.getOwnPropertySymbols, n = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function i(s) {
    if (s == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(s);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var s = new String("abc");
      if (s[5] = "de", Object.getOwnPropertyNames(s)[0] === "5")
        return !1;
      for (var l = {}, c = 0; c < 10; c++)
        l["_" + String.fromCharCode(c)] = c;
      var u = Object.getOwnPropertyNames(l).map(function(m) {
        return l[m];
      });
      if (u.join("") !== "0123456789")
        return !1;
      var p = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(m) {
        p[m] = m;
      }), Object.keys(Object.assign({}, p)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return cs = o() ? Object.assign : function(s, l) {
    for (var c, u = i(s), p, m = 1; m < arguments.length; m++) {
      c = Object(arguments[m]);
      for (var v in c)
        n.call(c, v) && (u[v] = c[v]);
      if (e) {
        p = e(c);
        for (var y = 0; y < p.length; y++)
          r.call(c, p[y]) && (u[p[y]] = c[p[y]]);
      }
    }
    return u;
  }, cs;
}
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var um;
function qT() {
  if (um)
    return _r;
  um = 1, dv();
  var e = Cn, n = 60103;
  if (_r.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var r = Symbol.for;
    n = r("react.element"), _r.Fragment = r("react.fragment");
  }
  var i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = Object.prototype.hasOwnProperty, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(c, u, p) {
    var m, v = {}, y = null, b = null;
    p !== void 0 && (y = "" + p), u.key !== void 0 && (y = "" + u.key), u.ref !== void 0 && (b = u.ref);
    for (m in u)
      o.call(u, m) && !s.hasOwnProperty(m) && (v[m] = u[m]);
    if (c && c.defaultProps)
      for (m in u = c.defaultProps, u)
        v[m] === void 0 && (v[m] = u[m]);
    return { $$typeof: n, type: c, key: y, ref: b, props: v, _owner: i.current };
  }
  return _r.jsx = l, _r.jsxs = l, _r;
}
var mm = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var pm;
function zT() {
  return pm || (pm = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      var n = Cn, r = dv(), i = 60103, o = 60106;
      e.Fragment = 60107;
      var s = 60108, l = 60114, c = 60109, u = 60110, p = 60112, m = 60113, v = 60120, y = 60115, b = 60116, N = 60121, x = 60122, T = 60117, $ = 60129, P = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var h = Symbol.for;
        i = h("react.element"), o = h("react.portal"), e.Fragment = h("react.fragment"), s = h("react.strict_mode"), l = h("react.profiler"), c = h("react.provider"), u = h("react.context"), p = h("react.forward_ref"), m = h("react.suspense"), v = h("react.suspense_list"), y = h("react.memo"), b = h("react.lazy"), N = h("react.block"), x = h("react.server.block"), T = h("react.fundamental"), h("react.scope"), h("react.opaque.id"), $ = h("react.debug_trace_mode"), h("react.offscreen"), P = h("react.legacy_hidden");
      }
      var E = typeof Symbol == "function" && Symbol.iterator, q = "@@iterator";
      function M(t) {
        if (t === null || typeof t != "object")
          return null;
        var a = E && t[E] || t[q];
        return typeof a == "function" ? a : null;
      }
      var R = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function w(t) {
        {
          for (var a = arguments.length, d = new Array(a > 1 ? a - 1 : 0), f = 1; f < a; f++)
            d[f - 1] = arguments[f];
          H("error", t, d);
        }
      }
      function H(t, a, d) {
        {
          var f = R.ReactDebugCurrentFrame, _ = f.getStackAddendum();
          _ !== "" && (a += "%s", d = d.concat([_]));
          var S = d.map(function(k) {
            return "" + k;
          });
          S.unshift("Warning: " + a), Function.prototype.apply.call(console[t], console, S);
        }
      }
      var pe = !1;
      function le(t) {
        return !!(typeof t == "string" || typeof t == "function" || t === e.Fragment || t === l || t === $ || t === s || t === m || t === v || t === P || pe || typeof t == "object" && t !== null && (t.$$typeof === b || t.$$typeof === y || t.$$typeof === c || t.$$typeof === u || t.$$typeof === p || t.$$typeof === T || t.$$typeof === N || t[0] === x));
      }
      function Se(t, a, d) {
        var f = a.displayName || a.name || "";
        return t.displayName || (f !== "" ? d + "(" + f + ")" : d);
      }
      function ae(t) {
        return t.displayName || "Context";
      }
      function D(t) {
        if (t == null)
          return null;
        if (typeof t.tag == "number" && w("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof t == "function")
          return t.displayName || t.name || null;
        if (typeof t == "string")
          return t;
        switch (t) {
          case e.Fragment:
            return "Fragment";
          case o:
            return "Portal";
          case l:
            return "Profiler";
          case s:
            return "StrictMode";
          case m:
            return "Suspense";
          case v:
            return "SuspenseList";
        }
        if (typeof t == "object")
          switch (t.$$typeof) {
            case u:
              var a = t;
              return ae(a) + ".Consumer";
            case c:
              var d = t;
              return ae(d._context) + ".Provider";
            case p:
              return Se(t, t.render, "ForwardRef");
            case y:
              return D(t.type);
            case N:
              return D(t._render);
            case b: {
              var f = t, _ = f._payload, S = f._init;
              try {
                return D(S(_));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var V = 0, de, te, he, _e, Z, J, z;
      function me() {
      }
      me.__reactDisabledLog = !0;
      function ke() {
        {
          if (V === 0) {
            de = console.log, te = console.info, he = console.warn, _e = console.error, Z = console.group, J = console.groupCollapsed, z = console.groupEnd;
            var t = {
              configurable: !0,
              enumerable: !0,
              value: me,
              writable: !0
            };
            Object.defineProperties(console, {
              info: t,
              log: t,
              warn: t,
              error: t,
              group: t,
              groupCollapsed: t,
              groupEnd: t
            });
          }
          V++;
        }
      }
      function Oe() {
        {
          if (V--, V === 0) {
            var t = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: r({}, t, {
                value: de
              }),
              info: r({}, t, {
                value: te
              }),
              warn: r({}, t, {
                value: he
              }),
              error: r({}, t, {
                value: _e
              }),
              group: r({}, t, {
                value: Z
              }),
              groupCollapsed: r({}, t, {
                value: J
              }),
              groupEnd: r({}, t, {
                value: z
              })
            });
          }
          V < 0 && w("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var Y = R.ReactCurrentDispatcher, fe;
      function ge(t, a, d) {
        {
          if (fe === void 0)
            try {
              throw Error();
            } catch (_) {
              var f = _.stack.trim().match(/\n( *(at )?)/);
              fe = f && f[1] || "";
            }
          return `
` + fe + t;
        }
      }
      var X = !1, ye;
      {
        var W = typeof WeakMap == "function" ? WeakMap : Map;
        ye = new W();
      }
      function ce(t, a) {
        if (!t || X)
          return "";
        {
          var d = ye.get(t);
          if (d !== void 0)
            return d;
        }
        var f;
        X = !0;
        var _ = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var S;
        S = Y.current, Y.current = null, ke();
        try {
          if (a) {
            var k = function() {
              throw Error();
            };
            if (Object.defineProperty(k.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(k, []);
              } catch (A) {
                f = A;
              }
              Reflect.construct(t, [], k);
            } else {
              try {
                k.call();
              } catch (A) {
                f = A;
              }
              t.call(k.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (A) {
              f = A;
            }
            t();
          }
        } catch (A) {
          if (A && f && typeof A.stack == "string") {
            for (var g = A.stack.split(`
`), L = f.stack.split(`
`), I = g.length - 1, O = L.length - 1; I >= 1 && O >= 0 && g[I] !== L[O]; )
              O--;
            for (; I >= 1 && O >= 0; I--, O--)
              if (g[I] !== L[O]) {
                if (I !== 1 || O !== 1)
                  do
                    if (I--, O--, O < 0 || g[I] !== L[O]) {
                      var re = `
` + g[I].replace(" at new ", " at ");
                      return typeof t == "function" && ye.set(t, re), re;
                    }
                  while (I >= 1 && O >= 0);
                break;
              }
          }
        } finally {
          X = !1, Y.current = S, Oe(), Error.prepareStackTrace = _;
        }
        var Ce = t ? t.displayName || t.name : "", j = Ce ? ge(Ce) : "";
        return typeof t == "function" && ye.set(t, j), j;
      }
      function ie(t, a, d) {
        return ce(t, !1);
      }
      function oe(t) {
        var a = t.prototype;
        return !!(a && a.isReactComponent);
      }
      function be(t, a, d) {
        if (t == null)
          return "";
        if (typeof t == "function")
          return ce(t, oe(t));
        if (typeof t == "string")
          return ge(t);
        switch (t) {
          case m:
            return ge("Suspense");
          case v:
            return ge("SuspenseList");
        }
        if (typeof t == "object")
          switch (t.$$typeof) {
            case p:
              return ie(t.render);
            case y:
              return be(t.type, a, d);
            case N:
              return ie(t._render);
            case b: {
              var f = t, _ = f._payload, S = f._init;
              try {
                return be(S(_), a, d);
              } catch {
              }
            }
          }
        return "";
      }
      var Ee = {}, Ie = R.ReactDebugCurrentFrame;
      function we(t) {
        if (t) {
          var a = t._owner, d = be(t.type, t._source, a ? a.type : null);
          Ie.setExtraStackFrame(d);
        } else
          Ie.setExtraStackFrame(null);
      }
      function Ge(t, a, d, f, _) {
        {
          var S = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var k in t)
            if (S(t, k)) {
              var g = void 0;
              try {
                if (typeof t[k] != "function") {
                  var L = Error((f || "React class") + ": " + d + " type `" + k + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[k] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw L.name = "Invariant Violation", L;
                }
                g = t[k](a, k, f, d, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (I) {
                g = I;
              }
              g && !(g instanceof Error) && (we(_), w("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", f || "React class", d, k, typeof g), we(null)), g instanceof Error && !(g.message in Ee) && (Ee[g.message] = !0, we(_), w("Failed %s type: %s", d, g.message), we(null));
            }
        }
      }
      var je = R.ReactCurrentOwner, Te = Object.prototype.hasOwnProperty, Ye = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, Ae, Be, De;
      De = {};
      function cn(t) {
        if (Te.call(t, "ref")) {
          var a = Object.getOwnPropertyDescriptor(t, "ref").get;
          if (a && a.isReactWarning)
            return !1;
        }
        return t.ref !== void 0;
      }
      function en(t) {
        if (Te.call(t, "key")) {
          var a = Object.getOwnPropertyDescriptor(t, "key").get;
          if (a && a.isReactWarning)
            return !1;
        }
        return t.key !== void 0;
      }
      function yn(t, a) {
        if (typeof t.ref == "string" && je.current && a && je.current.stateNode !== a) {
          var d = D(je.current.type);
          De[d] || (w('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', D(je.current.type), t.ref), De[d] = !0);
        }
      }
      function pn(t, a) {
        {
          var d = function() {
            Ae || (Ae = !0, w("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", a));
          };
          d.isReactWarning = !0, Object.defineProperty(t, "key", {
            get: d,
            configurable: !0
          });
        }
      }
      function gn(t, a) {
        {
          var d = function() {
            Be || (Be = !0, w("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", a));
          };
          d.isReactWarning = !0, Object.defineProperty(t, "ref", {
            get: d,
            configurable: !0
          });
        }
      }
      var dn = function(t, a, d, f, _, S, k) {
        var g = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: i,
          // Built-in properties that belong on the element
          type: t,
          key: a,
          ref: d,
          props: k,
          // Record the component responsible for creating this element.
          _owner: S
        };
        return g._store = {}, Object.defineProperty(g._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(g, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: f
        }), Object.defineProperty(g, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: _
        }), Object.freeze && (Object.freeze(g.props), Object.freeze(g)), g;
      };
      function un(t, a, d, f, _) {
        {
          var S, k = {}, g = null, L = null;
          d !== void 0 && (g = "" + d), en(a) && (g = "" + a.key), cn(a) && (L = a.ref, yn(a, _));
          for (S in a)
            Te.call(a, S) && !Ye.hasOwnProperty(S) && (k[S] = a[S]);
          if (t && t.defaultProps) {
            var I = t.defaultProps;
            for (S in I)
              k[S] === void 0 && (k[S] = I[S]);
          }
          if (g || L) {
            var O = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
            g && pn(k, O), L && gn(k, O);
          }
          return dn(t, g, L, _, f, je.current, k);
        }
      }
      var Re = R.ReactCurrentOwner, He = R.ReactDebugCurrentFrame;
      function Ne(t) {
        if (t) {
          var a = t._owner, d = be(t.type, t._source, a ? a.type : null);
          He.setExtraStackFrame(d);
        } else
          He.setExtraStackFrame(null);
      }
      var Le;
      Le = !1;
      function Me(t) {
        return typeof t == "object" && t !== null && t.$$typeof === i;
      }
      function ze() {
        {
          if (Re.current) {
            var t = D(Re.current.type);
            if (t)
              return `

Check the render method of \`` + t + "`.";
          }
          return "";
        }
      }
      function _n(t) {
        {
          if (t !== void 0) {
            var a = t.fileName.replace(/^.*[\\\/]/, ""), d = t.lineNumber;
            return `

Check your code at ` + a + ":" + d + ".";
          }
          return "";
        }
      }
      var Je = {};
      function qe(t) {
        {
          var a = ze();
          if (!a) {
            var d = typeof t == "string" ? t : t.displayName || t.name;
            d && (a = `

Check the top-level render call using <` + d + ">.");
          }
          return a;
        }
      }
      function Ke(t, a) {
        {
          if (!t._store || t._store.validated || t.key != null)
            return;
          t._store.validated = !0;
          var d = qe(a);
          if (Je[d])
            return;
          Je[d] = !0;
          var f = "";
          t && t._owner && t._owner !== Re.current && (f = " It was passed a child from " + D(t._owner.type) + "."), Ne(t), w('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', d, f), Ne(null);
        }
      }
      function Ze(t, a) {
        {
          if (typeof t != "object")
            return;
          if (Array.isArray(t))
            for (var d = 0; d < t.length; d++) {
              var f = t[d];
              Me(f) && Ke(f, a);
            }
          else if (Me(t))
            t._store && (t._store.validated = !0);
          else if (t) {
            var _ = M(t);
            if (typeof _ == "function" && _ !== t.entries)
              for (var S = _.call(t), k; !(k = S.next()).done; )
                Me(k.value) && Ke(k.value, a);
          }
        }
      }
      function hn(t) {
        {
          var a = t.type;
          if (a == null || typeof a == "string")
            return;
          var d;
          if (typeof a == "function")
            d = a.propTypes;
          else if (typeof a == "object" && (a.$$typeof === p || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          a.$$typeof === y))
            d = a.propTypes;
          else
            return;
          if (d) {
            var f = D(a);
            Ge(d, t.props, "prop", f, t);
          } else if (a.PropTypes !== void 0 && !Le) {
            Le = !0;
            var _ = D(a);
            w("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _ || "Unknown");
          }
          typeof a.getDefaultProps == "function" && !a.getDefaultProps.isReactClassApproved && w("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function fn(t) {
        {
          for (var a = Object.keys(t.props), d = 0; d < a.length; d++) {
            var f = a[d];
            if (f !== "children" && f !== "key") {
              Ne(t), w("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", f), Ne(null);
              break;
            }
          }
          t.ref !== null && (Ne(t), w("Invalid attribute `ref` supplied to `React.Fragment`."), Ne(null));
        }
      }
      function Qe(t, a, d, f, _, S) {
        {
          var k = le(t);
          if (!k) {
            var g = "";
            (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (g += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var L = _n(_);
            L ? g += L : g += ze();
            var I;
            t === null ? I = "null" : Array.isArray(t) ? I = "array" : t !== void 0 && t.$$typeof === i ? (I = "<" + (D(t.type) || "Unknown") + " />", g = " Did you accidentally export a JSX literal instead of a component?") : I = typeof t, w("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", I, g);
          }
          var O = un(t, a, d, _, S);
          if (O == null)
            return O;
          if (k) {
            var re = a.children;
            if (re !== void 0)
              if (f)
                if (Array.isArray(re)) {
                  for (var Ce = 0; Ce < re.length; Ce++)
                    Ze(re[Ce], t);
                  Object.freeze && Object.freeze(re);
                } else
                  w("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                Ze(re, t);
          }
          return t === e.Fragment ? fn(O) : hn(O), O;
        }
      }
      function kn(t, a, d) {
        return Qe(t, a, d, !0);
      }
      function Sn(t, a, d) {
        return Qe(t, a, d, !1);
      }
      var mn = Sn, vn = kn;
      e.jsx = mn, e.jsxs = vn;
    }();
  }(mm)), mm;
}
process.env.NODE_ENV === "production" ? ml.exports = qT() : ml.exports = zT();
var B = ml.exports;
const HT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePreferences" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_contactAttributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_UpdateContact" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }] } }] }, KT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactOverviewByEmail" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactType" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactOverviewAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "mobilePhone" }, value: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } } }, { kind: "Argument", name: { kind: "Name", value: "contactType" }, value: { kind: "Variable", name: { kind: "Name", value: "contactType" } } }] }] } }] } }] }, GT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getLatestMessagesByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactMessage_GetLatestMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }] } }] }, WT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerTransactions" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Transactions_GetTransactionsByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "createdDate" } }, { kind: "Field", name: { kind: "Name", value: "transactionNumber" } }, { kind: "Field", name: { kind: "Name", value: "storeName" } }, { kind: "Field", name: { kind: "Name", value: "numberOfItems" } }, { kind: "Field", name: { kind: "Name", value: "netPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localNetPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localCurrency" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" } }] } }] } }] } }] } }] }, YT = {
  "\n  mutation updatePreferences(\n    $contactId: Voyado_UUID!\n    $input: Voyado_contactAttributes_Input!\n  ) {\n    Voyado {\n      ContactsV_UpdateContact(contactId: $contactId, input: $input) {\n        id\n      }\n    }\n  }\n": HT,
  "\n  query getContactOverviewByEmail(\n    $email: String!\n    $mobilePhone: String!\n    $contactType: String!\n  ) {\n    Voyado {\n      ContactOverview_GetContactOverviewAsync(\n        email: $email\n        mobilePhone: $mobilePhone\n        contactType: $contactType\n      )\n    }\n  }\n": KT,
  "\n  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {\n    Voyado {\n      ContactMessage_GetLatestMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        count\n        items {\n          messageId\n          name\n          sendDateTime\n          type\n          source\n          isTransactional\n          status\n          messageLink\n          messageText\n        }\n      }\n    }\n  }\n": GT,
  "\n  query getCustomerTransactions(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Transactions_GetTransactionsByContactId(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        count\n        totalCount\n        items {\n          id\n          createdDate\n          transactionNumber\n          storeName\n          numberOfItems\n          netPriceSum\n          localNetPriceSum\n          localCurrency\n          lineItems\n        }\n      }\n    }\n  }\n": WT
};
function Ba(e) {
  return YT[e] ?? {};
}
const QT = Ba(
  /* GraphQL */
  `
  query getContactOverviewByEmail(
    $email: String!
    $mobilePhone: String!
    $contactType: String!
  ) {
    Voyado {
      ContactOverview_GetContactOverviewAsync(
        email: $email
        mobilePhone: $mobilePhone
        contactType: $contactType
      )
    }
  }
`
), JT = Ba(
  /* GraphQL */
  `
  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {
    Voyado {
      ContactMessage_GetLatestMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        count
        items {
          messageId
          name
          sendDateTime
          type
          source
          isTransactional
          status
          messageLink
          messageText
        }
      }
    }
  }
`
), ZT = Ba(
  /* GraphQL */
  `
  query getCustomerTransactions(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Transactions_GetTransactionsByContactId(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        count
        totalCount
        items {
          id
          createdDate
          transactionNumber
          storeName
          numberOfItems
          netPriceSum
          localNetPriceSum
          localCurrency
          lineItems
        }
      }
    }
  }
`
), XT = Ba(
  /* GraphQL */
  `
  mutation updatePreferences(
    $contactId: Voyado_UUID!
    $input: Voyado_contactAttributes_Input!
  ) {
    Voyado {
      ContactsV_UpdateContact(contactId: $contactId, input: $input) {
        id
      }
    }
  }
`
), eO = ({
  conversationContext: e
}) => {
  const { useQuery: n } = rn(), { track: r } = sn(), [i, o] = G(), [s, l] = G(), [c, u] = G(), [p, m] = G(), [v, y] = G(), { customer: b } = e, N = !!(b != null && b.email) || !!(b != null && b.phoneNumber), {
    loading: x,
    error: T,
    data: $,
    refetch: P
  } = n(QT, {
    skip: !N,
    variables: {
      email: (b == null ? void 0 : b.email) ?? "",
      mobilePhone: (b == null ? void 0 : b.phoneNumber) ?? "",
      contactType: "member"
    }
  });
  return Pe(() => {
    var h;
    const E = (h = $ == null ? void 0 : $.Voyado) == null ? void 0 : h.ContactOverview_GetContactOverviewAsync;
    !x && E && ("id" in E && (y(E.id), r("voyado:profile:received", { hasProfile: !0 })), "attributes" in E && o(E.attributes), "preferences" in E && l(E.preferences), "consents" in E && u(E.consents), "audiences" in E && m(E.audiences)), !x && !E && r("voyado:profile:received", { hasProfile: !1 });
  }, [$ == null ? void 0 : $.Voyado, x]), At(
    () => ({
      isLoading: x,
      error: T,
      refetch: P,
      attributes: i,
      preferences: s,
      consents: c,
      audiences: p,
      contactId: v
    }),
    [T, i, s, c, p, v]
  );
};
function ds(e = !1, n) {
  const [r, i] = G(e);
  return Pe(() => {
    const o = r ? window.setTimeout(() => i(!1), n || 2e3) : void 0;
    return () => window.clearTimeout(o);
  }, [n, r]), { isCopied: r, copy: (o) => {
    navigator.clipboard.writeText(o), i(!0);
  } };
}
const nO = {
  count: 0,
  items: []
}, tO = ({
  contactId: e
}) => {
  const { useLazyQuery: n } = rn(), { track: r } = sn(), [i, o] = G(nO), [s, { loading: l, error: c, data: u }] = n(
    JT
  );
  return Pe(() => {
    e && !l && s({
      variables: {
        contactId: e,
        count: 5
      }
    });
  }, [e]), Pe(() => {
    var p, m;
    if (!l && (p = u == null ? void 0 : u.Voyado) != null && p.ContactMessage_GetLatestMessagesByContactId) {
      const v = (m = u == null ? void 0 : u.Voyado) == null ? void 0 : m.ContactMessage_GetLatestMessagesByContactId;
      o(v);
      const { items: y } = v;
      r("voyado:messages:received", {
        emailsReceived: y.filter((b) => b.type === "EmailMessage").length,
        smsReceived: y.filter((b) => b.type === "SmsMessage").length,
        postalReceived: y.filter((b) => b.type === "PostalMessage").length,
        total: v.count
      });
    }
  }, [u == null ? void 0 : u.Voyado, l]), {
    isLoading: l,
    error: c,
    lastMessages: i
  };
}, rO = {
  count: 0,
  totalCount: 0,
  items: []
}, iO = ({
  contactId: e
}) => {
  const { useLazyQuery: n } = rn(), { track: r } = sn(), [i, o] = G(rO), [s, { loading: l, error: c, data: u }] = n(ZT);
  return Pe(() => {
    e && !l && s({
      variables: {
        contactId: e,
        count: 5
      }
    });
  }, [e]), Pe(() => {
    var p;
    const m = (p = u == null ? void 0 : u.Voyado) == null ? void 0 : p.Transactions_GetTransactionsByContactId;
    if (!l && m) {
      o(m);
      const { count: v } = m;
      v && r("voyado:transactions:received", { count: v });
    }
  }, [u == null ? void 0 : u.Voyado, l]), {
    isLoading: l,
    error: c,
    transactions: i
  };
}, aO = "_wrapper_1cyr7_27", oO = "_textVariant_1cyr7_33", sO = "_copyIcon_1cyr7_38", lO = "_block_1cyr7_43", Sr = {
  wrapper: aO,
  textVariant: oO,
  copyIcon: sO,
  block: lO
}, cO = ({
  contactAttributes: e
}) => {
  const { isCopied: n, copy: r } = ds(), { isCopied: i, copy: o } = ds(), { isCopied: s, copy: l } = ds();
  if (!e)
    return null;
  const {
    firstName: c,
    lastName: u,
    street: p,
    zipCode: m,
    city: v,
    country: y,
    bonusPoints: b,
    email: N,
    mobilePhone: x
  } = e, T = `${c || ""} ${u || ""}`.trim() || "Anonymous";
  return /* @__PURE__ */ B.jsxs(C, { className: Sr.wrapper, gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ B.jsxs(
      C,
      {
        justifyContent: "space-between",
        className: Sr.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ B.jsx(se.Heading, { variant: "heading-2", children: T }),
          /* @__PURE__ */ B.jsxs(ut, { size: "small", variant: "warning", children: [
            b,
            " bonus points"
          ] })
        ]
      }
    ),
    (p || v || m || y || x || N) && /* @__PURE__ */ B.jsxs(C, { gap: "200", flexDirection: "column", children: [
      x && /* @__PURE__ */ B.jsxs(C, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ B.jsxs(C, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ B.jsx(Fe, { size: 14, name: "phone" }),
          /* @__PURE__ */ B.jsx(nn, { className: Sr.textVariant, as: "span", children: x })
        ] }),
        /* @__PURE__ */ B.jsx(
          Fe,
          {
            size: 14,
            name: i ? "done" : "copy",
            onClick: () => o(x),
            className: Sr.copyIcon
          }
        )
      ] }),
      N && /* @__PURE__ */ B.jsxs(C, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ B.jsxs(C, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ B.jsx(Fe, { size: 14, name: "mail" }),
          /* @__PURE__ */ B.jsx(se.ExternalLink, { href: `mailto:${N}`, children: N })
        ] }),
        /* @__PURE__ */ B.jsx(
          Fe,
          {
            size: 14,
            name: n ? "done" : "copy",
            onClick: () => r(N),
            className: Sr.copyIcon
          }
        )
      ] }),
      (p || v || m || y) && /* @__PURE__ */ B.jsxs(C, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ B.jsxs(C, { gap: "200", alignItems: "baseline", children: [
          /* @__PURE__ */ B.jsx(Fe, { size: 14, name: "home" }),
          /* @__PURE__ */ B.jsxs(se.Paragraph, { color: _t.color.secondary, children: [
            /* @__PURE__ */ B.jsx(nn, { children: p }),
            /* @__PURE__ */ B.jsxs(nn, { children: [
              m,
              " ",
              v
            ] }),
            /* @__PURE__ */ B.jsx(nn, { children: y })
          ] })
        ] }),
        /* @__PURE__ */ B.jsx(
          Fe,
          {
            size: 14,
            name: s ? "done" : "copy",
            onClick: () => l(`${p}, ${m} ${v}, ${y}`),
            className: Sr.copyIcon
          }
        )
      ] })
    ] })
  ] });
}, dO = ({
  contactAudiences: e
}) => !e || e.length === 0 ? null : /* @__PURE__ */ B.jsxs(C, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ B.jsx(se.Heading, { variant: "heading-3", children: "Audiences" }),
  /* @__PURE__ */ B.jsx(C, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: e.map((n, r) => /* @__PURE__ */ B.jsx(an, { children: n }, r)) })
] }), uO = "_wrapper_1u9t9_27", mO = "_timestamp_1u9t9_33", pO = "_list_1u9t9_38", fO = "_listItem_1u9t9_42", us = {
  wrapper: uO,
  timestamp: mO,
  list: pO,
  listItem: fO
}, vO = ({
  contactConsents: e
}) => !e || e.length === 0 ? null : /* @__PURE__ */ B.jsxs(C, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ B.jsx(se.Heading, { variant: "heading-3", children: "Consents" }),
  /* @__PURE__ */ B.jsx(Ln, { className: us.list, children: e.map((n, r) => /* @__PURE__ */ B.jsx(Ln.Text, { variant: "dense", className: us.listItem, children: /* @__PURE__ */ B.jsxs(C, { justifyContent: "space-between", children: [
    /* @__PURE__ */ B.jsx(se.Paragraph, { variant: "4", children: n.id }),
    /* @__PURE__ */ B.jsx(
      _m,
      {
        time: n.date,
        relative: !0,
        className: us.timestamp
      }
    )
  ] }) }, r)) })
] }), yO = "_tagHover_1tvfi_27", gO = "_channelUnsubscribed_1tvfi_32", fm = {
  tagHover: yO,
  channelUnsubscribed: gO
}, ms = ({
  isSubscribed: e,
  channelName: n,
  channelIcon: r,
  contactId: i,
  contactPreferences: o,
  refetchContact: s
}) => {
  const { track: l } = sn(), { useMutation: c } = rn(), [u, p] = G(!1), [
    m,
    { error: v, loading: y }
  ] = c(XT), b = async ({
    newPreference: x,
    isSubscribed: T,
    channelType: $
  }) => {
    var P, h;
    p(!0);
    const E = await m({
      variables: {
        contactId: i,
        input: {
          preferences: {
            ...o,
            ...x
          }
        }
      }
    });
    (h = (P = E == null ? void 0 : E.data) == null ? void 0 : P.Voyado.ContactsV_UpdateContact) != null && h.id ? T ? l("voyado:channel:unsubscribe:succeeded", { channel: $ }) : l("voyado:channel:subscribe:succeeded", { channel: $ }) : T ? l("voyado:channel:unsubscribe:failed", { channel: $ }) : l("voyado:channel:subscribe:failed", { channel: $ }), s().finally(() => p(!1));
  }, N = u || y;
  return /* @__PURE__ */ B.jsx(jn, { content: e ? "Unsubscribe" : "Subscribe", dark: !0, children: /* @__PURE__ */ B.jsx(
    an,
    {
      className: fm.tagHover,
      color: e ? $e.green[500] : $e.neutral[200],
      children: /* @__PURE__ */ B.jsxs(
        C,
        {
          "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
          gap: "200",
          alignItems: "center",
          className: It({
            [fm.channelUnsubscribed]: !e
          }),
          onClick: () => {
            e ? l("voyado:channel:unsubscribe:clicked", {
              channel: n.toUpperCase()
            }) : l("voyado:channel:subscribe:clicked", {
              channel: n.toUpperCase()
            }), b({
              newPreference: { [`accepts${n}`]: !e },
              isSubscribed: e,
              channelType: n.toUpperCase()
            });
          },
          children: [
            N ? /* @__PURE__ */ B.jsx(ln, { size: 16 }) : /* @__PURE__ */ B.jsx(Fe, { size: 16, name: r }),
            n
          ]
        }
      )
    }
  ) });
}, hO = ({
  contactPreferences: e,
  contactId: n,
  refetchContact: r
}) => {
  if (!e || !n)
    return null;
  const { acceptsEmail: i, acceptsPostal: o, acceptsSms: s } = e;
  return /* @__PURE__ */ B.jsx(C, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ B.jsxs(C, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ B.jsx(se.Heading, { variant: "heading-3", children: "Subscriptions" }),
    /* @__PURE__ */ B.jsxs(C, { gap: "100", flexDirection: "row", children: [
      /* @__PURE__ */ B.jsx(
        ms,
        {
          channelName: "Email",
          channelIcon: "mail",
          isSubscribed: i,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      ),
      /* @__PURE__ */ B.jsx(
        ms,
        {
          channelName: "Sms",
          channelIcon: "sms",
          isSubscribed: s,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      ),
      /* @__PURE__ */ B.jsx(
        ms,
        {
          channelName: "Postal",
          channelIcon: "paper-plane",
          isSubscribed: o,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      )
    ] })
  ] }) });
}, kO = "_notificationText_1q2yz_27", bO = "_labelText_1q2yz_31", Va = {
  notificationText: kO,
  labelText: bO
}, pl = (e, n) => `${e ? e.toFixed(2) : "0.00"} ${n}`, _O = "_list_1sa46_27", SO = "_listItem_1sa46_30", NO = "_listSum_1sa46_33", zi = {
  list: _O,
  listItem: SO,
  listSum: NO
}, xO = ({
  lineItems: e,
  localCurrency: n,
  localNetPriceSum: r
}) => /* @__PURE__ */ B.jsxs(Ln, { className: zi.list, children: [
  e.map(({ quantity: i, articleName: o, localPrice: s, type: l }, c) => /* @__PURE__ */ B.jsx(Ln.Text, { variant: "dense", className: zi.listItem, children: /* @__PURE__ */ B.jsx(jn, { content: l, dark: !0, children: /* @__PURE__ */ B.jsxs(C, { justifyContent: "space-between", gap: "200", children: [
    /* @__PURE__ */ B.jsxs(C, { flex: "0 0 auto", gap: "200", children: [
      /* @__PURE__ */ B.jsx(se.Paragraph, { variant: "4", children: i }),
      /* @__PURE__ */ B.jsx(se.Paragraph, { variant: "4", children: "×" })
    ] }),
    /* @__PURE__ */ B.jsx(C, { flex: "auto", children: /* @__PURE__ */ B.jsx(se.Paragraph, { variant: "4", children: o }) }),
    /* @__PURE__ */ B.jsx(C, { flex: "0 0 auto", gap: "100", children: /* @__PURE__ */ B.jsx(se.Paragraph, { variant: "4", children: pl(s, n) }) })
  ] }) }) }, c)),
  /* @__PURE__ */ B.jsx(
    Ln.Text,
    {
      variant: "dense",
      className: It(zi.listItem, zi.listSum),
      children: /* @__PURE__ */ B.jsxs(C, { gap: "100", justifyContent: "space-between", children: [
        /* @__PURE__ */ B.jsx(se.Paragraph, { variant: "3", children: "Sum" }),
        /* @__PURE__ */ B.jsx(se.Paragraph, { variant: "3", children: pl(r, n) })
      ] })
    },
    "theSumOfItAll"
  )
] }), wO = "_transaction_19x38_27", jO = "_transactionIsOpen_19x38_35", CO = "_transactionHeader_19x38_38", EO = "_transactionHeaderSubLine_19x38_41", FO = "_transactionHeaderAlignItemRight_19x38_45", Nr = {
  transaction: wO,
  transactionIsOpen: jO,
  transactionHeader: CO,
  transactionHeaderSubLine: EO,
  transactionHeaderAlignItemRight: FO
}, IO = ({
  transaction: e,
  openByDefault: n
}) => {
  const [r, i] = G(n), {
    transactionNumber: o,
    createdDate: s,
    storeName: l,
    numberOfItems: c,
    storeType: u,
    lineItems: p,
    localCurrency: m,
    localNetPriceSum: v
  } = e;
  return /* @__PURE__ */ B.jsxs(
    C,
    {
      className: It(Nr.transaction, {
        [Nr.transactionIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ B.jsxs(
          C,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Nr.transactionHeader,
            onClick: () => i(!r),
            "data-testid": "contact-transaction-header",
            children: [
              /* @__PURE__ */ B.jsxs(C, { style: { flexGrow: 1 }, children: [
                /* @__PURE__ */ B.jsxs(C, { flexDirection: "column", gap: "100", children: [
                  /* @__PURE__ */ B.jsx(ut, { size: "small", variant: "info", children: Nt(s).format("DD MMM YYYY @ HH:MM") }),
                  /* @__PURE__ */ B.jsxs(
                    se.Heading,
                    {
                      variant: "heading-4",
                      className: Nr.transactionHeaderSubLine,
                      children: [
                        "ID: ",
                        o
                      ]
                    }
                  )
                ] }),
                /* @__PURE__ */ B.jsxs(
                  C,
                  {
                    flexDirection: "column",
                    gap: "100",
                    className: Nr.transactionHeaderAlignItemRight,
                    children: [
                      /* @__PURE__ */ B.jsx(se.Heading, { variant: "heading-4", children: pl(v, m) }),
                      /* @__PURE__ */ B.jsxs(
                        se.Heading,
                        {
                          variant: "heading-4",
                          className: Nr.transactionHeaderSubLine,
                          children: [
                            c,
                            " line ",
                            `${c === 1 ? "item" : "items"}`
                          ]
                        }
                      )
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ B.jsx(C, { flexDirection: "column", children: /* @__PURE__ */ B.jsx(
                Bt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-up" : "angle-down"
                }
              ) })
            ]
          }
        ),
        r && /* @__PURE__ */ B.jsxs(
          C,
          {
            gap: "300",
            flexDirection: "column",
            "data-testid": "contact-transaction-content",
            children: [
              /* @__PURE__ */ B.jsx(yl, {}),
              /* @__PURE__ */ B.jsxs(C, { gap: "100", flexDirection: "column", children: [
                l && /* @__PURE__ */ B.jsx(se.Heading, { variant: "heading-2", children: l }),
                u && /* @__PURE__ */ B.jsx(an, { children: /* @__PURE__ */ B.jsx(C, { alignItems: "center", children: u }) }),
                p && /* @__PURE__ */ B.jsx(
                  xO,
                  {
                    lineItems: p,
                    localCurrency: m,
                    localNetPriceSum: v
                  }
                )
              ] })
            ]
          }
        )
      ]
    }
  );
}, $O = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: r,
    transactions: i
  } = iO({ contactId: e });
  if (!e)
    return null;
  const { items: o, count: s, totalCount: l } = i;
  return !o || !s || !l ? null : r ? /* @__PURE__ */ B.jsx(bn, { error: r }) : n ? /* @__PURE__ */ B.jsx(C, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ B.jsx(ln, {}) }) : /* @__PURE__ */ B.jsxs(
    C,
    {
      gap: "200",
      flexDirection: "column",
      "data-testid": "contact-transactions-wrapper",
      children: [
        /* @__PURE__ */ B.jsxs(C, { gap: "200", flexDirection: "row", alignItems: "center", children: [
          /* @__PURE__ */ B.jsx(se.Heading, { variant: "heading-3", children: "Transactions" }),
          /* @__PURE__ */ B.jsx(ut, { size: "small", variant: "success", children: s ?? l })
        ] }),
        s === 0 && /* @__PURE__ */ B.jsx(
          C,
          {
            justifyContent: "center",
            padding: "200",
            className: Va.notificationText,
            children: "There are no transactions for this contact."
          }
        ),
        s > 0 && o.map((c, u) => /* @__PURE__ */ B.jsx(
          IO,
          {
            transaction: c,
            openByDefault: u === 0
          },
          u
        ))
      ]
    }
  );
}, TO = "_message_31gs2_27", OO = "_messageIsOpen_31gs2_35", RO = "_messageHeader_31gs2_39", DO = "_messageText_31gs2_43", PO = "_buttonLink_31gs2_65", ei = {
  message: TO,
  messageIsOpen: OO,
  messageHeader: RO,
  messageText: DO,
  buttonLink: PO
}, ps = {
  status: {
    Delivered: "check-circle",
    Waiting: "clock",
    Hardbounce: "close-circle-filled",
    Softbounce: "close"
  },
  type: {
    EmailMessage: "mail",
    SmsMessage: "sms",
    PostalMessage: "paper-plane"
  },
  source: {
    Automation: "chat-bot",
    Manual: "user",
    System: "eye"
  }
}, fs = (e, n) => n && e in ps && n in ps[e] ? ps[e][n] : null, AO = ({
  message: e,
  openByDefault: n
}) => {
  const [r, i] = G(n), { track: o } = sn(), {
    name: s,
    sendDateTime: l,
    type: c,
    source: u,
    isTransactional: p,
    status: m,
    messageLink: v,
    messageText: y
  } = e, b = fs("type", c), N = fs("source", u), x = fs("status", m), T = c.replace("Message", "");
  return /* @__PURE__ */ B.jsxs(
    C,
    {
      className: It(ei.message, {
        [ei.messageIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ B.jsxs(
          C,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: ei.messageHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ B.jsxs(C, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ B.jsxs(C, { gap: "200", alignItems: "center", children: [
                  b && /* @__PURE__ */ B.jsxs(B.Fragment, { children: [
                    /* @__PURE__ */ B.jsx(Fe, { name: b, size: 16 }),
                    " ",
                    T
                  ] }),
                  /* @__PURE__ */ B.jsx(ut, { size: "small", variant: "info", children: Nt(l).format("DD MMM YYYY @ HH:MM") })
                ] }),
                s
              ] }),
              /* @__PURE__ */ B.jsx(
                Bt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ B.jsxs(C, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ B.jsx(yl, {}),
          /* @__PURE__ */ B.jsxs(C, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
            x && /* @__PURE__ */ B.jsx(an, { children: /* @__PURE__ */ B.jsxs(C, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ B.jsx(Fe, { name: x }),
              " ",
              m
            ] }) }),
            N && /* @__PURE__ */ B.jsx(an, { children: /* @__PURE__ */ B.jsxs(C, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ B.jsx(Fe, { name: N }),
              " ",
              u
            ] }) }),
            p && /* @__PURE__ */ B.jsx(an, { children: /* @__PURE__ */ B.jsxs(C, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ B.jsx(Fe, { name: "exchange" }),
              " Transactional"
            ] }) })
          ] }),
          /* @__PURE__ */ B.jsxs(C, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ B.jsx(se.Paragraph, { variant: "4", className: Va.label, children: "Message text" }),
            /* @__PURE__ */ B.jsx(se.Paragraph, { variant: "4", className: ei.messageText, children: y })
          ] }),
          v && /* @__PURE__ */ B.jsx(
            rt,
            {
              slotEnd: /* @__PURE__ */ B.jsx(Fe, { name: "external-link" }),
              variant: "tertiary",
              className: ei.buttonLink,
              navigate: () => {
                var $;
                o("voyado:message:external-link:opened", {
                  channel: T.toUpperCase()
                }), ($ = window.open(v, "_blank")) == null || $.focus();
              },
              children: "Open message in new tab"
            }
          )
        ] })
      ]
    }
  );
}, LO = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: r,
    lastMessages: i
  } = tO({ contactId: e });
  if (!e)
    return null;
  if (r)
    return /* @__PURE__ */ B.jsxs(C, { justifyContent: "center", margin: "300", children: [
      "Something went wrong fetching the last messages",
      r.message
    ] });
  const { count: o, items: s } = i, l = o > 0;
  return /* @__PURE__ */ B.jsxs(C, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ B.jsxs(C, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ B.jsx(se.Heading, { variant: "heading-3", children: "Last Messages" }),
      !n && /* @__PURE__ */ B.jsx(ut, { variant: "success", size: "small", children: o })
    ] }),
    /* @__PURE__ */ B.jsx(C, { gap: "200", flexDirection: "column", children: n ? /* @__PURE__ */ B.jsx(C, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ B.jsx(ln, {}) }) : /* @__PURE__ */ B.jsxs(B.Fragment, { children: [
      l && s.map((c, u) => /* @__PURE__ */ B.jsx(
        AO,
        {
          message: c,
          openByDefault: u === 0
        },
        u
      )),
      !l && /* @__PURE__ */ B.jsx(
        C,
        {
          justifyContent: "center",
          margin: "200",
          className: Va.notificationText,
          children: "No messages available"
        }
      )
    ] }) })
  ] });
}, UO = ({
  conversationContext: e,
  settings: n
}) => {
  var r, i;
  const {
    isLoading: o,
    error: s,
    refetch: l,
    attributes: c,
    preferences: u,
    consents: p,
    audiences: m,
    contactId: v
  } = eO({ conversationContext: e }), y = !((r = e == null ? void 0 : e.customer) != null && r.email) && !((i = e == null ? void 0 : e.customer) != null && i.phoneNumber), b = !!c, {
    showCustomerAttributes: N,
    showPreferences: x,
    showAudiences: T,
    showConsents: $,
    showLastMessages: P,
    showCustomerTransactions: h
  } = n;
  return y ? /* @__PURE__ */ B.jsx(
    C,
    {
      justifyContent: "center",
      margin: "300",
      "data-testid": "widget-no-contact-message",
      children: "No email nor phone number are available in this conversation to look up a profile."
    }
  ) : s ? vl({ errors: s.graphQLErrors }) ? /* @__PURE__ */ B.jsx(
    C,
    {
      justifyContent: "center",
      margin: "300",
      className: Va.notificationText,
      children: "No contact found"
    }
  ) : /* @__PURE__ */ B.jsx(bn, { error: s }) : !N && !x && !T && !$ && !P && !h ? /* @__PURE__ */ B.jsx(C, { justifyContent: "center", margin: "300", children: "All features toggles in the widget settings are disabled." }) : o ? /* @__PURE__ */ B.jsx(C, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ B.jsx(ln, {}) }) : /* @__PURE__ */ B.jsx(
    C,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: /* @__PURE__ */ B.jsxs(B.Fragment, { children: [
        b && /* @__PURE__ */ B.jsxs(B.Fragment, { children: [
          N && /* @__PURE__ */ B.jsx(cO, { contactAttributes: c }),
          x && /* @__PURE__ */ B.jsx(
            hO,
            {
              refetchContact: l,
              contactPreferences: u,
              contactId: v
            }
          ),
          $ && /* @__PURE__ */ B.jsx(vO, { contactConsents: p }),
          T && /* @__PURE__ */ B.jsx(dO, { contactAudiences: m }),
          P && /* @__PURE__ */ B.jsx(LO, { contactId: v }),
          h && /* @__PURE__ */ B.jsx($O, { contactId: v })
        ] }),
        !b && /* @__PURE__ */ B.jsx(C, { justifyContent: "center", padding: "200", children: "No contact found." })
      ] })
    }
  );
}, MO = [
  {
    key: "voyadoApiKey",
    label: "API key",
    placeholder: "API key from Voyado",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "apiHostName",
    label: "API URL",
    placeholder: "The URL of the Voyado API",
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://"
  },
  {
    key: "showCustomerAttributes",
    label: "Show the customer attributes",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showPreferences",
    label: "Show preferences",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showAudiences",
    label: "Show audiences",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showConsents",
    label: "Show consents",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showLastMessages",
    label: "Show the last 5 messages",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showCustomerTransactions",
    label: "Show customer transactions",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], BO = (e) => {
  switch (e) {
    case "input":
    case "hidden":
      return "";
    case "switch":
      return !1;
    default:
      return;
  }
}, VO = (e, n) => {
  switch (n) {
    case "input":
    case "hidden":
    case "select":
      return e;
    case "switch":
      return e === "true" ? !0 : e === "false" ? !1 : void 0;
    default:
      return;
  }
}, uv = ({
  key: e,
  configuration: n,
  settingType: r,
  settingDefault: i
}) => {
  const o = n == null ? void 0 : n.find(
    (c) => c.key === e
  ), s = VO(o == null ? void 0 : o.value, r), l = i !== void 0 ? i : BO(
    r
  );
  return s !== void 0 ? s : l;
}, qO = (e) => {
  if (!(e != null && e.trim()))
    return "Please add a valid subdomain";
  const r = ["https://", "http://"].find((l) => e.includes(l)), i = e.endsWith("/"), o = r ? `Please remove the protocol \`${r}\` from the hostname` : "", s = i ? "Please remove the trailing `/` from the hostname" : "";
  if (o && s)
    return `Please remove the protocol \`${r}\` and the trailing \`/\` from the hostname`;
  if (o)
    return o;
  if (s)
    return s;
}, mv = () => ({
  SHOPIFY: {
    widget: LT,
    icon: "shopify",
    iconColors: {
      contentColor: "rgb(148, 190, 69)",
      backgroundColor: "rgba(148, 190, 69, 0.1)"
    },
    settingsConfiguration: [
      {
        key: "apiAccessToken",
        label: "API Access Token",
        placeholder: "API access token from Shopify",
        required: !0,
        secret: !0,
        type: "input"
      },
      {
        key: "apiHostName",
        label: "API host name",
        placeholder: 'Host name of your shop, e.g. "my-webshop.myshopify.com"',
        required: !0,
        secret: !1,
        type: "input",
        prefix: "https://",
        customValidation: (n) => qO(n)
      },
      ...Zu ? [...Zu] : []
    ]
  },
  JIRA: {
    widget: oE,
    icon: "jira",
    iconColors: {
      contentColor: "rgb(38, 132, 255)",
      backgroundColor: "rgba(38, 132, 255, 0.075)"
    },
    settingsConfiguration: [
      ...Su ? [...Su] : []
    ]
  },
  GITHUB: {
    widget: Mj,
    icon: "github",
    iconColors: {
      contentColor: "rgb(87, 96, 106)",
      backgroundColor: "rgba(221, 244, 255, 0.75)"
    },
    settingsConfiguration: [...Bj]
  },
  MIUROS: {
    widget: aT,
    icon: "miuros",
    iconColors: {
      contentColor: "rgb(246, 135, 179)",
      backgroundColor: "rgba(246, 135, 179, 0.15)"
    },
    settingsConfiguration: [...oT]
  },
  KLAVIYO: {
    widget: dF,
    icon: "klaviyo",
    iconColors: {
      contentColor: "rgb(0, 0, 0)",
      backgroundColor: "rgba(0, 0, 0, 0.075)"
    },
    settingsConfiguration: [...uF]
  },
  LINEAR: {
    widget: $I,
    icon: "linear",
    iconColors: {
      contentColor: "rgb(94, 106, 210)",
      backgroundColor: "rgba(94, 106, 210, 0.15)"
    },
    settingsConfiguration: [...TI]
  },
  VOYADO: {
    widget: UO,
    icon: "voyado",
    iconColors: {
      contentColor: "rgb(0, 0, 0)",
      backgroundColor: "rgba(0, 0, 0, 0.075)"
    },
    settingsConfiguration: [...MO]
  },
  LOYALTYLION: {
    widget: d$,
    icon: "loyaltylion",
    iconColors: {
      contentColor: "rgb(36, 31, 79)",
      backgroundColor: "rgba(36, 31, 79, 0.075)"
    },
    settingsConfiguration: [...u$]
  },
  TRUSTPILOT: {
    widget: BT,
    icon: "trustpilot",
    iconColors: {
      contentColor: "rgb(0, 0, 50)",
      backgroundColor: "rgba(0, 0, 50, 0.075)"
    },
    settingsConfiguration: [...VT]
  }
}), zO = (e) => {
  const n = mv();
  return e.map(
    ({ id: r, type: i, name: o, settings: s }) => {
      var m;
      const c = n[i], { settingsConfiguration: u } = c, p = (m = u == null ? void 0 : u.filter(({ secret: v }) => !v)) == null ? void 0 : m.map(
        ({
          key: v,
          type: y,
          defaultValue: b
        }) => ({
          key: v,
          value: uv({
            key: v,
            configuration: s,
            settingType: y,
            settingDefault: b
          })
        })
      );
      return {
        id: r,
        type: i,
        name: o,
        settings: p,
        icon: c.icon,
        iconColors: c.iconColors,
        widget: c.widget
      };
    }
  );
}, KR = ({
  configuration: e,
  conversationContext: n,
  showNotification: r,
  onToggleFn: i,
  isOpenFn: o,
  isMinimized: s
}) => {
  const { track: l } = sn(), { isLoading: c, widgets: u } = Nw(
    e.baseUrl
  ), [p, m] = G([]);
  Pe(() => {
    if (u != null && u.length && !c) {
      const P = u.filter((h) => e.featureFlags[h.type]).filter((h) => h.enabled);
      m(
        // Mapping the widget from the backend (`widgets`) to our
        // `widgetDefinitions` configuration
        zO(P)
      );
    }
  }, [c]);
  const v = {
    headline: "",
    text: "",
    onConfirm: () => $(),
    confirmLabel: "Confirm",
    confirmVariant: "primary"
  }, [y, b] = G(v), [N, x] = G(!1), T = (P) => {
    x(!0), b(P);
  }, $ = () => {
    x(!1), b(v);
  };
  return /* @__PURE__ */ xe.jsxs(xe.Fragment, { children: [
    p.sort((P, h) => P.name.localeCompare(h.name)).map(
      ({
        id: P,
        name: h,
        type: E,
        widget: q,
        settings: M,
        icon: R,
        iconColors: w
      }) => {
        const H = `partner-integration-${P}`, pe = `partner-integration-${E}`, le = /* @__PURE__ */ xe.jsx(gl, { icon: R, color: w }), Se = M == null ? void 0 : M.reduce(
          (ae, D) => (ae[D.key] = D.value, ae),
          {}
        );
        return s ? /* @__PURE__ */ xe.jsx("div", { className: "icon-holder", children: le }, `partner-icon-${P}`) : /* @__PURE__ */ xe.jsxs(
          Kn,
          {
            onToggle: () => {
              l(
                o(H) ? "widget:collapse:closed" : "widget:collapse:opened",
                {
                  widgetId: P,
                  widgetType: E.toLowerCase()
                }
              ), i(H);
            },
            isOpen: o(H),
            className: pe,
            children: [
              /* @__PURE__ */ xe.jsx(Kn.Header, { avatar: le, children: h }),
              /* @__PURE__ */ xe.jsx(Kn.Content, { className: ww.widgetContentWrapper, children: /* @__PURE__ */ xe.jsx(
                Sm.Provider,
                {
                  value: {
                    onError: (ae, D) => console.warn(
                      `Something went wrong with a partner widget of type '${E}' and id '${P}'`,
                      ae,
                      D
                    )
                  },
                  children: /* @__PURE__ */ xe.jsx(
                    Mf,
                    {
                      integrationId: P,
                      type: E,
                      configuration: e,
                      showNotification: r,
                      showModal: T,
                      children: $v(q, {
                        conversationContext: n,
                        settings: Se
                      })
                    }
                  )
                }
              ) })
            ]
          },
          H
        );
      }
    ),
    /* @__PURE__ */ xe.jsx(
      Bf,
      {
        isOpen: N,
        setIsOpen: x,
        headline: y.headline,
        text: y.text,
        confirmLabel: y.confirmLabel,
        confirmVariant: y.confirmVariant,
        cancelLabel: y.cancelLabel,
        cancelVariant: y.cancelVariant,
        onConfirm: y.onConfirm ? () => {
          try {
            y.onConfirm && y.onConfirm();
          } finally {
            x(!1), b(v);
          }
        } : void 0,
        onCancel: y.onCancel ? () => {
          try {
            y.onCancel && y.onCancel();
          } finally {
            x(!1), b(v);
          }
        } : void 0,
        children: y.children
      }
    )
  ] });
}, HO = "FULL_ACCESS", KO = "2", GO = ({
  type: e,
  baseUrl: n
}) => {
  const r = `${e}-partner-widget-${Date.now().toString()}`, i = n.replace("partner-integrations", "api"), o = () => {
    let c;
    try {
      c = JSON.parse(localStorage.authData);
    } catch {
    }
    return (c == null ? void 0 : c.access_token) || "";
  };
  return {
    deleteDixaApiToken: (c) => fetch(`${i}/v1/auth/api-tokens/${c}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${window.btoa(`token:${o()}`)}`
      }
    }).then((u) => u.json()),
    createDixaApiToken: () => fetch(`${i}/v1/auth/api-tokens-v2`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${window.btoa(`token:${o()}`)}`
      },
      body: JSON.stringify({
        name: r,
        scopes: [HO],
        version: KO
      })
    }).then((c) => c.json())
  };
}, WO = "dixaApiToken", ac = "dixaApiTokenId", pv = "dixaApiTokenName", vm = (e) => [ac, pv].every(
  (r) => e.find((i) => (i == null ? void 0 : i.key) === r)
);
function YO({
  token: e,
  settings: n
}) {
  if (n.length === 0)
    return [];
  const r = QO(e), i = (s, l) => s == null ? void 0 : s.find((c) => (c == null ? void 0 : c.key) === l);
  return n.map((s) => {
    const l = s && i(r, s.key);
    return i(n, s == null ? void 0 : s.key) && l ? l : s;
  });
}
const QO = (e) => [
  {
    key: WO,
    value: e.value,
    secret: !0
  },
  {
    key: ac,
    value: e.id,
    secret: !1
  },
  {
    key: pv,
    value: e.name,
    secret: !1
  }
], JO = ci`
  query getWidgetConfiguration($id: ID!) {
    Management {
      widgetConfigurations(id: $id) {
        id
        type
        enabled
        name
        settings {
          key
          value
        }
      }
    }
  }
`, ZO = ci`
  mutation updateWidgetConfiguration(
    $id: ID!
    $enabled: Boolean
    $name: String!
    $settings: [Management_SettingInput!]
  ) {
    Management {
      updateWidgetConfiguration(
        id: $id
        enabled: $enabled
        name: $name
        settings: $settings
      ) {
        id
        name
        enabled
        settings {
          key
          value
        }
      }
    }
  }
`, XO = ci`
  mutation createWidgetConfiguration(
    $type: String!
    $enabled: Boolean!
    $name: String!
    $settings: [Management_SettingInput!]!
  ) {
    Management {
      createWidgetConfiguration(
        type: $type
        enabled: $enabled
        name: $name
        settings: $settings
      ) {
        id
        name
        enabled
        settings {
          key
          value
        }
      }
    }
  }
`, eR = ci`
  mutation deleteWidgetConfiguration($id: ID!) {
    Management {
      deleteWidgetConfiguration(id: $id) {
        id
      }
    }
  }
`, nR = "_wrapper_17fxs_27", tR = "_wrapperBox_17fxs_30", rR = "_wrapperBoxErrorBorder_17fxs_35", vs = {
  wrapper: nR,
  wrapperBox: tR,
  wrapperBoxErrorBorder: rR
}, iR = ({
  required: e,
  readOnly: n,
  isSecret: r,
  isCreationMode: i,
  label: o,
  settings: s,
  widgetSettingsKey: l,
  meta: c,
  handleEditSecret: u,
  handleChangeText: p
}) => {
  const m = s == null ? void 0 : s.find(
    (h) => h.type === "basicAuthInput"
  ), v = m == null ? void 0 : m.additionalProperties, { username: y, password: b } = v, N = `Insert your ${y.label.toLowerCase()}`, x = `Insert your ${b.label.toLowerCase()}`, [T, $] = G({
    username: "",
    password: ""
  }), P = Tv(
    (h) => {
      p({
        target: {
          name: l,
          value: h
        }
      });
    },
    [l]
  );
  return Pe(() => {
    P(
      T.username !== "" && T.password !== "" ? window.btoa(`${T.username}:${T.password}`) : ""
    );
  }, [T, P]), /* @__PURE__ */ xe.jsx(
    Fn,
    {
      required: e,
      label: o,
      meta: c,
      className: vs.wrapper,
      children: /* @__PURE__ */ xe.jsxs(
        C,
        {
          gap: "300",
          flexDirection: "column",
          className: It(vs.wrapperBox, {
            [vs.wrapperBoxErrorBorder]: !!(c != null && c.error)
          }),
          children: [
            /* @__PURE__ */ xe.jsx(
              Lt,
              {
                noAlert: !0,
                required: e,
                label: y.label,
                readOnly: n,
                placeholder: N,
                input: {
                  name: l,
                  value: T.username,
                  onChange: (h) => $({
                    username: (h == null ? void 0 : h.target.value) ?? "",
                    password: T.password
                  })
                },
                ...r && !i && {
                  prefix: {
                    type: "button",
                    button: {
                      icon: "close",
                      onClick: () => u(!1, l)
                    }
                  }
                }
              }
            ),
            /* @__PURE__ */ xe.jsx(
              Lt,
              {
                noAlert: !0,
                required: e,
                label: b.label,
                readOnly: n,
                placeholder: x,
                input: {
                  name: l,
                  value: T.password,
                  onChange: (h) => $({
                    username: T.username,
                    password: (h == null ? void 0 : h.target.value) ?? ""
                  })
                },
                ...r && !i && {
                  prefix: {
                    type: "button",
                    button: {
                      icon: "close",
                      onClick: () => u(!1, l)
                    }
                  }
                }
              }
            )
          ]
        }
      )
    }
  );
};
function aR({
  isSecret: e,
  widgetSettingsKey: n,
  label: r,
  required: i,
  readOnly: o,
  placeholder: s,
  handleChangeText: l,
  handleChangeBoolean: c,
  handleChangeSelect: u,
  handleEditSecret: p,
  getValueByKey: m,
  isEditingField: v,
  errors: y,
  type: b,
  isCreationMode: N,
  prefix: x,
  integrationId: T,
  integrationType: $,
  configuration: P,
  settings: h,
  otherProps: E
}) {
  var R, w;
  const q = b === "custom" && (E == null ? void 0 : E.component), M = (R = m(n)) == null ? void 0 : R.value;
  return q ? /* @__PURE__ */ xe.jsx(
    q,
    {
      configuration: P,
      integrationId: T,
      integrationType: $,
      label: r,
      settings: h,
      getValueByKey: m,
      widgetSettingsKey: n,
      handleChangeSelect: u
    }
  ) : /* @__PURE__ */ xe.jsxs(xe.Fragment, { children: [
    /* @__PURE__ */ xe.jsx(wn, { span: 3, children: /* @__PURE__ */ xe.jsx(
      oR,
      {
        widgetSettingsKey: n,
        label: r,
        isEditingField: v,
        handleEditSecret: p,
        isCreationMode: N,
        children: b === "input" ? /* @__PURE__ */ xe.jsx(
          Lt,
          {
            required: i,
            readOnly: o,
            label: r,
            placeholder: s,
            input: {
              name: n,
              value: M,
              onChange: l
            },
            meta: { error: y[n] },
            prefix: x,
            ...e && !N && {
              prefix: {
                type: "button",
                button: {
                  icon: "close",
                  onClick: () => p(!1, n)
                }
              }
            }
          }
        ) : b === "basicAuthInput" ? /* @__PURE__ */ xe.jsx(
          iR,
          {
            required: i,
            readOnly: o,
            isSecret: e,
            isCreationMode: N,
            label: r,
            widgetSettingsKey: n,
            settings: h,
            meta: { error: y[n] },
            handleEditSecret: p,
            handleChangeText: l
          }
        ) : b === "switch" ? /* @__PURE__ */ xe.jsx(Fn, { label: r, children: /* @__PURE__ */ xe.jsx(
          Nm,
          {
            input: {
              name: n,
              value: "",
              checked: M,
              onChange: c
            }
          }
        ) }) : b === "select" ? /* @__PURE__ */ xe.jsx(Fn, { label: r, children: /* @__PURE__ */ xe.jsx(
          Qt,
          {
            required: i,
            clearable: !0,
            placeholder: s,
            readOnly: o,
            onChange: (H) => u(n, H),
            getItemTitleByValue: (H) => H ? /* @__PURE__ */ xe.jsx(se.Paragraph, { children: H.label }) : /* @__PURE__ */ xe.jsx(xe.Fragment, {}),
            value: M ? [
              {
                label: (w = ((E == null ? void 0 : E.selectItems) || []).find(
                  (H) => H.value === M
                )) == null ? void 0 : w.label,
                value: M
              }
            ] : [],
            equalityFn: (H, pe) => H.value === pe.value,
            children: ((E == null ? void 0 : E.selectItems) || []).map((H) => /* @__PURE__ */ xe.jsx(Jt.Item, { value: H, children: H.label }, H.value))
          }
        ) }) : /* @__PURE__ */ xe.jsx(xe.Fragment, {})
      }
    ) }),
    /* @__PURE__ */ xe.jsx(wn, { span: 3 })
  ] });
}
function oR({
  widgetSettingsKey: e,
  label: n,
  isEditingField: r,
  handleEditSecret: i,
  children: o,
  isCreationMode: s
}) {
  return r || s ? o : /* @__PURE__ */ xe.jsx(Fn, { label: n, children: /* @__PURE__ */ xe.jsxs(
    On,
    {
      "data-testid": `secret-field-button-${e}`,
      variant: "secondary",
      icon: "pen",
      onClick: () => i(!0, e),
      children: [
        "Update ",
        n
      ]
    }
  ) });
}
const ii = "partner-integrations-widget-name-form-field", ym = ({
  settingsFromBackend: e,
  settingsConfiguration: n,
  creating: r = !1
}) => n.filter(({ type: i }) => i !== "custom").map(
  ({
    key: i,
    required: o,
    secret: s,
    type: l,
    defaultValue: c,
    customValidation: u
  }) => ({
    key: i,
    value: uv({
      key: i,
      configuration: e,
      settingType: l,
      settingDefault: c
    }),
    required: o,
    secret: s,
    // The property `isEditing` is used in order to show/hide the input field in
    // case it is a secret setting. However, when we create a widget we _always_
    // want to show the input field because it will be the first time that the user
    // enters a value for it.
    //
    // We have two scenarios here:
    // 1) When initializing
    //   - the setting is secret=true so we set isEditing=false and hide the input.
    //   - the setting is secret=false, so we set isEditing=true and show the input.
    // 2) We create a widget (creating=true), so we set isEditing=true in
    //    order to show the input.
    isEditing: r ? !0 : !s,
    type: l,
    ...u && { customValidation: u }
  })
), sR = ({
  initialValues: e,
  onSubmit: n
}) => {
  const [r, i] = G(
    e || {
      enabled: !1,
      name: "",
      settings: []
    }
  ), [o, s] = G({}), l = (E) => i(E), c = (E) => !E || E === "", u = (E) => {
    const { [E]: q, ...M } = o;
    s(M);
  }, p = (E) => ({
    ...E,
    settings: E.settings.filter(({ isEditing: q }) => q).map(({ key: q, value: M, secret: R }) => ({
      key: q,
      value: M,
      secret: R
    }))
  }), m = {
    input: "This can not be empty",
    basicAuthInput: "Please insert a value for both fields"
  }, v = (E) => {
    if (!E)
      return;
    const {
      target: { name: q, value: M }
    } = E;
    o[q] && !c(M) && u(q), i({
      ...r,
      settings: r.settings.map(
        (R) => R.key === q ? { ...R, value: M } : R
      )
    });
  }, y = (E) => {
    if (!E)
      return;
    const {
      target: { name: q, checked: M }
    } = E;
    i({
      ...r,
      settings: r.settings.map(
        (R) => R.key === q ? { ...R, value: M } : R
      )
    });
  }, b = (E, q) => {
    if (!q)
      return;
    const { selectedValues: M } = q, R = M == null ? void 0 : M[0];
    if (R) {
      const w = r.settings.map(
        (H) => H.key === E ? { ...H, value: R == null ? void 0 : R.value } : H
      );
      i({
        ...r,
        settings: w
      });
    } else {
      const w = r.settings.filter(
        (H) => H.key !== E
      );
      i({
        ...r,
        settings: w
      });
    }
  }, N = (E) => {
    i({
      ...r,
      enabled: E
    });
  }, x = (E) => {
    if (!E)
      return;
    const {
      target: { value: q }
    } = E;
    o[ii] && !c(q) && u(ii), i({
      ...r,
      name: q
    });
  }, T = (E, q) => {
    const { settings: M } = r, R = M.map((w) => w.key === q ? {
      ...w,
      isEditing: E,
      ...!E && { value: "" }
    } : w);
    o[q] && !E && u(q), i({
      ...r,
      settings: R
    });
  }, $ = (E) => r.settings.find(
    (q) => q.key === E
  ), P = async (E) => {
    E.preventDefault(), h() && n(p(r));
  }, h = () => {
    var R;
    const E = {}, { name: q, settings: M } = r;
    return c(q) && (E[ii] = m.input), M.forEach(
      ({ key: w, value: H, required: pe, isEditing: le, type: Se, customValidation: ae }) => {
        if (pe && le)
          if (ae) {
            const D = ae(H);
            typeof D == "string" && (E[w] = D);
          } else
            typeof H == "string" && c(H) && (E[w] = m[Se]);
      }
    ), s(E), !((R = Object.keys(E)) != null && R.length);
  };
  return {
    formData: r,
    errors: o,
    handleIsEnabled: N,
    handleChangeText: v,
    handleChangeBoolean: y,
    handleChangeSelect: b,
    handleEditSecret: T,
    handleChangeName: x,
    handleSubmit: P,
    getSettingValueByKey: $,
    initializeFormData: l,
    validate: h
  };
}, lR = [
  "GITHUB",
  "JIRA",
  "LINEAR"
], cR = ({
  integrationId: e,
  type: n,
  handleRedirect: r,
  showNotification: i,
  configuration: o
}) => {
  const { track: s } = sn(), { deleteDixaApiToken: l, createDixaApiToken: c } = GO({
    type: n,
    baseUrl: o.baseUrl
  }), p = Zv().pathname.match(
    /^\/settings\/integrations\/partner-widget\/[a-zA-Z0-9]*\/create$/
  ), m = !e && !!n && !!p, v = lR.includes(n), [y, b] = G(), [N, x] = G(!1), [T, $] = G(!1), [P, h] = G(!1), M = mv()[n].settingsConfiguration, R = M.filter(({ type: Y }) => Y !== "hidden").filter(({ hideOnCreate: Y }) => m ? !Y : !0), {
    error: w,
    loading: H,
    data: pe,
    refetch: le
  } = Gv(JO, {
    variables: {
      id: e
    },
    // skip wants either `true` to literally skip the query,
    // or `undefined` to run the query. A simple `false` will
    // still run the query, therefore checking here for the
    // negated `integrationId` instead.
    skip: !e,
    onCompleted: (Y) => {
      Object.keys(Y).length === 0 ? h(!0) : h(!1);
    }
  }), [Se, { error: ae }] = lc(
    m ? XO : ZO,
    {
      onError: (Y) => {
        b(Y), x(!1), i({
          title: "Something went wrong",
          text: `The ${m ? "creation" : "update"} of the widget was not successful.`,
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      },
      onCompleted: (Y) => {
        var fe, ge;
        x(!1), Object.keys(Y).length !== 0 ? (m && r((ge = (fe = Y == null ? void 0 : Y.Management) == null ? void 0 : fe.createWidgetConfiguration) == null ? void 0 : ge.id), i({
          title: `${m ? "Creating" : "Updating"} was successful`,
          text: `${m ? "Creating" : "Updating"} the widget was successful.`,
          icon: "check-circle-filled",
          severity: "success"
        })) : i({
          title: "Something went wrong",
          text: `The ${m ? "creation" : "update"} of the widget was not successful.`,
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      }
    }
  ), [D] = lc(eR, {
    onError: (Y) => {
      b(Y), x(!1), i({
        title: "Something went wrong",
        text: "The deletion of the widget was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: () => {
      x(!1), r(), i({
        title: "Deletion was successful",
        text: "The deletion of the widget was successful.",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), {
    formData: V,
    handleIsEnabled: de,
    errors: te,
    handleChangeText: he,
    handleChangeBoolean: _e,
    handleChangeSelect: Z,
    handleEditSecret: J,
    handleChangeName: z,
    handleSubmit: me,
    getSettingValueByKey: ke,
    initializeFormData: Oe
  } = sR({
    onSubmit: async (Y) => {
      m ? s("settings:create:submitted", { widgetType: n }) : e && s("settings:view:change:submitted", {
        widgetId: e,
        widgetType: n
      }), x(!0);
      const fe = Y.settings.map(
        (W) => typeof W.value == "boolean" ? { ...W, value: W.value.toString() } : W
      ), ge = vm(fe) && m;
      let X = [];
      if (ge) {
        const W = await c().catch(
          (ce) => {
            x(!1), console.warn("API-Token (creation) error resonse", ce), i({
              title: "Something went wrong",
              text: "The creation of the API-Token was not successful and therefore the widget creation was aborted. Please try again later.",
              icon: "exclamation-triangle-filled",
              severity: "warning"
            });
          }
        );
        W != null && W.data && (X = YO({
          token: W.data,
          settings: fe
        }));
      }
      const ye = {
        ...Y,
        settings: [
          ...X.length > 0 ? X : fe
        ]
      };
      (ge && X.length > 1 || !ge && X.length === 0) && (Se({
        variables: {
          ...!m && { id: e },
          ...m && { type: n },
          ...ye
        }
      }), fe.forEach(
        (W) => W.secret && J(!1, W.key)
      ));
    },
    ...m && {
      initialValues: {
        enabled: !1,
        name: "",
        settings: ym({
          settingsFromBackend: [],
          settingsConfiguration: M,
          creating: !0
        })
      }
    }
  });
  return Pe(() => {
    var fe;
    const Y = (fe = pe == null ? void 0 : pe.Management) == null ? void 0 : fe.widgetConfigurations[0];
    if (Y) {
      const ge = ym({
        settingsFromBackend: Y.settings,
        settingsConfiguration: M
      });
      Oe({
        enabled: !!Y.enabled,
        name: Y.name,
        settings: ge
      });
    }
  }, [pe]), w || ae || y ? /* @__PURE__ */ xe.jsx(
    bn,
    {
      error: w || y,
      retry: w ? le : void 0
    }
  ) : N || H ? /* @__PURE__ */ xe.jsx(ln, { "data-testid": "widget-settings-loading" }) : P ? /* @__PURE__ */ xe.jsxs(se.Paragraph, { children: [
    "A widget with the id ",
    /* @__PURE__ */ xe.jsx(an, { children: e }),
    " does not exist."
  ] }) : /* @__PURE__ */ xe.jsxs("form", { children: [
    /* @__PURE__ */ xe.jsxs(
      Ar,
      {
        "data-testid": `widget-settings-form-${e ?? "create-new"}`,
        children: [
          /* @__PURE__ */ xe.jsx(wn, { children: /* @__PURE__ */ xe.jsx(Fn, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ xe.jsx(
            Nm,
            {
              input: {
                name: "enabled",
                checked: V.enabled,
                value: "dummy",
                onChange: (Y) => de(Y.target.checked)
              }
            }
          ) }) }),
          /* @__PURE__ */ xe.jsx(wn, { span: 3, children: /* @__PURE__ */ xe.jsx(
            Lt,
            {
              required: !0,
              label: "Widget name",
              placeholder: "Insert the name of the widget",
              input: {
                name: ii,
                value: V.name,
                onChange: z
              },
              meta: {
                error: te[ii]
              }
            }
          ) }),
          /* @__PURE__ */ xe.jsx(wn, { span: 3 }),
          R == null ? void 0 : R.map(
            ({
              key: Y,
              secret: fe,
              label: ge,
              placeholder: X = "",
              required: ye = !1,
              type: W,
              prefix: ce,
              readOnly: ie,
              ...oe
            }) => {
              const { settings: be } = V, Ee = be.find(
                (Ie) => Ie.key === Y
              );
              return /* @__PURE__ */ xe.jsx(Ov, { children: /* @__PURE__ */ xe.jsx(
                aR,
                {
                  widgetSettingsKey: Y,
                  isEditingField: !!(Ee != null && Ee.isEditing),
                  handleEditSecret: J,
                  handleChangeText: he,
                  handleChangeBoolean: _e,
                  handleChangeSelect: Z,
                  getValueByKey: ke,
                  isSecret: fe,
                  label: ge,
                  placeholder: X,
                  required: ye,
                  errors: te,
                  type: W,
                  isCreationMode: m,
                  prefix: ce,
                  integrationId: e,
                  integrationType: n,
                  configuration: o,
                  readOnly: ie,
                  settings: M,
                  otherProps: oe
                }
              ) }, Y);
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ xe.jsxs(C, { margin: "300 0 0 0", children: [
      /* @__PURE__ */ xe.jsx(On, { onClick: me, children: "Submit" }),
      !m && /* @__PURE__ */ xe.jsx(
        On,
        {
          style: { marginLeft: 20 },
          icon: "trash",
          variant: "secondary",
          onClick: () => {
            e && s("settings:view:delete:requested", {
              widgetId: e,
              widgetType: n
            }), $(!0);
          },
          children: "Delete"
        }
      )
    ] }),
    /* @__PURE__ */ xe.jsx(
      Bf,
      {
        isOpen: T,
        setIsOpen: $,
        confirmVariant: v ? "danger" : "primary",
        confirmLabel: "Yes",
        cancelLabel: "No",
        onCancel: () => {
          e && s("settings:view:delete:canceled", {
            widgetId: e,
            widgetType: n
          });
        },
        onConfirm: () => {
          var Y;
          if (e && s("settings:view:delete:confirmed", {
            widgetId: e,
            widgetType: n
          }), vm(V.settings)) {
            const fe = (Y = V.settings.find(
              ({ key: ge }) => ge === ac
            )) == null ? void 0 : Y.value;
            fe && l(fe).catch((ge) => {
              console.warn("API-Token (deletion) error response", ge), i({
                title: "Something went wrong",
                text: "The deletion of the API-Token was not successful. Please have a look in Settings > Integrations > Api-Tokens to find your token and remove it manually.",
                icon: "exclamation-triangle-filled",
                severity: "warning"
              });
            });
          }
          D({
            variables: {
              id: e
            }
          });
        },
        children: /* @__PURE__ */ xe.jsx(C, { children: v ? /* @__PURE__ */ xe.jsxs(C, { gap: "400", children: [
          /* @__PURE__ */ xe.jsx(
            Fe,
            {
              size: 24,
              name: "exclamation-triangle-filled",
              color: $e.red[500]
            }
          ),
          /* @__PURE__ */ xe.jsxs(C, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ xe.jsxs(se.Heading, { withMarginBottom: !0, children: [
              "By deleting the ",
              n,
              " integration, all links between Dixa and ",
              n,
              " are also deleted."
            ] }),
            /* @__PURE__ */ xe.jsxs(se.Paragraph, { children: [
              "All data in ",
              n,
              " stays untouched."
            ] }),
            /* @__PURE__ */ xe.jsxs(se.Paragraph, { children: [
              "Are you sure you want to delete the ",
              n,
              " ",
              'integration "',
              V.name,
              '"?'
            ] })
          ] })
        ] }) : /* @__PURE__ */ xe.jsxs(xe.Fragment, { children: [
          "Are you sure you want to delete the ",
          n,
          ' integration "',
          V.name,
          '"?'
        ] }) })
      }
    )
  ] });
}, GR = ({
  configuration: e,
  integrationId: n,
  type: r,
  handleRedirect: i,
  showNotification: o
}) => /* @__PURE__ */ xe.jsx(
  Sm.Provider,
  {
    value: {
      onError: (s, l) => console.warn(
        `Something went wrong with the partner widget settings of type ${r} and id ${n}`,
        s,
        l
      )
    },
    children: /* @__PURE__ */ xe.jsx(
      Mf,
      {
        integrationId: n,
        type: r,
        configuration: e,
        showNotification: o,
        children: /* @__PURE__ */ xe.jsx(
          cR,
          {
            configuration: e,
            integrationId: n,
            type: r,
            handleRedirect: i,
            showNotification: o
          }
        )
      }
    )
  }
);
var oc = { exports: {} }, Tr = typeof Reflect == "object" ? Reflect : null, gm = Tr && typeof Tr.apply == "function" ? Tr.apply : function(n, r, i) {
  return Function.prototype.apply.call(n, r, i);
}, na;
Tr && typeof Tr.ownKeys == "function" ? na = Tr.ownKeys : Object.getOwnPropertySymbols ? na = function(n) {
  return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : na = function(n) {
  return Object.getOwnPropertyNames(n);
};
function dR(e) {
  console && console.warn && console.warn(e);
}
var fv = Number.isNaN || function(n) {
  return n !== n;
};
function on() {
  on.init.call(this);
}
oc.exports = on;
oc.exports.once = fR;
on.EventEmitter = on;
on.prototype._events = void 0;
on.prototype._eventsCount = 0;
on.prototype._maxListeners = void 0;
var hm = 10;
function qa(e) {
  if (typeof e != "function")
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
}
Object.defineProperty(on, "defaultMaxListeners", {
  enumerable: !0,
  get: function() {
    return hm;
  },
  set: function(e) {
    if (typeof e != "number" || e < 0 || fv(e))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
    hm = e;
  }
});
on.init = function() {
  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
on.prototype.setMaxListeners = function(n) {
  if (typeof n != "number" || n < 0 || fv(n))
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
  return this._maxListeners = n, this;
};
function vv(e) {
  return e._maxListeners === void 0 ? on.defaultMaxListeners : e._maxListeners;
}
on.prototype.getMaxListeners = function() {
  return vv(this);
};
on.prototype.emit = function(n) {
  for (var r = [], i = 1; i < arguments.length; i++)
    r.push(arguments[i]);
  var o = n === "error", s = this._events;
  if (s !== void 0)
    o = o && s.error === void 0;
  else if (!o)
    return !1;
  if (o) {
    var l;
    if (r.length > 0 && (l = r[0]), l instanceof Error)
      throw l;
    var c = new Error("Unhandled error." + (l ? " (" + l.message + ")" : ""));
    throw c.context = l, c;
  }
  var u = s[n];
  if (u === void 0)
    return !1;
  if (typeof u == "function")
    gm(u, this, r);
  else
    for (var p = u.length, m = bv(u, p), i = 0; i < p; ++i)
      gm(m[i], this, r);
  return !0;
};
function yv(e, n, r, i) {
  var o, s, l;
  if (qa(r), s = e._events, s === void 0 ? (s = e._events = /* @__PURE__ */ Object.create(null), e._eventsCount = 0) : (s.newListener !== void 0 && (e.emit(
    "newListener",
    n,
    r.listener ? r.listener : r
  ), s = e._events), l = s[n]), l === void 0)
    l = s[n] = r, ++e._eventsCount;
  else if (typeof l == "function" ? l = s[n] = i ? [r, l] : [l, r] : i ? l.unshift(r) : l.push(r), o = vv(e), o > 0 && l.length > o && !l.warned) {
    l.warned = !0;
    var c = new Error("Possible EventEmitter memory leak detected. " + l.length + " " + String(n) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    c.name = "MaxListenersExceededWarning", c.emitter = e, c.type = n, c.count = l.length, dR(c);
  }
  return e;
}
on.prototype.addListener = function(n, r) {
  return yv(this, n, r, !1);
};
on.prototype.on = on.prototype.addListener;
on.prototype.prependListener = function(n, r) {
  return yv(this, n, r, !0);
};
function uR() {
  if (!this.fired)
    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function gv(e, n, r) {
  var i = { fired: !1, wrapFn: void 0, target: e, type: n, listener: r }, o = uR.bind(i);
  return o.listener = r, i.wrapFn = o, o;
}
on.prototype.once = function(n, r) {
  return qa(r), this.on(n, gv(this, n, r)), this;
};
on.prototype.prependOnceListener = function(n, r) {
  return qa(r), this.prependListener(n, gv(this, n, r)), this;
};
on.prototype.removeListener = function(n, r) {
  var i, o, s, l, c;
  if (qa(r), o = this._events, o === void 0)
    return this;
  if (i = o[n], i === void 0)
    return this;
  if (i === r || i.listener === r)
    --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete o[n], o.removeListener && this.emit("removeListener", n, i.listener || r));
  else if (typeof i != "function") {
    for (s = -1, l = i.length - 1; l >= 0; l--)
      if (i[l] === r || i[l].listener === r) {
        c = i[l].listener, s = l;
        break;
      }
    if (s < 0)
      return this;
    s === 0 ? i.shift() : mR(i, s), i.length === 1 && (o[n] = i[0]), o.removeListener !== void 0 && this.emit("removeListener", n, c || r);
  }
  return this;
};
on.prototype.off = on.prototype.removeListener;
on.prototype.removeAllListeners = function(n) {
  var r, i, o;
  if (i = this._events, i === void 0)
    return this;
  if (i.removeListener === void 0)
    return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : i[n] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete i[n]), this;
  if (arguments.length === 0) {
    var s = Object.keys(i), l;
    for (o = 0; o < s.length; ++o)
      l = s[o], l !== "removeListener" && this.removeAllListeners(l);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (r = i[n], typeof r == "function")
    this.removeListener(n, r);
  else if (r !== void 0)
    for (o = r.length - 1; o >= 0; o--)
      this.removeListener(n, r[o]);
  return this;
};
function hv(e, n, r) {
  var i = e._events;
  if (i === void 0)
    return [];
  var o = i[n];
  return o === void 0 ? [] : typeof o == "function" ? r ? [o.listener || o] : [o] : r ? pR(o) : bv(o, o.length);
}
on.prototype.listeners = function(n) {
  return hv(this, n, !0);
};
on.prototype.rawListeners = function(n) {
  return hv(this, n, !1);
};
on.listenerCount = function(e, n) {
  return typeof e.listenerCount == "function" ? e.listenerCount(n) : kv.call(e, n);
};
on.prototype.listenerCount = kv;
function kv(e) {
  var n = this._events;
  if (n !== void 0) {
    var r = n[e];
    if (typeof r == "function")
      return 1;
    if (r !== void 0)
      return r.length;
  }
  return 0;
}
on.prototype.eventNames = function() {
  return this._eventsCount > 0 ? na(this._events) : [];
};
function bv(e, n) {
  for (var r = new Array(n), i = 0; i < n; ++i)
    r[i] = e[i];
  return r;
}
function mR(e, n) {
  for (; n + 1 < e.length; n++)
    e[n] = e[n + 1];
  e.pop();
}
function pR(e) {
  for (var n = new Array(e.length), r = 0; r < n.length; ++r)
    n[r] = e[r].listener || e[r];
  return n;
}
function fR(e, n) {
  return new Promise(function(r, i) {
    function o(l) {
      e.removeListener(n, s), i(l);
    }
    function s() {
      typeof e.removeListener == "function" && e.removeListener("error", o), r([].slice.call(arguments));
    }
    _v(e, n, s, { once: !0 }), n !== "error" && vR(e, o, { once: !0 });
  });
}
function vR(e, n, r) {
  typeof e.on == "function" && _v(e, "error", n, r);
}
function _v(e, n, r, i) {
  if (typeof e.on == "function")
    i.once ? e.once(n, r) : e.on(n, r);
  else if (typeof e.addEventListener == "function")
    e.addEventListener(n, function o(s) {
      i.once && e.removeEventListener(n, o), r(s);
    });
  else
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof e);
}
var yR = oc.exports;
function WR() {
  const e = new yR.EventEmitter();
  return e && typeof window < "u" ? window._partner = {
    events: e
  } : console.warn(
    "Initialization of partner-integration events was not successfull."
  ), e;
}
const YR = {
  jira: sE,
  shopify: sT
};
export {
  _w as GraphQLClientProvider,
  Bf as IntegrationModal,
  KR as PartnerIntegrations,
  GR as PartnerIntegrationsSettings,
  XO as createWidgetConfigurationMutation,
  eR as deleteWidgetConfigurationMutation,
  YR as documentationArticles,
  JO as getWidgetConfigurationByIdQuery,
  mv as getWidgetDefinitions,
  WR as initializePartnerEventEmitter,
  ZO as updateWidgetConfigurationMutation,
  Nw as usePartnerIntegrationWidgetConfigurations
};
